var _style, _rect, _g, _g2, _g3, _g4, _g5, _path, _polygon, _path2, _path3, _g6, _g7, _g8, _path4, _g9, _g10, _g11, _g12, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path5, _g13, _g14, _g15, _polyline, _path6, _polygon10, _path7, _polyline2, _path8, _polygon11, _path9, _polyline3, _path10, _polygon12, _path11, _polyline4, _path12, _polygon13, _path13, _path14, _polyline5, _polygon14, _g16, _g17, _g18, _g19, _polygon15, _g20, _path15, _polyline6, _polygon16, _polygon17, _polygon18, _path16, _path17, _path18, _polyline7, _polyline8, _polygon19, _path19, _path20, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _g21, _g22, _g23, _g24, _g25, _path21, _polyline9, _polyline10, _polyline11, _polyline12, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g26, _g27, _g28, _g29, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _path55, _path56, _polygon78, _polygon79, _polygon80, _polygon81, _path57, _polygon82, _polygon83, _path58, _path59, _polygon84, _polygon85, _path60, _polygon86, _polygon87, _polygon88, _polygon89, _path61, _path62, _path63, _path64, _path65, _path66, _g30, _g31, _g32, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _g33, _g34, _g35, _polygon108, _polygon109, _polygon110, _path67, _polygon111, _polyline13, _polygon112, _path68, _g36, _g37, _path69, _path70, _path71, _path72, _path73, _path74, _g38, _g39, _path75, _path76, _g40, _g41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaceTrack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4096 2160",
    style: {
      enableBackground: "new 0 0 4096 2160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#9D7C4F;}\n\t.st2{fill:#A78459;}\n\t.st3{fill:#493B2B;}\n\t.st4{opacity:0.44;fill:url(#SVGID_2_);}\n\t.st5{opacity:0.44;fill:url(#SVGID_3_);}\n\t.st6{opacity:0.39;fill:url(#SVGID_4_);}\n\t.st7{opacity:0.39;fill:url(#SVGID_5_);}\n\t.st8{fill:#B2A34C;}\n\t.st9{fill:#6C7C2A;}\n\t.st10{fill:url(#SVGID_6_);}\n\t.st11{fill:none;stroke:#D0CC9E;stroke-width:31;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:38.9483,38.9483;}\n\t.st14{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:40.0702,40.0702;}\n\t.st15{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:41.9727,41.9727;}\n\t.st16{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:42.8085,42.8085;}\n\t.st17{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:37.462,37.462;}\n\t.st18{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:41.1226,41.1226;}\n\t.st19{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:42.2589,42.2589;}\n\t.st20{fill:none;stroke:#A24E2C;stroke-width:31;stroke-miterlimit:10;stroke-dasharray:41.7977,41.7977;}\n\t.st21{fill:#F2D291;}\n\t.st22{fill:url(#SVGID_7_);}\n\t.st23{fill:url(#SVGID_8_);}\n\t.st24{fill:url(#SVGID_9_);}\n\t.st25{fill:url(#SVGID_10_);}\n\t.st26{fill:url(#SVGID_11_);}\n\t.st27{fill:url(#SVGID_12_);}\n\t.st28{fill:url(#SVGID_13_);}\n\t.st29{fill:url(#SVGID_14_);}\n\t.st30{fill:url(#SVGID_15_);}\n\t.st31{fill:url(#SVGID_16_);}\n\t.st32{fill:url(#SVGID_17_);}\n\t.st33{fill:url(#SVGID_18_);}\n\t.st34{fill:url(#SVGID_19_);}\n\t.st35{fill:url(#SVGID_20_);}\n\t.st36{fill:url(#SVGID_21_);}\n\t.st37{fill:url(#SVGID_22_);}\n\t.st38{fill:url(#SVGID_23_);}\n\t.st39{fill:url(#SVGID_24_);}\n\t.st40{fill:url(#SVGID_25_);}\n\t.st41{fill:url(#SVGID_26_);}\n\t.st42{fill:url(#SVGID_27_);}\n\t.st43{fill:url(#SVGID_28_);}\n\t.st44{fill:url(#SVGID_29_);}\n\t.st45{fill:url(#SVGID_30_);}\n\t.st46{fill:url(#SVGID_31_);}\n\t.st47{fill:url(#SVGID_32_);}\n\t.st48{fill:url(#SVGID_33_);}\n\t.st49{fill:url(#SVGID_34_);}\n\t.st50{fill:url(#SVGID_35_);}\n\t.st51{fill:#87A237;}\n\t.st52{fill:url(#SVGID_36_);}\n\t.st53{fill:url(#SVGID_37_);}\n\t.st54{fill:url(#SVGID_38_);}\n\t.st55{fill:url(#SVGID_39_);}\n\t.st56{fill:url(#SVGID_40_);}\n\t.st57{fill:url(#SVGID_41_);}\n\t.st58{fill:url(#SVGID_42_);}\n\t.st59{fill:url(#SVGID_43_);}\n\t.st60{fill:url(#SVGID_44_);}\n\t.st61{fill:url(#SVGID_45_);}\n\t.st62{fill:url(#SVGID_46_);}\n\t.st63{fill:url(#SVGID_47_);}\n\t.st64{fill:url(#SVGID_48_);}\n\t.st65{fill:url(#SVGID_49_);}\n\t.st66{fill:url(#SVGID_50_);}\n\t.st67{fill:url(#SVGID_51_);}\n\t.st68{fill:url(#SVGID_52_);}\n\t.st69{fill:url(#SVGID_53_);}\n\t.st70{fill:#282828;}\n\t.st71{fill:#2D2D2D;}\n\t.st72{fill:none;stroke:#818181;stroke-width:7;stroke-miterlimit:10;}\n\t.st73{fill:none;stroke:#1E170F;stroke-width:7;stroke-miterlimit:10;}\n\t.st74{fill:none;stroke:#493723;stroke-width:7;stroke-miterlimit:10;}\n\t.st75{opacity:0.19;fill:url(#SVGID_54_);}\n\t.st76{fill:none;stroke:#FCE0BB;stroke-width:2;stroke-miterlimit:10;}\n\t.st77{fill:url(#SVGID_55_);}\n\t.st78{fill:url(#SVGID_56_);}\n\t.st79{fill:url(#SVGID_57_);}\n\t.st80{fill:url(#SVGID_58_);}\n\t.st81{fill:url(#SVGID_59_);}\n\t.st82{fill:url(#SVGID_60_);}\n\t.st83{fill:url(#SVGID_61_);}\n\t.st84{fill:url(#SVGID_62_);}\n\t.st85{fill:url(#SVGID_63_);}\n\t.st86{fill:url(#SVGID_64_);}\n\t.st87{fill:url(#SVGID_65_);}\n\t.st88{fill:url(#SVGID_66_);}\n\t.st89{fill:url(#SVGID_67_);}\n\t.st90{fill:url(#SVGID_68_);}\n\t.st91{fill:url(#SVGID_69_);}\n\t.st92{fill:url(#SVGID_70_);}\n\t.st93{fill:url(#SVGID_71_);}\n\t.st94{fill:url(#SVGID_72_);}\n\t.st95{fill:url(#SVGID_73_);}\n\t.st96{fill:url(#SVGID_74_);}\n\t.st97{fill:url(#SVGID_75_);}\n\t.st98{fill:url(#SVGID_76_);}\n\t.st99{fill:url(#SVGID_77_);}\n\t.st100{fill:url(#SVGID_78_);}\n\t.st101{fill:url(#SVGID_79_);}\n\t.st102{fill:url(#SVGID_80_);}\n\t.st103{fill:url(#SVGID_81_);}\n\t.st104{fill:url(#SVGID_82_);}\n\t.st105{fill:url(#SVGID_83_);}\n\t.st106{fill:url(#SVGID_84_);}\n\t.st107{fill:url(#SVGID_85_);}\n\t.st108{fill:url(#SVGID_86_);}\n\t.st109{fill:url(#SVGID_87_);}\n\t.st110{opacity:0.49;fill:#373022;}\n\t.st111{fill:#373022;}\n\t.st112{fill:url(#SVGID_88_);}\n\t.st113{fill:url(#SVGID_89_);}\n\t.st114{fill:url(#SVGID_90_);}\n\t.st115{fill:url(#SVGID_91_);}\n\t.st116{fill:url(#SVGID_92_);}\n\t.st117{fill:url(#SVGID_93_);}\n\t.st118{fill:url(#SVGID_94_);}\n\t.st119{fill:url(#SVGID_95_);}\n\t.st120{fill:url(#SVGID_96_);}\n\t.st121{fill:url(#SVGID_97_);}\n\t.st122{fill:url(#SVGID_98_);}\n\t.st123{fill:url(#SVGID_99_);}\n\t.st124{fill:url(#SVGID_100_);}\n\t.st125{fill:url(#SVGID_101_);}\n\t.st126{fill:url(#SVGID_102_);}\n\t.st127{fill:url(#SVGID_103_);}\n\t.st128{fill:url(#SVGID_104_);}\n\t.st129{fill:url(#SVGID_105_);}\n\t.st130{fill:url(#SVGID_106_);}\n\t.st131{fill:url(#SVGID_107_);}\n\t.st132{fill:url(#SVGID_108_);}\n\t.st133{fill:url(#SVGID_109_);}\n\t.st134{fill:url(#SVGID_110_);}\n\t.st135{fill:url(#SVGID_111_);}\n\t.st136{fill:url(#SVGID_112_);}\n\t.st137{fill:url(#SVGID_113_);}\n\t.st138{fill:url(#SVGID_114_);}\n\t.st139{fill:url(#SVGID_115_);}\n\t.st140{fill:url(#SVGID_116_);}\n\t.st141{fill:url(#SVGID_117_);}\n\t.st142{fill:url(#SVGID_118_);}\n\t.st143{fill:url(#SVGID_119_);}\n\t.st144{fill:url(#SVGID_120_);}\n\t.st145{fill:url(#SVGID_121_);}\n\t.st146{fill:url(#SVGID_122_);}\n\t.st147{fill:url(#SVGID_123_);}\n\t.st148{fill:url(#SVGID_124_);}\n\t.st149{fill:url(#SVGID_125_);}\n\t.st150{fill:url(#SVGID_126_);}\n\t.st151{fill:url(#SVGID_127_);}\n\t.st152{fill:url(#SVGID_128_);}\n\t.st153{fill:url(#SVGID_129_);}\n\t.st154{fill:url(#SVGID_130_);}\n\t.st155{fill:url(#SVGID_131_);}\n\t.st156{fill:url(#SVGID_132_);}\n\t.st157{fill:url(#SVGID_133_);}\n\t.st158{fill:url(#SVGID_134_);}\n\t.st159{fill:url(#SVGID_135_);}\n\t.st160{fill:url(#SVGID_136_);}\n\t.st161{fill:url(#SVGID_137_);}\n\t.st162{fill:url(#SVGID_138_);}\n\t.st163{fill:url(#SVGID_139_);}\n\t.st164{fill:url(#SVGID_140_);}\n\t.st165{fill:url(#SVGID_141_);}\n\t.st166{fill:url(#SVGID_142_);}\n\t.st167{fill:url(#SVGID_143_);}\n\t.st168{fill:url(#SVGID_144_);}\n\t.st169{fill:url(#SVGID_145_);}\n\t.st170{fill:url(#SVGID_146_);}\n\t.st171{fill:url(#SVGID_147_);}\n\t.st172{fill:url(#SVGID_148_);}\n\t.st173{fill:url(#SVGID_149_);}\n\t.st174{fill:url(#SVGID_150_);}\n\t.st175{fill:url(#SVGID_151_);}\n\t.st176{fill:url(#SVGID_152_);}\n\t.st177{fill:url(#SVGID_153_);}\n\t.st178{fill:url(#SVGID_154_);}\n\t.st179{fill:url(#SVGID_155_);}\n\t.st180{fill:url(#SVGID_156_);}\n\t.st181{fill:url(#SVGID_157_);}\n\t.st182{fill:url(#SVGID_158_);}\n\t.st183{fill:url(#SVGID_159_);}\n\t.st184{fill:url(#SVGID_160_);}\n\t.st185{fill:url(#SVGID_161_);}\n\t.st186{fill:url(#SVGID_162_);}\n\t.st187{fill:url(#SVGID_163_);}\n\t.st188{fill:url(#SVGID_164_);}\n\t.st189{fill:none;stroke:#F7F0C9;stroke-width:10;stroke-miterlimit:10;}\n\t.st190{fill:none;stroke:#F7F0C9;stroke-width:10;stroke-miterlimit:10;stroke-dasharray:11.6879,11.6879;}\n\t.st191{fill:none;stroke:#F7F0C9;stroke-width:10;stroke-miterlimit:10;stroke-dasharray:11.5342,11.5342;}\n\t.st192{opacity:0.43;fill:#191919;}\n\t.st193{opacity:0.44;fill:#191919;}\n\t.st194{fill:none;stroke:#202020;stroke-width:3;stroke-miterlimit:10;}\n\t.st195{fill:url(#SVGID_165_);}\n\t.st196{fill:url(#SVGID_166_);}\n\t.st197{fill:url(#SVGID_167_);}\n\t.st198{fill:url(#SVGID_168_);}\n\t.st199{fill:url(#SVGID_169_);}\n\t.st200{fill:url(#SVGID_170_);}\n\t.st201{fill:url(#SVGID_171_);}\n\t.st202{fill:url(#SVGID_172_);}\n\t.st203{fill:url(#SVGID_173_);}\n\t.st204{fill:url(#SVGID_174_);}\n\t.st205{fill:url(#SVGID_175_);}\n\t.st206{fill:url(#SVGID_176_);}\n\t.st207{fill:url(#SVGID_177_);}\n\t.st208{fill:url(#SVGID_178_);}\n\t.st209{fill:url(#SVGID_179_);}\n\t.st210{fill:url(#SVGID_180_);}\n\t.st211{fill:url(#SVGID_181_);}\n\t.st212{fill:url(#SVGID_182_);}\n\t.st213{opacity:0.33;fill:#202020;}\n\t.st214{opacity:0.46;fill:#202020;}\n\t.st215{opacity:0.4;}\n\t.st216{fill:none;stroke:#282828;stroke-width:5;stroke-miterlimit:10;}\n\t.st217{opacity:0.32;}\n\t.st218{fill:url(#SVGID_183_);}\n\t.st219{fill:url(#SVGID_184_);}\n\t.st220{fill:url(#SVGID_185_);}\n\t.st221{fill:url(#SVGID_186_);}\n\t.st222{fill:url(#SVGID_187_);}\n\t.st223{fill:url(#SVGID_188_);}\n\t.st224{fill:url(#SVGID_189_);}\n\t.st225{fill:url(#SVGID_190_);}\n\t.st226{opacity:0.25;}\n\t.st227{fill:url(#SVGID_191_);}\n\t.st228{fill:url(#SVGID_192_);}\n\t.st229{opacity:0.29;fill:url(#SVGID_193_);}\n\t.st230{opacity:0.29;fill:url(#SVGID_194_);}\n\t.st231{opacity:0.29;fill:url(#SVGID_195_);}\n\t.st232{opacity:0.29;fill:url(#SVGID_196_);}\n\t.st233{display:none;}\n\t.st234{display:inline;opacity:0.06;}\n\t.st235{display:inline;fill:#353535;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 795,
    height: 798,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAHQAdAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAA+gAAAiWAAAOkz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAyYDIwMBIgACEQEDEQH/ xACrAAEAAwEBAQAAAAAAAAAAAAAAAQIDBgQFAQEAAAAAAAAAAAAAAAAAAAAAEAACAQIDBgcBAQEA AwEAAAABAgMAETASBEAhNAUGFhAgUDEiMhMjMxRgsCRBEQABAgEHCQYFBAEDBAMBAAABAAIRMCEx QVEDBEBhcRKSsjPTdBAggZEiMlChQlITscHRYnLwgiNgQ1MU4cLSBRIBAAAAAAAAAAAAAAAAAAAA sP/aAAwDAQACEQMRAAAA3+q6Q5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0 g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0g5t0 lTnXRyc26Qc26Qc26Qc26Qc26SpzrpBzbpBzbpBzbpBzbpBzbpBzbpBzbpBzbpBzbpBzbpBzrohz fSc30gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIFYuSAAAABjr5z0gAAAAAAAAAAA5vpOb6QAAAAAA AAAAAAAAAAAAAAAAAAAAAAAIqTSbiQAAAAFTO1NiQAAAAAAAAAAAc30nN9IAAAAAAAAAAAAAAAAA AAAAAAAACCVBdQXitC6Bec5LqC6JAABBWlLk3mpcAAAAAAAAAAAHN9JzfSAAAAAAAAAAAAAAAAAA AglnieqPJU9MY7lJ0gmbCsgiZIiwqsKxcUXFI0grFoM2lS9sZNUSMdcS8qlq6VLgAAAAAAAAAAA5 vpOb6QAAAAAAAAAAAAAAAAEEx4/Ie7y29Z4/T6ZM7yAAAAAAAAAAAESKU2Hk3vgWv59yLwKa1sSA AAAAAAAAAADm+k5vpAAAAAAAAAAAAAAAAz+aezwz9I8fs0kiQAAAAAAAAAAAAAAAAjHceT0WxNlZ LIkAAAAAAAAAAA5vpOb6QAAAAAAAAAAAAAGZfxxBj7dbmWoAAAAAAAAAAAAAAAAAAAAVmRSZqXZ3 JAAAAAAAAABzfSc30gAAAAAAAAAAAAicRhMD1xcAAAAAAAAEEoEogsrBdWSQAAAAAAAAAAVprBFs pNAAAAAAAAAc30nN9IAAAAAAAAAAAAY4Zblt4uAAAAAAEVLxSxC0lFxnXSxlOkFaWqRawzXFYuLz 59S6JAAAAAAAAGegx2yg2AAAAAAABzfSc30gAAAAAAAAAAAiYPl/RjQSAAAAAqTTPUi8gAADPTPQ RIpEaEgiLCkaDFrBlNsza3k0N0SAAAAAAAMN4K383oJAAAAAABzfSc30gAAAAAAAAAAAysLSAAAA AEeadS1gAAAAz0z0ETmNIkAAAARIyrvkUvMGk4aF1cjcAAAAAGNr+c9IAAAAAAOb6Tm+kAAAAAAA AAAETkNK3AAAACBOd/KX3SAAAAAZ6Z6EVpqSAAAAAQMmhKalJvmee96noJAAAAAGG8Fb+b0gAAAA AHN9JzfSAAAAAAAAAAEefQaSAAAAgrbPQxnD2EgAAAAAzvFSu2OpIAAAAFbZmHq8/pFLVLxOJetp Ka5SaAAAAAAw1ZmwAAAAAOb6Tm+kAAAAAAAAAETB5/R5/SAAAAK2xLRp5DT0RIAAAAABGeuQ0qLg AAAAY7YjbLUrNbFYvBaEE56QTOWoAAAAAx2yNJrYAAAAA5vpOb6QAAAAAAAAAZ6YFtYkAAAAYbYm 3k3qbgAAAAAARIyBqiQAAAB5/R5Te8SUvS4AAiRhtGZsAAAABW0FNMdgAAAADm+k5vpAAAAAAAAA CMWhcAAAAFc71M98PSAAAAAAAAZWtQm+WoAAAA8vq85umCmlLgAAFMrUPROegAAAAiYMds7lgAAA Ac30nN9IAAAAAAAAKWwHorYAAAAAzrbI01iQAAAAAAACM9chpEFwAAIkZRTctEwVvnoAAAeeMvWZ 7+f0AAAAAGcxBqAAAADm+k5vpAAAAAAABDMjSZAAAAAAMq2sXAAAAAAAAAy0zNKXzNQAAAY6Tibx MFL0sWAAiYM418prtEgAAAAFKWqazEgAAAHN9JzfSAAAAAACrMm9bkgAAAAAEFJroSAAAAAAAACs JLZa5GoAAAGG9SZx2KxapdEgAgopuAAAAAAZ0vQ2kAAAAOb6Tm+kAAAAAFZwJvNyJAAAAAABnME3 AAAAAAAABE1IskY7YmwAAAAMN8Nia2FbUuAMtMTS4AAAAACCue2B6AAAAAc30nN9IAAAAIYkargA AAAAACs5jRIAAAAAAAAApehcDHbE2AAAABlXXznqBWZqWIM2PqJAAAAAABnFNiwAAAAOb6Tm+kAA ABmVtXYAAAAAAAQqRdIAIJRIAAAAAAApehcDHbA3AAAABHm9XlPUiSImC2O3mNNYkAAAAAECIqZ+ jLYAAAAA5vpOb6QAAFRhX0kyAAAAAACsVJukAARIiQAAAAAAAVtUsCMdsjYAAAADzenE1nPQpaly fN6fMekAAAAACtsiaWuTIAAAAAc30nN9IACCPNfM22iQAAAAABSJI0AAAAAAAAAAABEwIkSCM9cj UAAAADLXMrtjsZa5ajz+jA3AAAAAAx28xfX5/wBAkAAAAAHN9JzfSADO/kK+rD1EgAAAAKi2aRcA AAAAAAAAAAAFbULAkDHbA3AAAAAz0zI0rJXSlxlrmaIkAAAAAjzenznz/s/G+yAAAAAAc30nN9IA Z+PWp6NYkAAAARNTO9PGen0VuAAAAAAAAAAAAAM9My5IAw3wNwAAAAMdcDel6F5iRW0FNMtQAAAA CMtsj531vF7QAAAAADm+k5vpBW2Rir6TQAAAADLXznm2+b9wkAAAAAAAAAAAAACl4ItS4Ax2oWml wAAADNTYZaUNJiQDOyhqAAAABnpmReYLAAAAAA5vpOb6Qeb0eYr6/H7CQAAAAPB7vnmH2PlfVAAA ABBKJAAAAAAAAAM9M9ABEjPTHUkAAAHn9Hn9BFNIE56AEY74G6JAAAAGelC01sAAAAAAc30nN9IR 5vR5ivr83oLgAAAAjw+/wmH1flfVAAAAGWlSbAAKlgAAAAAImCts7FwAZXnI2AAAB5/R5/QAZa5a EgZa1IvjsAAAAK2gz1x2AAAAAAOb6Tm+kK+T2eE3szPUAAAAB4vbQ+b9XyeokAAAAAACJAAAAAAA EY71JnLUAY7ZGqtgABEjy+nOh6ESRnrQurYRI83p8vqAAAAAMdaWLAAAAAA5vpOb6QeD3+M1o0NZ x2AAAAAMJ1wN5x1JAAAAAAAAAAAAAABWL1LKXESKXw2JAABFbjz70obgpNoJRJ4/X59TQAAAAFaa Ym4AAAAAOb6Tm+kGeg+f7/n+48/r8frJAAAAAiRhG1DSfNuWAAAAAAAAAAAAAABWL5miJK01gTSS yJAAGegw3zzPQiSCDOmmR6kSAAAARh6PMelEgAAAAHN9JzfSAGfk9+JC3nPaiQAAAABEiuO4rfCx qAAAAAAAAAAAAAQTmF5AACsoLAAAUuMdqC8TBnW0k3iQAAAB5vT5j0TWwAAAABzfSc30gAiRll6a FdvB7SwAAAAAAGWox1jM2VkkAAAAAABAlUTCSFhSNBEgAAAz0zNESAAAVppmagw0w9JIAAAAI8/o wNrUuAAAAAc30nN9IAAK2Gfk9uZrPj9ZIAAAAAAESM67VJnzD0spNESCCUACFhCREgAAAAAAApeh aa2AAAIyvBoQeX1+L2gAAAAEYejzmt62AAAAAOb6Tm+kAAAESPLbfynqnLQkAAAAAACgTMjONYM4 mTHa/mPU8PrLgAIEqiyosqLKiyskokAEDNoJAAAQZa56jK/nHqpcAAAAAeb0+Y9EgAAAABzfSc30 gAAAAiR59L1LqWJAAAAAzSLgAArYZTpQt5dZMPRXA9bH0FVhEgAAAiRWLik2FI0ESAAAgnGbkyoU o1LyAAAAAEefbI9AAAAAAOb6Tm+kAAAAAAIppBFs4NVbAAgVSRZIAAAAiYK11GN75lfP6JNJ8HtL AEEqC6guoLqSWQJRIAARQvlOhFkEYtiLJAAAAABBhr5/USAAAAADm+k5vpAAAAAAABWwyvOZpOVy 1UkTFgAAAAAAABnoMfN76FNMBsXIkESKxcUXFFxRcUXFI0Gd5AgYrk3AAAAAABS/nK+rPQAAAAAA 5vpOb6QAAAAAAAAArntBjpXznsnyeguiQAAAAAAAABEjKukEr1JnIaq2AAABBKotEVJytqVuAAAA AAAEeX04m8gAAAAABzfSc30gAAAAAAAAAABTy+0eDfbzHqn53pPQiQAAAAAABE5C8WJAiRnGoxnU Ythk1GTWCkaDK9wAAAAAAAABSa3JAAAAAABzfSc30gAAAAAAAAAAAABTx+wfP9mnhPoT8z6BdEgA AAAgjNcmwAAAAAAAAAAAAAAAAAKzQm8SAAAAAAAc30nN9IAAAAAAAAAAAAAQkAU8X0B4/Vl5j3z5 tyyBIAIrbInRIAAAAAAAAAAAAAAAAAiMyUaEyAAAAAAAHN9JzfSAAAAAAAAAAAAAAAACJGHn98Hn 2rkeljc0iBS8XAAAAAAAAAAAAAAAABBNK5lkai4AAAAAAAAc30nN9IAAAAAAAAAAAAAAAAAAIkZV 3GDeCJyg3UsSiQAAAAAAAAAAAAgSjM089dzLW8kTWwAAAAAAAABzfSc30gAAAAAAAAAAAAAAAAAP Ma4eT0nrtloSBEjONIKaRQ1Z2LIEgAAAAAAAAKwWrFjOdJIkETBFokAAAAAAAAA5vpOb6QAAAAAA AAAAARMCYkAAAEHzLeT6Y9OMnl9aTQAAAERYUXFJkEQXVguoLxUWQJgETJReSsyIkAAAAAAAAAAA AAOb6Tm+kAAAAAAAAAAAAAAAAESPF6NMRa0mNPT5j02rYAAAAAA8+drl7xgekAAAAAAAAAAAAAAA AAAAAHN9JzfSAAAAAAAAAAAAAAAAAAAFFwAAAAAAiR4fZQMd7FgAAAAAAAAAAAAAAAAAAAAc70QA AAAAAAAAAAAAAAAAAAAAAAAAAARARYJAAAAAAAAAAAAAAAAAAAAB/9oACAECAAEFAP8A1FP/2gAI AQMAAQUA/wDUU//aAAgBAQABBQDkHTui5vF2LymuxeU12LymuxeU12LymuxeU12LymuxeU12Lymu xeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU1 2LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12Lym uxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU12LymuxeU 12LymuxeU12LymuxeU0ehuUAdjcprsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsb lNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi8prsXlNdi 8prsXlNdi8prsXlNdi8prsXlNdk8qy9FcJ/4Ad5w3Nl2forhPXyQAlziTnfs/RXCevEgV9ziRn9d Rs/RXCeuswWgC5xNRIQIYxHHs/RXCeuFqVb4ruEVFtQ9tn6K4T1sksQoOLI4QWvSqXZDfaOiuE9U JAoyJX6Cs5rOazmmkZjnAH6oKEiGs4rMazgUCD5yQBH/AFcf1a4unvs/RXCelXAptREp/wChabVK lDVxMRKprOKDA+FqKKaygVlFZVrItZFr8xWVq/oKuavHWSM0YkowuKWWRCrq48mobd+YCAGmUEQq Quz9FcJ6O0yKX1sSltTO1BHejBIKWFRQijFJBEjY9qKKayEVeQUzqQUDBZbeJIUQgu8rFVSVDVxU f12forhPRCQKl18KUdTqNQVgZzHpWASCNdpIBoxqaaJyP0eEpMjVJeViyoDnYZFyyJZwLDZ+iuE9 D1PMoYT/APZrDDo4wV04oKF24gEPphUTNFQMclMcqxyB1ksVHts/RXCeg6nXwacvJrNadPokQLAt Wt6EyqwbTmnkkUIyMu47T0Vwm3zTxQLqNZqtQNBp0kVIFHo5ANGDIynNQbaOiuE20kAS60kJA8rR aZVWPTxx+lMtza4+S0GDbN0Vwm2STKlTsxKQl2SMKPTmShJY7J0Vwm1ySEU0hQxRElEVB6gyhh84 6V1YbF0Vwm1PKzMzWI06uIkKJsdxVxWYVnSv0jr9Y7h0NAg7S8ZBjlDbF0Vwm06qX8okkDxqgARQ oxywFZ6+ZrK1ZFplFvxBoRQigkQrLGKRENJDG7HTQ1/zAV+U4q+pWhqVBBDDZJYs1RSknYOiuE2n nUxXTQIixIoGOZBWV2oIo8t/n4yDNToGIQgf0Ffowr9RRKGrsasUZZEYbJNFmEMubYOiuE2g+2rW Rp44ggxCQKMlqCs1AAecf6+P1EQ3eJVTX5ijGasRXvW9aExFKysNimQqY3DrjdFcJtDGwSMM2I7h RdnKoFwR/t4uc7gWHnKqa/MinBvkN01G8EHYSARGfylxuiuE2hjnYCww2YKLtK6qFGCP9vBiFWFT bCIBpohR+oRlCS5qBB2DUJdYnzpi9FcJs7tlEa2GJM5ZokCrhH/bwcZjit8myWMkeakkJoG9XqHU rM+IRcRn85cXorhNnHzfEmkyLFHiPukokAIN2IxyrprlKJsHSgA41OokDaWBIGxdQu6N86YnRXCb NM9hGuVcMm1b5prYkvhqCcoFhiTveGNcqU281IcghgAGYx6jFYBhCSkmJ0Vwmyk2CXklwnNqHtqZ MqaePImJMPgpuJvtiObIpzR+A3tVhSsuaZM1RsVOLOtirZlw+iuE2Wd8qQLlTCX5PX++pxZBdIzu nxdQbQ6VbpR3CP61LKbpGEBvWS6xvfFdcywm2J0Vwmyy/OQCwwXNliHx1D5ItGmWPFPspymcfzBu MPVcPpRbT05soFg7ZRFGF8G9hvEgsVNxiH4y4fRXCbIx3RDNLhTGlFhqiXkVQq4zL8fvHEbx4er4 bTboKk8LC5UGrGmBIpxcRNvxJhuQ3XC6K4TZJjZNOtkwj8pibCEfpqMe1RGxjID4etNtNELR0d8n nf8Am4NxhuLrCfjhdFcJsk5uwFhhQ75J2yx6VbJsD/GV/jLh68/xUWFLvfzuuZYWxD7RbmwuiuE2 MmwiGd8JjZdON2qNyi5U2CcXQgPHE2ZcLU/ObwjwJHEaSHK4NxhrufC6K4TY53qNcq4Uv0g+g/pP sLC6wG8Y+MuEoz6qj7R/Xz6rhozn0cLXTDcWKnC6K4TYncIsKlnw5voDlhgWy7FDuM26gbjAR7DT rZab6p7efWsF0mmW2i0x3Ycvsp34PRXCbCSADeQquUYc30O8AWGxR/6SDMkRumBLdZVFlpvqvt59 axnL2WLSbxhy/X/9weiuE2AkAb5SFtizfWFbnY0/1qLdg6hbojB0o+w+nmJsIo0Fal8sWmXLHhy/ U++D0VwmOSAPlIQABizeyCy7HH/pURu2Ad9Q/B/AD4qbr5SLgCwe8soFhhy/VvfB6K4TGZgosWKm +O43qbnYmNggs1AZZsGcZW9/C1mXcfNM+VYo8oxJaf74PRXCYrOFo7qUM2wOczAADYvd196k3S4L qHXTsSng25vMv9ZcV97nfNg9FcJiM1qzWKR78eR7UiZRsae3hN/phD4ajwYXCm48kz2WJcqYoHyj 3zYPRXCYZNgWaRkRUGO75RGltkc/ECw8Jd8uFqCF8g3N5B/SXGO4afecHorhMORzIyIEGOzBQilj sjb38Zd0uFqUzw6Vy8XgwuAbjwmcIsIsmNO2WPTi0eD0VwmFJIWMcYQY5IAALnZR9/Gb7YTi66b4 zeI96JsFvPNj6g3pBZMHorhMGaS1RRhBjkgAAudmX7eLb9Tht8Nb4p9a1L5U06ZI8ZjYWzy4XRXC YEsgQRR22AkCgC3nBvsK/bxj+Wow9X8ZfBtyp9an+UvtjA3Z2uYV34XRXCed3CKgLuBbHZgoUFtp X7eOm34muH8VN1qQ2Rdwr31OK5sq/FLEhRYYXRXCeZmCglpHRQoxncKFQsdpH28G+umH88PVi+n0 5vBUvt4JxGLIbs29gu/D6K4TyswUSveoI8oxncLSIb7UPt4H2hupw9R/hpOHp98ngn++KT81YKAb jD6K4TyyyXMSfpJjO9qRLbUTYD2Hv4qf7Yc/+Ol4el3zeAFp8Vz/AEmk/XW4nRXCeSZ8iMSBDH+a YrvSJl2t/rQ8icRhz/46cWgqLf4uLSYqb9RygmbmGJ0VwnklcyTwrnmw2bKFvaR7UiZRtcv1oeRO Jw5/8YRaKQ2SMZU8JRuU3GJGLN04Lx4nRXCeM8n5xoTHDp4/ziwyc8juFETGRgLbZL9PKN2qw9Sf 5qLLLvPiwusR3Ylt/T65IMTorhPHUn9HA/TUYbGyxbhLM+q1McSxrtk30Ht5H3ajDPzFDfL5PpJi L90jOkmxOiuE8GbKqVoVuuHOfjzHV/8ANp+W6QaXTbbILou9fJqBbDmbLHGlo6H08ko3IbrhjdJq FzRKbrh9FcJ4TtumJXTQpkiw52+VjrOabcRcRG6eSRcyRm6YOpN/B/qwtH5GF1hOI25yLhFyrh9F cJ4SnNJqN8o9sPVub8qUHXbfHuPljNmwX+Wqoi4lH8wbjyD4zYclDeMTorhPBPkWObUj2w5hm1XJ t8mGCCNjPxk8rnJLgjjPBhcQn4eSfcwNxhSfWM3XE6K4SjuEP+C/6L9cNh/9vJMOViSqhV2I7g4z IpuPJOuaNGzJgLxniPjN5JxdIjePCYXWE7sTorhKf6QcJaxjN0w5jl1fJdzYSJl8wvmxifzKbj5C LjTm2D7avxmFgDceMgumnPxw0NpMTorhKf6QH/5At007XXD1kZzcpDJqdvIBFzE/lb4T4Ej5NT4k XERynyac2kw5BlfE6K4Sj7RG0EO8RHJPhyIHXTkxv6A6B1jYjy6hbxqcy+eeNZFjdon8ZEzUjZh4 3y6rDmHxQ3TD6K4TwIyz6Y3XUApKDcYc8V6jluPQHQMEcnyEXEYAXAkjWRYpWRvFl3q1/HV/CUb8 NxdIDdcPorhPDWDJLpDv1S5otM+aLEkT82V8tAgjb2TNStfyMfykwZYllWGVg3iRQ8Nct44GzQ4R 9oTZ8PorhPCeISxaRyJSLjTHJLiEAi35m7QlWDDb2XNSMT4sodYyyYUsKyrFMwbxNA3GpGaLRt8M Nd02H0Vwnjq0MM0UgkjnBjnBuMRlDAfGiHgKOrjb5N3k96yEUGODLEsqxysjeI3Gf/NPg2G26XD6 K4TxniWaPSSNDJqkzRaWTPHikA1a1PG0JjkWQbdMfiPbykC+BJGsixMyN4Gp/wDMLmhjN1wpfce2 F0VwnkngSSomzCM/hqNgkhIMUwfbTLeljObzEXCNmGBIgZY2LL4aj/OIfyCgYc3sn1wuiuE8rrY6 pP0TTTCRNgliD0kpB2UkCswq7V8qJavzLUAAMAfGTAf6QfTw1J+MYtHhzfWP6YXRXCeUgEAWMgbS zKwddgZFcDPFQYEY96vXyNZb0FUY8u4YBFxp/wDPw1BvIBYYR9pvpH/nhdFcJ5mW4ZVlSGRtLL77 EY7H9grBgcO4q9fKrbHL/mu9cDT/AF8GObWYZrUbkj/zwuiuE85FaiATJpJmU7E6I4OmdKE06ETp QmiNAg+S9Wqw2eX/ADX6+eRsqQrljom1QfLV4mq9k3JhdFcJg6qDNWnnzrsLvlpQ1veihFXQ1/zw mjE4o6meExTxTDab/o+BJ85PCVrJpEObE1Ju43DC6K4TCmhMbRShhju9qRMvkIBBRloSi+4iXQxu RqdVpjFNHMvmzCsxr5V86+VXarmr1mFZhVx5SQAS0tKoUeckAQgnwY2ExLGNQoxH+Wow+iuEwiAQ 0RRo3vjO5uiBfOyqwyOlLKpr3qTQJmGrkgpZVcWc1lrItZFoADCKg1ZxWY1momQ1+QJwXJkYAAVI 92jF2AsMSD5TYfRXCYhjBoNbEZzSIFwnjV6tLHX7oaMX6g6WbTVBq45TtbyFiiBBUkgRQCEjSwxJ Wyx6Rfjh9FcJikA0SyUrq2CWLFVGGWCj5tRgjNXljpJEep9NFOE1MumcEEbOSACzylEVBTMFABkf LvAti6prLEuWPD6K4THaKldgQwPmJLGwFe2HbyPEjVeWOj+M6j9dAySJIviSBX6pWdqvJV5a/rX9 avJWY1c4HtRlBoRM9AAeBIAYlyqhRjN/XUYnRXCbAyBquyUDcXHiSSdygC2xPErV/VAAIHTUKazN WVzX5JVgPJlFZWq8grOaz1nrPWc1nNZzWdq/qa/IGgAB4EgBmzFEtjyNlTSrc4nRXCbD70YypEik 2IotegAAN+ytGj0dO6UJHiKSJINkZgoZi5RLbBq2ssK5UxOiuE2NkVgVkjqOeKSrG4IOz+9Np4yQ 8qvmYUJFOwFgKZyBvdlQLsLf01GL0Vwmyy6aKWjHrNPS66K6uCL32aR8ixJlFMitRSRK/YCgythF lFZjVmNM6pQjZyAANgY2XTrvxeiuE2d40kDaEIVm1URi1kMh2Qf0cb/IQDRhjNfk4q+oFfpIKM5B /ev2r9TWcmsy0HFGUiv7vSRqmxyH4oLLi9FcJtLIribSBgramAwayGY7DIxJtsFr0ABsp+T43RXC bXIisraT9I0n1elOn1mn1AxnbKEFgosPRGNhGN2N0Vwm1zG0cQtG8aPU/LbtHrp9OUlSRcRvkyi/ opNMczD2xuiuE2sgGvbxkijkD6KfTtp9fHIwar4LtlCL6KSAMxNKN+P0VwnoOo0kOoFtVpKj1cT0 DcAjzHdQvI4Fh6GzBRvbwUWGP0Vwnocukjeik+nZNSGpSCM3klJJRQo9DeQJQBYlxdFOw9FcJ6IQ CGgUgrkbPIgWRWrNRNgi29EeW1XC0BJJSRqmxdFcJ6MQCPyZCyq1ZJVr9VuG9CuBUupW6LKwSFVr 22PorhPSioajDai8iUsitV9ttUjogyyz1HDHGPD3bYuiuE9FmkeOOHU6qUIXK+Vo42rLKtCUCgQd p9qMgpi5pIVB8i7H0VwnokupdZdTqtZqE0pfTxyaiKI+W16y18qKrQJFZjQIOyFgKu5rKKsTQAHl O8AWGxdFcJ6HzDWTy6lNJDptXCywPXOA/wDzaaUTQ4BANZFrIa+YrMRWdauDgXFXFZlrMtZ0oyoK /S9fI0FIq22dFcJ6Hy8yRz6tGDrLFO4gKF4w4iWMDFsKyrRVAcgrJX5isgr81r81rIlfmlZFrItZ FrKB6B0Vwnoet0p/LTzpqI5dKjlf+gB4ppalJFRtnTF1WrWAabTygvIyAEEek9FcJ6I2mX9B+lst 6yKa1T5gi5ExdSSzxTrY2K6OXOvpPRXCejuhcRxJGMb5QzEKwaOJV5fGUh9J6K4T1cICRCgoxAgA Aek9HIq6T1g5a+FC3pX/2gAIAQICBj8AIp//2gAIAQMCBj8AIp//2gAIAQEBBj8AxF9iX3rHXd85 gF2WgQgD9TXWrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mc tcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsR tM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlr jYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNp nLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcb EbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5 a42I2mctcbEbTOWo/mxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xs RtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zl rjYjaZy1xsRtM5a42I2mctcbEbTOWuNiNpnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWuNiN pnLXGxG0zlrjYjaZy1xsRtM5a42I2mctcbEbTOWtX8uIhq6vuZRHW/8AGsZ1Dt1v/QIFQplI5RjO odut/wCgIlEmuiUYytx+QyjGdQ7db8fiVH6RRnlXXn0XfpbpryjGdQ7db8ez2KLvbZKi7ZxHzDML UGiqvKMZ1Dt1vx2DaazYo1W2ypcUb69me6YCwWZTjOodut+OQbRWVAe39ZXOV+S89rfaP3Qe/wD2 tsR05RjOodut+KzzKmOhTAnwXtK9pXtK1Q0wrKhquA0KEYeC9y9wVR8VPMpjHvxKN872NmaP3Wsf YKBatCdpyjGdQ7db8LnUC6JsE5UzXHwXrGrpIUGmJIjNOq/JV+XZT2TiKo7KFR2TRCmcqip2/upw BpCoCmiNBUWuj8j5rVeI51Fpj3Rdt9z5ggwUClQBmCzqevKMZ1Dt1vwiEYmwLVjrO+1nqPyUABdj +07vIKcuvDno8gmkQaIzwU5J+SmaEXsaA42ZDQvS4jSpwDoUHAg50HNmdaFB839qu0k0BG+dXMwZ lmrQAmBoNsOyGfKMZ1Dt1vwWJmCIadcimFA8V6B6LfazzpK9bi/+jfSz+SoTMbY1URNpymdTTHMp jHSvUCB8lYvxj2id5/ZQ8goH6qkGkRATHN9M8D45TjOodut+Cal3/wAt5WBQNJoWs86l15N8qSvS 03jvudQNAUXmOapQAhl0DOETdHVNlS1XCevOoj3fNFxqQJ9JsKz0jKcZ1Dt1vwLV997VdtnPjYpz +O5FLWmbxfX4L0N1j9zhBo0BRedY/JTfAoOEQosdDMf5QZetg2M7qvNAtnblWM6h2634BrXjoCoV nQEWXAN0IVe+Gc0NUSNZ9Y+mNs9Ki6c1Cr4PA0LXuvTa0UFWOsUHTZRjOoduty6JMAKSUfwAaopv ne3wFa13F0/1u97tH2hQhBv2j90NSaH7/CoiYqdTThTZNjOoduty2HueaGilD8x1nH23Df8A7IF8 HOFDR7WrP8Pi2YqD5jkuM6h263LNUTE+a/HdAflNJphpKMDrOPvvDSVAfEYFTepqiMjxnUO3W5X+ O6931OqCN1czv+u8NS/G2ikvrJQaTGFeTUhe4ea9w8woaw8wpnDzU2U6zJjYtV0zsixnUO3W5UXU Z7ELvDx9Qi55qQYwTVm1QyCcqYEqoKd3kp4lQAnNa9cXZqAvYPJTNA8FGAReQIVIvLBCqZTMA0TL 0ve3/cSFNex0gKhr9BgoXjTdnOJvNRBiMliJnCtaj5nDIcZ1Dt1uVC5ZO+8cBoCay79oAicgg2cr 1GAsCt7sLB3Ay2nQhdtmthYoNcqip2qhUkFUhwzrWY0ttAnaVTA2HJdZvuC1Xe4ZBjOodutyq6YW x9WsSoDxlZ1ATmxReYCxQHfdo7he6lF5pd3JwpjBVFVjROqnaZipot0TheqcWj+FFpjkf5G0ilA+ cvjOodutymK/I4RIoMrnUyz2yLtA7gYKBOZGcL0mGZeoTrWunarrFq3o1HW1FTZDA0FFhoMvjOod utynVFAUJSJWZQEkf8e0k1LWNLp5OdRC9Y1m12ha106I+1QIgch1hSEDWJjLYzqHbrcozlRNJldR soM7e0NqpMtqiqlazZjWKitZszgoPE4rCmMVPMntYJrswJtlYIsNBlsZ1Dt1uURqErNSaFrGkyjD pHZE1LWrMqSakXmlxj26zaQoiZyGGZxH0u+0Wp122wGNplg8UhA+crjOodutyfVFJWeVh9IlWGxw 7AwfUQFCVdq6E1tg7APHsLm01BF7/VePnLv2CDXUETGWINaLDQZXGdQ7dbk0VGoScOyApdQo1mV0 QQKYc4lSbArpv3GJ7SbJuyKLQY5kHVtWqaKjLB4pQNspjOodutyaFZUbZONQ7P6tliMygmGxwlXn MUx1jRDx7Y29n42e40mxQbNGnSrQiIQIoWqaRKkItNUpjOodutyYBAWSRKjanGszDxWsaXfpLtzz KNhBQMpeaFd/4jsKAU1JoCiZ3Gk9sUHjxUZWNRlMZ1Dt1uTF1k8mGoBNux/qKDRQJpd0KQYhaQhm mlLzQrv/ABHYBaeyNaz2qlQ8+0tlQbEDJ4zqHbrclJ8FG2ThYopzzQMhcw1GZOZ4yj8/8posA7Bm kA4UFREoVCyTxnUO3W5KGBAWSbijnmUbcha6p0xTX1GYygb9zgEB2OPhIEeS1DSKJQoiTxnUO3W5 JFF5qkycyJTWBBtgyGNbTFaRMp6RMZO5Znie0m0yBeaAm3godOoivJ8Z1Dt1uSBjaTSgK65M9kah kRFoQzTIipwj4ybnVMEBpk7z/Eq7dWGj5IZppQGTxnUO3W5HFF7vCUK0qNZyN7bCmv8AtKjIvBpY i40uMewoaJC9J+2HmmA/ZH904Sgk8Z1Dt1uRRKzKEq1gQFmRvRGZDykYVXgh4oCzsKbIXeFb/wBw xfmaEQJgGwHknGVHhJYzqHbrchiVCholgtY5I/w7HNsMjrD3MOsEHCvsKBs75K/JD1uE5RFZQtM8 q3QJLGdQ7dbkESrGqAlgMlebex1sjBOujVO3Qe0hDvEKFiAFAQFkq3QJLGdQ7dbLxK1nzNqCmmEu FmGR6Uew/wBhJMvR9Jg7Qe3Si3vwrKiaTKgJo0SWM6h262Wz2LWfOagtZ1FQyDVb4qAyOFiPZd6Z ItNYWqfcwwPaD4Hvx+kSwEnjOodutlc6m9Tz8lrPndkGq2krOackjb23emTIqeI+I7SFHuwrKzmc yxKJ0yWM6h262UitVniVNTWcgzmhaxpOSQtmUO27GeMmy8NToefchUe7GoS5KcZLGdQ7dbKfjZRW VAeJyCJWu7wyUCyfuMMm4IRpbMe3OO5nKia55c55lG0yWM6h262T/GzxKhXWcgiVrGioZMcw7jBW TJkK8ZbBw8e4bOyJUT7W5AGoDNJYzqHbrZLUb7iv7Gk5BOomizJ3dxo+0RlGWObDvQFJQtM+QASe M6h262Rzmha7vcaMhifLKHdy8Nk0pcv/ALQPaUOxrcgzBFxk8Z1Dt1shErXdPYMhicpd3HutdKa3 2uBQNo7Ch2aJcurKzlASeM6h262QtsChXXL56gtZ/llR7ToXiZR+hMNrR2AWntPjLBqDBVK4zqHb re9Er9VrGky8BO6xazpzlZ7jmGoxlH6CrvR2NFk/afGWJsTrx5gAgRXKYzqHbre9NQJhpU/tbTpl 9Vs7lEzuyo9h7jhmEo/QUzR2E2CGQ6qusE32sGve+FUrjOodut7s1JmCmpMw0oNrrltVtKiZ3HLT 3H6BKP0JmgdjnWntBliagsbfGfVIaPEn+JXGdQ7db3dUUM/VE/SyYaa5WJWqKSomk5Z495+gSjtC YMwRKA7QUDKvOYrE3lbr0/IR/eVxnUO3W9xzq6kXn3uo0lAV1ykKgs6OrRW/+Mt8e8c7ZQtFJQFg TW2nuEKFkq4Zir9lYvT+glcZ1Dt1vcbdiitNux7buc6ZQlF5X/rXBmbPevqaLEGtqy095htBEoXV RAHYTU0Q7uYypV4W+y9IPjK4zqHbre0lXl6agnXppeflKAWqDJ7x3pYM5rQBnvX+q8dWScuKGjus f9pk3HMmtOnsJ+492NiBlCjmn8kDaJTGdQ7db2htqDRS8/qmtsEoBYrth9jPVDMMvItQ7pCEkxn3 O/TsKaM47pCLZQFQNaDbJTGdQ7db2uFgh5q5ZUJzKkClxgFiHfaNUfAHNsMfPvObYYyTG/aCeyC0 ToHuwt/eUBlsZ1Dt1va91rv0WtYEJS7bnisU61/7mUiJxkgP3Td5rqnTGSOZvaRaoGls3da5RtlB K4zqHbrewlE2uJTihKN0FYj/AD/mT/G2k0mwINFAySIqnCBt7phSJwg60SLv8e4RU6cd3QUJMhES uM6h263sdoKGlOOcISjDpHmsSP7/AMyZJnJpPeMaKpeP0GnMi2qkaO7BOuzS0/KR0t7geKWn5KIr 7hGZEWGULbZXGdQ7db2O0FDM6HzT9KIslNcVThYhpEzvUD8AgaCgD7fpP7d4OqeIHTIs15gYgGru QNaN2aRRo7rm/wCppQOlcZ1Dt1vbeN+16dn/AIRbbKEeSLD4fAS0r8b6RQbR3Yils4QNokACIzr8 V4Zj7HW5u5rD3ChWGsdyFp/WUjYgZTGdQ7db23939w1gvJNvAgRXKa7fcFP8BsIoK1XTOHcgoAxh IlrvA2L8N9T9Lvu7ms2n9VYax2sf/qZRkyERZKYzqHbre27vqva7QU5tiJsnQtE0rrD2mkIGlpUR 8AsIoK1XTOHc1vofMcxktU01Gwr8N7M8UH7h3I19odYf1TTmhKOEpjOodut7XMNYm0oB1PtdpCIN addmv9pWBoWqZ2FRpYVEUfALCKCtV3uHaWmgrUfQPa7NJQMzh7XCkFfivpn1Gpw7kVFELVOmU0ym M6h263uC9b7X05nIOtp0oPFBnURXKwK1HTtK1mz3ZpCi0/AA8Uju+gwzGheoQ+YkYOpFBFIK/FfU /S+p3ch4rxTXVGUB0frKYzqHbre4WOroOdG4vJjR/BURS2dQrbNLTqBnC17v21tURTWMvDayZu/G MDap5AtcJl+K8MT9LrR2grxQNYQzSYKEnjOodut7usR6hWKUbt/uHzCLD7TkP5LqY1hQMzrMthdj WPy81rvMXfISGeuRnpE4NinpFPb4oKaTCGiTxnUO3W94ETWFa4HqbSv7NpyGImdatS8mNuTTlTTq Zvn2TAk+QX/IYj7alATCRhU6fxkToQNvaBnTdEoNKbok8Z1Dt1vegVA0/qELxvsd/qCDmzg0ZDAq B9TFEZDNOrFOSphLtd9pkSFCwkdobmULJQaU3RJ4zqHbre/nqRu3o3N57DQcjiyY2LVf6TnolZhk rkDmkXf5HthZCVGlN0SeM6h262QiKVD6hQV+G8pFEcjg4RC/4XkZjOFC9u4j7mn9lPEaQvcPGZTG PcmVOUO0IaJAlAV0ntc7NGVaE3RJ4zqHbrZL8jPcKYLVd7hTkUBOV6jP2RYfBQvGiOcKIEM4MF6L wiwGcL/nu4t+9qixwOavKoD2NpNpkW3dVLu1x8AnPNYlWhQk8Z1Dt1sn+RlFeQ6rZ3FRM7jX3IFR YfAqDhqlWha92TdXlTmrVxTNe7FF8yfzC17twc20SEwVSqVSoVCoMhEmAUGzMrdboUBMBIEmgI3h pdRo7Ipt2NJ0qaigeEqBYR8pTGdQ7dbJwK1mUWKBpltVs7v0VpNJ78CIqLDEWFQPpdYew3mHcbm8 tb7TpC1cY3VFV632nTYo3fqBoIoU5hoU5J7KFNJzGOlTtKoKmAbnKi86xz0SX42+0e4qAoHZqiqc ouUJVztMpjOodutlYiYqDqbZTVbTWbFGsyU4ntU3rb81D6vtrRF8ItP0VLWwbotruXUf7StRw/He iljqcs/Hd01usUB4nsjXUon3vWj9ZVxzIutMJTGdQ7dbLTq1qmMjqt8SoCgScSvtHzUYer7q1P62 /NTGexDWEHj2vEzh4r8WK9TPpvf/ANIEGINByiJmChdzMrd/Cg0dkSou9oUTTLBtqaM0pjOoduty CLZioHvwbRWVqtyCNBtCn9bba0WOnBqKnjeYU+bEHsOs00EdydQB1jmnUzD+imaPEqcN8z/CpCob 5n+FO0eBXtKokYMGuc1Hmo3pj/UUKAo7IlfoFCXAqH7SuM6h263Ic9qg8RFqiJx3NUeJUB4LPkUa DaFBw/Iz5ovuTBh9zDUdCAIIJosOgqZvmYL1Ohmb/wDKnGtpnU3dmd5zqdoOg/yvafkva7yXtd5L 2u8l7T8l7D8l7T8lMw/JUBvzXrJdpoUBMO2JUT7ahaomk/KXJTnnQJXGdQ7dbkcbswzLVeNV2dTT rVEx7InwyX1DxUGHWYfod+y9QJbYaRoKiwxGSxNCzVC1azqf0yANFaAlcZ1Dt1uSQcIr0HWFhUIw dWCrQMp1m+h/3NmQZEPNZU7fJQjA2HIJ1RDSppz8go0m3IYVCWxnUO3W5NFzfVU4THzX/C4X139j 5neYWrfg3L/7CbzUWkObaJ8njXUon3HsnC9BiLCvWC0/JTGMlOVMI/JTmGYKAncfNRfMLFACAyEl FxlsZ1Dt1uUQeAQta5JYf6mCg4C8Gy7+FqR1X1sdMcl1j7W0KNVXcnVEDmmXovDoM6oa75Ke7PgQ uG5cN3kvY7yXtI8FPHwCocVMw+SmaSbFUxvmVNObTkcLZfGdQ7dblXqEVRrgURpGgr0O/Iz/AMb/ AHDQ5ansvBSx0xyIXbaTSgwUV5DNksKhL4zqHbrcsOsFH3WWjQVB4N9dDbH8qN26etpmcPDINc+5 1Cz1/BYqNsvjOodutyxxzJozL1BfkuTqvtExX48W2I+/+UHMMQaCJXVqE7lrHwHwaGQYzqHbrcsg e5qvaCF+TBOm+q6dQUbt4N1fCljl+8lGs0BT+JtPwWJUbaMhxnUO3W/AvWIOFDxSF6iby7H1D9wh H0k11KInHfio1ChQ+CRK1nTNqCz1BZ8gxnUO3W/BIt9DrRR5KI9vyUHiBtUWmIU83cDBSaVD4JPT Ytd/gFaagtZ1OQ4zqHbrfgsDOFNMRQVB3/G6pw9pXrGs37gvSfAqdRRcfcfgmq2dyi4xcrBapqbc ixnUO3W/B4ERCjdOgPtNC9bNU2hek67bCoOBYbDQv3+BTrVYY6FMNQGs0qJnNpyTGdQ7db8LgRFR u3Fuapets33BTGP65dSokmNinGoz5r0ie3t0ZHjOodut+DFzGG8cKGggR81EXTRCn1zR8l6wA6sA xHenGqbRMpjriwqD2lv6KYxymdQaNYqEYZgounPdJtyPGdQ7db8F/GwAVRM5J0BfgwrHRdM9+q1u q2v3XiZcuuLwVaw1T4mDymh5hrmA09+YwVAKnaWm0KZwOYqceU+TTCGcr1HWKsCm70MjxnUO3W/B G/8A83BHVvXT316P+23+VcMYCXQJc9xi5xtJKdd3g1XOMQ+p3j2NLBFweCE19cJxYZGcKzQpnHxn VRU7T4TqzSpjI0qkKkL3DzVPkvSCfBTx/RUAKfLMZ1Dt1vwQ4h/Fxd6QSamNqHmrvENETdH1D+pT rsgECBEa4qN28tH2mcL/AJSC1s6iwQ1pehQJgTROq/NUnzVJ81SfNV+aoVCoVCoVCo+AYzqHbrfg jX3A9dy7XaLbQg9v+5tYNhQew/jvBQ4fuoOLSbZwoXjw27rDaT4rWu5m3YpTXWiMtBoL7w+1o/df +xiHa166qposC1iItrIQIoPwrGdQ7db8F/LdH8bzTCg6QvVCOZTzqcIYe6nc73QoaE1tghLC7umg 3tJJqC1b06rxSHTeSNYTm1NJA+FYzqHbrfhENYgZplBghaazLi9eYB7oHQpwCETqgQFIRJ+txI0f CsZ1Dt1vxhxeIxojYvS4tFgKgXOIsJQaJgKvhWLDXtfHEGdsZvSPuA+Mz9k3wr//2Q==",
    transform: "matrix(2.5063 0 0 2.5063 1048.7313 77.3324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2076.8403,
    y1: -230.9262,
    x2: 2023.0259,
    y2: 2215.1868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8BCE8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#466200"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 4096,
    height: 2160
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2895.32,0l-34.41,115.32l-40.25,55.12l-26.98,68.42l-36.2,45.55l-75.67,104.2l64.74,74.28l59.72-69.52 c0,0,71.07-48.35,95.38-63.13c24.3-14.77,78.11-37.27,93.01-60.86c14.9-23.59,66-71.76,92.32-91.03 c26.32-19.27,116.13-55.71,130.84-63.04C3232.53,107.99,3451.73,0,3451.73,0H2895.32z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_53"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "2867.45,122.72 2977,150.44 3073,136.58 3151.97,145.37 3450.14,1.57 2880.23,39.33 2867.45,122.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3085.39,179.93 3034.29,187.75 2915.06,216.55 2828.01,216.55 2926.19,251.9 2985.81,279.72  3041.21,229.82  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_52"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2686.29,390.18l105.18-138.28l30.54-74.41l45.45-54.77L2897.26,0h-16.34l-80.67,183l-10.57,33.56 c0,0-10.44,20.91-20.91,35.35s-31.71,39.98-35.03,52.76c-3.32,12.77-53.53,85.53-53.53,85.53H2686.29z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_13"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1919.0566,
    y1: 1447.3809,
    x2: 2638.4507,
    y2: 1447.3809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C5800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#748C00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1919.06,1642.58c5.04-4.76,59.43-79.93,59.43-79.93h103.23l108.7-36.32l139.35,36.32h68.13l55.74-92.06 v-83.61l30.97-41.43l17.8-149.63l36.88-118.58l77.2,226.03l21.96,282.32l-136.04,168.88l-150.72,62.86l-325.01-62.86 L1919.06,1642.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.0646,
    y1: 1422.5905,
    x2: 1444.0968,
    y2: 1422.5905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C5800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#748C00"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1444.1,1606.85 1227.32,1585.69 1162.29,1538.72 1091.06,1489.17 1091.06,1423.45 1091.06,1281.69  1143.71,1238.33  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 1087.0905,
    x2: 2102.1614,
    y2: 1087.0905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828B35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979200"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1437.9,374.33c0,0-9.29,144-37.16,162.58c-27.87,18.58-173.26,144-173.26,144l-105.45,185.81l-106.84,106.84 v260.13l-83.61,315.87l171.87,222.97l297.29-51.1l111.48,51.1l-39.48,139.35l-174.19,41.81c0,0-23.23,55.74-9.29,60.39 c13.94,4.65,65.03,23.23,65.03,23.23l-4.65,78.03l-4.65,19.52H673.5l-364.37-733.94v-364.65L0,368.3V116.89l673.5-77.55h375.23 l-38.18,172.42l-78.97,74.32l-51.1,97.55l-41.81,41.81l-27.87,157.94v204.39l83.61-55.74l106.84-162.58l60.39-167.23l165.84-167.23 l219.71-41.81l288-9.29l199.74-41.81l167.23,9.29v51.1l-102.19,27.87l-51.1,100.8l-139.35,145.39l-27.87,120.77l-227.61-111.48 l-32.52-154.68l-23.23-59l-69.68,18.58L1437.9,374.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2013.129,
    y1: 1079.6178,
    x2: 3860.3547,
    y2: 1079.6178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828B35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979200"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2125.39,2051.24l213.68-102.19l88.26-134.71l260.13-51.1l116.13-78.97l148.65-69.68v-157.94l-195.1-111.48 l-176.52-69.68l-33.97-60.39l303.39-137.77l102.19-136.29l37.16-111.48l148.65-102.19l-78.97-167.23l134.71-125.42l139.35,55.74 v-55.74l41.81-103.58l47.56,29.26L3580.87,0l279.48-0.76l-257.81,256.28c0,0-216.21,344.75-218.32,351.08 c-1.53,4.59,193.55,89.81,193.55,89.81l114.58,172.26l-182.71,63.09l-204.39-116.13l-209.03,125.42l55.74,301.94l130.06,120.77 l55.74,278.71l84.73,97.55l89.47,419.99H2013.13L2125.39,2051.24z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1626.03,2160l-46.45-187.73l30.19-125.15l-30.19-95.49l30.19-102.19l-30.19-192.77l-48.77-81.29 c0,0,2.32-81.29,0-88.26c-2.32-6.97-58.06-88.26-58.06-88.26l37.16-85.94l69.68-35.58l60.39-38.74h118.45l104.52-27.87 l88.26-125.42h141.68l65.03-72l46.45-109.16l27.87-34.84l-32.52-185.81c0,0-18.58-225.29-16.26-234.58 C2185.77,239.62,2262.68,0,2262.68,0l331.35-0.38l-108.65,274.84V381.3l44.13,253.16c0,0-34.84,141.68-34.84,153.29 s0,141.68,0,141.68l-32.52,76.65l-278.71,155.61L1993,1138.46l-58.06,37.16l-62.71,41.81l-85.94,37.16l-58.06,113.81l4.65,134.71 l9.29,120.77l13.94,139.35l-18.58,51.1l20.9,65.03c0,0-20.9,53.42-16.26,76.65c4.65,23.23,93.68,203.99,93.68,203.99H1626.03z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1666.51,2146.44l-50.54-190.83l27.87-122.06l-27.87-59.11l37.16-102.2l-17.81-130.06L1615.97,1440l7.02-23.23 l39.44-213.68l63.48-103.74l140.9-60.39l109.94-103.74l147.1-17.03l72.77-97.55l63.48-167.23l-30.97-171.87v-99.1l-3.1-157.94 L2278.68,0l267.87,12.39l-69.68,150.19l-66.58,261.68l20.42,27.22l67.83,181.81l-32.42,312.77l-269.52,117.71l-190.45,11.79 c0,0-243.1,93.46-247.74,99.66c-4.65,6.19-78.97,116.13-77.42,122.32c1.55,6.19,14.69,150.85,14.69,150.85l3.36-27.42l53.18,175.41 l-40.26,78.97l-29.42,99.1l26.34,6.85l34.05,79.86l-30.3,114.58l109.27,170.71H1666.51z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2036.1393,
    y1: 13.7197,
    x2: 2152.5056,
    y2: 2140.8982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B88F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#D8CE6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6899,
    style: {
      stopColor: "#D1E288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#728D67"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1669.84,2160l-51.99-194.05l28.3-118.53l-28.3-63.41l50.68-171.1c0,0-60.4-151.74-50.68-161.03 c9.72-9.29,50.68-241.55,50.68-241.55l61.85-90.02l132.55-52.6l123.87-110.54l68.11-8.58l73.57-8.12l71.34-104.73l62.13-167.23 l-31.16-170.32l-3.1-241.55l37.16-185.81L2286.94,0l273.55,0.14l-78.87,194.58l-71.23,226.06l71.23,222.97l-21.68,315.87 l-267.59,130.72l-89.42,8.52l-122.55,10.12l-88.03,67.43l-130.06,58.44l-31.9,74.58l0,0l-27.68,44.73l-13.19,107.8l41.35,129.29 l-28.15,203.61l28.15,90.58l-28.15,97.16l28.15,50.37l72.47,127.04H1669.84z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2313.22,1939.62c-0.67,0-1.33,0-2.01,0c-132.3-0.39-245.6-39.38-250.35-41.04l-2.3-0.8l-119.94-49.07 l-10.06-7.85c-97.84-76.35-195.06-117.52-259.38-138.62c-68.22-22.38-115.21-27.65-118.78-28.03l-19.87-1.57l-16.76-9.71 l-139.04-77.25c-73.38-40.07-130.76-86.57-170.54-138.19c-38.74-50.28-61.47-105.73-67.55-164.81 c-5.29-51.4,2.21-104.72,22.28-158.49c14.89-39.88,36.76-80.1,65.01-119.54c45.78-63.92,93.09-104.86,98.34-109.32l2.08-1.77 l1.65-1.24c2.17-1.69,45.49-35.71,94.8-93.37c44.72-52.3,104.01-135.73,132.52-236.2c20.59-72.55,65.39-134.53,133.15-184.22 c49.01-35.93,110.15-65.26,181.74-87.16c100.09-30.62,193.19-38.25,220.05-39.89c68.23-12.72,136.3-16.01,202.43-9.78 c55.07,5.19,108.88,16.95,159.92,34.97c67.53,23.83,113.29,52.7,133.31,66.75c16.29,7.63,46.63,23.36,80.12,48.25 c64.92,48.27,112.72,109.48,138.22,177.02c18.4,48.73,25.55,100.85,21.25,154.9c-4.65,58.4-22.84,119.5-54.08,181.6 c-65.48,130.2-47.14,241.55-25.9,370.48c10.66,64.7,21.68,131.6,21.4,202.27c-0.33,84.07-16.99,160.3-50.95,233.06 c-20.42,43.77-47.41,82.12-80.21,114.01c-29.97,29.14-65.08,53.13-104.33,71.32C2467.45,1925.06,2394.71,1939.62,2313.22,1939.62z  M2123.48,1724.45c27.08,8.74,332.41,102.14,422.86-91.68c50.64-108.52,33.96-209.78,14.65-327.03 c-23.14-140.47-49.36-299.69,43.17-483.67c36.15-71.87,44.71-134.76,25.45-186.91c-30.33-82.13-121.27-123-127.19-125.58 l-13.75-5.31l-8.84-7.85c-4.43-3.26-39.38-28.17-98.06-47.78c-82.67-27.64-171.69-32.46-264.61-14.32l-7.14,1.39l-6.85,0.24 c-2.39,0.11-91.23,4.39-184.12,33.35c-73.53,22.92-165.8,66.51-187.78,143.97c-68.91,242.84-262.92,402.42-290.16,423.88 c-6.55,5.85-39.13,35.81-69.14,78.53c-26.57,37.84-57.04,94.32-51.28,148.49c6.09,57.29,54.18,110.88,142.92,159.29l0.63,0.35 l123.89,68.83c62.7,9.41,252,48.5,443.88,194.41L2123.48,1724.45z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3__x28_\\u043A\\u043E\\u043F\\u0438\\u044F2_x29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1374.71,1585.69c-5.91-3.23-11.72-6.5-17.43-9.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1324.15,1555.4c-49.63-32.65-89.85-68.81-119.97-107.91c-38.74-50.28-61.47-105.73-67.55-164.81 c-5.29-51.4,2.21-104.72,22.28-158.49c14.89-39.88,36.76-80.1,65.01-119.54c45.78-63.92,93.09-104.86,98.34-109.32l2.08-1.77 l1.65-1.24c1.17-0.91,14.23-11.17,33.73-29.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1373.76,849.42c4.49-4.42,9.2-9.17,14.07-14.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2754.51,1345.54c0.93,6.58,1.83,13.18,2.68,19.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2761.58,1405.19c2.16,23.83,3.45,48.06,3.35,72.75c-0.33,84.07-16.99,160.3-50.95,233.06 c-20.42,43.77-47.41,82.12-80.21,114.01c-29.97,29.14-65.08,53.13-104.33,71.32c-61.99,28.72-134.73,43.28-216.22,43.28 c-0.67,0-1.33,0-2.01,0c-89.28-0.26-169.91-18.1-214.37-30.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2077.58,1903.92c-9.86-2.97-15.72-4.99-16.73-5.34l-2.3-0.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2583.92,343.42c4.82,2.26,10.88,5.23,17.89,8.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2637.99,373.6c8.32,5.38,17.07,11.39,26.05,18.07c64.92,48.27,112.72,109.48,138.22,177.02 c18.4,48.73,25.55,100.85,21.25,154.9c-3.72,46.7-16.1,95.12-36.88,144.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2778.14,887.18c-2.78,5.99-5.68,11.99-8.7,18.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1526.83,634.76c2.72-6.04,5.36-12.16,7.9-18.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1549.29,576.15c1.4-4.43,2.73-8.89,4.01-13.39c20.59-72.55,65.39-134.53,133.15-184.22 c39.79-29.18,87.59-54,142.47-74.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1849.14,297.46c6.27-2.09,12.62-4.12,19.05-6.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2604.16,822.06c3.06-6.09,5.92-12.11,8.59-18.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2626.35,769.1c16.51-50.14,17.63-95.04,3.26-133.95c-19.15-51.85-62.45-87.25-93.27-106.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2520.26,518.59c-9.69-5.39-16.38-8.38-17.84-9.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2123.48,1724.45c3.06,0.99,9.69,3.06,19.17,5.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2182.59,1739.88c100.02,21.39,294.63,41,363.75-107.12c34.92-74.84,37.83-146.22,29.94-221.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2573.91,1390.56c-0.83-6.57-1.73-13.18-2.68-19.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1516.37,968.38c-4.85,4.97-9.57,9.69-14.12,14.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1471.44,1011.46c-14.57,13.04-25.29,21.72-30.32,25.68c-6.55,5.85-39.13,35.81-69.14,78.53 c-26.57,37.84-57.04,94.32-51.28,148.49c5.23,49.14,41.35,95.57,107.53,138.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1446.22,1413.58c5.62,3.31,11.42,6.6,17.4,9.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1919.06,469.29c-6.22,1.94-12.56,4.02-18.99,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1861.17,490.83c-57.78,25.57-113.46,64.54-129.89,122.43c-4.2,14.79-8.86,29.26-13.91,43.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1710.04,676.25c-2.44,6.24-4.95,12.42-7.54,18.53"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1147.58,39.33c9.29,0,57.29,32.29,57.29,32.29v76.65l65.03,85.16l-103.35,229.64l-117.82,202.75 l-154.31,66.19L772.87,868.66H673.5l352.53-829.33l9.29-45.9L1147.58,39.33z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "0,430.14 81.87,527.55 255.52,709.59 485.65,824.48 556.48,889.95 744.74,885.3 604.1,513.73  161.48,71.91 0,-4.47  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_25"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.0896,
    y1: -111.4291,
    x2: 483.5195,
    y2: 1397.6667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B88F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#D8CE6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6899,
    style: {
      stopColor: "#D1E288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#728D67"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "673.5,868.66 768.05,868.66 894.42,732.01 1048.73,665.82 1180.54,423.55 1261.41,240.43  1203.35,156.77 1203.35,77.33 1034.96,-4.47 659.84,-4.47 0,-4.47 0,116.89 72.23,323.12 420.61,739.72  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_26"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1183.0856,
    y1: 685.6578,
    x2: 1161.5979,
    y2: 872.4811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1125.13,785.43 1141.64,718.07 1194.03,694.78 1225.3,722.72 1180.54,763.64 1157.72,803.84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1173.5548,
    y1: 685.803,
    x2: 1155.4608,
    y2: 843.1196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "1203.71,714.59 1186.29,726.59 1163.45,757.95 1146.42,784.65 1129.39,778.85 1141.64,718.07  1194.03,694.78  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.8454,
    y1: 874.7668,
    x2: 133.3577,
    y2: 1061.5902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "96.89,974.54 113.4,907.18 165.79,883.89 197.06,911.83 152.29,952.75 129.48,992.95  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.3145,
    y1: 874.9121,
    x2: 127.2206,
    y2: 1032.2286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "175.47,903.7 158.05,915.7 135.21,947.05 118.18,973.76 101.15,967.96 113.4,907.18 165.79,883.89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1710.3781,
    y1: 259.2626,
    x2: 1688.8904,
    y2: 446.086,
    gradientTransform: "matrix(0.9485 0.3169 -0.3169 0.9485 190.067 -522.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "1643.56,341.3 1680.56,282.65 1737.64,277.15 1758.44,313.57 1703.01,338.19 1668.63,369.09  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1700.8473,
    y1: 259.4079,
    x2: 1682.7533,
    y2: 416.7244,
    gradientTransform: "matrix(0.9485 0.3169 -0.3169 0.9485 190.067 -522.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1740.54,299.01 1720.21,304.88 1688.61,327.38 1664,347.31 1649.68,336.41 1680.56,282.65  1737.64,277.15  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1447.8612,
    y1: 403.9176,
    x2: 1442.8982,
    y2: 447.0681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "1433.17,423.55 1444.1,405.3 1458.03,423.55 1444.1,431.45  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 2297.5762,
    y1: 1032.2339,
    x2: 2291.3325,
    y2: 1086.5171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M2271.71,1064.45c0-1.85,3.2-14.44,3.2-14.44l18.09-6l10.04-7.75h9.7l6.19,3.1c0,0-12.39,9.59-13.16,10.99 c-0.77,1.4-6.97,9.53-6.97,9.53l-20.05,4.56H2271.71z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_17"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 2859.3225,
    y1: 765.7373,
    x2: 3328.4839,
    y2: 765.7373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st31",
    points: "3193.77,1111.36 3274.29,953.43 3303.71,1064.45 3328.48,815.62 3193.77,694.78 3169,498.98  2993.06,355.08 2942.94,412.34 2859.32,498.98 2955.32,743.24 3158.16,889.45 3126.8,1176.4 3193.77,1111.36  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.8708,
    y1: 1095.2283,
    x2: 3274.2903,
    y2: 1095.2283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2908.87,1238.33l217.93-42.42v-19.52l31.36-99.06c0,0,116.13-118.07,116.13-123.9 c0-9.29-148.65,34.06-148.65,34.06l-144-6.19l-13.94,131.61L2908.87,1238.33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 3023.4517,
    y1: 743.2387,
    x2: 3193.7742,
    y2: 743.2387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "3169,498.98 3150.42,624.3 3193.77,801.69 3150.42,908.53 3125.65,987.49 3023.45,919.36  3028.95,802.36 3066.81,743.24 3066.81,634.76 3069.9,525.27  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 2859.3225,
    y1: 868.6581,
    x2: 3274.6538,
    y2: 868.6581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABABAB"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M2936.74,835.21l15.48,69.98l-20.5,63.19l-22.86,120.75v149.2c0,0,108.39-143.56,111.48-149.2 c0.54-0.98-27.29-47.45-27.29-47.45v-54.19l15.68,48.77l25.55,28.18c0,0,234.53-107.37,240-111.02 c9.29-6.19-162.58-83.61-165.68-92.9c-3.1-9.29-79.67-58.17-79.67-58.17l-55.04-81.19l-49.55-165.64l-65.03-56.55l65.03,293.41 L2936.74,835.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.8708,
    y1: 1477.3711,
    x2: 3274.2903,
    y2: 1477.3711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st35",
    points: "3243.32,1843.38 3243.32,1700.39 3274.29,1567.22 3243.32,1426.79 3218.55,1231 3193.77,1111.36  3126.8,1176.4 2908.87,1231 3004.87,1475.25 3091.58,1700.39 3243.32,1843.38  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 2958.4194,
    y1: 1835.3679,
    x2: 3243.3225,
    y2: 1835.3679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M2958.42,1970.35l217.93-42.42l66.97-84.55c0,0-49.55-68.13-49.55-77.42c0-9.29-102.19-65.57-102.19-65.57 l-74.32,144.54L2958.42,1970.35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 3073,
    y1: 1475.2516,
    x2: 3243.3225,
    y2: 1475.2516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "3218.55,1231 3199.97,1356.32 3243.32,1533.7 3199.97,1640.54 3175.19,1719.51 3073,1651.38  3078.5,1534.37 3116.35,1475.25 3116.35,1366.77 3119.45,1257.28  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.8708,
    y1: 1575.6498,
    x2: 3108.6128,
    y2: 1575.6498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M2986.29,1567.22l15.48,69.98l-20.5,63.19l-22.86,120.75v149.2c0,0,108.39-143.56,111.48-149.2 c3.1-5.64,12.39-95.45,21.68-101.64c9.29-6.19-15.48-58.84-18.58-68.13c-3.1-9.29,5.5-117,5.5-117l-55.04-81.19l85.16-272.23 L2908.87,1231l65.03,293.41L2986.29,1567.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 3766.1418,
    y1: 476.3569,
    x2: 4406.2148,
    y2: 476.3569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st39",
    points: "4222.43,947.89 4332.28,732.42 4372.42,883.88 4406.21,544.42 4222.43,379.55 4188.63,112.43  3948.6,-83.9 3880.21,-5.78 3766.14,112.43 3897.11,445.66 4173.84,645.13 4131.06,1036.62 4222.43,947.89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 3833.7402,
    y1: 925.8786,
    x2: 4332.2788,
    y2: 925.8786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M3833.74,1121.11l297.32-57.87v-26.63l42.78-135.15c0,0,158.43-161.08,158.43-169.04 c0-12.67-202.8,46.47-202.8,46.47l-196.46-8.45l-19.01,179.56L3833.74,1121.11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 3990.0618,
    y1: 445.6623,
    x2: 4222.4312,
    y2: 445.6623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "4188.63,112.43 4163.28,283.4 4222.43,525.4 4163.28,671.16 4129.48,778.9 3990.06,685.95  3997.56,526.32 4049.21,445.66 4049.21,297.67 4053.44,148.29  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 3766.1418,
    y1: 616.7709,
    x2: 4332.7744,
    y2: 616.7709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABABAB"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M3871.76,571.13l21.12,95.47l-27.96,86.21l-31.18,164.74v203.55c0,0,147.87-195.86,152.1-203.55 c0.73-1.33-37.23-64.73-37.23-64.73V778.9l21.39,66.53l34.86,38.45c0,0,319.97-146.48,327.43-151.46 c12.67-8.45-221.81-114.07-226.03-126.75c-4.23-12.67-108.69-79.35-108.69-79.35l-75.1-110.77l-67.6-225.98l-88.72-77.14 l88.72,400.3L3871.76,571.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 3833.7402,
    y1: 1447.2328,
    x2: 4332.2788,
    y2: 1447.2328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st43",
    points: "4290.03,1946.57 4290.03,1751.5 4332.28,1569.81 4290.03,1378.23 4256.23,1111.11 4222.43,947.89  4131.06,1036.62 3833.74,1111.11 3964.71,1444.34 4083.01,1751.5 4290.03,1946.57  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 3901.3389,
    y1: 1935.6449,
    x2: 4290.0298,
    y2: 1935.6449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M3901.34,2119.79l297.32-57.87l91.37-115.35c0,0-67.6-92.95-67.6-105.62c0-12.67-139.42-89.45-139.42-89.45 l-101.4,197.19L3901.34,2119.79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 4057.6602,
    y1: 1444.3412,
    x2: 4290.0298,
    y2: 1444.3412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "4256.23,1111.11 4230.88,1282.08 4290.03,1524.08 4230.88,1669.84 4197.08,1777.58 4057.66,1684.63  4065.16,1525 4116.81,1444.34 4116.81,1296.35 4121.03,1146.97  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 3833.7402,
    y1: 1581.3136,
    x2: 4106.2466,
    y2: 1581.3136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M3891.71,1544.91v84.77l17.42,65.03l23.39,56.78l-31.18,164.74v203.55c0,0,147.87-195.86,152.1-203.55 s16.9-130.22,29.57-138.66c12.67-8.45-21.12-80.27-25.35-92.95s7.5-159.63,7.5-159.63l-75.1-110.77l116.18-371.4l-272.51,68.27 l69.42,313.2l-16.09,89.25L3891.71,1544.91z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.3871,
    y1: -136.6353,
    x2: 397.3871,
    y2: -136.6353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M397.39-136.64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 2926.1929,
    y1: 878.8771,
    x2: 3100.8708,
    y2: 878.8771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABABAB"
    }
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st48",
    points: "3100.87,913.17 2926.19,868.66 2938.82,844.58 3100.87,913.17  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 3193.7742,
    y1: 1047.1167,
    x2: 3303.7097,
    y2: 1047.1167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "3199.87,1140.8 3303.71,1064.45 3274.29,953.43 3193.77,1111.36  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3139.49,2160 3304.29,2039.04 3328.48,1958.06 3450.14,1883.42 3543.71,1497.69 3487.97,1141.47  3630.42,973.95 3729.52,877.75 3686.16,983.55 3630.42,1100.41 3618.03,1260.42 3673.77,1422.59 3692.35,1534.37 3611.84,1899.66  3497.26,2027.17 3540.61,2160 3162.81,2160  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3518.94,2146.44c-3.1-5.4-35.26-119.27-35.26-119.27l98.75-126.58l96-366.22l-24.77-129.59l-48-134.42 l12.39-169.96l111.48-222.65l-99.1,222.65l-12.39,160.01c0,0,57.06,170.13,57.24,171.18c0.17,1.05,19.23,93.06,17.08,102.78 c-2.14,9.73-80.52,365.29-80.52,365.29l-114.58,127.51l43.35,132.83h-46.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3474.03,2105.43 3304.29,2039.04 3328.48,1958.06  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3450.14,1883.42c0,0,134.34,19.81,132.28,17.17c-2.06-2.65-82.58-68.71-82.58-68.71l23.23,1.03l49.55,2.45 l12.39-9.16l16-33.03l-77.94,4.13l-44.6-30.63L3450.14,1883.42z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_69"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_68"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_29"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 2926.1929,
    y1: 895.5543,
    x2: 3100.8708,
    y2: 895.5543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "2938.82,844.58 2926.19,868.66 2938.82,946.53 3100.87,913.17  "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "2993.06,355.08 2993.06,380.14 2980.1,380.14 2980.1,394.08 2951.85,402.16 2938.29,423.55  2930.16,442.44 2924.35,451.29 2893,469.29 2958.03,507.83 2893,488.28 2865.18,492.91 2859.32,498.98 2984.74,355.08  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_19"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.5,
    y1: 1883.4243,
    x2: 1620.6129,
    y2: 1883.4243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M673.5,1606.85l191.5,93.54l114.58,39.62l155.4,52.65h213.11c0,0,80.52,181.96,96,177.69 c15.48-4.27,70.23,20.5,72.28,32.89s17.53,37.39,39.21,55.74c21.68,18.35,65.03,101.02,65.03,101.02H676.87L673.5,1606.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9032,
    y1: 1883.4243,
    x2: 690.8065,
    y2: 1883.4243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st53",
    points: "673.5,1606.85 604.1,1783.87 474.03,1767.51 339.32,1873.49 213.9,1976.5 258.03,2105.43  213.9,2160 690.81,2160 673.5,1606.85  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_64"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 604.0968,
    y1: 1775.5292,
    x2: 688.4839,
    y2: 1775.5292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "604.1,1783.87 673.5,1944.21 688.48,1918.07 673.5,1606.85  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9032,
    y1: 1919.4355,
    x2: 602.5484,
    y2: 1919.4355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "474.03,1767.51 602.55,2065.95 422.16,2071.36 213.9,1976.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9032,
    y1: 2132.7146,
    x2: 676.871,
    y2: 2132.7146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "258.03,2105.43 676.87,2160 213.9,2160  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_20"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.5,
    y1: 1825.1711,
    x2: 1134.9851,
    y2: 1825.1711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M673.5,1606.85l110.98,182.71L769,1861.09l37.16,182.4l120.77-89.81c0,0,83.61-71.23,92.9-74.32 c9.29-3.1,115.15-86.71,115.15-86.71l-230.74-92.26L673.5,1606.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 806.1613,
    y1: 1918.0743,
    x2: 1444.0968,
    y2: 1918.0743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M1332.61,1792.66l-139.35,92.9l-126.97,54.06l-174.64,40.31l-85.49,63.57h309.68 c0,0,102.19-52.65,120.77-55.74c18.58-3.1,207.48-17.41,207.48-17.41L1332.61,1792.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.0646,
    y1: 2029.5582,
    x2: 1526.8279,
    y2: 2029.5582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1516.37,2003.24l-425.31,52.65c0,0,226.06,0,241.55,0s194.21-12.39,194.21-12.39L1516.37,2003.24z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_22"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.1613,
    y1: 2039.0372,
    x2: 1002.8065,
    y2: 2039.0372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st60",
    points: "713.26,1970.35 688.48,1918.07 673.5,1944.21 554.55,1943.62 602.55,2065.95 422.16,2071.36  676.87,2160 1002.81,2160 824.74,2077.33 713.26,1970.35  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.1613,
    y1: 2115.6824,
    x2: 690.8065,
    y2: 2115.6824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st61",
    points: "690.81,2160 422.16,2071.36 459.32,2134.85 445.39,2160 690.81,2160  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_21"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 690.8065,
    y1: 2049.8079,
    x2: 1091.0646,
    y2: 2049.8079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "1007.53,2160 967.19,2077.33 1091.06,2055.88 942.42,2029.56 904.24,2015.62 860.3,2003.24  806.16,1939.62 785,1939.62 713.26,1970.35 690.81,2160  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_28"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 2916.782,
    y1: 1084.9443,
    x2: 2866.1399,
    y2: 1193.3699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M2888.74,1156.27h26.32l11.13-29.42l-17.32-37.72l-20.13-11.8l-13.94,47.97 C2874.81,1125.3,2868.61,1148.53,2888.74,1156.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 3190.5645,
    y1: 671.2702,
    x2: 3072.48,
    y2: 924.0911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M3193.77,685.56c-1.17-0.05-11.84,5.92-18.58,9.22c-6.74,3.3-26.32,10.91-26.32,10.91 s-27.87,63.48-29.42,68.13s-27.87,48.25-27.87,48.25l43.35-48.25c0,0,20.13-58.84,30.97-58.84c10.84,0,32.48,0.69,32.48,0.69 L3193.77,685.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 2926.1929,
    y1: 879.8331,
    x2: 3091.5806,
    y2: 879.8331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABABAB"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "2926.19,868.66 3091.58,915.08 2938.82,844.58  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 3108.6128,
    y1: 1122.6998,
    x2: 3151.9678,
    y2: 1122.6998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABABAB"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "3108.61,1180.95 3151.97,1064.45 3126.8,1176.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_31"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 3346.0164,
    y1: 959.0815,
    x2: 3040.5969,
    y2: 962.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "3218.04,919.27 3179.84,919.27 3139.49,915.08 3169.39,932.91 3167.06,946.53 3185.65,971.24  3158.16,993.3 3158.16,1007.58 3193.77,991.16 3274.29,953.43 3267.76,946.53  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 3320.7249,
    y1: 910.3065,
    x2: 3120.7261,
    y2: 912.5878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "3218.04,919.27 3185.65,895.55 3206.89,886.46 3237.9,895.55 3237.9,868.66 3249.37,893.97  3274.29,953.43  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 3337.0312,
    y1: 990.8927,
    x2: 3071.4524,
    y2: 993.9221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "3274.29,953.43 3235.13,1030.23 3240.72,991.83 3211.19,1007.58 3158.16,1015.36 3158.16,1007.58  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "2315.15,445.97 2315.15,478.09 2324.35,478.54 2331.32,448.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "1678.42,1720.91 1694.6,1726.55 1681.52,1758.74 1673.26,1754.57  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2313.22,1939.62c-0.67,0-1.33,0-2.01,0c-132.3-0.39-245.6-39.38-250.35-41.04l-2.3-0.8l-119.94-49.07 l-10.06-7.85c-97.84-76.35-195.06-117.52-259.38-138.62c-68.22-22.38-115.21-27.65-118.78-28.03l-19.87-1.57l-16.76-9.71 l-139.04-77.25c-73.38-40.07-130.76-86.57-170.54-138.19c-38.74-50.28-61.47-105.73-67.55-164.81 c-5.29-51.4,2.21-104.72,22.28-158.49c14.89-39.88,36.76-80.1,65.01-119.54c45.78-63.92,93.09-104.86,98.34-109.32l2.08-1.77 l1.65-1.24c2.17-1.69,45.49-35.71,94.8-93.37c44.72-52.3,104.01-135.73,132.52-236.2c20.59-72.55,65.39-134.53,133.15-184.22 c49.01-35.93,110.15-65.26,181.74-87.16c100.09-30.62,193.19-38.25,220.05-39.89c68.23-12.72,136.3-16.01,202.43-9.78 c55.07,5.19,108.88,16.95,159.92,34.97c67.53,23.83,113.29,52.7,133.31,66.75c16.29,7.63,46.63,23.36,80.12,48.25 c64.92,48.27,112.72,109.48,138.22,177.02c18.4,48.73,25.55,100.85,21.25,154.9c-4.65,58.4-22.84,119.5-54.08,181.6 c-65.48,130.2-47.14,241.55-25.9,370.48c10.66,64.7,21.68,131.6,21.4,202.27c-0.33,84.07-16.99,160.3-50.95,233.06 c-20.42,43.77-47.41,82.12-80.21,114.01c-29.97,29.14-65.08,53.13-104.33,71.32C2467.45,1925.06,2394.71,1939.62,2313.22,1939.62z  M2123.48,1724.45c27.08,8.74,332.41,102.14,422.86-91.68c50.64-108.52,33.96-209.78,14.65-327.03 c-23.14-140.47-49.36-299.69,43.17-483.67c36.15-71.87,44.71-134.76,25.45-186.91c-30.33-82.13-121.27-123-127.19-125.58 l-13.75-5.31l-8.84-7.85c-4.43-3.26-39.38-28.17-98.06-47.78c-82.67-27.64-171.69-32.46-264.61-14.32l-7.14,1.39l-6.85,0.24 c-2.39,0.11-91.23,4.39-184.12,33.35c-73.53,22.92-165.8,66.51-187.78,143.97c-68.91,242.84-262.92,402.42-290.16,423.88 c-6.55,5.85-39.13,35.81-69.14,78.53c-26.57,37.84-57.04,94.32-51.28,148.49c6.09,57.29,54.18,110.88,142.92,159.29l0.63,0.35 l123.89,68.83c62.7,9.41,252,48.5,443.88,194.41L2123.48,1724.45z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_60"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st72",
    x1: 1938.61,
    y1: 1848.7,
    x2: 2032.01,
    y2: 1687.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st72",
    x1: 1588.13,
    y1: 1492.62,
    x2: 1526.83,
    y2: 1670.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st72",
    x1: 2580.61,
    y1: 341.13,
    x2: 2488.67,
    y2: 504.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st72",
    x1: 2092.02,
    y1: 250.8,
    x2: 2110.02,
    y2: 435.7
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M2753.14,1826.89c-61.81,53.26-194.45,73.7-194.45,73.7s-130.34,13.87-209.3,14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M2739.85,1873.49c-82.06,44.13-236.9,52.33-236.9,52.33s-154.08,2.98-237.17-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M2746.05,1859.56c-70.45,45.68-219.87,53.42-219.87,53.42s-169.56,6.65-236.14,2.52"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_58__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M2558.69,1900.59c0,0,132.64-20.44,194.45-73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M2502.95,1925.82c0,0,154.84-8.2,236.9-52.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M2526.17,1912.98c0,0,149.42-7.74,219.87-53.42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3_\\u043A\\u043E\\u043F\\u0438\\u044F_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 2132.113,
    y1: 49.2127,
    x2: 1841.0162,
    y2: 2164.3093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8BCE8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#466200"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M2313.22,1939.62c-0.67,0-1.33,0-2.01,0c-132.3-0.39-245.6-39.38-250.35-41.04l-2.3-0.8l-119.94-49.07 l-10.06-7.85c-97.84-76.35-195.06-117.52-259.38-138.62c-68.22-22.38-115.21-27.65-118.78-28.03l-19.87-1.57l-16.76-9.71 l-139.04-77.25c-73.38-40.07-130.76-86.57-170.54-138.19c-38.74-50.28-61.47-105.73-67.55-164.81 c-5.29-51.4,2.21-104.72,22.28-158.49c14.89-39.88,36.76-80.1,65.01-119.54c45.78-63.92,93.09-104.86,98.34-109.32l2.08-1.77 l1.65-1.24c2.17-1.69,45.49-35.71,94.8-93.37c44.72-52.3,104.01-135.73,132.52-236.2c20.59-72.55,65.39-134.53,133.15-184.22 c49.01-35.93,110.15-65.26,181.74-87.16c100.09-30.62,193.19-38.25,220.05-39.89c68.23-12.72,136.3-16.01,202.43-9.78 c55.07,5.19,108.88,16.95,159.92,34.97c67.53,23.83,113.29,52.7,133.31,66.75c16.29,7.63,46.63,23.36,80.12,48.25 c64.92,48.27,112.72,109.48,138.22,177.02c18.4,48.73,25.55,100.85,21.25,154.9c-4.65,58.4-22.84,119.5-54.08,181.6 c-65.48,130.2-47.14,241.55-25.9,370.48c10.66,64.7,21.68,131.6,21.4,202.27c-0.33,84.07-16.99,160.3-50.95,233.06 c-20.42,43.77-47.41,82.12-80.21,114.01c-29.97,29.14-65.08,53.13-104.33,71.32C2467.45,1925.06,2394.71,1939.62,2313.22,1939.62z  M2123.48,1724.45c27.08,8.74,332.41,102.14,422.86-91.68c50.64-108.52,33.96-209.78,14.65-327.03 c-23.14-140.47-49.36-299.69,43.17-483.67c36.15-71.87,44.71-134.76,25.45-186.91c-30.33-82.13-121.27-123-127.19-125.58 l-13.75-5.31l-8.84-7.85c-4.43-3.26-39.38-28.17-98.06-47.78c-82.67-27.64-171.69-32.46-264.61-14.32l-7.14,1.39l-6.85,0.24 c-2.39,0.11-91.23,4.39-184.12,33.35c-73.53,22.92-165.8,66.51-187.78,143.97c-68.91,242.84-262.92,402.42-290.16,423.88 c-6.55,5.85-39.13,35.81-69.14,78.53c-26.57,37.84-57.04,94.32-51.28,148.49c6.09,57.29,54.18,110.88,142.92,159.29l0.63,0.35 l123.89,68.83c62.7,9.41,252,48.5,443.88,194.41L2123.48,1724.45z"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st76",
    points: "2569.71,1161.55 2569.71,1100.41 2615.45,1100.41 2615.45,1161.55  "
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st76",
    points: "2651.01,1202.61 2651.01,1141.47 2696.74,1141.47 2696.74,1202.61  "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st76",
    points: "2578.87,1260.42 2573.24,1199.54 2618.78,1195.32 2624.41,1256.2  "
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st76",
    points: "2658.78,1302.91 2653.15,1242.03 2698.69,1237.82 2704.32,1298.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 2314.3206,
    y1: 87.1544,
    x2: 2379.7393,
    y2: 87.1544,
    gradientTransform: "matrix(-0.1445 0.9895 -0.9895 -0.1445 3064.7324 -1999.8562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M2676.77,310.4l-4.16-13.76c-4.38-14.51-20.34-22.05-34.33-16.23l-23.5,9.77 c-22.03,9.16-20.62,40.71,2.09,48.04c10.35,3.34,22.42,5.47,36.2,5.17C2669.9,343.02,2681.64,326.52,2676.77,310.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 2305.2612,
    y1: 79.5547,
    x2: 2358.1208,
    y2: 79.5547,
    gradientTransform: "matrix(-0.1445 0.9895 -0.9895 -0.1445 3064.7324 -1999.8562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M2679.31,296.24l-3.36-11.12c-3.54-11.72-16.43-17.82-27.74-13.12l-18.99,7.9 c-17.8,7.4-16.66,32.89,1.69,38.82c8.36,2.7,18.12,4.42,29.25,4.18C2673.76,322.59,2683.25,309.25,2679.31,296.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 2298.9392,
    y1: 71.3762,
    x2: 2328.4216,
    y2: 71.3762,
    gradientTransform: "matrix(-0.1445 0.9895 -0.9895 -0.1445 3064.7324 -1999.8562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M2675.06,284.01l-2.17-11.94c-1.06-5.85-7.67-8.81-12.74-5.7l-13.13,8.05c-5.02,3.08-5.41,10.18-0.81,13.86 c4.88,3.9,12.16,7.29,21.94,5.58C2672.79,293.05,2675.9,288.64,2675.06,284.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 2281.6802,
    y1: 635.0781,
    x2: 2347.0989,
    y2: 635.0781,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M2140.1,193.58l-6.1-13.02c-6.43-13.72-23.31-18.88-36.32-11.1l-21.85,13.07 c-20.48,12.25-14.52,43.26,9.01,47.23c10.72,1.81,22.98,2.17,36.57-0.12C2138.01,226.85,2147.25,208.82,2140.1,193.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 2272.6208,
    y1: 627.4785,
    x2: 2325.4805,
    y2: 627.4785,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M2140.57,179.19l-4.93-10.52c-5.2-11.09-18.84-15.26-29.34-8.97l-17.65,10.56 c-16.55,9.9-11.73,34.96,7.28,38.17c8.66,1.46,18.57,1.76,29.55-0.09C2138.88,206.08,2146.34,191.51,2140.57,179.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 2266.2988,
    y1: 619.3,
    x2: 2295.7815,
    y2: 619.3,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M2134.59,167.71l-3.87-11.51c-1.9-5.64-8.86-7.61-13.43-3.8l-11.83,9.86c-4.52,3.77-3.88,10.85,1.2,13.83 c5.39,3.16,13.09,5.46,22.52,2.35C2133.66,176.99,2136.09,172.17,2134.59,167.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 2579.821,
    y1: 635.873,
    x2: 2671.3831,
    y2: 635.873,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M2154.15,502.81l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C2151.23,549.38,2164.15,524.14,2154.15,502.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 2567.1411,
    y1: 625.2362,
    x2: 2641.1252,
    y2: 625.2362,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M2154.81,482.68l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.93,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C2152.45,520.3,2162.89,499.91,2154.81,482.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 2558.2927,
    y1: 613.7894,
    x2: 2599.5574,
    y2: 613.7894,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M2146.44,466.61l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32L2105.68,459c-6.33,5.28-5.43,15.19,1.68,19.35 c7.55,4.42,18.32,7.64,31.52,3.3C2145.13,479.59,2148.54,472.85,2146.44,466.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 2636.3662,
    y1: 725.4114,
    x2: 2727.9282,
    y2: 725.4114,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M2064.61,559.36l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C2061.69,605.93,2074.61,580.69,2064.61,559.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 2623.6863,
    y1: 714.7746,
    x2: 2697.6704,
    y2: 714.7746,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M2065.27,539.22l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.92,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C2062.91,576.85,2073.35,556.46,2065.27,539.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 2614.8379,
    y1: 703.3278,
    x2: 2656.1025,
    y2: 703.3278,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M2056.9,523.15l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81c-6.33,5.28-5.43,15.19,1.68,19.35 c7.55,4.42,18.32,7.64,31.52,3.3C2055.59,536.13,2059,529.39,2056.9,523.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 3816.9478,
    y1: 1557.4985,
    x2: 3908.5098,
    y2: 1557.4985,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1232.53,1739.94l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C1229.6,1786.51,1242.52,1761.27,1232.53,1739.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 3825.7368,
    y1: 1557.4985,
    x2: 3899.7207,
    y2: 1557.4985,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M1222.54,1741.27l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.92,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C1220.18,1778.9,1230.62,1758.51,1222.54,1741.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 3842.0964,
    y1: 1557.4985,
    x2: 3883.3611,
    y2: 1557.4985,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M1202.73,1750.41l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81 c-6.33,5.28-5.43,15.19,1.68,19.35c7.55,4.42,18.32,7.64,31.52,3.3C1201.42,1763.39,1204.83,1756.65,1202.73,1750.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 3722.7034,
    y1: 1702.375,
    x2: 3814.2654,
    y2: 1702.375,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1087.65,1645.69l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C1084.73,1692.26,1097.65,1667.02,1087.65,1645.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 3731.4924,
    y1: 1702.375,
    x2: 3805.4763,
    y2: 1702.375,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1077.67,1647.03l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.93,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C1075.31,1684.65,1085.75,1664.26,1077.67,1647.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 3747.8521,
    y1: 1702.375,
    x2: 3789.1167,
    y2: 1702.375,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M1057.86,1656.17l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81 c-6.33,5.28-5.43,15.19,1.68,19.35c7.55,4.42,18.32,7.64,31.52,3.3C1056.54,1669.14,1059.95,1662.41,1057.86,1656.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 3547.4451,
    y1: 1948.8232,
    x2: 3639.0071,
    y2: 1948.8232,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M841.2,1470.44l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C838.28,1517,851.2,1491.77,841.2,1470.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 3547.4451,
    y1: 1969.9846,
    x2: 3621.429,
    y2: 1969.9846,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M810.06,1462.98l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.93,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C807.7,1500.61,818.14,1480.21,810.06,1462.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 3556.2341,
    y1: 1978.2427,
    x2: 3597.4988,
    y2: 1978.2427,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M781.99,1464.55l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81 c-6.33,5.28-5.43,15.19,1.68,19.35c7.55,4.42,18.32,7.64,31.52,3.3C780.67,1477.53,784.09,1470.79,781.99,1464.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 3754.9451,
    y1: 2535.7073,
    x2: 3846.5071,
    y2: 2535.7073,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M254.32,1677.94l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C251.39,1724.5,264.32,1699.27,254.32,1677.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 3754.9451,
    y1: 2556.8687,
    x2: 3828.9292,
    y2: 2556.8687,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M223.17,1670.48l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.92,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C220.81,1708.11,231.25,1687.71,223.17,1670.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 3763.7341,
    y1: 2565.1267,
    x2: 3804.9988,
    y2: 2565.1267,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M195.1,1672.05l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81 c-6.33,5.28-5.43,15.19,1.68,19.35c7.55,4.42,18.32,7.64,31.52,3.3C193.79,1685.03,197.2,1678.29,195.1,1672.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 3969.7334,
    y1: 2650.9043,
    x2: 4061.2954,
    y2: 2650.9043,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M139.12,1892.72l-8.54-18.22c-9-19.2-32.63-26.43-50.83-15.54l-30.58,18.29 c-28.66,17.15-20.32,60.55,12.61,66.11c15.01,2.53,32.16,3.04,51.18-0.16C136.2,1939.29,149.12,1914.05,139.12,1892.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 3969.7334,
    y1: 2672.0657,
    x2: 4043.7175,
    y2: 2672.0657,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M107.98,1885.27l-6.9-14.72c-7.27-15.52-26.36-21.35-41.07-12.55l-24.71,14.78 c-23.16,13.85-16.42,48.92,10.19,53.42c12.13,2.05,25.99,2.46,41.35-0.13C105.62,1922.89,116.06,1902.5,107.98,1885.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 3978.5225,
    y1: 2680.3237,
    x2: 4019.7871,
    y2: 2680.3237,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M79.91,1886.84l-5.42-16.1c-2.65-7.89-12.4-10.65-18.79-5.32l-16.56,13.81 c-6.33,5.28-5.43,15.19,1.68,19.35c7.55,4.42,18.32,7.64,31.52,3.3C78.59,1899.81,82.01,1893.08,79.91,1886.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 2304.1311,
    y1: 898.1068,
    x2: 2382.0256,
    y2: 898.1068,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M1884.16,221.32l-7.27-15.5c-7.66-16.34-27.76-22.48-43.24-13.22l-26.01,15.56 c-24.38,14.59-17.29,51.51,10.73,56.24c12.77,2.16,27.36,2.59,43.54-0.14C1881.67,260.94,1892.66,239.47,1884.16,221.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 2293.344,
    y1: 889.0578,
    x2: 2356.2844,
    y2: 889.0578,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M1884.72,204.19l-5.87-12.52c-6.19-13.2-22.43-18.17-34.94-10.68l-21.02,12.57 c-19.7,11.79-13.97,41.62,8.67,45.44c10.32,1.74,22.11,2.09,35.18-0.11C1882.71,236.2,1891.59,218.86,1884.72,204.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 2285.8162,
    y1: 879.3196,
    x2: 2320.9214,
    y2: 879.3196,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1877.6,190.52l-4.61-13.7c-2.26-6.71-10.55-9.06-15.99-4.52l-14.09,11.75 c-5.38,4.49-4.62,12.92,1.43,16.46c6.42,3.76,15.58,6.5,26.81,2.8C1876.48,201.56,1879.38,195.83,1877.6,190.52z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 2489.2461,
    y1: -42.8372,
    x2: 2567.1409,
    y2: -42.8372,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M2825.1,406.44l-7.27-15.5c-7.66-16.34-27.76-22.48-43.24-13.22l-26.01,15.56 c-24.38,14.59-17.29,51.51,10.73,56.24c12.77,2.16,27.36,2.59,43.54-0.14C2822.62,446.06,2833.61,424.59,2825.1,406.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 2478.459,
    y1: -51.8863,
    x2: 2541.3994,
    y2: -51.8863,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M2825.66,389.31l-5.87-12.52c-6.19-13.2-22.43-18.17-34.94-10.68l-21.02,12.57 c-19.7,11.79-13.97,41.62,8.67,45.44c10.32,1.74,22.11,2.09,35.18-0.11C2823.65,421.32,2832.53,403.97,2825.66,389.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 2470.9314,
    y1: -61.6245,
    x2: 2506.0364,
    y2: -61.6245,
    gradientTransform: "matrix(-6.233226e-07 1 -1 -6.233226e-07 2738.0359 -2115.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M2818.54,375.64l-4.61-13.7c-2.26-6.71-10.55-9.06-15.99-4.52l-14.09,11.75 c-5.38,4.49-4.62,12.92,1.43,16.46c6.42,3.76,15.58,6.5,26.81,2.8C2817.43,386.68,2820.33,380.95,2818.54,375.64z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "1961.74,1585.69 1978.49,1562.65 2081.72,1568.14 2190.42,1526.33 2337.52,1562.65 2397.9,1562.65  2453.65,1470.59 2453.65,1386.98 2441.26,1465.95 2390.16,1541.82 2337.52,1540.27 2176.48,1512.4 2081.72,1554.2 1969,1551.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "1364.79,1599.11 1227.32,1585.69 1091.06,1489.17 1098.81,1500.78 1225.3,1592.14  "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_23"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_33_\\u043A\\u043E\\u043F\\u0438\\u044F_2"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_33__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 1705.6887,
    y1: 668.356,
    x2: 1862.3506,
    y2: 668.356,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "1800.26,550.02 1808.45,523.66 1832.64,544.94 1854.07,515.13 1861.27,544.58 1894.13,513.73  1883.68,553.08 1926.53,565.87 1891.45,581.47 1913.6,607.18 1870.88,600.27 1857.74,645.79 1830.1,622.2 1814.79,634.39  1804.28,605.61 1760.37,622.49 1787.32,583.37 1756.34,560.43 1785.67,557.64  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 1713.0758,
    y1: 649.1842,
    x2: 1833.293,
    y2: 649.1842,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "1811.14,534.23 1817.43,514 1835.99,530.34 1852.44,507.46 1857.96,530.06 1883.17,506.38  1875.15,536.58 1908.04,546.4 1881.12,558.37 1898.12,578.1 1865.33,572.8 1855.25,607.73 1834.04,589.62 1822.29,598.97  1814.23,576.89 1780.53,589.85 1801.21,559.83 1777.44,542.22 1799.94,540.08  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 1720.4629,
    y1: 633.8262,
    x2: 1800.0756,
    y2: 633.8262,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "1819.22,521.16 1823.39,507.76 1835.68,518.58 1846.57,503.43 1850.23,518.4 1866.92,502.72  1861.62,522.72 1883.39,529.22 1865.56,537.14 1876.82,550.21 1855.11,546.7 1848.44,569.83 1834.39,557.84 1826.61,564.03  1821.27,549.41 1798.95,557.99 1812.65,538.11 1796.9,526.45 1811.81,525.03  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.2557,
    y1: 1062.7903,
    x2: 1530.9177,
    y2: 1062.7903,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "1305.33,693.1 1313.52,666.73 1337.71,688.02 1359.14,658.2 1366.34,687.65 1399.2,656.8  1388.75,696.16 1431.6,708.95 1396.52,724.55 1418.67,750.26 1375.95,743.35 1362.81,788.87 1335.17,765.27 1319.86,777.46  1309.35,748.69 1265.44,765.57 1292.39,726.45 1261.41,703.51 1290.74,700.72  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 1381.6428,
    y1: 1043.6185,
    x2: 1501.86,
    y2: 1043.6185,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "1316.21,677.31 1322.5,657.08 1341.06,673.41 1357.51,650.53 1363.03,673.13 1388.24,649.46  1380.23,679.66 1413.11,689.48 1386.19,701.44 1403.19,721.18 1370.4,715.87 1360.32,750.81 1339.11,732.7 1327.36,742.05  1319.3,719.97 1285.6,732.92 1306.28,702.9 1282.51,685.3 1305.02,683.16  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.0299,
    y1: 1028.2605,
    x2: 1468.6427,
    y2: 1028.2605,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "1324.29,664.24 1328.46,650.84 1340.75,661.66 1351.64,646.51 1355.3,661.47 1371.99,645.79  1366.69,665.79 1388.46,672.29 1370.63,680.22 1381.89,693.29 1360.18,689.78 1353.51,712.91 1339.46,700.92 1331.68,707.11  1326.34,692.49 1304.02,701.07 1317.72,681.19 1301.97,669.53 1316.88,668.11  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.9062,
    y1: 1787.1287,
    x2: 837.5682,
    y2: 1787.1287,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "326.08,908.68 334.27,882.31 358.46,903.6 379.9,873.78 387.09,903.23 419.95,872.38 409.5,911.74  452.35,924.53 417.27,940.13 439.43,965.84 396.7,958.93 383.57,1004.45 355.93,980.85 340.62,993.04 330.1,964.27 286.19,981.15  313.14,942.03 282.16,919.09 311.49,916.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.2933,
    y1: 1767.9569,
    x2: 808.5104,
    y2: 1767.9569,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "336.96,892.89 343.25,872.66 361.81,888.99 378.26,866.11 383.78,888.71 408.99,865.04  400.98,895.24 433.86,905.06 406.94,917.02 423.94,936.76 391.15,931.45 381.08,966.38 359.87,948.28 348.12,957.63  340.05,935.55 306.35,948.5 327.03,918.48 303.26,900.88 325.77,898.74  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 695.6804,
    y1: 1752.5989,
    x2: 775.2932,
    y2: 1752.5989,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "345.05,879.82 349.21,866.42 361.5,877.24 372.39,862.09 376.05,877.05 392.75,861.37  387.44,881.37 409.22,887.87 391.39,895.8 402.65,908.87 380.93,905.36 374.26,928.49 360.21,916.5 352.43,922.69 347.09,908.07  324.77,916.65 338.47,896.77 322.73,885.11 337.63,883.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.6475,
    y1: 1551.1746,
    x2: 447.3094,
    y2: 1551.1746,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "133.31,495.38 141.5,469.02 165.69,490.3 187.12,460.49 194.32,489.94 227.17,459.09  216.73,498.44 259.58,511.23 224.5,526.83 246.65,552.54 203.92,545.63 190.79,591.15 163.15,567.56 147.84,579.75 137.33,550.97  93.42,567.85 120.37,528.73 89.39,505.79 118.72,503  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0345,
    y1: 1532.0028,
    x2: 418.2516,
    y2: 1532.0028,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "144.19,479.59 150.48,459.36 169.04,475.7 185.49,452.82 191.01,475.42 216.22,451.74  208.2,481.94 241.09,491.76 214.17,503.73 231.17,523.46 198.38,518.16 188.3,553.09 167.09,534.98 155.34,544.33 147.28,522.25  113.58,535.21 134.26,505.19 110.49,487.58 132.99,485.44  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.4216,
    y1: 1516.6448,
    x2: 385.0343,
    y2: 1516.6448,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "152.27,466.52 156.43,453.12 168.73,463.94 179.62,448.79 183.28,463.76 199.97,448.08  194.66,468.08 216.44,474.58 198.61,482.5 209.87,495.57 188.16,492.06 181.48,515.19 167.44,503.2 159.66,509.39 154.32,494.77  132,503.35 145.7,483.47 129.95,471.81 144.86,470.39  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.388,
    y1: 1599.0692,
    x2: 609.0499,
    y2: 1599.0692,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "240.99,625.22 249.18,598.86 273.36,620.14 294.8,590.33 302,619.78 334.85,588.93 324.4,628.29  367.26,641.08 332.18,656.67 354.33,682.39 311.6,675.48 298.47,721 270.83,697.4 255.52,709.59 245.01,680.81 201.09,697.7  228.04,658.58 197.06,635.64 226.39,632.84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.7751,
    y1: 1579.8973,
    x2: 579.9922,
    y2: 1579.8973,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "251.87,609.44 258.15,589.21 276.71,605.54 293.16,582.66 298.68,605.26 323.9,581.59  315.88,611.79 348.76,621.6 321.84,633.57 338.84,653.3 306.06,648 295.98,682.93 274.77,664.82 263.02,674.18 254.95,652.09  221.26,665.05 241.94,635.03 218.16,617.43 240.67,615.28  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.1622,
    y1: 1564.5394,
    x2: 546.7749,
    y2: 1564.5394,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "259.95,596.36 264.11,582.97 276.4,593.78 287.3,578.63 290.95,593.6 307.65,577.92 302.34,597.92  324.12,604.42 306.29,612.35 317.55,625.42 295.84,621.9 289.16,645.04 275.12,633.04 267.34,639.24 261.99,624.61 239.68,633.19  253.37,613.31 237.63,601.66 252.53,600.24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.9504,
    y1: 2.791,
    x2: 2257.6123,
    y2: 2.791,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "2499.18,217.27 2507.37,190.91 2531.56,212.2 2552.99,182.38 2560.19,211.83 2593.05,180.98  2582.6,220.34 2625.45,233.13 2590.37,248.72 2612.52,274.44 2569.8,267.53 2556.66,313.05 2529.02,289.45 2513.71,301.64  2503.2,272.86 2459.29,289.75 2486.24,250.63 2455.26,227.69 2484.59,224.89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.3918,
    y1: -28.2335,
    x2: 2220.6089,
    y2: -28.2335,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "2510.06,187.22 2516.35,166.99 2534.91,183.32 2551.36,160.44 2556.88,183.04 2582.09,159.37  2574.07,189.57 2606.96,199.38 2580.04,211.35 2597.04,231.09 2564.25,225.78 2554.17,260.71 2532.96,242.6 2521.21,251.96  2513.15,229.88 2479.45,242.83 2500.13,212.81 2476.36,195.21 2498.86,193.07  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 2104.2908,
    y1: -48.7948,
    x2: 2183.9033,
    y2: -48.7948,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "2518.14,167.88 2522.31,154.49 2534.6,165.3 2545.49,150.15 2549.15,165.12 2565.84,149.44  2560.54,169.44 2582.31,175.94 2564.48,183.86 2575.74,196.93 2554.03,193.42 2547.36,216.55 2533.31,204.56 2525.53,210.76  2520.19,196.13 2497.87,204.71 2511.57,184.83 2495.82,173.17 2510.73,171.75  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 3244.99,
    y1: 1329.5793,
    x2: 3401.6519,
    y2: 1329.5793,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "2710.66,1956.37 2718.85,1930.01 2743.04,1951.3 2764.47,1921.48 2771.67,1950.93 2804.52,1920.08  2794.08,1959.44 2836.93,1972.23 2801.85,1987.83 2824,2013.54 2781.28,2006.63 2768.14,2052.15 2740.5,2028.55 2725.19,2040.74  2714.68,2011.97 2670.77,2028.85 2697.72,1989.73 2666.74,1966.79 2696.07,1964  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 3259.6633,
    y1: 1321.2765,
    x2: 3379.8804,
    y2: 1321.2765,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "2721.54,1953.67 2727.83,1933.44 2746.39,1949.78 2762.84,1926.9 2768.36,1949.5 2793.57,1925.82  2785.55,1956.02 2818.44,1965.84 2791.52,1977.81 2808.52,1997.54 2775.73,1992.24 2765.65,2027.17 2744.44,2009.06  2732.69,2018.41 2724.63,1996.33 2690.93,2009.29 2711.61,1979.27 2687.84,1961.66 2710.34,1959.52  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 3274.9773,
    y1: 1315.4323,
    x2: 3354.5901,
    y2: 1315.4323,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "2730.91,1952.92 2735.07,1939.52 2747.36,1950.34 2758.26,1935.19 2761.91,1950.15  2778.61,1934.48 2773.3,1954.47 2795.08,1960.98 2777.25,1968.9 2788.51,1981.97 2766.8,1978.46 2760.12,2001.59 2746.08,1989.6  2738.3,1995.79 2732.95,1981.17 2710.64,1989.75 2724.33,1969.87 2708.59,1958.21 2723.49,1956.79  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1362.6611,
    y1: 458.528,
    x2: 1519.323,
    y2: 458.528,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "1632.17,184.72 1640.36,158.36 1664.55,179.64 1685.98,149.83 1693.18,179.28 1726.03,148.43  1715.59,187.78 1758.44,200.58 1723.36,216.17 1745.51,241.89 1702.79,234.98 1689.65,280.5 1662.01,256.9 1646.7,269.09  1636.19,240.31 1592.28,257.2 1619.23,218.08 1588.25,195.14 1617.58,192.34  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1362.1024,
    y1: 427.5035,
    x2: 1482.3196,
    y2: 427.5035,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "1643.05,154.67 1649.34,134.44 1667.9,150.77 1684.35,127.89 1689.87,150.49 1715.08,126.82  1707.06,157.02 1739.95,166.83 1713.03,178.8 1730.03,198.53 1697.24,193.23 1687.16,228.16 1665.95,210.05 1654.2,219.41  1646.14,197.32 1612.44,210.28 1633.12,180.26 1609.35,162.66 1631.85,160.51  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1366.0015,
    y1: 406.9423,
    x2: 1445.6141,
    y2: 406.9423,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "1651.13,135.33 1655.29,121.93 1667.59,132.75 1678.48,117.6 1682.14,132.57 1698.83,116.89  1693.52,136.89 1715.3,143.39 1697.47,151.31 1708.73,164.38 1687.02,160.87 1680.34,184 1666.3,172.01 1658.52,178.2  1653.18,163.58 1630.86,172.16 1644.56,152.28 1628.81,140.62 1643.72,139.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1665.0902,
    y1: 173.8122,
    x2: 1675.3215,
    y2: 180.671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "1666.3,172.01 1667.84,178.27 1675.73,180.06  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 1664.5088,
    y1: 212.2055,
    x2: 1676.9083,
    y2: 220.5177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "1665.95,210.05 1667.84,217.56 1677.38,219.81  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 1472.6053,
    y1: 238.7178,
    x2: 1629.2673,
    y2: 238.7178,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "1845.89,63.36 1854.08,37 1878.27,58.28 1899.7,28.47 1906.9,57.92 1939.75,27.07 1929.31,66.42  1972.16,79.22 1937.08,94.81 1959.23,120.53 1916.5,113.62 1903.37,159.14 1875.73,135.54 1860.42,147.73 1849.91,118.95  1806,135.84 1832.95,96.72 1801.97,73.77 1831.3,70.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 1472.0468,
    y1: 207.6933,
    x2: 1592.2639,
    y2: 207.6933,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "1856.77,33.31 1863.06,13.08 1881.62,29.41 1898.06,6.53 1903.59,29.13 1928.8,5.46  1920.78,35.66 1953.67,45.47 1926.75,57.44 1943.75,77.17 1910.96,71.87 1900.88,106.8 1879.67,88.69 1867.92,98.05  1859.86,75.96 1826.16,88.92 1846.84,58.9 1823.07,41.3 1845.57,39.15  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.9457,
    y1: 187.1321,
    x2: 1555.5585,
    y2: 187.1321,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "1864.85,13.97 1869.01,0.57 1881.31,11.39 1892.2,-3.76 1895.86,11.2 1912.55,-4.47  1907.24,15.53 1929.02,22.03 1911.19,29.95 1922.45,43.02 1900.74,39.51 1894.06,62.64 1880.02,50.65 1872.24,56.84  1866.9,42.22 1844.58,50.8 1858.27,30.92 1842.53,19.26 1857.44,17.84  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 1878.8093,
    y1: 52.4517,
    x2: 1889.0406,
    y2: 59.3105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "1880.02,50.65 1881.56,56.91 1889.45,58.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 1878.228,
    y1: 90.845,
    x2: 1890.6276,
    y2: 99.1572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "1879.67,88.69 1881.56,96.2 1891.1,98.45  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 993.3835,
    y1: 527.8488,
    x2: 1150.0454,
    y2: 527.8488,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "1286.84,36.68 1295.03,10.32 1319.21,31.6 1340.65,1.79 1347.85,31.24 1380.7,0.39 1370.26,39.74  1413.11,52.53 1378.03,68.13 1400.18,93.84 1357.45,86.93 1344.32,132.45 1316.68,108.85 1301.37,121.05 1290.86,92.27  1246.94,109.15 1273.89,70.03 1242.92,47.09 1272.25,44.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 992.8249,
    y1: 496.8242,
    x2: 1113.042,
    y2: 496.8242,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "1297.72,6.62 1304,-13.61 1322.56,2.73 1339.01,-20.15 1344.54,2.45 1369.75,-21.23 1361.73,8.97  1394.62,18.79 1367.69,30.76 1384.69,50.49 1351.91,45.19 1341.83,80.12 1320.62,62.01 1308.87,71.36 1300.8,49.28  1267.11,62.24 1287.79,32.22 1264.01,14.61 1286.52,12.47  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 996.7239,
    y1: 476.263,
    x2: 1076.3365,
    y2: 476.263,
    gradientTransform: "matrix(0.8306 0.5568 -0.5568 0.8306 730.138 -971.9974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "1305.8,-12.71 1309.96,-26.11 1322.25,-15.29 1333.15,-30.45 1336.8,-15.48 1353.5,-31.16  1348.19,-11.16 1369.97,-4.66 1352.14,3.27 1363.4,16.34 1341.69,12.82 1335.01,35.96 1320.97,23.97 1313.19,30.16  1307.84,15.54 1285.53,24.12 1299.22,4.24 1283.48,-7.42 1298.39,-8.84  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1319.7582,
    y1: 25.768,
    x2: 1329.9895,
    y2: 32.6268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "1320.97,23.97 1322.51,30.22 1330.4,32.02  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1319.1769,
    y1: 64.1613,
    x2: 1331.5763,
    y2: 72.4736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "1320.62,62.01 1322.51,69.51 1332.05,71.77  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 1141.6688,
    y1: 741.7968,
    x2: 1298.3307,
    y2: 741.7968,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "1293.68,290.48 1306.03,265.79 1326.45,290.71 1352.43,264.76 1354.77,294.98 1392.18,269.86  1375.5,307 1415.72,326.57 1378.57,336.28 1396.27,365.24 1355.23,351.5 1334.9,394.3 1311.44,366.53 1294.36,376.08  1288.65,345.98 1242.58,355.54 1275.51,321.29 1248.65,293.64 1278.05,295.63  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1141.1101,
    y1: 710.7722,
    x2: 1261.3273,
    y2: 710.7722,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "1309.28,262.58 1318.76,243.63 1334.43,262.76 1354.37,242.84 1356.16,266.04 1384.87,246.76  1372.07,275.26 1402.93,290.27 1374.43,297.72 1388.01,319.95 1356.51,309.41 1340.91,342.25 1322.92,320.94 1309.81,328.27  1305.42,305.17 1270.07,312.5 1295.34,286.23 1274.73,265.01 1297.29,266.54  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1145.0092,
    y1: 690.211,
    x2: 1224.6218,
    y2: 690.211,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "1320.39,244.81 1326.67,232.26 1337.04,244.92 1350.25,231.74 1351.43,247.1 1370.45,234.33  1361.97,253.21 1382.41,263.15 1363.53,268.08 1372.53,282.8 1351.67,275.82 1341.34,297.57 1329.42,283.46 1320.74,288.31  1317.83,273.01 1294.42,277.87 1311.16,260.47 1297.51,246.41 1312.45,247.43  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1323.7959,
    y1: 286.0486,
    x2: 1334.0272,
    y2: 292.9073,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "1329.42,283.46 1329.92,289.88 1337.42,292.93  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 1323.2146,
    y1: 324.4419,
    x2: 1335.614,
    y2: 332.7541,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "1322.92,320.94 1323.56,328.65 1332.62,332.42  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1173.2551,
    y1: 1059.3677,
    x2: 1329.9171,
    y2: 1059.3677,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "1099.52,543.75 1111.87,519.06 1132.29,543.98 1158.27,518.03 1160.6,548.26 1198.02,523.14  1181.34,560.28 1221.55,579.84 1184.41,589.55 1202.11,618.52 1161.06,604.78 1140.73,647.57 1117.28,619.81 1100.2,629.36  1094.48,599.26 1048.42,608.81 1081.34,574.57 1054.49,546.92 1083.88,548.91  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1172.6965,
    y1: 1028.3431,
    x2: 1292.9137,
    y2: 1028.3431,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "1115.12,515.86 1124.6,496.91 1140.27,516.03 1160.2,496.12 1161.99,519.32 1190.71,500.04  1177.91,528.54 1208.77,543.55 1180.27,551 1193.85,573.23 1162.35,562.68 1146.75,595.52 1128.75,574.22 1115.64,581.55  1111.26,558.45 1075.91,565.78 1101.18,539.5 1080.57,518.28 1103.12,519.81  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 1178.8331,
    y1: 993.7628,
    x2: 1258.4458,
    y2: 993.7628,
    gradientTransform: "matrix(0.7295 0.684 -0.3846 0.4102 631.5391 -717.342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "1120.71,507.24 1122.96,498.98 1133.98,510.96 1141.6,503.73 1145.9,515.77 1158.23,510.13  1155.61,522.76 1174.04,534.85 1160.1,534.51 1170.47,547.77 1152.36,537.86 1148.89,552.28 1136.33,538.86 1130.49,540.68  1124.84,528.32 1107.28,526.93 1116.79,517.23 1102.87,503.47 1114.97,507.51  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 1173.2002,
    y1: 567.4201,
    x2: 1183.4315,
    y2: 574.2789,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "1135.25,536.73 1135.76,543.16 1143.26,546.21  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 1172.6189,
    y1: 605.8134,
    x2: 1185.0183,
    y2: 614.1256,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "1128.75,574.22 1129.4,581.93 1138.45,585.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.0569,
    y1: 1440.5707,
    x2: 1295.7188,
    y2: 1440.5707,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "813.84,798.46 826.19,773.77 846.61,798.69 872.59,772.74 874.92,802.96 912.34,777.84  895.66,814.98 935.88,834.55 898.73,844.26 916.43,873.22 875.39,859.48 855.06,902.28 831.6,874.51 814.52,884.06  808.81,853.96 762.74,863.52 795.67,829.27 768.81,801.62 798.21,803.61  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1138.4982,
    y1: 1409.5461,
    x2: 1258.7153,
    y2: 1409.5461,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "829.44,770.56 838.92,751.61 854.59,770.74 874.53,750.82 876.32,774.02 905.03,754.74  892.23,783.24 923.09,798.25 894.59,805.7 908.17,827.93 876.67,817.39 861.07,850.23 843.07,828.92 829.97,836.25  825.58,813.15 790.23,820.48 815.5,794.21 794.89,772.99 817.45,774.52  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.3971,
    y1: 1388.9849,
    x2: 1222.0099,
    y2: 1388.9849,
    gradientTransform: "matrix(0.7295 0.684 -0.684 0.7295 945.7926 -1052.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7CE74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284D00"
    }
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "840.55,752.79 846.82,740.24 857.2,752.9 870.41,739.72 871.59,755.08 890.61,742.31  882.13,761.19 902.57,771.13 883.69,776.06 892.68,790.78 871.83,783.8 861.49,805.55 849.58,791.44 840.9,796.29 837.99,780.99  814.58,785.85 831.31,768.45 817.67,754.39 832.6,755.41  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.5298,
    y1: 865.0154,
    x2: 942.7611,
    y2: 871.8741,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "849.58,791.44 850.08,797.86 857.58,800.91  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 931.9485,
    y1: 903.4087,
    x2: 944.348,
    y2: 911.7209,
    gradientTransform: "matrix(0.9868 0.1619 -0.1619 0.9868 67.916 -211.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7A4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846136"
    }
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "843.07,828.92 843.72,836.63 852.77,840.4  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_39"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.6774,
    y1: 381.8163,
    x2: 900.6129,
    y2: 381.8163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "822.68,439.88 847.97,431.45 900.61,361.43 900.61,323.75 866.03,337.17 822.68,409.43  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_40"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.1613,
    y1: 381.9776,
    x2: 897.5161,
    y2: 381.9776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "824.16,409.56 867.32,338.72 897.52,326.72 894.42,354.59 843.9,422.91 824.16,437.24  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_41"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.9355,
    y1: 360.6227,
    x2: 860.8387,
    y2: 360.6227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M859,386.14l-76.06-46.39c0,0,1.55-4.65,4.13-4.65s73.77,46.87,73.77,46.87L859,386.14z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_42"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 745.5497,
    y1: 352.3464,
    x2: 860.3539,
    y2: 352.3464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M745.55,324.84l94.99,43.85c0,0,13.11-1.91,17.75,13.29c0,0,4.64,1.97,0-6.61 c-4.64-8.58-86.19-48.68-86.19-48.68S756.68,318.7,745.55,324.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_43"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 2075.0645,
    y1: 894.9776,
    x2: 2129.2581,
    y2: 894.9776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "2075.06,919.36 2102.16,911.62 2115.32,893.04 2129.26,882.2 2097.52,870.59 2075.06,894.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 2147.0645,
    y1: 696.3969,
    x2: 2176.4839,
    y2: 696.3969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "2160.23,708.01 2176.48,697.95 2160.23,684.78 2147.06,694.78  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 2300.3547,
    y1: 1202.0946,
    x2: 2359.1936,
    y2: 1202.0946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "2356.87,1180.95 2300.35,1205.04 2315.84,1223.23 2335.97,1215.88 2344.48,1218.98 2359.19,1202.09  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 2851.5806,
    y1: 1481.8163,
    x2: 2888.7419,
    y2: 1481.8163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "2859.32,1465.95 2851.58,1475.25 2868.61,1497.69 2888.74,1489.17 2884.87,1475.25  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 2929,
    y1: 1379.385,
    x2: 2984.7419,
    y2: 1379.385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M2929,1370.73v22.44l12.39,11.61l33.29-17.03l10.06-17.03l-17.03-8.53c0,0-10.14-7.29-10.49-8.18 C2956.87,1353.12,2929,1370.73,2929,1370.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 2250.8064,
    y1: 2054.3325,
    x2: 2308.0967,
    y2: 2054.3325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "2260.87,2046.59 2282.55,2039.62 2308.1,2052.15 2293.39,2069.04 2273.26,2063.62 2250.81,2065.17  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 1979.8546,
    y1: 1958.0562,
    x2: 2013.129,
    y2: 1958.0562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "1979.85,1960.66 1999.97,1976.5 2013.13,1968.03 2013.13,1956.01 1999.97,1939.62 1979.85,1949.04  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 1492.0771,
    y1: 1827.113,
    x2: 1535.4517,
    y2: 1827.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M1507.58,1843.38l27.87-5.82l-8.62-20.13l-19.25-6.58c0,0-18.45,9.12-15.1,14.32 C1495.83,1830.38,1507.58,1843.38,1507.58,1843.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 887.4516,
    y1: 1179.101,
    x2: 926.5443,
    y2: 1179.101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M887.45,1166.33v35.76l35.64-6.18c0,0,7.77-42.74,0-39.65C915.32,1159.36,887.45,1166.33,887.45,1166.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 2761.7742,
    y1: 136.0794,
    x2: 2799.6589,
    y2: 136.0794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "2761.77,133.56 2773.39,122.72 2786.55,128.14 2799.66,128.14 2799.66,142.07 2780.87,145.17  2767.97,149.44 2761.77,143.62  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 2142.5425,
    y1: 73.9063,
    x2: 2176.4839,
    y2: 73.9063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "2147.06,62.64 2142.54,77.33 2157.57,85.17 2176.48,77.33 2168.35,62.64  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 3222.8064,
    y1: 255.5118,
    x2: 3402.8064,
    y2: 255.5118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M3229.97,265.12v57.8l44.32,20.51h29.42l24.77-20.51h45.29c0,0,23.23-40.27,25.55-43.2 c2.32-2.93,3.48-41.07,3.48-41.07L3358.68,183c0,0-52.26-14.21-60.39-15.37c-8.13-1.16-49.55,48.93-49.55,48.93h-25.94 L3229.97,265.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 3280.8708,
    y1: 521.4323,
    x2: 3312.8064,
    y2: 521.4323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "3290.16,514.85 3290.16,543.88 3312.81,529.95 3303.71,498.98 3280.87,507.83  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 3697.5806,
    y1: 961.3309,
    x2: 3729.5161,
    y2: 961.3309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "3706.87,954.75 3706.87,983.78 3729.52,969.84 3720.42,938.88 3697.58,947.73  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 3457.3918,
    y1: 925.8786,
    x2: 3489.3274,
    y2: 925.8786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st181",
    points: "3466.68,919.29 3466.68,948.33 3489.33,934.39 3480.23,903.43 3457.39,912.28  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 2153.7742,
    y1: 697.1711,
    x2: 2169.7742,
    y2: 697.1711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st182",
    points: "2157.39,690.72 2153.77,692.78 2153.92,701.67 2161.77,703.62 2169.77,700.01 2169.77,694.33  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 2075.0645,
    y1: 898.5582,
    x2: 2129.2581,
    y2: 898.5582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M2077.97,916.46c0-0.58,5.81-14.52,5.81-14.52l3.48-10.45l8.32-7.94l6.58-5.81h7.35l19.74,4.45l-13.94,10.84 l-13.16,18.58l-27.1,7.74L2077.97,916.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 2271.7671,
    y1: 1051.14,
    x2: 2318.5066,
    y2: 1051.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M2271.77,1063.82c0.72-0.32,9.62-7.03,9.62-7.03l6.97-4.77l4.52-4.77c0,0,6.32-2.32,6.97-2.58 c0.65-0.26,7.61-4.52,7.61-4.52l6.19-1.68l4.86,1.24l-14.67,9.09c0,0-1.81,3.35-2.32,4.26s-2.97,3.48-3.87,4.52 c-0.9,1.03-10.06,2.97-11.61,3.35S2271.77,1063.82,2271.77,1063.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 2315.8386,
    y1: 1202.0946,
    x2: 2359.1936,
    y2: 1202.0946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M2316.23,1221.49c0-0.58,3.1-14.13,3.1-14.13s10.06-5.23,10.45-6.19c0.39-0.97,9.48-7.35,9.48-7.35 l13.16-9.68l4.45-3.18l2.32,21.14l-14.71,16.88l-8.52-3.1l-20.13,7.35L2316.23,1221.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 3234.8064,
    y1: 265.5863,
    x2: 3401.552,
    y2: 265.5863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M3234.81,321.69l30.19-37.55l6.58-26.71c0,0,25.94-15.48,27.1-16.26c1.16-0.77,20.9-8.52,22.06-9.68 c1.16-1.16,25.55-34.06,25.55-34.06l10.45-9.68c0,0,27.1,34.06,26.71,35.23c-0.39,1.16-15.48,22.84-15.48,25.16 c0,2.32,1.16,24,0,25.94s-39.48,16.65-39.48,16.65s45.68-8.9,45.68-10.84s3.1-32.52,4.26-33.29c1.16-0.77,23.13-9.52,23.13-9.52 s-0.65,37.72-1.44,40.18s-26.34,45.66-26.34,45.66h-45.29l-24.77,20.51h-29.42L3234.81,321.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.5806,
    y1: 1379.385,
    x2: 349.5807,
    y2: 1379.385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M176.74,1388.99v57.8l44.32,20.51h29.42l24.77-20.51h45.29c0,0,23.23-40.27,25.55-43.2 c2.32-2.93,3.48-41.07,3.48-41.07l-44.13-55.65c0,0-52.26-14.21-60.39-15.37c-8.13-1.16-49.55,48.93-49.55,48.93h-25.94 L176.74,1388.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.5806,
    y1: 1389.4595,
    x2: 348.3261,
    y2: 1389.4595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M181.58,1445.56l30.19-37.55l6.58-26.71c0,0,25.94-15.48,27.1-16.26s20.9-8.52,22.06-9.68 c1.16-1.16,25.55-34.06,25.55-34.06l10.45-9.68c0,0,27.1,34.06,26.71,35.23c-0.39,1.16-15.48,22.84-15.48,25.16 c0,2.32,1.16,24,0,25.94s-39.48,16.65-39.48,16.65s45.68-8.9,45.68-10.84c0-1.94,3.1-32.52,4.26-33.29s23.13-9.52,23.13-9.52 s-0.65,37.72-1.44,40.18c-0.79,2.46-26.34,45.66-26.34,45.66h-45.29l-24.77,20.51h-29.42L181.58,1445.56z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st189",
    x1: 2714.49,
    y1: 1059.23,
    x2: 2708.5,
    y2: 1058.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st190",
    x1: 2696.83,
    y1: 1058.29,
    x2: 2562.61,
    y2: 1051.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st189",
    x1: 2556.77,
    y1: 1050.87,
    x2: 2550.78,
    y2: 1050.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st189",
    x1: 2725.11,
    y1: 1067.99,
    x2: 2719.12,
    y2: 1067.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st191",
    x1: 2707.6,
    y1: 1067.06,
    x2: 2552.11,
    y2: 1058.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st189",
    x1: 2546.35,
    y1: 1058.51,
    x2: 2540.35,
    y2: 1058.19
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2828.52,560.49c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2831.69,562.56,2830.11,561.62,2828.52,560.49z M2830.42,547.99c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2830.76,548.23,2830.59,548.11,2830.42,547.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2830.42,547.99c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2832.11,549.16,2830.42,547.99,2830.42,547.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2831.36,540.63c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2828.51,539.79,2831.36,540.63,2831.36,540.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2832.85,559.85c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2836.02,561.92,2834.45,560.98,2832.85,559.85z M2834.76,547.35c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2835.09,547.59,2834.92,547.47,2834.76,547.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2834.76,547.35c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2834.76,547.35,2834.76,547.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2835.69,539.99c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2832.84,539.14,2835.69,539.99,2835.69,539.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2837.62,559.04c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2840.79,561.11,2839.21,560.17,2837.62,559.04z M2839.53,546.54c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2839.86,546.78,2839.69,546.66,2839.53,546.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2839.52,546.54c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2839.52,546.54,2839.52,546.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2840.46,539.18c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2837.61,538.34,2840.46,539.18,2840.46,539.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2831.45,582.53c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2834.61,584.6,2833.04,583.66,2831.45,582.53z M2833.35,570.03c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2833.69,570.27,2833.52,570.15,2833.35,570.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2833.35,570.03c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2833.35,570.03,2833.35,570.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2834.28,562.67c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2831.44,561.82,2834.28,562.67,2834.28,562.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2835.95,581.14c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2839.12,583.21,2837.55,582.27,2835.95,581.14z M2837.86,568.64c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2838.19,568.88,2838.02,568.76,2837.86,568.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2837.86,568.64c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2837.86,568.64,2837.86,568.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2838.79,561.28c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2835.94,560.43,2838.79,561.28,2838.79,561.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2835.7,604.23c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2838.86,606.31,2837.29,605.37,2835.7,604.23z M2837.6,591.74c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2837.94,591.98,2837.77,591.86,2837.6,591.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2837.6,591.74c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61s-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2839.28,592.9,2837.6,591.74,2837.6,591.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2838.53,584.38c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2835.68,583.53,2838.53,584.38,2838.53,584.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2839.57,625.97c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2842.73,628.05,2841.16,627.1,2839.57,625.97z M2841.47,613.48c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2841.81,613.72,2841.64,613.59,2841.47,613.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2841.47,613.47c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2843.15,614.64,2841.47,613.47,2841.47,613.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2842.4,606.12c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2839.55,605.27,2842.4,606.12,2842.4,606.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2836.58,646.28c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2839.74,648.36,2838.17,647.41,2836.58,646.28z M2838.48,633.78c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2838.81,634.03,2838.65,633.9,2838.48,633.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2838.48,633.78c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2838.48,633.78,2838.48,633.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2839.41,626.42c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2836.56,625.58,2839.41,626.42,2839.41,626.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2762.08,483.54c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2765.25,485.62,2763.67,484.68,2762.08,483.54z M2763.99,471.05c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2764.32,471.29,2764.15,471.16,2763.99,471.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2763.98,471.04c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2763.98,471.04,2763.98,471.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2764.92,463.69c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2762.07,462.84,2764.92,463.69,2764.92,463.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2748.02,466.95c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2751.18,469.02,2749.61,468.08,2748.02,466.95z M2749.92,454.45c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2750.26,454.69,2750.09,454.57,2749.92,454.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2749.92,454.45c0,0,1.11-1.37,1.46-1.52s3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2749.92,454.45,2749.92,454.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2750.85,447.09c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2748,446.25,2750.85,447.09,2750.85,447.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2820.1,540.05c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2823.27,542.13,2821.7,541.18,2820.1,540.05z M2822.01,527.55c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2822.34,527.8,2822.17,527.67,2822.01,527.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2822,527.55c0,0,1.11-1.37,1.46-1.52s3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2823.69,528.72,2822,527.55,2822,527.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2822.94,520.19c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2820.09,519.35,2822.94,520.19,2822.94,520.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2824.5,537.67c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2827.67,539.75,2826.1,538.8,2824.5,537.67z M2826.41,525.17c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2826.74,525.41,2826.57,525.29,2826.41,525.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2826.41,525.17c0,0,1.11-1.37,1.46-1.52s3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2826.41,525.17,2826.41,525.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2827.34,517.81c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2824.49,516.97,2827.34,517.81,2827.34,517.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2807.54,523.66c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2810.7,525.73,2809.13,524.79,2807.54,523.66z M2809.44,511.16c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2809.77,511.4,2809.61,511.28,2809.44,511.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2809.44,511.16c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2809.44,511.16,2809.44,511.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2810.37,503.8c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2807.52,502.95,2810.37,503.8,2810.37,503.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2811.86,518.97c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2815.02,521.04,2813.45,520.1,2811.86,518.97z M2813.76,506.47c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2814.1,506.71,2813.93,506.59,2813.76,506.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2813.76,506.47c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2813.76,506.47,2813.76,506.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2814.69,499.11c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2811.84,498.27,2814.69,499.11,2814.69,499.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2795.58,506.4c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2798.75,508.47,2797.17,507.53,2795.58,506.4z M2797.49,493.9c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2797.82,494.14,2797.65,494.02,2797.49,493.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2797.48,493.9c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2797.48,493.9,2797.48,493.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2798.42,486.54c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2795.57,485.69,2798.42,486.54,2798.42,486.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2799.76,503.86c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2802.92,505.93,2801.35,504.99,2799.76,503.86z M2801.66,491.36c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2802,491.6,2801.83,491.48,2801.66,491.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2801.66,491.36c0,0,1.11-1.37,1.46-1.52s3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2803.34,492.52,2801.66,491.36,2801.66,491.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2802.59,484c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2799.75,483.15,2802.59,484,2802.59,484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2782.5,488.88c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2785.66,490.96,2784.09,490.01,2782.5,488.88z M2784.4,476.39c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2784.74,476.63,2784.57,476.5,2784.4,476.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2784.4,476.38c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 c-0.38,0.2-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27C2786.08,477.55,2784.4,476.38,2784.4,476.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2785.33,469.03c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2782.49,468.18,2785.33,469.03,2785.33,469.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2787.17,487.65c-0.19-0.14-0.38-0.27-0.58-0.41l-0.78-0.56c-4.95-3.52-6.12-10.41-2.61-15.36 c1.11-1.57,2.49-3.27,4.69-3.64c2.27-0.38,3.97,0.86,5.77,2.15l0.78,0.56c4.95,3.52,6.12,10.41,2.6,15.36 c-1.11,1.57-2.49,3.27-4.69,3.64C2790.34,489.72,2788.77,488.78,2787.17,487.65z M2789.08,475.15c-0.05,0.07-0.1,0.14-0.16,0.22 c-1.28,1.81-0.86,4.32,0.95,5.6l0.83,0.59c0.16,0.11,0.33,0.24,0.49,0.36c0.05-0.07,0.1-0.14,0.16-0.22 c1.28-1.81,0.86-4.32-0.95-5.6l-0.83-0.59C2789.41,475.39,2789.24,475.27,2789.08,475.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2789.08,475.15c0,0,1.11-1.37,1.46-1.52c0.34-0.15,3.05,1.72,3.29,3.61c0.24,1.9-0.84,5.09-1.22,5.29 s-1.41-0.61-1.41-0.61s1.44-2.93,0.5-4.27S2789.08,475.15,2789.08,475.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2790.01,467.79c0,0-5.63,3.6-5.13,8.67c0.83,8.3,6.82,11.77,8.21,12c0,0,0.94,0.19,1.25,0.15 c0,0-3.89,3.25-10.25-3.44c0,0-7.15-7.63,0.17-15.22C2787.16,466.95,2790.01,467.79,2790.01,467.79z"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M1878.66,278.18v-7.23c-21.71,2.91-42.01,6.79-61,11.46c-226.49,55.73-265.71,224.67-265.71,224.67 l8.77,2.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st194",
    x1: 1819.82,
    y1: 289.54,
    x2: 1817.65,
    y2: 282.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st194",
    x1: 1728.68,
    y1: 331.82,
    x2: 1717.86,
    y2: 319.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st194",
    x1: 1623.71,
    y1: 402.2,
    x2: 1617.34,
    y2: 394.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st194",
    x1: 1566.91,
    y1: 481.02,
    x2: 1562.03,
    y2: 478.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 2168.4651,
    y1: 933.6282,
    x2: 2247.5269,
    y2: 933.6282,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "2483,1024.63 2453.65,1051.11 2461.9,1089.77 2499.51,1101.95 2528.86,1075.47 2520.6,1036.81  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 2185.1135,
    y1: 930.5601,
    x2: 2248.3599,
    y2: 930.5601,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "2489.08,1024.23 2465.6,1045.41 2472.21,1076.34 2502.29,1086.08 2525.77,1064.9 2519.17,1033.97  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 2206.1677,
    y1: 930.5601,
    x2: 2248.5671,
    y2: 930.5601,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "2499.15,1027.3 2483.41,1041.5 2487.84,1062.24 2508.01,1068.77 2523.75,1054.56 2519.32,1033.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 3265.2871,
    y1: 1439.0864,
    x2: 3344.3489,
    y2: 1439.0864,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "3635.94,665.16 3606.59,691.65 3614.85,730.3 3652.46,742.48 3681.81,716 3673.55,677.34  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 3281.9355,
    y1: 1436.0183,
    x2: 3345.1819,
    y2: 1436.0183,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "3642.03,664.76 3618.55,685.95 3625.16,716.87 3655.24,726.61 3678.72,705.43 3672.12,674.51  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 3302.99,
    y1: 1436.0183,
    x2: 3345.3894,
    y2: 1436.0183,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "3652.1,667.84 3636.36,682.04 3640.79,702.77 3660.96,709.3 3676.7,695.1 3672.27,674.37  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 3093.7051,
    y1: 1732.7753,
    x2: 3172.7668,
    y2: 1732.7753,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "3705.29,998.16 3675.94,1024.64 3684.2,1063.3 3721.81,1075.47 3751.16,1048.99 3742.9,1010.34  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 3110.3535,
    y1: 1729.7072,
    x2: 3173.5999,
    y2: 1729.7072,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "3711.38,997.76 3687.9,1018.94 3694.5,1049.87 3724.59,1059.61 3748.07,1038.42 3741.46,1007.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 3131.4077,
    y1: 1729.7072,
    x2: 3173.8071,
    y2: 1729.7072,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st203",
    points: "3721.45,1000.83 3705.71,1015.03 3710.14,1035.76 3730.3,1042.29 3746.04,1028.09 3741.62,1007.36  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 2762.5447,
    y1: 1634.0682,
    x2: 2841.6064,
    y2: 1634.0682,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "3393.29,1146.71 3363.94,1173.19 3372.2,1211.85 3409.81,1224.03 3439.16,1197.55 3430.9,1158.89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 2779.1931,
    y1: 1631.0002,
    x2: 2842.4395,
    y2: 1631.0002,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "3399.38,1146.31 3375.9,1167.5 3382.51,1198.42 3412.59,1208.16 3436.07,1186.98 3429.47,1156.05  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 2800.2473,
    y1: 1631.0002,
    x2: 2842.6467,
    y2: 1631.0002,
    gradientTransform: "matrix(0.7425 -0.6699 0.6699 0.7425 226.4753 1849.2192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "3409.45,1149.38 3393.71,1163.59 3398.14,1184.32 3418.31,1190.85 3434.05,1176.65  3429.62,1155.91  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 1737.2421,
    y1: 661.9137,
    x2: 1816.3038,
    y2: 661.9137,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "1958.67,1125.69 1952.46,1164.73 1983.17,1189.63 2020.08,1175.48 2026.29,1136.44  1995.58,1111.55  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 1753.8905,
    y1: 658.8456,
    x2: 1817.1368,
    y2: 658.8456,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "1963.15,1121.56 1958.19,1152.79 1982.75,1172.71 2012.28,1161.39 2017.25,1130.16  1992.68,1110.24  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 1774.9447,
    y1: 658.8456,
    x2: 1817.3442,
    y2: 658.8456,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "1972.92,1117.62 1969.59,1138.56 1986.06,1151.91 2005.85,1144.33 2009.18,1123.39  1992.71,1110.04  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 929.653,
    y1: 682.209,
    x2: 1062.3953,
    y2: 682.209,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "1835.27,1883.04 1824.85,1948.59 1876.41,1990.39 1938.38,1966.64 1948.8,1901.09 1897.25,1859.29  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 947.8507,
    y1: 681.4465,
    x2: 1054.0396,
    y2: 681.4465,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1845.6,1886.42 1837.27,1938.86 1878.51,1972.3 1928.09,1953.3 1936.43,1900.86 1895.18,1867.42  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 971.0334,
    y1: 680.5233,
    x2: 1042.2209,
    y2: 680.5233,
    gradientTransform: "matrix(0.157 -0.9876 0.9876 0.157 1056.6875 2801.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#789273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F5F5A"
    }
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "1859.18,1891.69 1853.59,1926.84 1881.24,1949.26 1914.47,1936.52 1920.06,1901.37  1892.42,1878.95  "
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "2583.92,932.91 2613.63,939.11 2715.53,944.27 2746.5,955.36 2741.08,973.95 2710.89,958.46  2613.63,944.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "2700.67,803.97 2719.19,810.16 2782.72,815.32 2802.03,826.42 2798.65,845 2779.83,829.52  2719.19,815.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "1321.31,1268.92 1269.9,1285.95 1227.93,1309.17 1194.03,1326.59 1235.94,1313.82 1276.48,1305.69  1327.29,1292.61  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M1464.11,1017.95c1.41-1.23-24.87-21.16-32.51-25.81s-32.3-24.39-43.77-30.19 c-11.48-5.81-41.33-18.58-41.33-18.58s56.45,11.61,58.83,15.1c2.38,3.48,52.31,22.19,52.31,22.19l33.68-12.28l-12.77-18.05 l-24.39-30.97l62.21,7.81l21.4-24.9H1561l0.18,17.09c0,0-51.28,57.68-54.76,57.68S1464.11,1017.95,1464.11,1017.95z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 254,
    height: 206,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAADPCAYAAAA6cgdnAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAKGBJREFUeNrsnWtzG8fRhQcLULJj JS5XLk5Scpx6//9fknNR7ORTqmJbUSRgd985gz7D3sbsYkGRFCmerkIWWIIkzOiZ07fpSUkmk8lk MplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQy 2c1toz+BTHYnrIyCXyaTGD7IBUHwywT57X/P+BgWAsEvE+y3+54lsMeHtAgIftlTg31zwf3JvS+/ /HLxl/7nP/9ZAns8A/29LwI7/TuRPUHYN3PPf/WrX9UXfd9Pvvfbb79d/BCvXr26/kGbzfjzzz9v HNgbB/gYfq9/PT6EP5pM9inAvgj6MAxpHMdyH9c//elP5Yu4fzgc6vvz19Z9sM3xW549ezb+/e9/ L9+Ke2/evPHgtzyCe/cEBL/ssQO/BvZZ0Ak54IbSE/J8f+OBx+s14EPxce26rly32225/utf/yrQ //e//20tAuPKUEHwy5408Kthp9u+BDrfQ7h53e125fu4AHDROAN/AT3/jskCgCsWgfwzx5WLwL0s AIJf9piBn1y/+OKLCezv37+fBR2v8b4MZX3u4efP8oq/pP4AnNcc65eFAM/z7yxXPrAANBaBpQVA 8MsEfLy+ePGC6lzu/f73vz+B3Ss6HlR0D7l/D9V+blE45+7n9432vMAOuPGc9/PvH+AF4HF1dTX8 85///GgLgOCXPSrgvbq/fPmyuPHelY+wA2IP9i9+8YuNhzwDuvGLAReTzz77jC5/ec1EXjSEElR9 fPu7d+8q+LB8HbgI4DkWgfyZBsJ/ZgEQ/LJPGvqLgKe6A3jvxq+BHVfA7uDfPH/+HO8n/IB842L9 jcGP7H2TlRxaFNUnrONxpSiAYyEA8Pg4vPf27VuAPyAcIPwzC8Cdq7/glz064D3suJ9d6U2Ena89 7PnaQdH52kDvqO54ZBC90m9com+OldE+J75p2O/3Bfjjjx6h+rg3cBHAFa4/FgGYXwBevXoV4b9T 9VeTj+xjQb8I/Ndff12B/9///reJ6m5QlgeBxdfc4tAR5mwd/se+3nnQkaPjz8LVvInqQVhYMAv/ ePziJKbHrwLo+bMPWACg9Pl+jwSkVQPS559/nn788Ud6DWUhwr28KIyNv1lsEpLyyx4F9IvAG/Rn FR4wNtR9Aq5Tdqp5R5c+g84FYKL0+ed29AK8+8/3MEHIxB4hZAkQ7jvdfkKPa76P5z2UvsebjotA j0UghwPlPq68D+XPn/1e1V/KL7tvla9Zdqr17373u7MKj9icqm0LQ8fFIMfjALujshN2qjoM9xEe dMdMHD9H/Rmm9Px6ohq7Fl+8xyf6amnvuKYMvNK97+3zAnT8HBi9hZIozEqPsuBon33E32BG/aMX IOWXPQroJ+BDtfECKs9M/ZLCE3gCbEm6zoGLewC7KrupegdV95Dj6haUiQfAhYJfZ9DvFoqTON/i epbyiuJbnN/bItDjY+d7BzzPt0D/AeqfF7rqBWCBwPOg/sNdJ/6k/LI7d+29yv/mN78prj1VPsPf MTHXUngPvKlyZyreWaLP36NydwwLYE7Ry8+z18zuc4HYMC+QrrP+9AAmqmv3a3bfng/26G3xGKxP oHgHiPNR3tvv91tr/CnrRVb6zZs3b+rfB4thXvSQ+Y8bf27dtvo3LLsB9JuF51TVDtDD/c4qj1i8 A8CAnQ+Al//R499g+Xq2LV5nOLYZhG3+3l2+Vx759S7DU55DtPAaz/P7d/nnlAeS5/x6fn2FK77O 99r98sj3r/i9JoL1eb5ujY3yedzrjvfx3BaOyeJBs/r/5ugATDYGlcUi/7dhQSj9AHD5zYMoeYWv vvoq/fvf/x7v2luX8stuQ+lPXPtWLB9VHgsD3OzuGCAXpW4pvLnt5TVceX7dmnvKPYLolL0zQDfM B3ilZ3OPc/sruF7xY3cPvubr+lR98G4ufnL7AUZbQEp5D58X3glDHZYh8ffC9t+1OwcFv+xBQR9d e8D89u3b2HxTwEOCziXnqrtOwPPr7RzwfA2InYvf2YLCRaBm9fmaVw86/xu4GMWafqutj26+gTpY K+/GdgwmtvLCxbfPOoS+gnpFiIOF0W8ecovHrZf2BL/sTqBHXZ4JPNSzCXdQ+Y6JO8CJRQD38Bpf dwvAdg54PPjau97nYGfM79R94931Vr6iocS1b9/ox88cuIBgweOi4kuQ6bpsWN6D/oIc+2/89mL2 Fbheg7l6v+CXPRzo8Q95xrUvgLMGD2jp1lupjm79Nij6tgU87hN4Jvr4e8yN7y6AfeMgb8F+AhvX CEviocafvJp7T8I6D8t7DPrFP7qV+OT2yx4+9Dme3zCeB/B075ldZ+2ddXeDfss4Hs+5AOA53ouf A8mnS+8WgK2pbHl4dWdZz+DrggvfBN7v1lv590huIdg493+SC+B7ADr+DM6dn1yZBPT2008/lcXC LzKCX/ZQoWeSzpfLOoO+uPZ4biq/da76lsA7D+Do49uCUAg+Kn55TdeegLNzzyXvOh/LRyWeAf0c YWN09+15qb+zqYfJPqvzM2tf3sO9/MjqIwfA7D76//GaC4g1CtXn+NqZzyP4ZQ8Deqi6xdwT195i +a256Vuv8ozrqepcAOjS8z433wR1n7TvemX3+/txa6kv/xzwDvraYGPNO7zvwe+Poj4gPsHznve4 GPifCcjz37IM9mBI4LYG3wnsgl82B37st48xfRN6uvYOerr2W1sAmLzbRpVnHG8/b+uacro54N2C MEnquUac6jYzLvfK7xTcA1YBd1+fwG+AVlW3/v3RSnzD0dnpuQj0XAT6439knxdO/CF67PBDBSBd VwpGDPfEIsA6f/5by+2XPQjoa0wfocd9Zuzz8y1BtwReVXYXy0eV37oYfuuSdjXR1wI+tNxubE7e SRzPOLwB/BjuT+AH1Pz6eF30Z6Z/OO7TKW28fF2gt628BXhc7Z6/ltZfwE/Vj5N/cO8vf/nLuNI7 EfyyD3bxa3MOS3ZroIdLT5XHw5J7W4vnq7JT9QG7V3nG9S2VDy59FxJ46egItDP13HQTYXfKXuGm onvYCaN7jx/UMZh7PtjvGQz6gSpvrbtF/fP9A65Q/ffv3/dUfZvmM/z88891rBce+T1j63NL+WV3 Etdn6Ds257x7967UmQG4Jekm7j3q8R56g3xL3x7tsFwAmLCja2+tsgV+e12TeS5pN0nmReBnynIR +rERs48NVU/msp98PbnefQ+72WBKTejxdSr/YNDX7bxYAPAaCwAeeWEtHX/0Hjjqy1S/pe6j4Jfd iYufoS/xvG/Oodtt3Xgdm3Tg3jegL88JuUG/pdLb8wJ9dOtj5j5db8NNlslfBJ6Z9zl19wm6qOpU bt7nzD23EAx++OaKRWCwe729qadHgOeWBBxsERh++umnyUBPU/17cfkF/xN18WNcnx8dd9CxaQZq bypeFgDA7dz7FvQT4NP1ppjq2lvsPtkQEzvxYgy/BvgFdR8C7My6l2uEOV1voy1XK7nx5w1+EcAV pTtbPAaGAzbEY7CY3+cD4PaXygCAp+vvR3o71b9zl1/wPx21n7j4C3E96/SM67fWXltgt+tuAXq/ C64qOzvz0vUeep+936RGL32rtdaaY1hiOwHettHWxFxQds7R4977eg2LwJCmwzgHO3WnwE6zgZzl 61wE3M8rI7wAvs3w6wm9/fwBwzptvBcepfaflk/x1QBP2e24+IzrmUzDllrL0hcXn7E7lN7H8Xhu W2kn21353BTeZ/Hrw6k8k3tx78zJHvbg0vv6egU+uRIcJ+lwAXCKzf32tTzXWjBC3D/E5J+BPsbv sa9NBndyeq8f3okpPYAe78PwDiwg+ID/+Mc/zo3uEvyyi9S+Qo/JOXDxLZFX4/rPP/+c22BLIo9K H6DfWYaeC8CuAT1bcCfJvKDyXZrW4jczStd06z2wLYidR0AVrh14c9/r3fcG6L5rr97HA0rN5y4c KO8n9PwseG5z+0fr4CvQZ8+qTPttgJ+S5vbLPkTtUbrDIA3utvMuvg27pIu/tcSeh35HpQ/Pi+u/ AP3WQR9Vfunfmwd+mEnaDV7hI9xU/ca9CDtj/sGDHhOCBJigp+vJPcnX5lGzd30ANXGI5x56vh+K z5bfBfCT4Jd9kNpnFerWuvjbY8P5zq74OqHfeRffJuFMknoB+s435MSavMvIe+gnbbO8F9toPdiu tTYqfHWzLSafwG5x+GSR4b2o5h5yXAF6hJ/9AnyNjr34dfxJ8XfA70CM/8MPP6x183VWn+zmar/S xd8xcYdEMKH390KM37kEn4e+JvLczPuJwnM2ZoA+KvrYAj4dZ+R54PsG8D7rPkTYvQcwB3pU8wg5 /gO8mmNXnkseJg88N/XgfgP6c8CryUd2c7VP16W74tr70p1l60sMb7PytjYPjxn8Cn3M5qcwyy5M yfFKP1F5qrkHnDXz4K73TJa5abiDa6Otbr6NySo/B2434mr3ejAA/W67Wmbzik+3nRl+Qk7Qsxtf D+Xk13HNf1PCX69QePTp4+cZ9GlFTH9vm3uk/I8T+gn4a9Qe/57nXHzAz8Qes/h8boDvqPQE3t7T NXbWzWXtJwrfUnUPODfLuPewY64uCiyp8f187Ut7eI21hR4BVd2/DsrPY7ZHD7lbCCaQ+3uY6w/Y uSUXQzq/++67tcp+L119Uv5PQ+1x8EW3Vu3ZnBPVHnF9VH0f2zPDT6V3dXvfijt3nt3oYveW0td2 WHPZyxXdcFYPr33yTsF7dtKxdm6A13ZZvib0UHZ6Fl7Vqegov0XQMViDbjthd+58eW6hRLKpPeX7 s8KvVfKPovZS/k/EzbfyHRW/9t9D7QEmsvhe7Vmyo6rbArBzSTy69bxXs/kp9OMzkTd3qMWKhF3P ffDudV0ErCc+Kv7AjTN06ekBEHC683kxHNxR2YOHnaruh2hE0FuQw7J7X5/b4RpLan3J6/Fj/gOT PZ6kXse6vcFfgMR9PofC2wSdmtCzrjwP+y64+Ls0nVVfobfnTOylmdNrJz3xC9BXsBm7c+trWABO XHz/eg54m5hbj8pm9r0FO72AlstOhyZAfsmUnTXvHR/CPzTZI0nqsUvPevJnY3tbAHZ08QE33HzG +V7107SJh4m8SVuuG4T5wdBz51sEntDTI4jAe8Xnvng8Z42eC0EEPsKe/3aJiwBBz5CfU+NLID8H 9viQ/rHJHs7/D5ulpB434tDNz7E9B2DWJh2qPUt2VrNn5n4Xave7JRe/kb2vk20/FHpuerFTLKtb z5NtW8BD4Ql8hD0CT+hZaiPslog7l4S7bZDHh/yPTvaA3fyY1IPaA/hkdXubkzdx7Q3semwVYWdM 75J8fr99Ld3xZJsV0I9U8Euh9+7/nMpjRxzLflR4dM/RtffuvAeebvzr168vqaWPtwTv+JgUR/ZA 3fyY1GOXnm/NZdutU3l/nh079WqrrlP7ug03XY/NKp8ljsZqQe/d9BnoDw3oh5bqz6k8f9fbt2+H qPBQcu/OB+BvUksfPxXABf8jBD+6+Xj4pJ7F9lXtWbcn7FbCm3gAPr53NXw/S8+PvD5px43uvW2U 6RvZ+wn0HGRhR1f3riuP9yduvld5uvVZ5Ycllz6485d2zI2fKuCC/+FDH8FvuvlZ7bcuqVe33Lqk nld2f5Lt1sX7sWlnktBrQZ/CVtmG0kfoC/gz0Pes26NmT6W3GXeTWJ4qT7f+jEt/G279Jwu64H/g 8T2bdnw2v+Xm+6SeP6oaz9P0uOmazDPgi9rb4uATei0XnxtcfGfe4GvzrTjenh/o0sf43kFfXH26 9nbfb38dolt/R8CP+sco++jx/ddff32SzYfat9x8f948z5nnAtAo5TXV3p2pl9xBFzxyym+mqbvn YmmOoIeY/tDI5LM5p3xvXrh6QO9jebbccr+73wWH17cE/Kh/ioL/wcX3c9n8lpvvk3oupp+ovsvu V7VP11N1TtS+4eJPTqPxSm4LQBN0uPx87xL0XuW9aw+ln9kFl9LpbLs1XXICXvB/9L/vBPwXL16U 02sZ38emHUC/0s2/ch6Ad/Vjt17XSujFabbxBJowjvrA+fRM6vmSnVd6795H6GM8H137UJo7t8d9 FOyC/9Ek9hDff/PNN5usfCfxPZt2bDPO7pyb78t6YU9+5xp3ltTeT7zpG3H9JGufrweXyDtcCn2M 58+49mtVXsAL/scR33NTzrn4HrX7c26+d/dd3b5C7xt1ZtS+b+2w8yfOeFee97zb76AvjTpL0DNr vzDVRiov+D/d+D7W71vxPcGfyeZfBTd/silnKZPvwO8bat83XPy4ABx4Jh2h90k9jKq+ZegFvOB/ vOBbfD9J7HE+PhQ/xvfWrRfd/KsZN3/nknpU/JO6PTP5fkDGTMnuYKfNNKE3F788p9KzTo+SHVT/ DqAX8IL/cYKP+B7QM7EHQ+0e8APcGN97954q33LzZ5J6nYc+qH0FP6p9UPiDc/EPvoQX43ooPTvy CD3LdYJe8D9p8F++fNnhHDyCTzc/P9+uiO+vvPJHNz/sxuvCttsKftxpZ3voDzNq72Hnew4eejt4 Eq24ExffZ+8FveB/8uAjo+835vjE3g5zqGbi+/z8ymr1Vy0338/Ua6m9gT+Eun1/Ru0PrkvvYPH8 JMb3yTx83ZftfMnuBpNqBb3g/7TAZ2IPFhUfKu/r9/l65VS+XJ3Sx6QeD8Jsqj2Teq5Lr3dtt4eG 2vvYvi4KXu0R1wN+xPbOxa/ghzr9Rx9PLZs3DfC8B/CpzAAfys2EHg++ZCuuBz8d23FLAw+hT655 J12feDsH/kkfPsHGc1yh9FR7egCo4efPVBt5oPpYIOjiM7bnGfOM6zkye6YjT0ov5f/0wffNOwSf ao/nTOzN1O2vwpXP/UEal7j5NakXynZs2jkEd//ABh6v9kjoAX7cX3Dxh7Q8k17QC/5PE/wvv/yy xPS+eceD79pzJ4k95+Izrr9yIYDP+PsRWyfTdaKb30jq1SvuEXwX29fFgdAztmdyD3vqV7j4SuQJ /qcF/rffftu9efNmEXwf3xN28wAA/JW18HrVnxyRlabZ/Hoazpybz7jdK3t092NsDzcf7j6g97G9 L93xBJyZuF7QC36BH8GPGX2A7uL7K1P5GuO7dl1uxU0L4E9GZ/ksflT5hrtfM/oAHm4+99eb2s+5 +ErmPWLb6k9w/+BbYo/gXzm3/yoM3ax9+g76CficitPaZpuvGGy/99f89foai0D+fAeqvTXt9Ezo 2Yk44/Pnz+sc/O+///6mLbkyKf/TAd+A9xn9K6/4PrNvwF81FL9rnIoz+r32vh/fZe7nVL7e83V7 ZPJDbF/VHr8nnCMvF1/KL/BvCr6594jzq/Kn6fit7RnwTybkevBx9SqP5/mz7ON7YOm4q6+fU/sA vtReyi/wPfi+a+8c+L5zj24+p+64o7DXJPZqfG+Z+j1VHcC34n2f1GNrLpSfmfys9sNKtRf0Un6B fyn4VH1T+0l232r5m5WJvdqRZ+W7fbhWN59qb3F+3ZTz7t27nmqPBw+1bKi9XPxPzNThd0fgZ3W9 iu26BJ8bdtJ1uy635HZz4PuxWlR7gm+NOUX18+tyhbqjds+FgWpve+1rUg9delT7hUy+1F7KL/Dv CfzrD3HdsVcU31Tc9+Yf6O4Ht58qXxYAuPsAP4Nefg5q9wZ+ie8xVbuRyZfaS/mfLvh43Bb46Tqj H8HfRPBbHXsxsdcCP/Tql4Qea/f4OVg4EN8D+mfPng02JXdYmJ0n6AX/0wQfvfozWf2LwU/XJT12 +dWOvbmhmo3ttxPwzb3fB0/g4CbtHLybj8k7gJ5JvQ8YpSWT2//pgo/deRi7taac58G3+3Pg15bd UMrbWGyfziT2qtLbgI09d+IF5S9JPag+fkbLzVdST/AL/BnwsS2X03cuAT/NZPJD196khs9xe63m neDK732CL79nfy6+Z2IP0GfVL17F3/72N7n5gl/gpxX78deAb+fc+yaeOfA3dnrOYvMOldxdW4m9 WtbD98ID8DPzbVNOie+H44fGSbZy82VPNua/FfBb03fWgB+hN+Wve+/Zo88YHmrfquP7nXq4ujJe 34rvF9x8QS/lf3LwXwQ+t+P6Bp4Vyb0T8GNyzyt+mJg7Ad517E0y+0zswc1PoX5vij8KfFm0TuBP x2tnN7lm9pd258WpujcB32AbwqacvUvs7ePVwN/b+/bsz2diL4NfpvAAfMT4KOW9fv26TPYR+LKn 7PY3wceDc/VRu+d47XPgp9OW3UvAPzn2OpTyZl1917F3YGKPik+1R6tumtbvlc2XPVnlb52YW4/Q ahyoMevqt8D3h2pcAP7JNlyv9KbsqOVX5beaPq4FfCg+ynqm+AX8/NmL0ofE3lxmX+Ar5n+aCb4M fscjtNyBGuXorKyiPrl3ZRN4rlrgs7R3A/Cbis+SHjP8bqout+JOWnUBPWr49rPHBfCl9rKmGj4p 8NG9h4GbWTWLiw/Fx/HYPrNvC0BN7iW3H9/24k9adpPbi18Iuxz8vY3L3vutuTwxB7V8TtwB8G/e vKmuvsX3SuzJpPznEnzs3sNWeHTc2dl5peeeB2Vyoq5X9/x4ZrBfxV79RufeGvB9195JLZ+Zfzdm q5byAvjnxmcLfNmTifkXS3rM6uMB8P1JOrhy0CaSfWk6gacsCA3w49itejquTcUZzoHPON/H/QY+ SnkHgm9jtmJGX4ovE/xpIbMfj9GCWrvM/o4JPndQ5mTYZppm9uvuvIbi1yEcKxV/UtN38f1sKS8d M/ot8EeBL1uy3ScOforgI7NvtfwNE3xQfRydZWfnIdbnrju6/Zyh7+fp72zc1mQ//uSXTqfvtLL6 E/DZvOPBZ0afM/ZiKU+JPZmUfznBVwzgI85HLf848u66pGfHZPuSXi3bpTB2i19rDeJwCwD343tX v49bcpfAp6tP8C8o5Ql8mdz+NM3sx5JeWQTcMVr+NB3v5k9q+MkdmBkn8HAIhz8O27n6vmGnxviu XXcfXX0cjBnBR4wv8GWCf2WCDyW9DP7GN/EwzkeGP56mEw7P9HH+dg58D96Mq38g7GjccYvBoRXj A3zO0Bf4MsF/wwQfoM+wFaW3kl6dxGMZ/a0Hv7U7L4VhHAsTeE4O0ohz9f02XYLPDTpz4GMAh8CX 3ZZtPzHwJ9AzwZfhKWU8U32Cyw6+elCmwf0sHqqRrufvMc4vO/7CMI4J+Ijv8+uTBh4f4+ev79cq PsB/9erV4PMJAl/21JV/qXW3Jvh8Zt8l+Kryu9bdVpJvt3CElj8e++T4rDCMYzJL/wbgS/Flgv+c 20/w42Yd69nfhlq+L+NNknxYIOgppIUjtAg7J/CwNdcl9Iry83mjnDesAD8l1fBlgn85wfeHP/yh Jvh8Zt8l+LYzJb14L47fWnVgpk3gObiE3t4WA9+y27OOn39WfwH4SeDLnjL8s408jQSf7+ArIMPL biT4YkmvZvbD+K3q7rf69anyYQBHgT7//r3r1fedewJfpoTfDVS/leDjTj267Tu6+zwZl9ty8/WZ xfbPXL/+Fb8vQ1mGbTbifJ6k05yrH8/K47ZcJALzZ5sF38p5Al8m5V/h7icf54cOvi528IWW3Ste XW2frbs1xm+B32jiqaW8GOuzbx878/A9iPE5Vnumjp8Evkzwf0CczwSf1fS3IcFH4H3Lrk/wdS7O b2b2wxFacYPOpL7vB3Hkr9UYH/36Cw08Al8m+G8a57cSfEzuhVh/6xJ83bnM/lwTDxQ/KH9VfJ6i Q8XHeoQJPAudewJfJvhb0KfpTr1a1mMH31yCL7V79Xc+wdfYnjvJ7LfOzuMwjnhuXizp+f34SZt0 ZIL/w+L8ViNPHMrBzP5MaQ/v71oHazQy+wd7zrLdnm27vomHiu9Lehy9JfBlgv+W4vy4Rdf37jPB B9c/qn66Lul1NnvvJM5vlPR616O/58k6rSYe372HYZvcky/wZYL/luJ8v0XXJfi2voPPxfhXFyT4 JiU9qj0Vn008KOPNNPHU7j0858w9gS/7mLZ9RPBv3IK1WM8H1DaOi3V8P4ijechGmmnd9aqPDL2B 3TOx55Xf7nGHXrn6I7Itzh/teGz16suk/Be6+2fr+Zbhn9ubP5fg62YSfCeZfdbtfazvs/2YsWdZ /ZNa/syBmQJfJvjPxfl4rKjnxwRfK873jTytzP7oj9NqDebwih8z+1B8X8tnE4/Alwn+yxeCWtbL oG+W6vk+zucCkKYbdXYxwefhi+A7N38ykcdv2PEDOfLnKck8P2KbTTxJZ+bJBP9Fqp+iu3+unm+u fHH1OZcvuVN1UNJrJPg8hKUs51t345FaODfP78tngg9uf47xe4K/solH4MuePPyr3H3G+VBuJP7S cabeidqHhN5FcX5sz3Uz+Or4LTs/r4+ZfVwvKOkJfJngX3D3Z8t6nLxrC0ABPH/taiHO787E+Set u1B2gh/LeVgAWMtPti//gpKewJd9FNs+QNhPVB/g//a3v10q65UZfO4svVrWc/d8OMD9+V0LfDwA MRJ2Pr735+cxwWdeQW/5AR/nry3pyWRPXvkX3X0k+ebKejxlx5f1cOVAjnS9YSfG+THmnnTwmbrv mdmn4sc4P+7SU0lPJvjvyN0/V9ab2bjT+f35M3H+5GitCLvv4PMJvtTI7Dvwk8CXCf71ql8M2f3s 7tdz9Zjdx+f2ZT2EAYA+zOSr23PtcA28Xqznxzifbr0fw2UJvnJaLhN8rnuvZval+DLBf7MF4Ky7 n2a26foFgIM3qfjZFuv5bN11vft7twC0OvhKbgDgM8GX5jP7Al8m+Gegv9TdL2DbaO25XXp+t95c Pb9s2vFxPhN9Hnwm+NwYrt4n+HBqbv68yuzLBP99uPuM8d023W3s4lso6w2tUVyxX9/H+X5vPhYN P4ZrRYJP4MsE/7kk31p338PuHnV7brpu3/UtvJzBN4Z6fh/ifJ/oK24+PIMY52MdspKegJcJ/pvG +Je4+7GLz3Xv7Wbc/WoAP1lZL3Ty1QUgdvdhAXj//n0zzv/hhx+0PVcm+O/K3cdC4N19i/cr/M7N 3zp3v2udsGPQD+6IrcksvpjgOxfnJ03blQn+23P3eZR2bOZpuftM7jG7n2Ym7y6U9Xrft+/i/F5x vkzw363qn2zVheGKTTu+mSdm9xvufu3im/zS6wTf4BJ8MdF38Im+uXr+yjhf4MsE/4p4P5nq+xN1 u7hHv9HMsz3j7k+SfMnN4nPtu7WsF2L/fqmevyLOl8kEfwP6ibvPJB9ifYgzwIcHwK26jd59X98/ ye6v2K032Z/f6Oir7buK82WC/24WgEmSD8DjUMx4lLYtADvbrrsNzTw1u+9m7nsIW3H+5NANV9Yr au/35yvOlwn+O1L9VpIPn8urPgEPI7lq7z7BT6e9+yzrtdz9muhrlPUOrTgfffuK82WC/xYWgFaS 71wLr8X7kzP16O63evf9HD63W6+PyT1+3bL7JbbHohH79hXnywT/h6s+k3xcADZU/UZN30O/DQM4 Wy28l7r7NbuPr6OZJ9+v7j4+ykLfvuJ8meC/qerjAWsl+ZLbpJMaNX0Cf6G7X6bvuKEcNbu/oqyn OF8m+G9B9TvG+1T9mOTzMT5Lfb6kh++5gbvf+2Ye18XXdPddWa+l9AJfJvgvVX1m+AEvroj1AbTd 83vxt+b6cxJPs4Ov4e4PDXe/b23aabn7C2U9AS8T/B8S6wNe8InNOz7WT9dJvskCEBt58PMy0In9 +1bPb7n7fSu7v+TunynrKc6XCf4LF4DkYv3y8LF+S/XN1fcNPFX1raZfwU9u406jdbe/JLsP1VdZ Tyb4b0/1N3/84x9Z1y+uflb9sgjYDH7Av2UCEKAb+NsW9GzoIfiNmfu9P2dvbXZ/xt0X+DLB/yEL QoasuOl4ZNDKAkBFx3N8Jig+a/i4j5yALQSbuGEnTYdz1Ln73t2Pvfu34O7LZIL/Essuf7JYP1ms X1Q/u/wbWxCg/hu3ODCpx0k8G8vslwUAwNujxPjJZvF56BvTeOXuy2R3CH9z2y5cfoguHgTckn7V pfcNO76G76H3it+I8/vW7H1/tJbcfZns/hJ+FVq6/XD5CTWuQfEr9PY8+e9PoZaf3EguP5kndPP1 bgEYcIy23H2Z4L8nI/h4/sUXXxS4nz9/XqEPLbob+x4/g4+lPJbzquLHo7RD737vJ/Ok4978Xu6+ TPDfgwF2uPsO6JP3QP359WO5f1rGS42jtWIDT5y37xcAxvlQ/eS26rJ3X+6+TPDfgf35z3/26l8X gNCbXy2DOonrmc33au+n7/q6Prflco9+nMCLK9x9tBic6d2XyQT/hTH+rCG7T9Aj8M4bYExfwDTo m3E9ld1q+Pu4VZcLQJzAS8VX775M8H9cK6DD9caVB10iE28JPR/bH3j1Lj7BZy3fN/PMuftI8p3p 3Rf4MsF/a27BZoNteAUqXC2eL6SHFt3Jxhzv5vt5e3aY5t418ez9ZB4287Tc/ZDkk7sve1K2u/fV xoFvYUCi6iPrnlW6qLJBjhUA7y3fYh2AG7dYFJDRsYc0gVd88wzqMVt09wk+3H13lLbcfdmTs+0d x/y1bIdsP8yafErvPu5nRcZWXrbxcqceoS/dvHiOfACgtRAAEPfmGZwM52Cc3x9/Uc3yW02/gG9J vmFG9QW+TG7/bdlf//pXwluU/s2bN8XNNw9gYEzu1ZoZfIvdcXJucel5pBbcfXPz9zHmRxcfQgHf uw/VDzX9pBhfJrf/9mxM7Yx/uc/S2rGfp8g9ZuJjks+QXxZX3zblJFP9rb1vsqkHLvtxN3DZAjjZ s8/2XQO/NvMwzg9JPrn7Mrn9d+D6xxN40cabbC7/5t27d6XDzxaFckV9Hw0+tvlntHi/ZOmR/ccj AF8n8/iZ+0jxQ+XhUSC7j+fI7uP7leSTye4H/nrvxx9/TF999VUd5FFcj92uKDpGeuVYvLwRMT5D BIN+ZGWAnX3J7eCzzTrltTtiq3gS7N2H4mMx+f7779XCK5PdA/xe/Yu9ePGibubB4/379ym7/HUh sEQfQC3KzyRfePRM6MXEHpQdrj6uPGILio8k3+vXr5fm7gt8meC/S9cf6v/rX/96smU3w1nKeVn9 ERJgESgwHof5HA3Kzfq/lfZKLA/oEdtD5blJx2X2K/jIEeTfLXdfJrtn+Cf3s/onuPhs54X6YwEY j8f0lL5+qD6AJ6hmHNpRqwOAnll8WwzYwTcSfCT4Zsp6Un2Z4L9H9U9QfywAfq8+FgBAj/Pwygez qgCn9WSIS3Yf0Of3lsSdZfDZEFTcfFs0SozvwFd2Xyb7iPBPDAvAL3/5y8kCgEoeXH8Aa4tAifkB OMd1WR6gqjwecPGR7wPwVHzu+w979AW7TDYH5T2o/8QTePnyZRnfzfFe3PVn1zIHoPVDrUmo7g/A lfvysQi4nXpLzTxaCGSC/x7Vv7kAAHZk+90iUN7TGvpBLyEdk4IpQH9uh57Al8nuCf5VCwBe+EUA rzn5ZzZmydDnOD8F6FNal9gT/DLBf8+/59xCkL755ps63vuzzz5r/kBAD1c/x/RppWsv8GWyjwD/ uQVgdlH4v//7v+YP++6779IZyOdgF/gy2UeEfw78pefRxgufC3yZzIfND2DBWQv4ufuCXiZ74PAv Qb/WE1m7KAh6mewBuP03+Qw38QoEvUz2SOC/zc8i6GWyRwj/TT+XgJfJZDKZTCaTyWQymUwmk8lk MplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDLZfdj/CzAA 8MYwQ1K5d7UAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 1620.9794 326.0458)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 254,
    height: 206,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAADPCAYAAAA6cgdnAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJadJREFUeNrsnQlzG8cRhQcLUlIq kg+57FRc+f+/LOXEsiLHNi1RIbGbecPu4dvG7AHeFF5XIQAWIAgr/Ob1NT0pyWQymUwmk8lkMplM JpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCa7uW30TyCT 3Qsng+CXySSET3JBEPwyQX73PzM8h4VA8MsE+929Zwns4SktAoJfdkywb27Bwm3hHw58LvhlsjuG /UbXfvzxx/T3v/998hf961//Sj/99NMc8MNK8AfBL5PdHvYlqEePf/jhh/T999+XJ5eXl5vdbnej L7jdbtOvv/46vHv3LgI9zMD+4J6A4Jc9Z+A3Bzxvgu6Q932/ybfyIj8uFA7DJt+Wv+Rmg9vQdV3K t3qfF4L0n//8hyFfsxjc+wIg+GXPCfiDlHwJdL93uPHcIWfg8XjVF87g+wKAe4CP++wJDCcnJ8Nv v/02rFwEHmQBEPyy5wb8Kti//fbbRdAddofbX3v16tUm3/YWgCn1Z+A/f/48fPr0ycEfzAMYsAAs LAJrFgLBLxPw8f67777bZOBHsGf4m6Az5C9fvqzXW4vBGrff4Xf1d+D/97//Defn54MvBBn+HvA3 FoFHWQAEv+xZAu/qfnFxMQk7bg4vHgP2Fy9etBaC0fP8npTh3KyBn8HPYcWQvw8rfu+LQL71fg3w n56e9vm2tAAIftkXC/1BwLO6I353Nx7QL8FuwG9I4TcZvo1DHhcD/514nN+DxWDvPyZ/h3Jz+PGr Dfw+f6chv9b7AoB7PPdFAF5A/m5zC8C9q7/glz0r4AG6w87AroE9A9wBdn7NAbfXNxlMVvvNSk4K 9Plzh/zdeov/e1sEys0Uv9yyd1AWgfz71iwA9wb/if42ZY8A/UHAf/r0aaTuDDRidnLlNxkqf18H ZceNYO8QJjjoGcTyPl8A/PNxHWW6lfADengAvcf1AB1mC0Gfv6M93ZXPyd+p/GD+rv4ZvZUWh4l/ x4HupfyyZwH91AJwkMIz8K7u9lo3pewMdQayg6L7AuCqDsizdaz+/hj3aNbBGxrffzBicRtc+QE6 bvnnC/z5d+7wGNRjQcjfDc/xdAf1x4KRf8cOHgAWiD/++ONB1V/KL3solW/db96+fZu++eabWYUH 8FBwMIRrnz9/ruAD9vxax8oO2G0RYLB9AegoHCiv4zotDuC9/m4PAbAQwBsI0HuJb3Do3cXPz435 Dv+Dz9ohP2AJyYSkImL//H07Cxc2M+ofvQApv+zZQV/Lcl9//fWiwjPw7MoDbn9Oyt6xshfSs6rz NbzPwca1oPj2I5v6Pd0DmHL3DX5AX6Te43youys/8oJ4btcuof5YCCwMgAewQ6iQ/7t2pP79QyT+ pPyyu3Tt4+MR+CjNZeiLaw/1Nvi7KeAtfvfYvXPYAa678natc2U3NS+LQ2fmP2OLS8dKj/fSgrCx n9uYTQnkYIsDFLsm9+AUlMD+ygB47fLD27fw8XdYB65+DrV+/GqUCKlUOTR+572U+gS/7C6hb8by rPLn5+cbrsMDViTtLDHXTQEPSBHT4zluUHXLzHcGdr3miwF+Lv9eV/TuSqg38frGro9cfqvrl8Qf xf2Du+2JynqWsCvKjzwCfu7q6ab8gFUlBksO4r+jt4VqtOjg3+irr76ChzL88ssv9+76C37ZXUO/ F8u3VN6Ar+47YnXAvQJ4V/YOi4m7991Vir16AAa7u/bVEzCQR2rvcX+Vepfq6/r/6B8Dau4uuaXp Xfl3viHIYN8OV19osEWns5AFj3trKCqJR/z3P/T/qYJfdlvo91z7N2/eFJX/+PHjnsrjjz279wXG rPKdAb9xwJeAJ1e+vidA7QuMv7XAz7G+eQxV5dN1hr+W9yw0GPveV6o/ysL7ZwF66/ZzrwDfY3CP w2/cUxD2DtTfbYnGQfDLnjz00bWH6+6lOFd5AhoqVxTQVR6fQa9vDdBJ4Fnt3cW361XxGXaLwbsI ICl+BY9Le42W3sEWBE/wFYH3HXwer1sysai7/86QZxgtNgZ7WQgo7r83d1/wy+4U+pZrD7hd5QE8 u/VR5UnhtxPAb13Zyb3fU/wW7B6DO4Su+v7fwao7+49z1cY7mGfQ9R7Y0++hRGFdQGwhmvxc7CDE DsT8byS3X/Z8oLfafNdy7XEd0FsPPTLde259hmLr8XpmZMvxu8G9jcCz4ntZz75ftwD7yLVPy0NC WvvqZxXYcwQxZJiz8/PzskegtX9A8MueFPRITuV4vvPylCfoWOkBbF4EWOW3Dr0Db66xK/o2uPSj 554w89vG3hRq+6OsPbvXab7zsMkxP6bNOz25/SXZZ8k7f4+/zknB2vvvhjKfeQWDJxB98Me4qbD5 fQS/7PGh93je1L9ASrE8Yvuq3ADagN2a57z1xcCe18f0fM/Ft0VjL3lHih//W9bantKzq++QG6i9 gV7gR12fHtfX6DbQIlJq+7YIeEhRdwfaYiDllz0I+LeC3uP5hmvvbvx2QuW3FptvTc1d4bcR+NC5 Vxt0Gsru2fryxDfThLh9CfbEsFoHX1H9oO699/OnqzKfd/WVjj5fDPgehjq/fWbZ64+FAIr/0H8I gl/Q78Hfiulb0APU/ByPHXp37R3ercfyDZWPC0D1FoKbvwd8UHcvyW1a8XeAvULdAt0f82Ydz7x7 /366ru3HBp+d1/oBflgE6mKQrroARx1+7vrj+e+//z58+PBhrXci+GU3dvFvDH2O57eW2S+ufbrO 0m8D2E2Vxz259VsCvPNSGTXeOPC1Bs/luUbCbXI0NrnxHo+n6JI7kByzX310cekH698f9fPbIrBz 99929dS+fn8dqu+NQdjVh919UH2f8+d9Amm/t/9e/zBkxxnX7zXnAH60v0bocQ+IbbdaARaq72BD 8c3VH0HvLj+ukQvPr9U4njP3vLHGY/tJORxDP8zAPgI9PuZEHS0G1U1315+27w6s/JYXKIuAPb5E S79t7Kn32OCT/43L1l48xlCPs7MzjPnu0/SWXim/7O7i+rdv325ev37dcXOOJ++QuHMX3N17QGyL wdYUm4F3d754Ar4g+Guu8jF77z36rvz+3ZaAJze9Cbxx2VR1gnbgTL1n3h12e90HddTP9GvWzz/a zuvxv3sB2LmHddJ39OEaJvlYrO9jvYYViT4N85DdnYuPZB4SdtyRB+g9eedq7zV3V3pz81nlWdm3 Drm7+aG8V7vweJjGUgw/BfyEuvcMPGXq967TAsGv9V6e80WAVN935lW3397rQzxK4s+fQ/ltP39v E3x3cZTXjOqndE/DPAT/can9KK4H+BzXA3rccG1re2bxt+uwL0C/Da69Z/Br6c730JPyT3bG3QD4 nq714VpPAzda13kR6Dnm55+z7but6571H3iEFz3eTc3wQ5IPk3wfeoqP4D8OtW+6+I24fovnFNdX tWfA8/3JDPRbgr5j6APwXQP4zX4Yf70Vllz6vgF8T+rek3KPEnPxvQ1F59i+qj+FEWUBSOOxXd7A 0/Pe/jC9t0Afp/euAD8Jftmhar/o4kOM0IHnyTxXekrgTSo8FoAZ6LfBtY/QL8n8HvSN2roDy6U3 Brhn4OlaXRQaih5Bd5j38gX4HMTr/JqP6MZ1H+bp0GOWv+b2yx5S7de6+M79Huge4zfU/oSht9CA 4/su9tsv+fXe9hrd+hCrR4XnJht22/laC/Yap0+BTnF8BZ2+V23L5YM65g7r8NdsZJdO7JHdr9qj dAelX+nix7i+As6PWfVnoK9DNKZq8g5RA3pvgK/ue6I22hm44+TcvgU7rlkSr2fQW2rOQPu4LYDO 8NP7kwOP8/r49XheH9x8HOG90s1XnV92M7UH5Ie4+KzqBP1JdPHpcYS+brJp/X1NQD9SdHLzm3Bb HX0O+J4bcBh2yuL3jQTepJoz5HwKL27xcE5fCBh4PM5KnxrQLwEv+AX+zdV+jYsPwBsLwOhaK5sf obcYP37nUetsyMr3UyqPOnkD7h0tAqPmGgY8jNEewU6Z+VnQpyDno7gd9Nax3PZzqXEq71xM/yDg C/7jUfsK/YKL77AX195uJw2l366EPibwRqrObjyp/C649bvGSOx6IEYYmT3KuHMGnmGnhFwL+uSn 6zLk4XHdeefX8M/hsJviF5V/9+7dWmVv7UFIgl/gz9btl9TelX7GxR9Bz0rviwDvyOOYnhJ5m5kk 3iz05MbvglvvPfEF9uj2E/BR4ft4YGYLdj5GuwW6vyeo/AhyXAPoSOBh4m6A/baPBb/A31P79P33 3wP6bq3am5vfjOcXFoCOuvVq3Z5i+jnoJxN26WqnW1X6dNUS6y78Lrj0e4rvwFOyrp6Ii9foqGwv sY1gD+79HuhzkOPx+/fv088//7yk1oc8Hx7zj0z2jNTe6/aYgAvwAT135wHefL2qPZfsHHBbANzF 59r9SbrejBP78Ls0PSiDJ9fMQT9Sdt8Ik2hPfGMBqB7AHPD+3A/NxLUp2G0XXdNln4G8BekUuGve OzyFPzbZM0jqeZfektpTnX4qnj9h1Te33heAjjfjmLtfm3RuCz09HgEfoW8AP1J86qIbqKlmT905 8x5h95r7Cpf9UMiXwB6e0h+c7Gn8f7CZS+rFLr38x1t32cXYnqAvkGNqVEv1qXa/5+Kb8rdm4cUM /sHQ+9ALPtuOEnlN4GEOPDfTLNXWGXZKxC0l4e4a5OEp/+HJnklSz9S+NOuY3Ldi+wp9w8Vv1e7X uPgt6Ad33w+FfmIBGEGPe1oACvRw5wE8u/nszuMGRcfzDHuaKLXdlcI/C9gF/5fj5peYnt18AB1j e1L7k0aSb69LL13vuttMzLLfg55LdDeEvib2JlS+t+OssTFmpPC+Qcbd+QbwN6mlD18K4IL/+WXz Z5N6nsiLdXt26Smm98dber5tbbml/fWtEVnRvR8a0PcMuj2+jDPtuKRH2ftdVHkfdAHoTeWbLr3t jhsOrKsfAvDwpf8Ryh4H+ib4DTe/qLzDPpXUc7VvxPQjtW8l9Fpq74MrvAtvQulXQT+l9IDch12Q W19UPpbqZlz6u3Drv1jQBf8ziO+X3PyY1HOFD2pfr8eM/sSW2zno6045bqlNoUQXHl8uQc8JPXft 4/ZXduvvEfhBf5CyR43vvWmHs/mu9tHN56RejOmDu8+hQJyl53PxRy6+Hz7JG2oI+hjTXzZi+sup +N6mWu2i0kPlceNyXVT5sP31NsAP+nMU/E8qvp/J5u+5+fnaCbnyJ0HlW6W8Q9W+ucEm0Rx6U+4W 6HVa7Rz0QeV7cuvLfveJXXApzU+zlboL/if5bzsL/ufPn7tbuPlTC8BI7b2UFxN6LRc/hQm0UdXZ vY/Z++jqN6AfxfPRtW/sglva4z4IdsH/bBJ7f/vb3zZfffVVgZ7je2/a8YMwPJk34+afNuL70S68 FWpfp+WEBF6ZO89ufUjkXR4KPW5T8fyEa79W5QW84H/6ib218b0r/ZybH9U/qj016mwm1L65w86V vZHAu5xz+1ujqhl6j+kXptpI5QX/lxnft+r3rfie4Z5z89N+x95t1D4m7uICUI+g4lKeLQY7H1V9 x9ALeMH/RSb2oPh78X2imn0jm38a3PyThpu/V7dvxPatkl2BHZC3oDeFrwtAS+n9GKo7hl7AC/7n Bz7i+2+++QbxfU3s4fgrxPYOPcf3rO6+ADRi+6abH0Zlpyk3P6p9gJ1V/3KqhAfg+VAKP3iSDqgQ 9IJf4EfwofYZlMX4PkN2OhPn7yX10vW2W7Y+ZvJn1J5hv4xJPkrmjVz81oEUgl7wHzX4MaMfE3u8 A68R37Pan065+VNq77CFuv1uRu0Zdq/XX3Jtn118HDcFF9931/nxUwdCr3he8H+Z4J+fn3dTib24 /bYFO+5D3F/LeKT2e+O0wijsnjfSONxB7S/ja7Fhx4S+xPiUzHP3fu4wiiXoBbzgPw7wHfpGYu80 xPenFN+PJu3Mufl8jBUn9VjZcSO1Z9hrKQ+vzbn4HtfPHD0lpRf8xwu+Q48Mv8/Wy49bdfvTGfUf Tds5wM0vSb1WAq+1AOTP3GvaMeZ3cy7+2dlZ/+HDh6Vz5gS94P9ywefmnQD+3mgtT+x5Qi/eN5J7 PGIrTs4dopufGttrHXi+sdp7fA/gcYa8u/l8nvwKF1+JPMF/POD/4x//qGo/BX6i4609joegmroX hc/vO42Jv0Z834XvEsGvbbkxpl9w9+siwbH9DVx8QS/4BX4EP6g5x/ctl7/Ozac6/qYB/uhMuxSy +FHlGwtAje2h8DZgY0cbcOZcfCXzBL/APwD8U4N6BD1n9NN4hj6rfTz/rg/xfW3GMcgvGHyL6Sv0 cPc5tvfkHqs9wL/BkdKCXvAfL/itMl7M5NsC4DG9LwCs+HWEdvhevSf24o67JTefFoBR3d6VP6o9 3HzU7OXiC36Bf0vwo+Knxj78kNhrgR8Te5etZJ4rf0zqhdi+ZvKl9oJfdiD4vgefa/hrwM+KzIm9 1tSdpcRejO8vGPzg5reSeiPwD1R7QS/4Bf4h4FNG/zSeoOPHXi+AX+fnOfzuzhP8F604Pyb1bCPO bkUmXy6+4Bf4a8CnWH6U3LsF+DWj78B7/R7Db0Ny74LjfMoB7CX1EN9jMViRyZfaf4G21T/BkwM/ BcC8Yy9uyKm3fP2C731RQJxvHkHt2Mvfm8HvX7x4gVvZiBPAl9oLfoH/GODDzV+T2HPg88f4AuDX ywLAk3bg1uMe4OMxoH/16lWfFR+n1ErtBb/AT9Q++/Llyw224HJWH/DfAPzyGmf0rQ9gr3lnKrHn YLcUn+L+2qOPa4jt8Rno2MsLWFlEENdD8QH9P//5z+HPP/9UJv8I7UTgT4M/16t/A/C9a28bZu1V 8E3to+KP2nTJtb+weL9k9SP47uojpvexWu7mK6knO3b41+7OOwh8AB9Keq0hmy3oHbKetuLuxff5 pYuY4EPiPn+3mtjj+B6KD/gd+uzJ9L///vvciGxBL7df4De25d4V+FNde1XxWclJ0S+Cu1+VH7G8 J/c4vvf6PaDP8X1R/J9//lluvuwoS313An4KLbozrv4I/MYGnZGrn6634takXQplvER1fL/nrbjk 5u9mmnak9lL+o4X/IPB57NYdgJ84uZeuJ+30nNEPXXsX5AVcxMSex/dw89G4w2W84OYLfNlRwn9j 8NN4d95c594h4NcTcFNo3nHoJzL6F7F+b+BXN99j/Kz4/fv37xXfy44a/lnwMV47g4MbynidxfT3 BX4B0Dr2eA9+bckF7AH0Cy718cEZSOzhs6D4sX7/7t07ZfNlTTs5MvBTBB83nJ7Dc/X9FJ37Bp8y +s1SXut5ooy+JfZGio/EXr4N//3vf2NiT2ovOzr4NzOLQIpHZONADZiBu/WTcdN4As9s596B4De3 4XJJDypPpTyv+6N8VzfnQO2h+gJfdlNFPAbwR008f/3rXztWfKi9d+/l5yPg/Xaf4EPpUbdP11ty PbO/47Ha1qNfFH9l447Alx1VzL+ZAx/de3Zg5jaU9Oosfavd11l7mLjjiwFN35kau7UW/Oriu+J7 go/je8Burbq7jx8/lrHcSuzJpPwHJvg4s49efT47L40PzDjl5h1W/gb42wnw+wPAvwjufy3lYSsu Snn5O+9iRp825qhxR3bUyr8afKh+Gm+0OTHld2VnlXfwR5t0bHdeE3zfi59CVn8N+DRau1nKW8jo 65AM2dEl/GYz+9ikE4/RsgTf6FANqLon+nzclocCBPtoW25qT9/x/fiXS+C3XH0+QKPVo6/Enkzw Tyf4qlFmH4FzLen5wRhxtr6dp3cSXP4TXhxa+/F9d56P3UrX5byR8s+B70k+35zjrr5KeTLBv97t 58x+s6Rn4G9jDR/3GbzTqPzu7s+AXzfpBOC5VXcEfgojt1XDl923dccQ58+V9KysNzo0k++tpMcH Zm7T/pTdGFtPufp74JOLz9t2K/j5Owt8meC/aYIPrbsYaJOhKopvI7g8zkcmbeTysweAmD7tH5rZ BN+TezxMIzXGb6GOT9dGC4DAlz2Ubb8g8PeSe8nGcME9j5l9i/VPvG5viTsA/yJRTT+/bdS+awvD 3hFanNzD3DwemU1jtaOrfzHl6kfwUc7797//rRq+TMq/kOArUCLBh7LexcVFzexD9Xl7rt8AO+J7 7uOnBh/u1587HnvHx2fZ8EyGezSg4xDwf/rpJym+TAm/FQm+vZ79qcx+LOnxJJ4MZMkNAPqZKTyj YZuu+DaIY6Ty6CPCNW/ZTTRPH336K8CPqi/wZUfp9s8m+F6/ft1RZr+AD7cfoMPS9dHY3LL7ghJ8 p+TmNwdupvHorVrOw2M6TMO356Jnf5TVp734vZXzBL5Mbv8B7v5sgo8z+7jHDUfUxcx+orPzwrl5 HiJE8D2rPwTwS3xvc/S5a8935l14cs8792zW3k7gy6T8h7v5iwk+gG2xftyYg+cvXPk9/qda/tZ2 6HUhzq+HaaT95p29+N7v4YBYtl/gyxTz39Ldr9bo4Kutuyl08Hmbru/MY+VPNF8/jTP7FfxEJb0I f4z1ObPPh2W2wLdyXoRc4MuOHv6lRp69Dj4HeaJn33fmeXxfXf2J7bmjfn24+3xSTrou5V1y4i+c lltGbtmgzd4GcMzV8QW+7Ohj/oPjfGzR9Vg/hZ79ZLX9RN17tDi0SnopUWY/TTTxIKM/pfiu9tay W47GttHacw08Al929DH/TeP8Ur7zLL7H/Ol6Gs/o4A1bHFolvVFmHzX80Lnnbbs1xnePgDP7KOnZ glG35Wp3nkzKf8M4v9XI4wM4Pc5Hhj9R6266quOfUtbfw4OOMvujuJsy+wVob+JJ16fmjJJ73q5L W3OLq++jtwS+TDH/HcX5sZEnhbZca+GtO/NiSc/j+8aJOnu1fNx41l7YmnsREoC1e8+GbQp8meC/ TZzvB2n6hp3GFl2/1QWAtuierkzw8RSemtnnE3LTVV2/XIvDONzVN/Dr6C3E+GH0lsCXKeZfUP1u Ls7nDj6O79N4o87erP2p1l1P8nlm39QcMb+foFMP08ACQA08l7F7Dwk+gH92dtYLfJli/sPd/Rrn Y/Ku1/M5zs/XT1pTeZJl+MNr26UEX6LMfrqewNM8MBNNPHDzefwW1/JxYKbAl8ntv4M4P9bzHWok +KhppzWPL07cnVR8gv+Skn0X7ubHXXp+fJYdqFFr+RMn5Qp8mZR/ZiGoN9Ty5+r5FMPXDH+6nshb N+pwgi81Rm0b+DXWh0ufxrP3ankvhX59ruVz9x5q+mm+aUfgy45a+RfbdzF9F6oPeM0K9IA9u93V nbcM/ylt1R217c4dsBGSfJeW2a+Hadj23Lgvv3bvQfUBPlR/ZROPwJcdNfyHlPUQ49fsvrv17O7H Udus+o1dehznj/blUzJvdHjm1S7hy5rV98y+1f8PKekJfJmUf427H8t6KZT2woadVpw/m9lPoXWX 6vh78T1O0clhR83sQ/FxO6CkJ/BlRw//pLv/9u3bMn3XD9pwdx8wZ8BOeNQW1B7w20x9Hr+1Ns4f Dd8MLv/olFx/vbVLLy8KrWO0BLxM8N/A3W9u08XkXRywiZFbPFffO/nS9YadxTg/TuNxN5/je27d NQ+g9OnHXXrK7MsE/z24+2mirMdjtrmV1xV/RZy/83uG3Up7ow4+Ar8qfgP8JPBlgv/u3X3P2pd7 XwBI+UfxPTwDWgBacT439FTY03ULL0/hqUk+r+dzZp9KelOwC3zZo9v2icDfdPffvHnT2W69rW/a AeDm3p+GYZunfM1O162eACUIWxt2PNbnZN4os89ZfxyYaefoeS/Aml16Al8m5W+o/qHuvp+Q66O1 W2U9HsC5qp5v7v7OIW918Hnbbrqq6Y8SfMrsywT/A7j7voknuPt87h67/VNxfi3r0X78ixjnJ9ql R3H+oQk+gS8T/DOu/5rsfquL74QO4cC1mNVvDuYg8HcxqUdxfmnVJehHcT7ie7j6Hz58WErwyWSC P82M5Frj7qO8x1185vJ79n/W3ffpm96Fl64n78ZE32inHtx7j/NhHuf/+eefvYGvBJ9M8N+Du9+x u5+uj9KKDT1xMMeeu8+bdYK7P5q3n8Iknqk4H7ekabsywX+v7n7J9k+4+3yeHm/RXVPW23HfPrn+ 3OWnOF8m+O9J9UfuPm5YADJko007vEFnwt0vwE8M4OwJ/F3I4E+dqtOs56+M8wW+7Enb9hHgn6zp Z3e67MuHiw8D5J7c84SebdGto7iwgYeGcZ7MDecwt3/Hp+kmO1cvDt3E636sVqznr4zzZTIpf0Pt 95J8PHqbt+py7366bt2t9f1Gdn9xt16M82n81qhvX3G+TPDfzwJQjJJ8ZWR2Bm1jMBcPwIZ0bENC b66ZZ8rd57LeLpb17Fot6ynOlwn+e1T9mSRfUX1XeFd7PlabYn9P9hXw7ZitKwrN/ERdd/c9oTdV 1vP9+YrzZYL/flS/meSDi58mWnhpp97WSnzV3ceaEVUfh2oma9911Tdlj+7+KLNv+/NH9Xz07Wfv RHG+7Iux7oGhZ9VPfMwWMvuI9bEA8CBOU/3a0UceQGdeQfOwjdQYu+1qnxrjtn0Apw3fLIqfPZI+ v7/27WvDjkzKf4eqD6/cb5i9n/aTfFzDH9X0AfwN3P1yxh65+yWhZ+O4lsp6ivNlgv+2qo9Y36fw QvW7q2xbgZ6TfLw/nzL+t3H3dzG7bx5A092nsl6aUHqBL5Pbf4jqw923eL/E/IAeJOOxnZTrLr7H /nUij6l9VX2CcMnd3wV33zfq7Kbc/YmynoCXCf6bxvp08AbA33is7wofDtDkJCCr/p4a55/1Zp4C MB2pPTp4g919P2QD4ONMvRVHaynOl8ntP1D100ysX1QfSb90ndjjMl5V+7Bpp/wOuPp8yk5o5tkd kt1HTV9lPZngv1vV57r+Jqs+8nS1jx9gW2mvgm7gl2tc2tuYOYSAt9XM4zE+NfPUwzbcI3DwvZmn 4e4rzpcJ/tuYxfd884RdUX2G3bP5Dr3dRll9Aj95dt9UfsfxfWjmmczur+jik8kE/03MIC3ewKtX r1y8q8oz6BF6/Ixn9v1zbBqPLwIj1U+U2Ze7L5M9DPzNbbvR5Y9mUFfQLR/QGfT1essFh+Kb2z85 pMMTfn76jtx9meC/Xxsl5Uz9a6LPrnuSrwDOoDdq+A57VOR6zJYfuBE279RRXXL3ZbJHivnhqWeX PxHYG1Z7vgaHwK75zxfwDf4Kfn+VPCiKHs/Vo26+epJuXgB6/zm5+zLBf89m5b2U9ufqFcOELvMI ysJA72Wlh2ufHH5bDHoexrk0gTc1turK3ZcJ/nuyH3/8Ee286fz83F3/5Jl7VntaKMo9IgC8xSEv qwF5Az5dB4k8gM6n6gR3nyfwlvzAyt59mUzwHxDjz7r98ABI2fc/4KqSVwAkN7+nEl8t74F63riT L18w7NHdp8k8xQC+evdlgv/xrICeFwU+TGMw1feOvQ2V9uoigPZdCwVGR2fzIE5r5mm6+7iFPfpz x2nLZIL/Vq6BJewg5CFxx2fn+YRdH+1VQgDc6ophdTqovsX8Dn5Vf9+8I3dfJntk+A3gFMHPQHpM D5iRfOu9Bg+wr6p/pfW3o0Wkd+WHe4843zP8NJl30t3HUdqW5JO7LxP8D23Z/R7IE6j1+itB35Tc AFTfjtcCrDvKH0wp/wh8dvexYw/Qw93/448/+pkdewJf9sXbXc/tb27oyaAVmLGRBwk/n9QLuLsr q11/3MkHD8G27Xo9f3D3HdDbYuDQ8yz+euCG79NHnA93HwM6zs7O0MyTFOPLpPx3Z0OayPh7zO7l O1PyAVDaAuBuvPf+gnaU/Qab48/NPr4S+NCNHR2hXXv4zeV3b7/330k1fbn7MsH/QDF/sph/+Pz5 84DYGyAa+Jsc+++s8w9q7QtER+3A1y6L5QWg6j5z3+L6uhAg1sdnrpy7L5PJ7b8j138E68ePH4t4 ZwD9YI6UgdxkiIvLn6yXH6puSb+a0SePwYGv8by7/rurUUDcwlvcfZ/Mg1gf7r5aeGWy+4d/FPfj yevXrxl+zPEr78ECANivDuG9KueT8tc43w/adMjdvffBHdiwgwWCwN95nL/ifD2BLxP8d6z+9Qb1 h9uPvfy+AGQ44QEkG+pZwgIAb2O5SpcfngNihAeu/N7TjwUArr15AUXl8borPsCH6qOykH+/3H2Z 7AFj/hFk8P0BY7pq5kkZ0nIdCwCAh+IDVMTomO1HU3/850tIYO+rfQF+w7UI/kxZT6ovk/I/lPp/ +vQpmfrX90DxP3/+XCoC8ARs805p/rFs/2C773qv12PxMKUvrj069/Jnl+tIJDr4v/322/D+/Xu5 +zLZI8E/MiwAUO+//OUvo9exmw+99lgcAC51+2ER8Mz+4O69Q5/d+RIOAHpT/MHBt8z+pCcikx2r bR7o8zctT+C7777bvHnzJh7gUY/qRm7g5cuXex8KL+H8/HzUM8A1/LOzs1ZyT+6+TPZI8KepBeDr r79GjZ9P7fVdfJPfzzcHMfSo4f/6669LO/QEvkz2APCvWgDwhBcB6+ef3PNv8CdT/RSgT2ldYk/w ywT/A/6OpYWgLALffvtt4gx/ywA9js3O7n1a6doLfJnsgeFfWgAmF4UffvgBI7/3PuyXX35J7969 SwuQT8Eu8GWyR4J/Cvy5xy0bDnws8GUysu0D/77NAYvPcOBrgl4me8Lwz0F/iBcyrLwu6GWyR3b7 b/L7NzdcAAS9TPYM4L/r7yHoZbJnBv9tvpOAl8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJ ZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMtlD2P8FGADGJQamFxcEEgAAAABJ RU5ErkJggg==",
    transform: "matrix(1 0 0 1 1673.5519 369.2654)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 382,
    height: 229,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAX8AAADmCAYAAAA9WoVYAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAANWtJREFUeNrsnYtyGzezhEFSshM7 tpM4qfrf/+1SJxffbVki9+xA01BjFlguJUrWpbuKxYtoiaLtD82ewSAlSZIkSZIkSZIkSZIkSZIk SZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZKi VnoLJEkS97oa9CZIkiSJVY9msRD8JUkSf57ggiD4S5L0EPjyWJz/8Bj/ciRJEuBv888+BF4NN3hM 8Jck6cEDfnUL3/chwn8f+IeH9JcqSZIgv+T5q2P/vOfPn6e3b9/ufeJut0vb7fbofFutVunk5GQC 7O/fv6e///57CfyH+7IInOjfuyQJ9Nd83o3gPoJ89eeff2ZQLwX3CN708uXL7vcdhsH+/Mqu7XIb Wq/XtggMdk2/S37scn1Y2esf/vnnn5bjXy24LecvSdKd/T+/DuRXh7j0CPXT09P05s2bdHFxsWJ4 23MY3A7yFX8fvt+C/y2/n4MvAPF+eXx8HcPHjx/TZrMZxt9v+Pfff3tOf1jwCUHwlyTpVkF/8OPP nj1Lf/zxRxPu5tJ/+eWXVYT6HMxbX/fHJ18fwZodN4OfnxsXhRu9qavVBP72ur99+8afAgZaAPK1 RURYCOzTwLt37xj2P3QBEPwl6XHD/hCgdx8D5BnwBtQRwKvXr1934Q6wx8d7MLefg68H97+KnwIM rvT8uU8DR+GcxzrVt7as3x63xcGuTXhsfH18yc//8uXLQIvAvgXgVuGvzF+SHg/sbwx6g6lFNRad IIsH5F+8eDEBvD1nBFoT7i2w0+MTmDtAy21+Dl4vHrfH+Dk3jKj2xjzT9WSwuKq4fF+MMszh9s/P z/MnAYt+sAiM7yGes7P3zuMg/jkr+nmr21wABH9JelywX/JYcfO///77xMm/fPlyH+QrwNtC0YJ7 B+wrfg0B5qvG620+hqcy/HmROLL7H/x1VvAn546vZ1ePRWCUrZ6W+e+wCIzvVb5+9epV/vN2n6Kg O10ABH9JehiwX/r4XtAD2JbJ//zzz3shj+6ZEWqrFuDtccDdrr3gugLYvT1yRQvBKgC5XEeA48/b otQCea82cMzYx+OcyWLgLZ8Z4LwQYBEYX7PB3y6W+exsEbCFwZ5v3+/09HRnBW+7/f79+7lPAHL+ kvTEYb/vsb2gRwZv1/a4FSwj5O2+5+nFkQPCEfDkxBnkqwh0fn4EeqMOMFkcYjGXvsfsYnCMBSBm /YC3P16A76C3F5Yhb87fNN7erfDGXS4C5fvZAmCftAj+LfDfykIg+EvS/QX+Ylf/22+/AezZibdA //Xr10lc04I8blP+vuoBnnJ3du35uQAzFW9XEegB5vn19ODfeLxq6+wAvjzGffl7c57L9ye6cXxC wu3Bi70l4rGXZPD3TH/n97cejeF3tMesZoDFZWdF8w8fPijzlyTBvn2/5+pfvHhRIG9fg6Nn0Js4 tgHgvW1xRZl8BXosCi3A25+1xYbBjucCzLjvz+t9PfFj/vwUPy3guveJYO49P8T9D3XAXy0Anukn dvy+EOws6vGFYOuLwNYXWbuf/47s78t0dnZ2CeHLv7/dCP/4+m7V/Qv+knR3wF8U28zBHgVZ2xjV cvXepVMcPaIcAj27/gnwAeYY6ZyenrYcPB4r35vhjq/hm/AiEOMken4FfL6P2kJcMPz7TxaE+J4e 2uuP0kSMf4ZhYPO/87bO7PgBfnu55vj9fdl6lGaPZ8ePPQD292oX+91evXq1sv0AdxH5CP6SdPfA n7u/CPYGeof6xNWvSHDO+0CP6wB5jlrKc+z1ENSr27hEuMeFAK8XNYSwQHThz58K/M82F0/qzDlq fz+g79fY0AXnj+KuZfwW+G/De71FjGQ1A+/+WXs76Mr/ng3+Q3jdin0k6ZEAv1mgffPmzV7Yc0GW QF0Bn9z9agRLyZkjoO2CDpwI8xbkrW7psQUDvlpIGO4U88T2zknuH+sLoa9/0usf3P1c5n8M+HPE g5wfC0KJewB+d/3V+2x/h5j34wvG2hYAWyPGv4N8G+7/9evXK8/+U8P9H/VTgOAvSXcMfBRox//w seVyL+w5xjFYwNWny3bCpaBfM9gZ5Ax7/hquQ15ffZoIcAf0igBw3I41ggD2EvVQBNNcCBqPHWMB qJr6AXxq+yzdPS3wc/GcXh/2BKyxH8Cin2/fvuX31y42DsOzf/X5S9IDAf7eOAfu3v6To0Brjs9A enZ2NolxWrA3HnJxlmC/5ugGcOavkZtfc1ZPcF/HKMe/z5oAXgGeop7UWHRibJSwoFDOn1K/z3/V gHovw191Iptru38q+qK1swA8Ud7P4Mffi/8dlY6gy47PtUF/7cp9oPZ3YrUZMwL+byMPu3v//v2t T/kU/CXpOMCfjXOo/TIX+GKBthXjtGAPQDdc/ZpAW7l2hr3dZpCHr5Uf3YN8dPq0gMSunklxuAf4 GNlwu+fc+0zF3zmHfwj8mwevcOEXeT3HMFy0pk8Kgy+aa3/P8/X6shCztq6gi4uLvPnL/v4s5vNP gTn6GeE/zPw+R1kQBH9JOi7w86CzsLEqA9/cPcU5GRgGfIa9g34dIFscubvGCtzu6tdw+8jn/WeU 24hy8D35Z4SvNSEfFx3K6qsW0MbmrFXDhc/t6t33qSq6e3brR5vhwyObGwsBiL/jaMi/tobbt/ef FoH8d2z/FngfBH7n2zp/QPCXpFsAfi+/5zgnunu+zw4/wp5inLUvGHgcC0Dl6PEYLw4t0IdPD/Fr Xci3Yp007f2fuPrUmc/Tg3UDgjeJbg76d9CY3Fm5bXQZeecO10zWtCBUCygWEXwiQueVRT7n5+cp 1W2ugr8k/QDo9+53Hb79B/7ll19yd04P+PZRvgd6ilg4s18HZ7/2vH7NUIerN4eJ58HtHwD69VLI p/44h9R4bmvuzpL3/CYRzV38exmWvn6Pr0rrKa7tcWT8MwvWrY94EPwlAX+/4+9GOsjvAfsG8NcE fYYtsvd1yOzXDWe/JnCvo6vHc1Gc5YVlIejX+yAfc/uFgF/afXMo1IZDvscBNd9h3+PD1Q4vRD9l tg/m+TPo+T71+Sfap9B7vbd+sIvgLwn61wD+HofPwEfmPoG9O/a1RwAl2gnOniMfFHInCwDHDwTq dYgmqsfiqIY5yMf3rzGRc+69Hg50+bPg60Qzx4Dj0ImMhqu3p2T7u0TjHbjXH7fRDYQiMXX+5DZP 7/svLaQ3aEwS/CXpGLGO5fjWcXEM4MOZO9xLLGP30QFCmf0ahdng7Juwh7OP0U7o25+4+sZc/etA vrcLdW4+zaLjCgPcJ7fRMx+PVryFmGjS64+5Phjk5o9veYcvLwS+AJQhb7vLfzj504JN97Q+f3wK EPwl6Qe5fCvGWo812jIPAT618xX4e6G2tPpFd+87PRng68tvt64+ASAK4tiH4Y/HA8ibbZdp2pGT UmfH7AzkV3uAuRTuQ73ODEsWi1bv/WL4H1hUHWaucdnROGfr9d/SYLetw74sArwY8CKAURH2qcBH PBxzERP8JQF/LtZh6B8KfEQ03s0DcK/J8a/ZxaMNkHvAOfOnvL4F+zUBfE0dNs2CbQf0i1spOwAe DoD70HDrw4HX1aarRi6+95NAPJDlkEUAG7bo94gLAMN9i4XAh7ptGfx2gev3M3/tdqkLhNn+cv6S dAPoTx4zSNsURcQ63q2zBvTRluk92bPAp4LtHPDX7O4d6hXwCfSxRTPCftbVp4U7ZA8A/eR2BDyD eY9bnnwtQL0J+BnwT+bsd+IjPHatBYCHu+HnI8unmGdw6O8c+Fsf8FY+BVx+2Lu8tueN/77ywS+o BXz69GnYE5EJ/pKgv2ABaMY6gDs2YAH4Bn+4/ESF1VQXbScOnyKdNbbxk5vnTT5rKtzyIjABfeO6 msHTcPXduTfXiDfK7Q7kl8QhMcppgr0FdZ6XzI/H60acU3rx/RitFvCv5fzxMinzL4VfXwR4zk9Z AAj+Nsph68/Pc//tMZvqaWf64nxfj3xuvdNH8JeeRLQDlx+z/PHjdox11hH6iVovo6PHfbh4wNz+ b8cFgKEfvnf8eXuHtB0J9BOAMpyDk5+73QJ8iUnC9x7iKVj4GjvrsHjwkYnlKXFRogNWygLh8B86 Tn4x9fkDxXA1nW4Is354ESgLQKIagF1bDGSLgDl/i37sdRv4TZ8/fx46sdqtLAKCv/TYop1Jlg+X 71k+iq5lLg5iHYO5babyTwBw+K2ibRXp0Nc3HOnge+C5aOtk8MeIZw/suy6/0/7Ygv2hoI/n1Da/ hsdjWyMDnpz8AGdOi0LihSNMz5xk7nsWhOQF1KWL4L4FIIUIKvmh7SkseNn9e5RTun1GbanjB+DP F/sEYEc+Wttnw/Ur85cE/UNdvmX5P/30k2X5a3b5BlkDPmbo0Nb8AmQC/qYH/BDpbHCfgU+fBvCp Yj3j7tc92Dd208bzZZfCvgf6Hd/nTUwMa3b65Nxj8XMgxz75Ghw6Mm7+ebwA4DYfmehuvrrPiwh+ Nb59DJDi7aeFrHodvOilq/7/DHTEPAZ8g7wXewv4zfXb8798+bJrLKa9SE7wl54s9GNf/sTlI8s3 F08uv8QscPrs8gF1cvSbuaKtLQ4N4G/IyXcLuD2H35qNEwaXpVYWzyBquPp9bn5HkE4NgO/Ixcc/ Wy0SvecA5hz3XL6lQ4RoogUnhToBH6TSfB9iFxAdxH5jeMb9B43aQ9X+6Zu5dt7Ln4u71OmTC72j 0chxkU/xHNIdFHoFf+khQ7/Zl4+OHXL5Kz8pqWysmot1xudvEOP4YrDpFG03jfsM/MlmrAbs13D3 oVWzGTs0IpoJ7COMO6BvOfUdjypmB9ty8VTcnFsEJosNg51jnRbgo7NP7YLx3G3+Hsf691n9LPu+ 7u5T/BRk1+O/LfTx73BtTt8WA/8UkLt7sGEsLWh3FfylJw/9WMDljp2eywfEZ2IdhnoEfF4cel07 e4DPkQ6SnOo82g7wYyfLItjTpqMm7HmDUQP08c/t5iDPX/MopMr6IxApz59APYw56F1Xt+372IHo c/A/4s7ZyaeL1qcTA7x18XhkNaCwa4sBCrz2+IcPH3Yzjl/OXxL0I/RbBVzv2Cngbbl8inU2VKgt kLfHY47fyvSvAfwqzumdLhWAPxvVRPAC0pTP71rRDZ05G0G/S9Ndq0shX3an4n4siDbAPoE7nHR8 3Au3E/CGIvBtzvzpLgI2CsTuj582E/3uCcB36CeG/pcvX/KCsBD86vOXHj30m4/FPN+KuCHaWXtf Prpxei4/QxxZfs50Lh3/ptGps6Ecf8NF21gcbgGfDySfi3MC5FMDuNHdTxx6hD27esryd3ER6Ll9 71IpgKeNTBXkU13krADf6M9vgb3K73udOw2gV3l/iHWGfe/xEXL/6ufZwuSwrwrU7vJt5Hf5/QP0 048Ev+Av3SfoN4u4Mc8fP043o53oyrl4u7G2itrlb2gzFlw9gL/xBYD78qsunVsG/tCIc3bs2Hkh AOx9fEDl6mn3aWsOzcALA3rU2dXjugX5VvzjM2qaUU4L7Kk9tK03GoLBW6AL8OKx3oeqWxqaVn7m 8+fP+f6Amf0GfLtvr/Hdu3eLR1nc9X9GSfqR0J8Uccf/UGtsyLKLtW1SvFNFO7iP6AZgd8hvfDRy cfns8EPcUxYJgnvl8hn+Ibvv/n+Kh4G3YM8wBsyD49+Re9+FeKeCPaZMBrdfXD46UQLgd61Ixx17 6z6Al38Hg1109Yhm7MQq7vJhV8+xz9nZWQT5BNydHv5Z+O/p+b+2zNnz9zbIY0SD/c4N4C91+cr8 pacD/U4Rt3TrGPSNZQZ5dvaxgIsuneQFWtpx23T59ryQ4/diHXb6hzj8CvCUVVdjARpjAqLrL5EN O35+Lr4HwG6g5ucGR78LoN81nHyMb6rIgl08b9pigNlrwsKA062iIwfQg4NugjsCtwXeO/nHPb4+ 69zhxyz7//vvv/fB/IdCX/CX7hX0W0XcdNWqmaHs0F9RtLMJBdxN6MrZIMu3rwH43L1DoOfunTgj n89jvS7we3HOrpXPpzAXnp4zC/v8gG8rpYy+PC9k87sG6BdDHt0sLcCza7fnNqBegX3OQe8DbgO8 dw7S1j+FG94X/KWnA/3xP+86FnExIwdOf31JiMrlw9ljMbD7YQFY4vKbnTrchz8T6/DYgR7wd2na SbMLsQ0fBgLHXi4M8RbsOftnV4+FBbf3gT5RX34P8qFPvwf4UvQE2FtQP9BB3wTAPxL+hzwm+EsP GvopNU6ImoO+wRjQN8dvgEarpkMfef6GsvkNsn24fHf3BfZ7XH4T+gtinTiOYB/wJ3FOx9FPToLC czAOeA729hy4+lQfFLJbCnoUgBdCvgK85dwfP37kXD95y+N1oD7cAoB/9AJwX16b4C/dGvQr+C+A Poq2pVXTd+BuYp4fMvwS7dBiUKBPX9vr8hfEOhPgp2kffg/4E4efwlF/OPCD2jjLYoAC7T7Y++ai 5jiGhaAvm6+shx1wZ8jbcz98+FDAzoC3gu0///yzBG7DHcF7uGf/Z+7N6xH8pduCfr4+APprbtmk MQsbB36BOxYAdvm8AAD+YZhaa9bOEpc/NMYr7DrQvxbw6c/xAlDcPmIbTItcCvvhagdUgTy6clqg x6YkuHQ/XGQCeXP3//777z6YHetM3eEB/z+5169d8JeuC/0m7HGNPn0D7vPnzxdDHxuvgsvf+HM2 lOfHaGdDrn6TZk7HSvVO2954hapwG4/tC8Bn2PeAv02dw73ZzUd37zPgSzF4Cez9U8Lgow9wG9FN F/SfP3+u4hrrFNoD+ZvEGoL6PfvPLEmHuP0u9C2VwUhl26CFjp0W9Ongkw2yfUAft7lrB04/XeX4 MdrZBHe/jrEOADcH/OjuQ289O/UhTfP6bXwMkQ4AD7ijCwcVXWrTLC2d7rzLASCtw79xHixBfWDI I7rpgd7jmhbcruPuB0FW8Jceb8TD0E8j9FcMfXP7vBsX8Ee75VLow9nz5iyOd1KnRz81CrjB5le7 SqlTZxcWgEnLZVwADgU+3+firQHfQMxjFlCw3QP7UpBl2I+LbP5FUIS9JuiPDXlBXfCXHij0K/hb rv/bb7+VMQwOfh7BULp3zNjauAVA/ADoF+CHWGczA/yY60eT35tWWUU3yOM5rkEWfxPg0yHe3L2D bB/5fAX/OdjjHNiY0xPsbwL6g8681X8fwV96xBEPF3MxcA1jGAzC46eBAv0wcuEm0G+1bMYxDC2X H03+ZFhaz9WHRWBLj2/5uL6lwI8O34Ff+vDpdoE9Qb4Le7tvnwxmcvpjxDmCvOAvPVXoI9c32Dr0 M/jh9r1Vc2PgR7bPc3YOgT7BPl43DzxP8x07zR78RK2Zc0Vagz3uj5ftEYBfRjDQpqtdcPcZ9Lhv L98O+l4A+2NuMhLkBX/pCUY8s7l+r5iLXB/D1pZA38F+kq6KuJtGETceidiLdlrQ3/UcPgOfYp0t tWBuqQ1zewzgc5QTnb1vmpoUaBcMC7upqxfoBX9Jbn95rm/whsuPub536tjl5BDoB/j3XP5cY348 Im8S5wD4vVgH1+T48/1jAN8hnxvtGfiY/Y7Mntz9obAX6CXBX7qe229t0vJsv+n0aQxDgT7B/mQu 3pmB/qSIOwP9oXMASoluGOLcqQP4h1iHHT8Av42Ofwnw0aPPcU487OMAd38XXTmS4C89NbcfIp5y iAo2adkY5RH+m1YHD6A+Pn4SFoATQL6xADD0Nylk+tcs4jZjHXb7dj2+NhRut+mqm2frrr64/pbD p/sHAR/F2kacc4i7F+wlwV86PvRjxNPYpLVpFHNP2OmHiOfEJ29uwoEqLegfWsRtxTtbvt2Icrap zvkB/PxYdPkMfLRfGuiTd+gcAvxQrD3GrHfBXhL8petHPL///vuKOniqiMcLuJuQ67cKuCce5ZwE h3+SprtyN3PQ99vDHPT5sJNU5/lw7Qz58hjfDsDPjj/GOnD5BnqerJmuxi7kDP+OgC/YS4K/dDsR T6LDVCji2bRy/eD0ubAbF4DYsrnuQb+86Kspmi2nz33420ZRduvRDjp2EO1skevjU8Ec8DF+ASMW fG5OGb1g0L9l4Av2kuAvHdftt7p4zOXbJi0ftFYinghyzvXJ6cPhR+hzvr8X+qk+DnAC/Va0Q9cV 5EO0E4u52xjreGwziXViHz66dOwwEgFfekjSVM8n7vYNwrZpawTaJOKh06/K6GQ/SKW4ep+8CdiX hQALQDhBa9Ny+jRbP4JvCfSra4pzSkHXb289qdki20+XxyBucUiKgZ9P0YKzB/x98bCpmJO2zGsA X7CX5PylH+P2Wxu1QhdPL+I58eFqBfqc68/s0F2l+pzcZvfOIdAH7EOEUy0AfJujHVsEYpYP0KfL 4w53PhwNsU6ZltloyxTwJcFfurduvxrLgMmb6OKhjVqzEQ8B/oQ3afFzw7z99RLo45Qs2ny1FPrF 3beiHjwnRjtenM2Q5+Ktj00G7Ac/X3bAWAVbHAR8SfCX7rvbr3bosttP3rIJ6NNGrVYXzwktACcU 4/DteEG0U23UmoF+a8bOUuhX8Q5ue5vm1p09II92ThyHuOPi7Qj7XYx0CPgMbwFferBS5v/I3T7v 0LXbZ2dnvFELbZvl5CyDNBy+O/mTkOGX69ZoBoI+irp8oEqaiXjg9Pdm+TPQ33IRF6C325zfp8us H/Px8yeA8b0oxVt7nrn88Wt2Vi3vFt4H+UP68iVJ8JeOCv5Wtp/bN8dL2ajlHTxryvExX98uk0yf YH9C0c5JK9dvOP3VAug3i7g96MP9M/Qtw6dduFs6KAUF3YFn6Nttg74BP3mOv8DlC/iSYh/pfrp9 7uSx83O5fdMKunD7yPfpZKwqz+eMP4Vcn/v307SDZ01dPD3ox/ELceftlqKbahEYX/MFbcoq0Mf3 sHgH0RHyfI928mYwRDsGepO1Z1o6dIDLV6wjCf7SvXX7k2zfgI9jFAF/dvKhoDuX8ePPYYcuu/3U iHiQ6+9CB0/M8bkz5yJC32Oei/hc3pWLwm2A/o42YpVox5y+u/zUgb5cviT4S/cO+gz+nttfYbMW Az+4/SrL9559Bn7p16cYqIxnSNOD0lvQb3XwNKMdulzEmKdxuwCfO3e4VZNaNAvwQ7TTcvTXna8j SYK/dHcxD8/kMehbvp8anTwzbp9Bf0ID2OIUzpPUaN1MM7l+K94J1xcNqOfHkOXPQd9cP1w+8nxu 1eQ8/wbRjoAvCf7S/Yl5vG+/NXZ5sds3oIdOnuqTQJi1X0U8CzZpzXXwbKkfv1oADP5cyOU5PS3o U7Sz40NRFkJfLl8S/KUHFfOs3r59m54/f56hb46fO3mM+HNun6KdMo8H3Ts8d5/gvzfioahnMkOf ++9tJlro2LmIuX6iArBdvIi7nYM+F3E9z0+CviS1pVbPBxrz/Prrr/n6+/fvVtQtbh87cw3c3rZZ NmlR3/7E8QP4aPNMoZPHZ/3sbd1MdARiK94h139Bu3AvWj37mLtD32vn83kK9G33LaAfirhLWjUV 7UiCv3TvY57WMLbqkBUclk7D1arha4A+PgXA7dP92NGz5ogngL+MWQ5dPNVAtRDxlA4ejnpi7IM+ fTh+GsJWrgF9+7lfv37tFXGV50uSYp+HHfPMFXXRwomoxwA+gvCE+vFPOnFPM9+nmGeV2mMZYq7f inhK1w7dv+Be/VYxF8PWMJMHIxko4qmc/vv375XnS5Kc/+ONeax33/J9Hr3sMc/GN1Xx/PyTEY75 YBU4/XS1Szdf87yeVM/nmcv2o9uPXTwl4oHTD7EOd/FcRKdvnwp8DMOOoW+3sRvXwM/xDoFf0Y4k yfk/vpgHvft+lGKZu4+iLs7P5U1aBvpWcZecftXKma7yfT5cZZ/br6Cf6h79C49vLuDq7TaPa8Du XGzcisVc69P3w1Jy55BFPDPxjqAvSYL/g3rfV0tjHhvPgOmbiHnM7VO/Po9kyJfOAjCZuU/AX+L2 47z8C4f5Bd9H22YKuT4uOF4xxjtxN+63b992gr4kKfZ59DGPgb8V87jTL337gL136ZRNWgz/RlG3 xDwzBd3K7SfvtEnToxK3wfFXsKdFoBrAht59fE908GDCZmNz1k7QlyQ5/8cY80w2bVk3Ty/mQTGX 3Ty7/PFyypk+z+c5gtuvCroe4Vyw68ftRsSz5fn6dkme6yPiSf3NWYK+JAn+jwr8Od9/+/btKm7a 6sQ8XLCt3D3698ntn9BGLR7PsDkg298G+F94D/4F8nx3/LMRD3J9ZDwpdPCgkDuzI1fQlyTB/8G+ x0vy/cn4ZRycvqB1M7v+1CjsJurb3+f209WmqqbbZ9j7AnARRzMkL/L6SIZmro9i7gFtm4K+JB1B yvzv3u0X8FsHz5s3b3B7ku+b0091N04Fecv5bQGgjVtV/35qZPup7t2fuP1E2T7OxCXgF7dPIxku 0NIJx++fCtC6WXbptnJ9g/7Xr193C9o2BX1JkvN/0DFPSlezeVY///xzhn5s49y4Wt08FOeUqKcR 86DrBydstU7WYrDOZfsx2rmgx9HGebEv4pnJ9XeCviQJ/o8Z/K18f9LGiZgHB6gD7FTMjREPt3ge FPOkmU4eGsdwQaBHnl+iHrh+jnh8CuduXNiK27d4x8Yy2M9sRDwq5kqSYp/HC37s1jXn7+Dnwq7N Nshtm62ox3fmVtCP3T4HxjyznTzI8nEJbZw8mC0/N0Y8aOX0nbl5xn5jZ66gL0ly/o8X/Mj3Tejo QcyDTp50WcRFC+emUcjN0A8buiYHq6fpiIbWMLZtBH9qd/Iw/Ks2zhQKupi134p4bGeufc0cf1IH jyQJ/o8Y+hX4//jjj9zNY04f/fvo5jG3P5fvx3gnXfXxF7dP45c3c7376aqFMx6jGDdqFbcfd+1y xEM9+3kuD3fxjL/fbmHEI+hLkuD/aNx+YvCjmyf075eYB62ciUYy0AErp7QYnKbGxq3g9tfR7fvt 4vRpRn6Ob6wRZ4nbR8TD0G+5/c5IhjnYC/qSdIdS5n9LMY/dsFwfYxrOzs6qwm66HLuM/v3qNC2K c07x2HjBbS7oYtPWXDdPr4WzFGrNwcPlB7dfOnt8cZgcrWjAp/bNWNDdKeKRJDn/pwT+VkdPtWM3 btyKMY+BP10dpo7IZ+OPFfB3unkqt7+nhZMhX7l+nsK5z+3Hgu6M2xf0JUnO/3GCP3b0WN++Qd/g z+2bHPOEYWyA/SnP4KeIZ0M9/JOYxyKXROMZaPLmZIdudPkc9WwvixEXS92+Of2FBV1BX5Lk/B8P +HsdPXD7KOymMISNAU/5Phd4OeM/JObZOvy5dbOKeJLv0OUCL56LOEhuX5Lk/AX+GfD/+eeftmN3 Zfk+d/QYqJHvJ5q3b3EOj2cA+Cnfr9o4/ZSufZu2JjEPnZo1cfm8EFjMw84/XfXwL3X7gr4kyfk/ LfD3Wjnjxq1Q0M0On45WtN7PqqPHFwVAf5P2d/NsyfVXoxnc5Z8nKuoy7O3aYh7apZsz/vF3Wur2 VdCVJMH/aYHfO3omo5ipsDs3gbMUeFPo30/9s3VbMU/VzcPRzkxRtywOKOxyzIOjFXk0g9y+JCn2 EfivwN8d1RBc/Gl0/qm9iYuhv0nzm7Z6p2sV4MPxx6FsaOGE8+eYB27/2bNnldsP4JfblyQ5/6cL fp/EWSZyJhrV0HD8p53rQwu7cdMWRiwj5z+PvfspFHXh+MeXvI1un3fpyu1Lkpz/kwd/3LyFVk7k 8p7tZ9c/8nQynqFT2K0mc9r3sk8Rqd+/3z1Ld/xzFfTZ5Vumn0LOj0Fs20uVeft+stZObl+S5Pyf NPitk8f69+34Q2zeYvDzjl3k9gZ67+gB8HF7EvP4QlDm8xD8M1hj/34APm6fp3r8cjPnd+BPirqW 7YeZPDu5fUl6fNroLVgO/v/973+rly9fZifeAz/FNqfx4sB/5tcR/j3Xn4Lj3nJhl9s4EfP49fn4 es496z/nPn4+aQujlw38Bn3L920BMPDL7UuSnL/AP4Lfcv5v374tAX+JeriLJ/ULu+VgdQf/4nw/ XXX1nLecv+/QLZ08cPuW8fdaOG0x+Pfff1u7dAV9SXokUuZ/HPCfJDpxK9Xtm3OtnLGrZ7UP/AA+ 3b6Asze3H9s5bdIytXPmP2fO3g5eMddv0FdRV5Lk/PU+HAj+xsErp7R567Tl+OOcnjTt6Jkr7Mbz c5uOHxFPr5sH+f7M6GVBX5Lk/AV+gH8E5sHgt4w/HMFYCrutjp65wm7yXn2HO3brnqONM4Ui71w3 j8U8KupK0tPUUy/4Hgx+y/aXgN+Ab7N77LaPZOYDWXgq57oD/m3YsRt36paoJzX6+JHx25832Fvf Ptz+s2fPsuM36HdO2BL4JUnwF/gD+NcMfnL4pwx+tHJSS+cmgr/T0ZNjmRT695Hl++WcnX9cGFKd 728B/oXdPIK+JD0xAAr81wN/VeBl8Kewc9cHtOVRDQ7+CNnJNE6KfM7TTMbfy/ct2jH4G/gb3TyK eSTpieopZv73CvydfH/SzcPXHPsk37nLp2318v1GN49iHklS7CPwHxH81VhmnsO/EPxlKFu62qB1 zrk+j2bmmMdcfyvf//jx404xjyRJTxH+RwE/gZ0z/da4hjiyoRrHHMC/bTj+8wD5SWGXIh+Avzh+ zvetqPvu3bsdAV7gl6QnrtUT/D1vBH5u4UQ3T2qMakh1H39rHHMKo5gvYtSDaMdinTS/c7eaz+Pg z47foK98X5Kkpwj/Hwn+2XENBm0+eIX793lkQ2s8Mwq7OHULhV2Mafj69Wse20Pg7x2eLvBL0hPU Yy/43jb4TxaCPzruLcU9fKh61btP0U+zq8fobmMaON9P7TENcvuSJD0Z+Hfn8Y+g7I1s2FvcDeA/ XQj+KuNHRo8xDTSPpzj+2NHDO3aTF3Z5DLPHPOrflyRpkR5rwXf2IJZff/21O5b5FsBvu3ZTCrt2 o+NPNHaZjlw8T50du7Gwa48Z9L2wq3xfkqQn5/z3Hr1osL9F8Lfcfsn403TXbmnlTKG9MxzAXnbs wvGb2+fC7n///af+fUmSniT8Dzpz9xrg70GfwR9bOYdGV0+5RJefwu5ddPOk0MOPjh5z/FbU3VPY FfQlSXq08D8K+FPjkPWFXT2r8BqQ72MD16SVM121dJZrtHDS81o9/LmjxzZuLejoEfglSZoF5mP5 XQ4CfzyIJR7A0ti5uxj8qT2npzh9P1mrcvwW9+CM3VZxd+bgFYFfkqQn5/yvC/5NapzAdRvg53ZN XwCqzp50db5uvngP/w5FYmT86uiRJOkYegzdPl3w//nnn7mn38A/OucMa4N/58zdyTz+G4C/ZPwE /srhw/HHr3FR2PJ9u9j3Qr6vjh5Jko6h9SMBP98vvfwG/u/fv+fOHhuoNsLzLsF/0QD/OYMf9xO1 cyLm8ZHMW/Tw+wx+6+jZyfFLkvSUnX+3wGvu/s2bN7mX3+Bv1yM8NyYDvxd4Tzji6YD/NPX7+NfU 1dkC/7YFfo56OO6hkQ1l167l+1bcNfCHGT2CviRJN9JDzfxnN3H99ttvOec38Bukce7u6KQ3tgj4 XP0N3P4e8G/SzM7dVGf8iHp64D/HnJ7UmMrJPfwzw9kEfkmSnmTsMwv+t2/f5rhnhGg+NIXGNmSA 4xB1dvt0+6QB/pMW+Huz+HtRD+b1MPhj1NPq4Rf4JUkS/NuLQFXgNcdvGX/y4i4cv7V0+gaukxGw WABipn+aGidwAf4Nx1/N498D/vNUF3ZLOyfAj+MWtXlLkiTBvw/8Cvxo6eQJndzS6Zu44ORPx+dU B69b3OM9//HoRRzC0jqBa66rJ4L/ogd+SOCXJEnwn497muD3ls4MfwM9O34UeOH+g+M/ofx/cvQi vU+rVtxzBPBn6I+/Q75+9+6dwC9JkuCf9oxn9pbO1cXFxQotnQ7+iePHAoDjF8OO3njY+iTqSTPT ORvgvzgE/Ob8LeP/+++/BX5Jkm5VD6Hbpwf+NMJy9csvv+Re/hH8Jec36KOXv3Hpzek5CeBf0WHr A4Ef83qqHbvhJK6L2NUzB36PenJXz19//aXNW5IkCf49xz/T0rlh15+uWjpbC8Ap9ftj1EMEP4N3 Gw5cj9M5sYHr/Abg13GLkiQ9+dhn1QP/npbOE7R0ctTTAH4Bv8dD6wh+ZPzpch7/3FjmOLJB4Jck 6d7qPu/wnZ3ZM4KzjG3wjVuW89vs/RN07WDjVqqz/fJYChu5sHM3gh9dPXbYOqZzEuDLeIYUzt0V +CVJkvO/Hvj5Pp+/m8GPzh5Tp6UzfgJoQj9d9fGjrXOyicvAz64eYxrg+GOBF9C/AfgHgV+SpKce +2RRgbfV2TNp6fTruQJvAT8tMAW+jXx/S8csnofop/oUYGOZbwh+SZKkW9N9LPh2c34u8Cbv7LFh bSjs4sJjGuw25f2xo6cF/tjHX3r5Y7zjB7IU4HPUk/ojGwR+SZLk/JeCPxZ4rbPHZK4/Rj2pfQzj vtHMK4paeF5PdPbVxi12/DaCGVGPJVEY2TC+1mH8HQaBX5IkwX9PxENAthHNJecfXTTGKZdhbejw iSdyhZENiIHKBi4a1JbBbzm/nZQV4B8XgMkF5+7SWObmrB6BX5Kk+6L70u3T2si1BvhfvXqVQY0C r0U9BnLk/Cl09vjlGY9p9suGFoAJ+Mn1b1uQx7gGtHZS7m+1gHz4ioN/G6dz/vfff8P//d//pQ7s BX5Jku5U9y3zn+zg/f333/MCQP38saunZPxo9Ux1b3+zuEvgLwDmQW20AJSOHj6AJTXGNnjUMwF/ Y0ibwC9J0pOH/6EF3jUXeFHQbRV2A/jXqdHSmaZjG5oxD9y+uX84fhR27dpcP4q7Bn2D/8x0TkmS pB+qH535dyd14vD1XoE3XR20Eo9jbE3rnO3sceCXXn4sANzL31oQvKWTz93NxV27jC910FhmSZIE //2LQHMjV6vA6wtALOSexoKvX4rjD4euV+BH1NNw++jZn4xr4M6enWVOdNi6TuCSJOk+60cWfJtx Dx++PsJ/4xu5qgIvYp7xfrVr1wu8z3AOrz+XRzfsbelMlPOnUOQNvfwX7PgR9wj8kiQ9BP2ozH9v zm8Hs2Bgm49njpu5coGXc36e0MnP7XT27OL5u6nexMWHs5THEfMQ+MvuXUulBH5JkgT/efBXkQ9O 5LLOnhH82fljUqfFPDa8LYUdvHZNhd7Y1dPq7BnCzJ6qjz/M4S/dPRb78NdTY/eu7Q94//79YC2d Ar8kSfddPzLzn5zIFXN+FHjTVc7PRd7TNM33ucDLRzBOZvb4ZUvjGKrdupz9jy+j5PwMfuzetQXF wb8T+CVJEvyXxT3VwDaMaQb46VQuy1hO0rR/P17W5PybM3t6rh/z+FM4f9cWAiwAsZffXuaHDx/y ubsCvyRJin2WgX9xzh82cpXxDWExKBk/xT0phQKvz+WP5+/y4euxpTMvFAb+cXGyxp4yodNkrn8G 9gK/JEmKfRj8ycc3oJ8/hZyfjmKcjGpO8xu5VjOdPdn1O9yb4E+hpdOKvL6JC738ZRPXx48fezt3 BX5Jkp48/KPrTxz32Gz+uZy/k/VXh64H8CPnx7C2oXEE45Y2cTU7e3gu/+V5MQX8SzZxCfySJMn5 R9dvcY/N7UGRFwez4Drm/HD9Fv/Q6Vyb4PjnDmXBXP64exez+XOujwUA45mTF3h5E9eClk6BX5Kk Jw//VYx6YtzDrt9cPA1uKzk/xz7h0prNDwCjwLtN0wNZKvCnRmdPYy5/aenc08svSZIk578v7rHX geMYY9yDyCe4/V7c0yvwTrp7Uvvw9aqzp9XS+eHDB7V0SpIk+B8AfXb96aeffjL4W5COPn/EPRnm DnYu9nLuv2Hwr1wBwHMF3guazBlz/tLZE1s6P378uBP4JUkS/K/p+l+9egXXb8wuWb8ru32Du+/e RfsmoI/r4vhXlxXd/HMaBd7S0skOv3UbnT0mA7+1dSLqoV7+1IG9wC9JkuC/0PWveVwzDlanvL9a ANJVD/8avfz8c2h0Q57UyTt4lxR4UeQ1l8/jmbGDN6mlU5Ikwf9wPXv2LMH1j6DNjn10/Ssa2RwX gPwJwPP+EgW5619z3MMze1o7eNMBBV675s6ez58/7xrgV6FXkiTBf4n7R4ePgR/wN9dv0LezeX1z FxaANRV+K7dP1+y8S0snFXgvUuM83oUF3iWdPQK/JEmC/1zkY64fHT7k+rnFsxR7aQEoA9rg9h36 sY9/COOZL+IOXof8+ZIC7wHD2iRJkgT/OZnrf/HiRXH96bK9My8MgL/HP5PbwfUX8I/fp5A/1XP5 uxu5xp95nQKvOnskSRL8ryuDNVy/LQYGdnP5vgCUsQw4fMUuFPmsQktnOZDFz96N4J/EPbjYAhAL vOjl7xR4BX5JkgT/AyKfLDuo5fXr1ysHen6Oze+3a3f/iHzwSWCVpnP42eWXmT3m0lHgpe6eUuQN Z++WuT6W78fzd+0yU+AV+CVJEvwXLgKlvfPly5eIacoiYCbeu31Wifr13fGnBnSH8XuUfJ8OWGk5 /DiobRsPXw+jG4rjV4FXkqTHrjuZ528wR9bvzr9aBMpKNJp/j4XwnLxAwO2nq527VfTjFxR4q3n8 7Pwxxx8Xgz5m82MHrw1sE/glSRL8j/1x4LK9czW/VgzxTo57vIWzLAz+2NY/CVSu307iimfw4vB1 5P18/q4VeD3nj582JEmSHp3ufKTzZrPJm70axM+xkDl9H8/ABd0S86RG336qN26x88+3e5M6MZu/ s4NXBV5JkgT/Y2l02+n79+9zlp9d/s4LutsA/ngCFxYAgJ8fn5zBqwKvJElPXXce+xjYz8/PB7h/ z/etkLvzEQ05hzco05gGQDgezWiXLVo9Pdc/9+t9Z/Bmx2+9/DOHrwv8kiQJ/jeVRzoo5GbYjp8E itsH8Gk8Qyn6prrQCzBPdvUC/Ojw8UWhbOZSzi9JknRH8DfQ2yZeB365b+DHubgAucHfh6vxYrHz Hb/Nw1oSxUEE/nIIu7v+3dnZWQa/5fwm5fySJD1VbW6D9XRdLtbhYxcc3pKu+vrLDl9/LGEjr3f9 ZCgbvBn25uQt7vFunwx5inqqnn6cwWtu3+A/3t99+vRp9/XrV+X8kiQJ/rcA/ywDvnXy2GA3q+X6 fYx4WPlQtxW6ffBnvfCbHT5iolSPcdimq1O6eDPXlsFvnT0e9+RPHH4Uo3J+SZIE/1uAP7v/fNva PAF8zPghx7/yTV4l7kk+xgFtn6gFsOsP8N/SRq4cH3HOb58e9uT8Ar8kSYL/kdx/vmC0w+vXrxPv 9n327Fk5ghGbv2gXcNXy6dFPVcSl6Gfr8M/P8WFtBfy2i9e+9tdff82dyCVJkiT4HxH+yd19Ivef FwNz+5cz3a4+MVxOeL7cwWu38QkgXbaBbmmKZwa9yT8R5IKxT+tE1IOcP8c9jZxfrl+SJMH/FuBf rtn9e/STN33ZgmALgN2m1s7BgM3z+kMraDXNE58MMKjNvs7gt5k9GtgmSZJ0u/Bvuf/SzWNTPsn9 Z+hjgJstBLYoJMr77do6dODmAX/v4MmfBOzx3WUzf4a9j25YAn5JkiTB/xbdf4L7N71586Z8zRaA 0a0PgH5+YVeuP49eQKvn7vJJpQZg1Lfn2M5dewwHsthi8fnz5+Hbt2/7wK9FQJIkwf+W3X+WRTw2 3uH58+dXT/Sox6MfZPwDBq85pDPgEesA+nbbZ/WUk7isq8faOWcyfoFfkiTB/47cf77GcDcDvt22 RQDtnQC9H9pS5f6+03fAfB57HoCPHv4vX76Y22/t3hX4JUmSApTvfAFIV6d85SMeLev/+eef8wYw 3wWc+NhHBrYf34iTwDLcDfoWHVEPv8AvSZJ0D+DfXQDsBi8CL168KLUAq+lOPq6MwB9Bnz59+oTb EfopzRd3BX9JkgT/e7AAlGvb9OXF4Hy+76tXr8ofPD8/Tx8/fszO3+D/7t27lPptmwK/JEnSPYJ/ C/zNx6wo/Mcff5QnnJ2dpX/++acH8n3xjqAvSZJ0x/CfWwDmbu/TUtAL/JIkSaTND/iZqyMuQMOB 9yVJkqQ7dv5LfvZ1Xs+w8DFJkiTpHsD/kNewWgh1QV+SJOmBwP8Yr0XQlyRJeqDwP+S1CfaSJEmS JEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmS JEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEnSPv2/AAMAUW7EuKzVKoIAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 1643.7145 324.8135)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 268,
    height: 185,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ0AAAC6CAYAAAC0qhhxAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJcFJREFUeNrsnYt220gORJuUnNeM Z7Oz//+He3ZmJ9lkkljistpAqxrspiTHD9kunMNIoiS/Yl4XCmh0SgqFQqFQKBQKhUKhUCgUCoVC oVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKO45Bv0I FIqLvQ4nQUOhUPzMdTc95y9eoVA83fU2vYRvQqFQnH6dnXvdTZcED0FDoXic6+uu4JhOODc91Tel UCgeFhZ3AUcPEE8GDkFDoXg8WDShcX19nQ/Ep0+f8tGBwbRy7tHgsdX/s0LxYMDo3aZffvll+PDh Q5qmKb179254//59Pj+OY3r79m0ahmH68uVL+t///ndMhQwBFMNDg0NKQ6G432uoBYrBQTHDYdjv 9wDDADgAGvPj6mPMwAA8pm/fvqX5mP7+++80A2QKSmM6Q30IGgrFMwBGuQ9YQE28efNmuLq6GhwU gMd8Pz+O0IDSgOoAPL5//57mA/CYvn79OhE0ngQcgoZCcf8pyeCwgLIAKHDsdrt8EDTy+e22dglu bm6m+cjAADwAkc1mg3P7Hz9+QIFMc9pyDByChkLx3IDxj3/8A0AYHRY4AIr53DBDIN/HbYTG/Lpp fm7CLeBhqmOaX7efjwIPKI9Pnz49OjhkhCoU9wiM6+vrnIoAFnMMc1oxAg4AxgyIEcoC5/EkXo8U Bcf8HGCRD0ACygIXPe47QKBQ5gPgGGcFs8cnpUpLyxR9kNjo/1+huD9g/P777zA4MyhmRQCVMc4X /gYX+gayYhjG+cLHdZfPp1wwuY35PECSb/E+fEy8xSCTvQ5AJRNiAk+GDJxZdaQVb0XQUCguGRiA wnwRjwAGjjk2s7rIsJgv8I1dcxucd2gAIngOsDCoZGDgFvBBIIWBGoHacHBAtQAaX79+fdQfgqCh UJwPjS4wkI44LBC4dVAAEnRsDRoZHKw87BgsRjdOoTYcHICFGaS4Pz2m2hA0FIp7BAZUBmJWARkC pChmsbB1iMBLLNBg1WHwYGhkWJifMRg0JvM+0ps3bxKpjekh0xJBQ6F4QGAg5cBhigOA2Nr15sDY mrfBR1QZGRTp1vhwLyMZRLIxekRtPEioeqJQnO5jFGDgQJUEGci3b988JamAEVKQTYBErq5kMiTn Qe7ywg2MjL3BY2fNX/k5wAGVFfimKLviY6BpDP0g1jXa+x7uraoipaFQnAYMVhmjrR2BEcmGZwSG H1esMEx1bNdURkqlMzSXYCNYvPEL9wER9G8gTUHn6ArwBA2F4gmAgcatEY1bIAVSEqQn8CtawCBQ FHDQuQIMe68DY/C0hKJ0gCIACdxH/4YvcsP5IwvclJ4oFI/sZwy//vrr8PHjxwwM+BgIAMNKppug JOIRlQWDAcTYIzWZ7+9MbLiyyGVYL8la+XZv61ZKg1hcwyJoKBRPA4oCDBifMzCyFzErjMHqqt5X sVAYEARQGLh1aLiv4YrC/QakGuZl7Oji36dDRSW/Fp/bYWEVlUf/4QgaCsUJwEgH43PwSgk8DAeB 91+YitgaKK4cHHaOTdHKBLWjAANCwpzS0uA13JLFy6+omvRSGUFDoXgCH6MCBoxPtIJ7t6f1UoxW Vm2lIlc4Pz8PcFx5r0aqTU9WFJOVWD1VGVJdfs1pCH+N6BLFy7CoTdBQKJ4WGNV9X7Ea0hJuymKF AVXhyuIqGKDFz6D0xBea7UlxDAakgSNCDbDwlvLHjFG/KwrFaqVkaFRKynoRUhClKuJKw+Hhtw2A jKnuAh0JECUm7+QyqHgpFnM30KtBJVkpDYXiKYFxrFKC62e+76CIJdWrxnlfX1K4YNWSxOkJpSnO DH9+ohMT9XEkXwWbllO9BA2F4jGAcaxS4qmJV0YcEJyeBGB4auLmZbKpXKMJiaIwuAPUnuBu0fyk tZVPPqAHTV2NjtAHGcaj9ESh6KwpQXUCKQkOu1ZKpcSgUUqrfjTSlLiataQlXvXgnozpQJCJFMU+ 12Nza8btrQ/mATAAEAwf/vz5szwNheKRQFEB41//+ldeU+Kl1VgpCUBYVE0aCqNSGg3PIjEs0qGa gts9nS/rUhDwNAwaj+prKD1RvPa0pAWM4du3b4OXVuFj2NStWClhdVHBwvoz/HVluXs6VEzYn9gT LPzYUYfo3u+7+mCVga0OsEfKY/gZUhoK+Rh035u3sGqVlrlnSLQqJUFdxHbxLY314ypJ9BwqUDgs DBTlvoPDVYZDA4vVUEGx6eQP7mdIaSgEDCqtYnyeA4NKq2OnUlIOX5BmJijPznDQlK5NT0VawDA1 gdsMD9x3kIAT/lq8H7BwYNheKI8WUhqKVw8MlFb/+c9/5o5Pmoux4UE6ODgdYdMzHfowNgEYY1q2 efeAAUjcGCxu6JwDZH/rgWaVsZ+/nrydAaomYQ+UB98wSdBQvHpgoLSKtGQGxmC9GItFaOxVQHGk tukZgeEVkmqNiacZriIYFC1w7G/7x5sqA3ufNL5feRoKxUMAA8bnrDBGL63ievBuz0ZpldORAguq plRVEktrIjCKselAmG9v7Mj3XXFAYXB64moDMX+9WWWQl/FoKkPQULxqYHAvBq6FkJI0S6tBeUSV MdKxUBjpsJK1gIFUxY1B44Y9jf3tEldXGRkYwcvobc8opaFQ3DcwfCCwAaOYnt7tGdMSB0ZYlNYb rjM0PAyvhhRlMR+YBnzDaYmB4wb2hRmg2QQllbF/7IqJoKEQMGiCuO96RsBoNWtdpU7jFs3JYJUR geEHA+OGVQY9t7Nyq6cwRWUgLUG59e+//96nR+rLiKGSq+JVAQPNWzA7fYI4A8MH6YTKSLfjkysl LWD4NC7yJSpgQGVAUTg8XGWE6glURQbOrIaw+fP0119/nbJrvKChUJwJjNQCBnV7LuZirCkMW7Va SqusNngrxfC5Y+PWDSmMH56GsOpgrwOpyfx17gwYudQ6A2P/WAvTlJ4oXhswhg4wquatZGtKWqYn r2BtrDGp5mE0LmJv+94FGBQfg4+ej8FpCVSGAeNJ0hJBQ/EagJF+++23HjBKpcSPRKZnR3G0Jos3 S6vpUF7l1OQHFIalHz/scQHHrHi4esLAyCqj42M8qsoQNBQvGhiYuHUMGK4i0LDlw4DTci7GmsJo AiMt+zD4+NG6DyUygyNDZv5ac7kVaQnizz//nD5//vzkwJCnoXhJwKiWugMYv//+ex6iwwvQVvYo aQHCvQxWHyeVVlPH+HRIRC8jUV/GnIZklWE+BhufLR9D6YlC8ZPAGOaUZOwAo5q85eVV7r8ghRHH 9zW3UPQL2KZw9YzPH9HH4LQE993H8E5QAOPNmzcZICtdn08CDykNxYsChvdhdIDBpdVKUdDk8KvQ vFW1h1ulJO6M1lIYi/SjVynxla2+JgXAcJVha0suIi3x0F6uihcFjOhhNICx7QHDocFrS3izZpqL Ue2M5sCgtSILD2N+nasNfFEZJFAX7mMAGiivWlqSx/n9+eef+0vxMaQ0FAJGBxgEi4XCSDTXk4HB i9AYFFYp+cEKI1GlBPaFvafyMXD/v//971oD15OGoKF4kcCgKsnYA0a63QWtV1J1dbEYBJw/cQ2M HfsULUh4t6fdz4oECgOBSgk+FjwMxAnAeFJ4yAhVvBQPY4zAsCrJtgOM7vkGMIY1YITSalYX6WB+ 8lEZnwhPSdCLMUMjLndPlwYMKQ3FiwAGIGFrSYbYh9FZgOabGcV+jE1LYfDXcAQYRWnwWpIUSqsA hvVjlJQEKsMauC6qUiJoKJ4rLFaBgdWqPqav4WFsYkoSZnpetVISqpKwh5GOAKMyPOl+XJRW5oA6 MPAx//Of/0yfPn26OONT0FA8V3VRgOEj+kAMXt6OxWcrHkbuw4CHEWdipH7HZ1QYUy8lSQ2j09KQ ysdwYMDsTIeFaKiUrAHjokLQUDyXdCQxMNCH4QN05r/UZXiOz7ZoVEm21IfR23Ygmp5Vt+daStLy MLy0CuuCFEaplMDDMGCslVYvDh6ChuJZ+BfJthnAhsxhRF+c6bm1Hd0LGKysuuX+ix4wGpsacUqy b6UkVFrltGQxvg+3qJScWVq9OLUhaCguHhjwL7CREfYlgcTAhszpMNNzjF2euAU8CBhxB/erdDA9 t8eAkQ6bFZ0CDDY+S7cnQMG9GKG0mjqQUHqiUNwFGNyDgZTEDU9feOZDdFK90Ky1zcDVuQoj1StW m81bqV6EFo3PUlpN1ovx9u3bfWP61kVWSgQNxSXDogkM6sEY2PCcgVF8jNTZvCjVXZ+rjVtrwEhh JoYBIXZ7tiolxfik0up0qWtK7vqfplA8tbpIKZRUAYvYg5FspWqjpFqMz6gwuDXcy6qpNj17wPB2 7xYwWGn8aAHDZ3w+t9KqlIbiWaQjuBNLqq0eDFcYqbERs++pmo60hhMsjgFjUSWJwEiHKVy7nwDG swhBQ3FJwMgVEgzQsaatmJIsPIyWoiBlUfYm8XkYvU7PU4FBaqIChqsRbt66AzCm5/YfqFA8mX/B wICqcHXhFzhBY9trDbfmrWptSQobGgXDky/Wk4BhqcerBYaUhuJi/AuUVJF+oGnLl7Vjd4F0uy9q Vgi2CG3Lu7c3lEVJSVhhpPXl7VPow1hUSs4ABu9Tcmq3p9ITheJc/8IbttCDEZe1k3+Rm7cwb5e2 FygpSejFqHY/G24XjsTl7akDDAbCycDAx/Bl7gSMZ9XteUpoabziKf2LcU5HxrBF4oaXtfNGzD7D 01eo9qZtpbqBq6Uwji5vvwsweGOjt2/fYp+SFwcMKQ3Fk6QjaWl4YhqNG55V01aqOze7pVWfm5Ha 60hG+tzTKcvbGRJ3AQY6PkMvxosAhqChePR0pOdf2G5nm+BBtBq3etWSTQBGc5uBE4BRjem7KzD+ /e9/Zy/jpQFD0FA8NCxiOlIWnEFdcEs4ryHxRWdueIZ9R66Cl7FoCw97q/ZMz6PASKEPQ8AQNBRP l44sWsJT6PDkcikDI5idZed2MjxbO5+lcxWGgCFoKC4kHWH/ws7xXqqVf9Eb0xeURezyXDRt+SZG a6ZnXHwmYJz2H65Q3Hs6gvUjno54w5arAagMVxeejjAwYkqSlmtItqYqel2evFVi3GJgoTJoDoaA IaWheOx05MOHD3l7RFs/UqUjfqEH07OVjrRMz2h4jicAY2e31XaIKZRWU72mhPdYFTAEDcVDqov3 798jHcnt4ADGsXSEZ3o6MGjRmacki6E5qV0hSUFdtFrDq1WpabkI7Sa1Oz1fPTCUnijuVV242Qk4 YCn7GelItZaEgZEa5dTOHIwWMIrCSKEHIwCiGtGXVpa3v3ZgSGko7g0WUBc2jm+IzVrH0pG00ovB MzC8JJv6q1R7C892UWFY6oEmkcU0cQFDSkPxMKlIOkVdxBkYXiJ1aPgCtFRXTIq68NenMwxPu+Cb CiPR7AvAA4rDp4bbTM8uMLCWBK3h6PR8rcCQ0lA8uLrArfkYvniMzcxqXUlqlFLTGYYn7au6cxPT VQWri0TzPH1fEuv+7A7QeamLz6Q0FI+iLlAZwUIzACOqC4dGUBecYsQ0hJexbxuw6DZspYbh6ZsS pUaFJDU2Noq7niF8pmd6ofMwpDQUDw2LhbpoVUZIXYzWCr6hVvANpRkxHSneBb2G/YuhAYwptUuq iy7P4GXc0JoS3mbAKyV735D5jO0SXxUwBA3FSalIOvRdDK4uwkKzfN/SD7/d0oKzhcLgaolVU7YE io2rlnTYsX3o+BdxDsYutUuqN5SWVBsyt7ZKFDCUnijOh0VJRd6+fYutD7PCgHp3dYHdzdy7sPSE VUKlLGhozqLMSj0brZF8TWCwf9ECBt9ahaRq7ILCgJ/BPRhhmwEBQ0pDcQ4sOBVB6gFYIB3BfRy4 sF1d8EVP4CiQCN2em+hdeN+GPeZ0JHXSkb35DpV/QVBg38KNUDY7sTFzpTAcGNjICKangCGloTjR 5CSjMwMDqQiUBQ6ICVMXOQ0xeDAkqhkYARCtnc22pirWmrXyBWrKYkr1bme70BbeNDpdbThoIjAQ 8/eab2fFkTcyEjAEDf0fHzE5KRUZkIpgkRmqIlAYrizI8CylVDMwY0mVfQrutSjnCRStdGShMBrp yC6qC/cr2OhMnQoJG6gzMKbOZswChqAhWJzrW9xaFUNp0kpWHUl1hSNCIo7oK2Ch946N6khqAKNX Tt1x30U67NAeG7pyKhKH/3o64k1bf/zxh4AhT0OwOAaLnm+BoTi0hUDp7vSZnVzlcBCwouioi6pR q1EdiRfmPk4Jt/QiGp4xFYngKO9tVUi8aYt2bxcwpDRe5f/jSbBA+RRpiCsL9y28UQsLzEwRxFSk gkWslnTUBSuV0bYUGBoTwsuWAgaORToS1UQLGvAw3L8waBSFgXQE0GiUVJOAIWi8dlXRhUUwOVu+ RRnB5xe8N2CFVaoLZZFCReSY2UmwKOVUWzviKQmnI56G8A7tu5iOGDhgXzh4stEZ15A0DE8BQ9B4 1ariJFi4b0EDcirfgmdgNDyMahEagSKqi6GVjrC6MGgUk9JLpGlZUmU1Uc2+ADC8OoJzXk7FKFKv kMjwFDQEi/6istRJQypY+DRwUxZjw7eIy9OrsmnDuxjjEvaYjkR1QenInr2I1B7PtzA+fbGZpyPR 8ERKAtWB1akChqDxWkHRhQWVThOAcQ4s/IIPvsWmsS/qNgwDLmmIfcyTvAtXF56OcEoS0pFF+zc9 V4Dh5VR8bO+/cMPzjz/+8FWqMjwFjRf/f3JSrwX3WVDpFNWQChZ+QXNzVkxJUj2KrwIHwyN0g/Ly 9dH2Su2pi7LYjKaEs3exa5mbKczu5EYtKAkfyefpSMe/kOEpaLxeUHgKAjh4U5aDwkqnpRoC1QEV gG0PvQ2cIRAAEdXEpmF0RoOzqy5SvW5koS5asIhVEoPDWjqSTU9PR440bAkYgsaLA0XX2OylIA4K S0O4dMq9FvlC9w2KHBoBFgsvI3VmXLDRmVYqI/Pny7dUFan2IAkpya7hWfiK1KPpiBq2BI3XCooF NLwK4qoipiD4yz4eYgiwWFRG5vdVi8wanZ6V+kjL1u+u0Rku0DV1wWbnolLikEiHlalH0xFbPyL/ QtB4UT/fU0CREpVL54slMShMVZQUxNKSuGS99FxY6XSMIECqcgQcI6kOHuM3nGB0Vo1a6VBKjepi x6kIrR3hLQTumo7IvxA0XgQkjoJiTj9w1eVyKVVAMihwi+c4BaE+CJ+cVcBBA3KaaYh5HLG3Ys23 iOtF1ozOuB1i1bCV2h2dlSlqoNjzYrMz0xEBQ9C4+J/d2WlIBAW8CgaFH14FIYWRoYHHPOOC1nbE MmozDWFYpHry9ybCIlZFOqlI7Orc0QyMoi5CKXXX8i4cFD7sl5u1lI4IGs/1Z3Qnr+IMUGQ44L6r ClYSnoKYuekVkTEAYjwTFvHIU8dTvypSzbxIy2E5UVnEPotFVYQWmZWP5+pC6Yig8Zy+t7v4FPnx r7/+mlD1MBgkr360QMHph/dXeArCqoJTEEs1uv4Fm6AnwmLgWRdQGLHnwqsiabkN4j6FlalURt2R d7Fjs9OWsWeTMy5lN3UxeTqCxWZKRwSNS/pafzr9uL6+dkjkiw2AACgMECmCwqZ8D3bh+1/2qikr qopGJ+dIaYg/t5Z2rMLCU5HwvVkGckhFWF0kagEPy9lbe6RWmxNxOkJmp6sLTAuPzVpKRwSNB/m6 hnt+XxMaERLv3r3LFQ9cA64mcB7XWQsUUBYI9yscDjjHWwS4wrDKx8gGJt8P4BjjIrJ7gsVCXaTl 2pEdzeksu5iluguUzc69tZifYnYqHXnl0Bge8Gsd7uk9+RwAgXTDQLCAhKUYTTUBOOD1eGwqIndq EihKv4Vd5ENDVcQmLU5HYpk0lks95bgrLHq+RVELUUkE83MXvQu8l2HxE2angPEKoDGc8XUNj/i9 Yp+PDIZ0+xudFYRdQRkQc6rhimEBCbwf583ELD0V5lMUiHjqEUAx+KIvAscY1UJQHJWq6AAjbm1Y GrOOwIJNzp5vESdrlfSE1Ya/ztVF8C6ysnBYyOwUNM42Dh8KGgwDDgYDYgZDhgNDwVMLB4SnG37r kLDHg639KNDAOQ+raHjqsQaKkVKOUh1hKJyhKtjYHEhdnAqLmIrEfUdafsVCXfj7j6mLr1+/yuwU NE7vhjz21793sR8LhwFHBAPBgM8vAIF0w6sdfg6Q8PSDUxCChvsXMfUYw7Lyqoyawsi8dOjWHOOy 9J6qeABYlKORilRGpwFlH41OqQtB49TPd3TiFP7xMqX9Mi8ueL7YW+EXeeNcdd7NS3/e/vKX182/ zOkYIHDOlYWd87RjcEjY67gSMvRAsWJ4jg010YIErwsZ/ed6B1g0gRFVRFAUi1TEPxagYSbnJHUh aJyrLpq33PTk5qJd1NVf/R4AIiDi5+f3XF1dYZVopS7ct2BlgUl4bGD6eU4//DFFgURMQyIYGqnI 4jE1bI0NeAyN9KMyN03lTKfAgud0Ru8iwmAFHN1UBPcxt1jq4vnF9kKAUa3iRHckm4zzX56BLuhS 0owXPEEigmPoqQ/AgP70egNT9XWFqkLzoHKpKwdvuR6stbuUUqndu8DAgLB4zMBwKBBQBnq8SEE6 5uZJyoJXo7pRScCoeivczwhbJZZ0hBRGSUUwTctgMX358kXqQkrjaEpSXZAMC5oNkbhUaXMuK18B KYP99W/CgaHBMOH0gxQEpySVyki3LdSJvAA3Mv0Y6SotXoVfzLEi0gDA0FAUY0NR8OuqQb3+uQka LcXFe4pMJ6Qh+5Be7GhF6o7BwaVT7rnwwb6cikBhACAARgMWUhevHBqr2wC6urB9Q8feSk4/yCso F7j5BeXjr6QjQytlwfVsH7d8zPiXmuBQQYOWhfOU7QoSfnF7G7iriUbqMTRAMURFwUvRY4v3mqog SDgoVlu/E+1q1gDHTUhPfIuAsmx9LRWBbzGnInsojAAIqQtBo5uKLDbswb6hriowF8Ih4ePqGv4B ewpdaBgUutAgWAykVhbQYHXBgKCVnwOrC/ITSoWkkVJ004yw/HxsfM6B06oTUxAGxXQOLLjN2w9/ j60XySkNmZxZXZiyKKlIx+iUuhA0jgPj48ePGRjzL5FvNOxgGGkl5+CLs/xxJ0WovhcGhL2n+rpI TTBQhgCQKj3hzx+UR6xQOAB6F/8izQjnFioipB+J7/dAkRpzLXrq4lRY8HkzOctGRJ6GmOKAeZPV xUoqInUhI/R0OLnCYGAQLMZQdaj2/eR0INWTrhkO7GFEP6MoCgDDujd59WZJgxgQZsAOMdjXYJVA 6oGB0oNK9T1FUOBmRVVMQVbsg5nYNDh5n1SHAC50BgR2KGvMwuCtBipQQGT4OhHAwk3Ob9++tVIR qQspjdNVxm+//ZYZAWA4LOyC8rUUJeenJd48BIbNxgU0IkBawODn+DFXSdhcbKUl9PxIz48hhSjP RVXCYIiph30x/LOb6GueiBOpoSqiuti1vAtLKSq/IoIj1T0WWV0YRPZscnZ8i4lgccpKVAFDSmNh fJaBuPMv1WjeRd60Z/4F3CQagEuDcDe2mMsbm6q/6rbIK7XSFFYZ7FHwXIjWYwZE8A8WEGkBJryu KoPG9wVYNDuvQvox8X2faxFhQX0W+0YKwn0X+zCDExf/QlkwLGy5+sQmZ6uEKqNTSuOnVcaHDx/G 6+vrojJsCG5Zjel7hibbeDiup6COyIGVh3sXLRXh51zityASYNEFR/ATmuDgc/zYP1l4PqVOibTh UyxAYRd8NWKv41lEZcG7se9jm7crDoLFnn0LhsURk1OpiJTGz6kMDKBxlYE0xKdmW9MT76kRt/6r hsbQFOwxpA1V+TSkHLGPY/E6Lrf6x4kg8HPxe4vNX/FxmNa9Coqp7lCLiqKChHsYrioMAHtWFX4u KIs991PwfYACgICnwcqCKyJQFmZyZlAIFoLGvSsXtIVbl2fyuZcgBXsYZojGjYX9fpw2FY3EgZRE ubhZTfD9HjCCGojgaxmSQ6hmDNGIbf1sGBgtSBgIUgcUC1VBxmalKhwOeOwQiIDg+972jdebsiiw wH/XDPpSEcH0rBNgIWAIGneDByom8DO+f/9emrKG2zFNZaxdamzOE7cG5LUXaTkTYugAoPV1VfCI qUrr9REY7oV0Psex1K+YmVwmBfdu2TdVu6oTKBZlU1IZLVVRAYEfO2QiLNJhi4AMB7TJOCzOqIgI FoLG3VMTVEygMvwCoRF3A1VCqrkRcTNiwCMtB80stgOMCmIFZievuCU4HPuYa4CopYSBwiDBCmOf ltO9F7AwxcAGZwGFqwoyRKPi8EashV+B1IOrIQ1YqCIiaDx8WGriKiP3aAAa6NMIJdexsfM4l1x5 Fia/tmc4pmPwCEBYA8G5pnGzWkDeRLO1u6EoWgYnK4o9GZsOk6wk/Hl+jvwKXkRWWjjNs5jcs/Cm rDkVSQEW3e9RsBA0ftrP8DTAl7f7YStD83nqsWCV0hooswBLoj05Gt5DTEXuqhZOUhH8mJahV6XS hk/hmwsdS0W4srHnMqgrD/Ynoqrg1AMwcLsCZqapipyKeDUkeBZJJqfi0ZRGgMcQV46GRqyFARmb oBorOmO5s+dp/KxySB3lUJ0jEERIcBOWVzxKGhIrIQSQChTepm0dm3vyLvbRq0DlAykHKRkvmU7R 3PSmrCPVEMFC0Hj1MZ3yXA8OVg5tAWMK6UfVX5FsoyFSCdyYVc6TUVlUgysEr4ZwdYO9Cv88SEfs 9ZMri2huAhK4r2qI4lKh4btz5YuR0pOJVEf5S+7VBL/f+Ovdz5kOF3tMUVpKoQWMsrS8AYe0oiIW 5wgSE3VsTpRWlN4Lv8jxmtvK9G0wSKyywV7F5IrEOzbdr/AUBM+/efMm34eq+PLlS2qYm4KF4nKg 4dUCHPZLnvwx/6WmC2i0i2u0v8Slw5M/LC8mIzjE1GcK/RGJqhhpRX5XgOj4E1Wp1ABRvApXD/bc 3n4OnIJ4mjEFg3Nv4Jjcl3DwRFPTVMVkXkZ+fVQVnoKQX5EEC8VTQWPq+QT4a4YpWw4I/CL7Reay O3XWTKTbVufBSot8gU+0O/lIvkb0K4aW8gjqZOopDAJCasAhrQBiMcfCX8MmqCsJhwmDgzyMiRRF 6Z1gU5PSj/I8DlYVMyRSJwURLBQXoTTKL9n8C4o+jemXX37JFxN+yXHr+TR3M+LisBJhayLVZOVW fGxeLs+TtofWkJ0AghQB1HtsnaVuX5SSKacf5ElUgKD37fk8Q4KAMLE/4erCQQFD09+Hw0ulOAcI x/QDgHZYnKAqBAvFk0Mjqg4ffVVSEfyS2wXE0r0oi3RbSkx2ofrH9FSFl8r7GpSSjnQUR8vcXHgU 0+EDVZ5K8E/20btgZcEpFnkYVTnVn5tutxnjtKQyKxkU/n72KfxnyOnH9+/fMyQAjjuqCsFC8fSe Bv7auVQ2CT3Z5r65ldxTEIdEw2PIsHBvg3coS+2l5b2Sate/4OG7lHIUhRHUQ7XSlAGYDoWV+Fwx JglGBSqcdkSDFe+zdGUyLyiDArcr6cdd0g7BQvGo0Gj5GpOlKNjoKKco3iPgF5Yva2eDMsDCgbFP jVF6nML4JK4OOIqfEdMQVx5h3UfT7IzwYFAwPMy4XKgOf60rDANFBZvpUP7IPy8HBfsUOGZVkVbS D6kKxbNTGhVESG3sbS/U2y9iu0UlJXeG2pBgXsQ1UiWhObS3sVnSQBDgKkmK3kar/wK3bir6i115 cOnX4RDhEcDiKUj1vtRo+jKPoqp6mK+RWqDAx4LJvJJ+CBaKZwENBwUDo6iN9+/fT7YXq+foC3DQ xVS2KTRw8MBdnyMaZ2iSZVGlOYsLxIFh7e3sYaTW8nSHhsGkgkMEQPRsUqNs65BYUxNuaKKXAus/ BArFa/A0KrUBGY0Vr5glCeWAv6pzPs4+RrngUhjxz5soh8nkPHynMMEVhqcdARjlArIBw1zKrVrB O3BI5k9UCiKWY3HgorfvK/UgEdUE9nKBoQlA4Hk0X33+/Pln4CBYKC4aGlFtcPk13378+BFbKmaP wuR48gvIzUDfvgAfw+dukNJIPD/DzFTOP5r9GT1TlJeo8wXv52x4EKuL6HdEFVEAYRWRDA1XFwyJ lprAOYDi06dPAoXiVSuNqQUOa87KRQVUAexCGmxR1mjmZnXgonSQ8GZJMQNJy2pJiuanX8zcyt6A wwIoZI4U5UFKwh8Xj2SGRPJqB85b+7Zv6NRTE3dJNwQLxbOExqJXg1WHg+P9+/cZHJjq5RCAdMes DZRjTXGU3dV4n1X2LlI9SJiX2HehEZbjN0uUpmIyBHipu6cbnmI4aHw9jQPCUqcCCVcSOE+QuA8F IVAoHiWeai/XlMJ+ru/evcvjAH0DaNvLtWwCDYDALGVo+ObNa2nJWnriFzoMWBycplBzVwYDnud1 M6xIoBwcDv68A8Ja52O6cV9phkCheHHQ6IGjgkYLHvhLTbvGV+P2/PEMmOQgCeBYwKEFET8PI9bM 2AUU/LV+8VNX6+RpxQyI5AoCrz8CiJ9VDgKF4sVDo/V5hrVb2xw6wwCVFowK9CnmDgUHhQPk7C/I LvoWSMjTSJxeoOOS4YDnoDKQYpwBCEFCIWj8JDha8Cj30dPx4cOH0sA1K5Hsg3g4TNZmajRSkiY0 EIACGqf49Z5+AAwrcLhPGAgUCkHjTHh0X3d9fZ0PDvgf1hR2NLy82XsequGvv/6660V9V7UgSCgE jZ+ExymPHzqmB3hOkFA8+9hcKLiGC/i67ksdCBAKQeMFqp77utgFCIXSE31dgoNC8Zwuzqf8WgUG hUIwVCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqF QqFQKBQKheIQ/xdgAFcvJh0q0mU6AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 2387.5872 1716.7593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 268,
    height: 185,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ0AAAC6CAYAAAC0qhhxAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJatJREFUeNrsnYt220YSRAegZMm2 5CSb/f8v3LMPx0kkWwQWPeoa1jQGIKknZVWfg/AlUbbiuayu7ulJSaFQKBQKhUKhUCgUCoVCoVAo FAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKxRNHp1+B QnHS628UNBQKgeKhMb71v4BCoXiatdYdCYjxVP8iCoXi6ddYd8DXjQfCYjyFv5BCoXj6tXUIOPZB YzwVeAgaCsXLwKJ7Imi8OjwEDYXiedOQbu25q6ur9Pnz5+p7//zzz/Tt27dxDzTGA1XIk8eZ/l8r FM+uLqpbg8THjx/TOI751i6O8/Pz9OHDh26K9Pfff49//fXX2s8e/X1H+hnjS/1lFQrF0wCjddt9 +vSpu7y8TBcXF90EhTQMw+r6M2j8+PFjvL29HSd4ZIAEpTEeoEIEDYXiDQGjwMJB0ZmKMFjYNSmN tTU4GjQ2m83Y9/34/fv3NF0ZIJPyGAkaLw4OQUOheCZgWBpioJiu/uzsrNtutwUWdmvP2RXfeFIX 6e7uzqCRgWGXA2SY3mMEPP78888WOJ4dGvI0FIqngQeUhZmblob0k6ropoXeTQDoJxB0UBj2nL02 wSBfs0V5lpflOH3taPBwaIwGm+m18fr6eoAPYqZpgETX8DmeNDb6f65QPAoUVSoyqYv+t99+6y0d mRZ5b8CY1EG+pph4sbH/5PvT67b+NhMQ+uk2XxMoejNIDSYWgAr7H/a6pTnTe5rP8eIZhKChUDwd MLpff/01pxyTsgAwNgSLTAvAwp6fuFBBw0Djt/k9TZW4IkkOj/LnsOfssZmle9ImQUOhOBEfo4DD FAYDwy6XFvnGlUXvyiJfgEZ/LysyMOyy+50H4GEpCyABcNhzlrLc3Ny86C9B0FAoHgaMAg7zMCwl ATBMKUz3CywACQZGvOw1UhlZaXDkHzbdGDjcSE1ujub75n3sUUSChkJxCmmJAWNSGKYoCjDOz89N KWymxWwgMHqckbIwlzNfDAxPT3DbQ2UQKKz6kiHh0MgVFfM2XlptCBoKxQOBcX19nRVGBIZ5FnaR kjhzOGSAOETOoDxSMEP9fgYGLgODgcNKKPe2SI6iNux+8DbSc3kbgoZC8UBg/OMf/zAzsoeHYSmJ QQDAIEVRgQLPhbSlQAPAMIUBYHhYGTY3fJkQMeVhAPnw4UMmiHeMPhssBA2F4ngfo1y//PJL7sW4 vb3NwLivjvaVurDUBIAgUPDzBRheUem7EPTzSyOXA6X0bhhcSG0oPVEoTgQYuO2ttGqt4dZTMS3S XP2Y0hJ4E1ZZZUicT/fP8diAAXjg61lpwMeAuvBbwCJf5mdY5cTVRn7u4uIif82ezW1PEuoIVSgO B0buxTCVgbTEwtISr3jk1GNa1DkdgYdhjw0WeD2kIR38iSmG6eFACmOMaUu678/ovPTa7dv0Jmgo FK/nZ6BSkoHx/fv3AgyvkpTyqgMCyuIc6YkbpGcEgrLgDRb+3NYJsnGFMSBtIciUy57z20P+LqOg oVA8LygKMMz4tNKqfcrbPhI0blHD1hmXU01dWGriz527j8ElVix4pB8ZGH4fwOgSdYfiz+SVlOQp yqF/ryfbhyJoKBQHAMMqJRamMCwtsdJqum/I4gatAg1TGH7/PDy/oZJqd8+AcbZTFcqCL4LH/eJ1 aNzd3Sk9UShe2cdIvFgvLy9tD0h/c3NTKiWuADbwLug6J7PzPEADcOlZZbitMUBxeKpSAIFeDSux chgs4nOChkLx8sCo7pvxadvYJ4WRt7gbMKZPeKuQcKqxcRVxRuoiAgPVkp48iuQm6ODg6Oh53tVa Dd1BSmKVE2vosj6Nl/xl9fr3ohAwmulJs1KC0qqZnzElYU9j7SK1Ue1oDaXWkZnhRAEwSvkVA3pu b2+Tl1vjYB4pDYXiJYARKyWuMGalVRidAQrnnprgtWqPCXhAEKhSI28PHwkUxfcATNAtikYvGwHo k7yqtwq3goZC8RzAWKiUbFqlVVIY525+tlKSfOuKomcFYUBgUKRdmTXfOjgGa+hyYAzufwxo7DKA YN6G0hOF4hWAYZUS3oQGhZGotEq9F+UKfkYFDp+TsaH28C76FYACLjdEAY7yNaYseBSgzQxt7DsR NBSKlwKGpSIorfqCLwoDKqPhYbRgUVrFebAO/VxWFvHaAhp2f/q51vSVVYaFqQwfOpz9DJ8V2vIz RkFDoXgmYPz++++5tApghNJq2YiWdj0XXFptpiQEDJRZu1gNoZRj24IFQGL3pysrD1MattvV1IZN Jk8veESjoKF4j8BIC8Bollbj8JxUl1TR7RmbuJDOFFgEdQGFsfVUhG8NHKYsyn0TF0hVTGkYPAwa lposnIOi9ESheEJgdC1gYJt7q7Qa52OkUC1ppCMzYKD9O6YkgMN0e+f37wwUDA6kJs6MQ1XGKGgo FE8IjC9fvsyAgdIq0hJTEVZaTe1+i1JaZYO0BQyKyreAkgAoAA67heoY7icJAzCmMF5NZaSkkqvi fQIj/fLLL8knb0VgVMYnSqvTugUg1kqr8TgC/LySjlBFZOvQuPPL4HGH5yg1qYCx3W6HSQW9msqQ 0lC8S2BY09Y///nPfg0YcdcqeRWrpdW0a+CKVZLSX8GAMEVB4Lib/kxFYbjigBIpacn05xwmlTG8 hsqQ0lC8V2Dkx9iA5nMxSvNWAMY50hBSGOcBKGUPihugrbLqCBBAWTAscHlaku9vra46fb2XWDNw JpVRznN9DZUhpaF4l8BAa7hVSXjyVvJTz1AtWVAb5wsl1mq6VgAG910wMH4AFJSS3CUyQsnX2JqX YWe52ia1cPizNqwpFM8JjCklye3htJ+E52LEbe5VeTUtNG/tAQauSmHE1ASvx7TELktJ7JpAN3j3 Z+vE+PQSANFgYcV7BEZu6Q7AqFISAGMpNaGvjSojL1xv+y4VkkZKYtQqqYiriwoclpYYJMwLMfPT PI2vX79GlfGiwJCnoXiXwEi+n2TBw5h1e7aqJRjf1wAGIpZW2beYAcNLraVqYunIBIwt+RjDBAw2 P9NLgkLpieK9A4N3rJ61UpKwvZ0VyD5glN2p6Lfgpi34GHwBIAYK7/xE9+cAH8NKrHuqJdqwplC8 ADCijxGBET2NOLKv5WPEPowCC1MY7mP8CBdKrSi3MjCyyri5uRle08eQp6EQMGg/CcCwAgwepnOW 1islubSKLs/G9YPVRaqbu7KXYWmJQePDhw95R+v//ve/NR/jxUPQUAgY+4HBe076RloSN6A1jU8G BsMi7YzPAgzzMYLxuZSKyNNQKE4JGKFfg4GRVoDRhEVqlFrtvhVJOC0xYJjKsMrJnn6MV1Ebqp4o BIwVYJDSiApjjD5G2vViVKmIq4viYcRKCRq4kldK0PV5c3Pzqv0YSk8UAsbDgREbuFIAxlJKgn6M mY8BcBgwbDZG7Mf473//O3z79u3kgCFoKASMw4Cx2u1JU7dKCdUrJc0GLn+9qAz2MaxSMgHjpIxP eRqKtwyM7sSAgYV/t+JhVKXV2CJOCuPQSskoaCgUhwOjgMMOMfr9998zJGy3qm1As0V+LDDSbhfr EjCwmY1jsduzBYoUTND7Tavb7QS53CpuzVt2SlrYiJZOERgpyQhVvEFg2MQtG6CTfHs7ZnraOM+H ACPNZ2UwMFoeRgULbtgy/4L8Cn69tIdjWDAUBtKSBePzpIAhpaF4c8DAMQONATo9Tdw6O7YPYw8w qslbVO2IG80qeLDS4NIqvh+lVYPHv//97/GPP/44SeNTSkPxpoHRGgIcd6sGEDwWGAnnp6b2mL4f rXQk9GIU09ONz2qgjhmfK8A4uVD1RPFmgWEKw6aGr4zoe4jpGYGx1rjVKq1G4/MxpdWThIegoXiz wMBMz0Sdm88EjJbpyc1aVR8G7VotwHhgafUk1YbSE8UpwqLlYfAAndbU8OcExqK68F6MmcJg7yIC 462UVpdCRqjiJNWFXVdXV/n0doOEl1U3PnFrc+jErWcARlEXpiTSQnmVzi2pejEuLi6Gt1JaldJQ vClgfP782YCRqyR8tqodk2h9Ey0PA8bncwMj1RWS5kRxMz8taPpW7sVY2VPyJoAhaChOFhjWvGUp iQ0A5pTEUhH3MWKlBGB4UmB4y/cdpyG4DalJqZSg49PnY1S9GG+ptHrI/zyF4qX/vc0Mz8vLy25a YBkYOGIAC9xUBiZtWSMlSqX2mFKSsxVgbOjq+AQ0L6suzfREdeS7N28tAaM6fmCCXX6/A3sxBA2F 4kB1kRIZntbVaSe3c0nVFUEZzwfF4GeslslaPgS4Ov2sAYyluZ6jw2IIwICxuRcYpjBwQtrPCgyl J4pTSEcSGZ6lLRxNW9YWnvwQo3R/gllRF1AVqT6j5OwBwKgOZE6N3gsGRmqYnmgPt47RnxkYgobi ZPwLUxWsMKLh6Yt+dqZqAEXp8lwARtytmtaAker9JAUY3jb+g4FBKQkfO3BIt+f4lv+HKhQvlo6k YHiaupgWWdlH4qqCj0jcUBqydhAzDwBeAsY+hXF3LDBMZYRzSt5kt6eUhuIk0xEYngYHK6nyHhKk IlQhaTVunYU0hM8jiYbnscD4QV5GrJK8e2AIGoqXgMUsHbH+CyuEWP+FXXwIM9IRgMNAQDCYgSLV 55Gc0Zmse09wT/OZnty8dQeVsbBjtQmMi4sLmyD+0wJD0FC8SjrS8i+mRdin3UFEZ5RicGmVKyXx IGZ8T+/v0fIvqsOMwtkkLVDcHQsMaxEPzVs/FTAEDcWrpCOmLti/IFWBlKI6a4TKqEvAqNIRUhip pTCwVZ36KkpptaEsjgLGv/71r2x+/qzAiP+zFYpnSUe8/yLDAuVUA0byhi30XyAdaSiImIqchYpK n/b3YMC/GGiS1l2AQ1NdCBhSGooXSkc+ffpko/nyIrYt7TyWDwvdU4lNTEeWzE5SFq3+i6UeDHgY ZRAwDcmJsLhrAcMbt8qO1fcKDEFD8Wzq4uPHj5aO5HKq+ReUjpiy6GM6wnMxIjDodpPm+0cO7cGo TE+kJFxCTaGkmnZTt+6ocetdA0PpieLJ1QXMTvMqpk/kLu4fwaazVjrCvRgNcJTeC1RI0sJBzL7x bKTzSOJBRgUSNBQ431rLSFQYcS8Jyqq25d1Mz/cEDCkNxZPCwtSFbzarzE5LR1xJoLKRYQFIUHdn 08vgikra9W7Yz+1p01nxLxwWXCGJG9CqcXyYIJ52FZTtPmD8zH0YgobiqYDRSkVSS11w7wWDgtKJ M05JIjBW/IuSjhAsZhPDDRqARTxKAIDgoxI5HbERGACFBba3J99L8t6BIWgonlVdJDI7Q1m12h+y 0HOxBIwu1YYnL968uIO62HIK0vAxYjqC7xl4RB82n1kq8p6BIWgoDoXFTF2gMmLAaKmLhtnJnsQS JNCHwXBBZyfKtPv8iyHND2KuqiJx/0jaDc+5ax0z8LPuVn2KfyAKRbdHZVSVEVMTpuChLqYFVtSF 92LwdvalkupsqhbBpSfDs1sAhi3oqqSa5kNxWqVUPlu1eSCzHZdo0BAwpDQUD0hFSF10UBdho9mS uigl1agwFjo7zyitWeu/WDM8t6lRIUFlhA8yIt+jlFQpJRkPGNH3roAhaCgOSkVMXUwLyC60gXct 78LBUdRFbAtfUhchHcGmtVY5NaV5w9ZACx+KgXeqxr0lbIxW8zzj1HAzPQUMpSeK/bCYpSKmLKwN 3Gde5LQEizqcoco7TKvqSARHY2MapyNd2t+wVXowQlv4zMMgdfED4/goJRkADD/BPd/aMQPWgyFg CBqCxQGwQCpiZVSkIhiSY0rDvAuHxpJ3sWHvIkzRmlVGQqNW079ghRHSkW1IN5qt4CkckYiSKsEn exgGj8ZBRgKG0hPBYsm/MFhM0ry3dCSmIqYqfOs5pySr3gXNuKiMTvY9VqojFTC4w9PBcZd2e0k4 /ZjtHWHTMzVKqmjaEjAEDcHiQFi0qiIGDJtzkY2K6TmkIqnu7Fzs8ETaEXakRqN0TV0k9i/MqMSi J/+CzU7eP8KG55a+r1lSRdNWOPlMwBA0BIslWFgaYsBAVQSpCNSFG5xsdG5iS3isjvBQYHq9NGqR sljbzo50pDqPBIZn2K3KKQgbo0sVklJSXWjaEjDkaQgWLVgE36IYnbE6EozOcpbqnpRkk+YzO7PZ eUQ6khu23MDcNvyKmX/h0MhfjzkY9l4wPI8sqQoYgsb7hUXL5DRQWBriiqKDf9FKRQCNAItNw/CM 3kVUF0tmZzX018ERqyOxaWu2M3XB8FSFROmJQHEsLC4uLrpockJdQFXAZ4ipSNjOzh5F5V+QzzFT F2m59wLNWsW/COqiKp3icaNha7tmeJq6UIVE0BAsjoCF+RbR5MSwHN9UVsqpiSZrcboRoRGNzpiK HKouHBQDmq5geMa0IyqL6F8sGZ6qkAgaAsUKNOBZGCAMFtacFWBRTE72LSySd2UCBI0ZGFW1hDs6 kdI8Ql20dqjOgEFl1HLoMlSGeRgEn2J4qkIiT+M9/r/ZpypSy+CEZ+FpCIyLaHJWp5qR0TkDQ5o3 Zm0e6F3E3amxlLrlVnBuAQdY4rGIFmgHt5MRzL/gKVsN/0LAEDTeBSiaKcjl5WWyNASl02kxFVh4 +tGh5yLCAoYnPItWWhLBQY9n8zoJGim1J2tVe0dSeyzfXWpXRQpYSFnk9+INZ0d2eAoYgsZPk360 VEXTr5gWSsJWdbu16VY9aGEr33ejtmDBhmcERwqnl/GRiZTK9BjB10hF0h51Ue0fiRvLKA3ZpkY5 FamNjeRDdQTpyH/+8x/5F4LGu1AUq6piSkES+xUwNz0N6e6PEulbcy76NViENCMecbgJ6qInaLTU RbUg96gLVhYVOEJ1ZNtIRwZsPEP/hcHCy6kYy5cEDEHjPYGiZWwm8ysACaQhSD+6+yilUx+3V8Cx BIuQbqxd/F6r6sIH5HBlZKYuuDV8IR0pqUgjHan8C4tGOiLDU9B407/bo0AxpR+28oqxCUUBYNhr bG76Qi4XBuOwyjgSFv0CLKAuMix80O9SKgJobLksSkN/qyMS2ezkJi0AA81a9t5IR+RfCBo/0+/x KHMzgsJUBUOCVYXBgu7nhWwpSbovnc6UxZJ/EQHBUEl1+bSkIYAFSYquAYux4V1sQwrS6vQsVRRu A0c6ArPT1UVuBZ+AMf7999/yLwSNN/k7OzoNORAURVHY/dLvTWmHny9iry8piz7Nqx4tNRFvq1Tk /qYCBqci3AZeYBFURlQSUXFs6bFBY4jpiKuLDItJXQx//fWX0hFB4838Xh7kVRwKCk4/wAl4FrRf JKqKAo6gLPo9qUcchlOas/xndntgwcqimJ3cCo45GKEfY1VdoKuT05EDqiMChqDx6n+fY1KQ2eOr q6tk5VGHQfIy6V5QeNm0c+XQ0WnrvcOhb6iKfN9f2zQOK9oHiz7V/RaJgbEAi3huaqs6UkEi1dvc WV0Ma2anqiOCxqn9GbsHvDaDxPX1NSCR1YQBwkDhgEgRFL7/I3sUAAV2nQIO9gR7FQAFwEGqorof 05OGTzGDBUxOh0VidbEAi3JQEZudDIsICu63CFvYhyPNTqUj7xwa3Qm8T3fE8/k5KAlfVAUSAASa rez1FihMWVjA2LT3xYYypB9uNrZ6LXpWFd43MWu+ClO+eV/IDBY7cXGQbzE0zM47muVZfIrYzRn2 jAwtdTFdh5idAsY7hEb3DH/Op/6+rCDsgmKwhWy3aOHeBwmDg38P1IQ9boGi+BYEip7maRYQBMXB 3kVPG8jKDlbaydodAIuRbvfCIpieUVFYs1bxLkxZGCjWvAtTF5aKBLNT6cg7hkb3iOee6+9nBwJl 5WABOPjCwf4OgCC5B5EOgYT7FCUlITB0ERQhNYGq6FPdtt2HdKRv7DLt11KQCAtnRFl8aM4K6ch2 xb+42wOOYnACGpaKGChwHaAulI68Q2h0j3z8oJ8DlcDBUEBMYMhwYCgABhEQrg7SPkiQT4HH7FHg cQFFmNAdfYueUhBWFRVIGpBgWBSDk2Ex7qjRgsUSKIbQhFXd50OJCCblvBGM4IPRKXUhaBwKg27f 18VF31rwSwGV8PHjx/IcQ4FMvhkk6LmiJAwQ04XnDoFE6a1AVSJ4FFj0HSsKT136huKIYGj2VGBf SKLSaet3fCQs4lECUWVkUFgqknaTtKr2b98zInUhaDwIGIszIoK5mBUAFn1c8A1IJG5txnusPQfl wM8bGAwQASAZEDavBsBYgETVPemVjLx4WWEkav32r6lAAlVBQOhDSjJTFAQNTkGKYfFAZTFwtYOV A/dZ8P20m/VZjE6DhO9IHY9UFwLGO4LGwYNvuZ/BlIHt4nTDsfXJn8Keh+j2V6/BuLT7to3cLn4/ KBJWFgYGSjkAlc43h0VoVE1QgES3m9jb+9fD3Fw1O7ni0Ug39qmK0mPB5uZjYIEFD4+iAY67aIg6 KIZodJqiMGXBfRdSF28jzl4JGIsj9WM/w83NTUkJ4B94F2VCehBAUaUk/BiL3O4bDFiqU15fHX5M LdNxAhXg0lMVpKOUozRn4eugOvz5yrfw9u8+qokGRHhn6WIFhP7wHTPiobDwxT4zPAEIS0Uo/eCR e81UxAb8GjQMJF+/fh0bI/ikLt6p0tg79DaOpwMsuDvS4IBP+6gAlgDRUiGcflB6wSlJ9TPseQMN +RAVHHD56Dx+bSlNaCmDQ64u3MZRen1MP8LvZVyAxZAaJ7C3YBH3j9BmM1YWQ8u38JilIlIXgsba +y8C49dff82wmP4B5aExDAvs5ITBGFKE5K+X9+WUBOlLmu+VKN97nw0U1UDFhI6VRMe+AAerCHvd IVbSEjwfm7MaANgLCfRzpEapNKqKAM54vOFir8U+WPAW9bg/xO4bIMzSyVtRjRJODNtjp1RE0HiI yijAuL6+Nr+iTJ2yk718AG5PfkEfm5+oMpHYV2hBwxdS8hLmDBp8S5/IM2gwINJubgS3WPf8fAqD aVh18OLfk2ZUCgWNWEumZvg9j42GLD7isGr5TrvmrOEQWMQOTlYWGOgLlWGgQFXEKiLfv38fpkup iDyN4+FhwLATvkxd2LmhBg3a7l3yfvcxel40WMCUDsSFX/3cAIiW0qjSkYXHXdjlyT4Fg4XVBJ6u FAYgEJQDD7Tp+WenXQ9HWoEFoDgQLFrKotWctaUBOUMEhHkVtKFsyxWRVJ+CNnij1ohdqF5CHa0a cnt7O4bt61IXgsbetKSkJKYwAAy7LGyOJfoTTNHedxfvJlDFT3RacCmog1VoACwOKYZDQgoUTM0u LuIleCAVCd83MytbsGiAotowtgKKke6OK6AYllRF2h0uNBwCC5RO/evhW4w4Y4R9CzsyYA8sBAxB Yz0FMpVhKQkUBoBhC8gH4cZ5lnFqFFcl+ggn/kRmM9CrI1wNQUWmQA1+SfQtIkQCPKIK6sMIvI5T jFR3ZFbVGUo/EqchK6zA7ZDaZ6G2PAvu5qx2pdprB8Bi4FSEy6fThwF2omZQmG+hngt5Go9WGV++ fMmgwCnlEzA2PFqfN1il+uCdDS8+XoSUlhRo4AOYP6xDCjN7zFDgikkEQKq3jqeGgpipB37cmKtZ mZn7RcW9N2FvSWlJgQUMyaAsOJXYcjpCVRFb/NVjhgWXT7kiQt2cLZMzKRWR0niUyrBKCQ4e9lH7 vd/nYTGbFkB8nD43TaE60YXFnxpASA01UhRIvE/KIQVIdNH/CM/1sbcjPg6GbfU7au0wvX/7+0qI gyKWTSt1welHw6/glGQIG8hy5cPspH2wsK+xVASt33Z62QGwEDAEjYOUS+Vl8BRtHrHPxwAyPPzQ nmomRAp7N3jx8sc0tUxXBmlctFxuhc8RQFBVU7gaFEbgxZF4Xctn2aPwMJg3Vj/w2gCjMyoMSjcq ZRH8Ck5J4v0BO08dHCUNacECacjt7W2r9VuwEDQeF6wysC0cJVS0U6PZyTZm8RmiqXHmRpgJ0YV0 Awu6lZ40gdFIXSIY+PnoORSV0qrgHJAGIs0ooDBmucIYyeQcQmWEqxiVwiCjs6QoAAorC4DDncwC GofFuAcWMjkFjedRHFdXV3mjGe0XSZhaBcWBagmnJqQ6+GzRyhhNuzLmWgl2qRSbQvpw0C0Bovne ++DQeIy0g6sgQ5ofB9BUFoBDIwUZcN9e8wE4Q1AWA7d8UzoyHgELmZyCxpOBA+eN5sE10z827Bxl lVE1OWEATYRH2p0pyj4HN0J1QWWsbpILe02ayqBRxj1GPXAMcQHBm0AVJFY/GopiZEVBJuZABmiB Aacp5FcUcNj9WAkxQ9NA4V83HgELmZyCxpP5Gfjo5L0kCcNqrFcDvgT1YvThMc+3jBO0ZyVP8iKW /lxdNB0bO2UfMwRopiYaKoLvRzUxeprB3ZtjhIODoTRVQWEgzQAcKAUZvLt7a3BI3rVpX46mLB+E I1goTsPT4K3suO9dnYkH6QSjMZ4VGneBVu3ZC41Qs3TkGOAdm2oQIKKRWamKAIkqBbGFzFAg5YHK BsMBvRUDpxyuFgYGCVIPNjcNFvbzHRSl5dsqITc3N0mwULwaNFqpi2824zJjM1XgqkWobFTnicbU YWnWxoHAGNeeYziQkTl6WTQFFVHBYwUSI/VYlPu4EIABFj6rCvRvuIooVRCCxszctFQETVmhdJoE C8WpQOMhn+Qts42f7+j2IT+nNi68Wtv6WoZDqgfwjqmxDZ38C4ZE8SoozRhD2jFCTeB5rHkGSUNV jGRoFkBAWUS/wkBh9xt9FoKF4vWhgVKifxriU5kX6Rj9AJQecZ9y/OR+B762gkhQAwdDypnQes84 xGYGCVIJ5fWGkihKY01hQCVEoJCiyN9rjy3loK8fWVXY79mgYK9j+M2PHz/SAX6FYKF4Vmgsfsr7 FvXkA20KOMzLsFv75MOnL30Cxys2V/HP7X2RLrWMM4TWFA37DrPbFjAo3WBAFEOTujirNIQXtyuH vKh58xfUAwOAQYEqB3kVmF8xtlQFNpEZJA70KwQLxYsrjfyPbPrHad2g+R+w/YOf/nGHD/Vx4DkP adeoxNUCHqzD0r/3BRp3uq5u4IgKogUMVj+75tIdOJYAEfssoCDwHCDBygKwcIWRPQm78BjgYFCw okBvxZKqsNQjpCBJsFCcGjSK8rBDem3u5+fPn/NitU87WzTY5IScmysAade4FKsfSFVasyhK9WQB HGPwKmaPOS1BmkIg4P6KaGiOId2o4EFKApAofgd7Efh+L5GWdMZTjzGkHkXBmMp4oKoQLBQnAY1Z qmKfcPjkQ29AGMjbp13782x3O8PCoVLNykQpF4qDd7pGc5M2f6XgR5SqCPkos9Jp2vVejASIqoSK hT/uYuDn8TvAYwDI2cHqhKduNUFhF6kKUxPpSFUhWCheDRqLvsb0SWf7T8arq6usLuwf/Hg/xy8/ Tvc9CFjcHaUjI6UiDItq+lVrstU+/yKqC6iKeJ89DaQkZMwO9+M96oiv+S7RSo1QyoHFP/D34+fh efzeIijs+v79e6JyaUoP2wsiWChOw9NAmEye0pSZ2sBU8OhbhEOHN35bGrt44E3clMYmaKN8WgxR 3nae5g1YiRVFChUTrujA0MXiZtOT/Qtv0x4bKcfsvaEm8N5LoLDXDcoHlEsFC8VJQmOxZ6KlNnys vR2xmC+Eq44+AqNxPECc61llJKkeXjNrygIYkJq4/E8kGirFATBwauLfUwGEXh8IEuM+SDTURIL/ cyQopCoUb1JpzP5x2qY1VxsDVIVVU3zRFnD4JzWOLxzojJAu1VO9U1oY8xcDwPADl6oBN7gN5mjl b8Rt6y31AUAARC0/hLe7B0jknws1YY/t1nopTKU9ABSCheLNGaGsNvI/Vsu3P336NExqI8PAgGGg sMVBJuSA08ZsJCCmd9MU79lhxjiuYOlsV1YYthgdSgUSu0bKehcqmaNsgiZPr4qCYOgEBZHcl5gp CfSpABL+d8hqwqod3tuSKyDfvn1LAoXivSiNCJHsbRg4psXSu8FZToDHiWa+EAc6qrCLJ50xNGxx 2nus/RlYiEAJEBhSCj0Z9udB1ypSE/6+4BlUgMBzBsQlJQFImKdj54FY1SOoicemG4KF4k1BI6qN cvvHH3/kL7i8vDQ/o7cp1j5oOPmnceeLqvNdnNXp5zi2MfmxiXQg0kHQsIUclQaBZNa70bitR4G7 4mgBwt5rHyTsa01N+O/lsQpCoFA8a5zEWa52NCNOWsMMUVw4lpGPZuQt9nSq+1HQYAURoFHu4+v4 Ne5qtU5LLHpOZRgQ9ho8CVdRa5DYBw2BQvHTpyfR04jKI3lPQbJxgHYqlw0f9rSggMNUCKUhVaVk oWqy1wyFCbtQTSnpiZu0XF0pj20aGcMEHoSZvVAR9hp5Eg9RD+PK71ah+OmURutnLM7exAnyU9pi kj7DAqkIpn8lP9QIoJhAY5PA9oKDVYQpBLvwPB0EPVMdtMEOKgMb8DIczH+AgrDnTWUYIA5QEVIT CkHjAeBowuPq6sqM0qwyABAHReIDoPEGDJE1aBAcZjBhOPjzRT2YakDJE68FOBy60I9VDQKF4t1C 41DVMbt/fX0NgOQn7CgEAwkHoBF2wSaqiixCw8KAYA1T/Bx6JOy+gWFBOTxk0Y970jmFQtDY83O7 Y1778uWLHYnQfFOUbVsLfy1MMXz9+vWQBfsQRSBIKASNF0pbDnn8lDE+8mvGJ/oZCsVJx+aE4fXS QHvqRS9AKASNn1z5jK/0vQqF0pOf9M8mMCgUJw6N1/jzCgwKhUKhUCgUCoVCoVAoFAqFQqFQKBQK hUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBSKdvxfgAEAP+IuVGCAyTcA AAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 2340.5872 1667.7593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st215"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 399,
    height: 196,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAADFCAYAAAB6i6Q8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAMbNJREFUeNrsnQl320gOhEHJzn3M THb//y/cfTtJJpdjcYk20K4G0RRlSz6r3mN0y4ot9afC1SIURVEURVEURVEURVEURVEURVEURVEU RVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEURVEU RVEURVEURVHUM9HAXwFFUdSDXY9HAoSiKIo6xvo7Pvb/AEVRFHX/6+74VP4jFEVR1OHr7aFr8PiQ QEKAUBRF3d06exuIjAdeJkAoiqKeGDiGG6zDS7C4N5AQIBRFUaddV4c1QHn//n05XF+/fpXPnz/v A8Z4nxA549+aoijqTlzH7La3b98Ob968kXEc5dWrV8Pr16/rHbbbrbx8+bKA4Nu3b8M///yTQWII p/j8413+ZymKoqjjwmNIAFKgMcFiePHixTBBoly52+0GBUl9gmGQzWYz6unPnz/H6ZDv37+PE0wc Hug+7sWJECAURVHHXUdTaBg4FBgKDlF4KDSmQx1IuV8EyHSMDpLpkIuLi9FgMoIjGRcgQoBQFEU9 UnhEcAxnZ2fD5eVlcRvmOvQ60evxiX7//j1ORwOR7XZbDgWJHupIDCT3AhHmQCiKok4ED81xKDjO z88VEhsFx7TwO0CGCQYFKJrv0PP4ZKPZkem+ChJ1IOMEnFEvT/fdvXv3Tjz8NUFEAjDuJAey5XuA oijquPB4//798PHjR02Kb/SYrttMECjHBIDtBIPNBIGNQkVPJ1Zsp+s3k9PQ85sJMuUxkwaVnuqT u2PxHzqBSUNher2Gt2ThNREgFEVRDxQeA8Ljr7/+Uuex0QXfwLHVQ4kwQcMBoqflsLVYry7gUIgY TKpTMZhoSKvkTRAiala+ffs2LrxGAoSiKOqBwqOcf/fu3fDnn38WEPz69auCY1rztwaMjUNDr9ND 12E/VSfi8NBDSi59qHAykBTHgRDR6xQid+1CCBCKoqgjweOPP/5QZ6F5jhKG8lBVhAbA40xPFRy2 HhcnovCYAFEciIexHCSWUBdLwpdqLQ9jff/+XV/LeFcuhAChKIo6ATwUAufn5xEcZ+pE9FSuipgK QBwwlvQoELGj/pyrhw0lD6KnBpDRwlql8VAvJy5ETgUUVmFRFEXdEB4TNAbtILdk+ODJbwWHXOUy irtwOIiFqeQqbOX5jhqi0pJdcxCjndc41aXeNt3v0l/A5eVlbTS0yqxSIqzNiSEX4q/3JBVZdCAU RVE3hMe//vUvBUhJljs8NEnursLW2DPNnavr8GOCQXUg7lDsvht0H6DiOLzRUEt8FTAqLevFPpFO RdZJRIBQFEXdEB7qKn7+/NnAY1rACwwUGtOCXqEhV+Gqc4UHXifXSfSNrcmDXIev5Cr1ccUNuzw6 RBQa7ljU4GhfiF5v405OLoawKIqijggPD1k5HBQkCg0LXZ0ZJEq1lVwlzDGf4kDQRMfOyngRIOow 9EfvrFprZ6GzwR0KjkOhA6Eoinpk8AB3ca6uQw+9PN1+jgl0cyWYE9nKdekuCvMi1Xlo/kPDVnB9 SaarC/n169ea/xsdCEVR1AOEx5lDQ65DVWcxiW7A8J+3s+su4TXszKlsrlIfJflRTr0vRKVzs9R9 6Eh4zYN8+fLl5L8sAoSiKOo08DgPp2ex3wPdhoWePHTll0cJSXV/TQ4OrOK6618YAUJRFHUaeJwH B4L5j63BYAM/swxBNCB4HmSwXAeW+oo8kEnqBAhFUYTH8eCB0IgOpCbRIXzlDsLLcqvrgFEm1WWg A7F9RDTn0Yxy1270uwhfESAURREeR4SH9XecowMJAMnCV+MVR657OzSMBXARbDC07vPRAaLyxkI9 9gDkqCVaG75/KIoiPI4HD6u4ag67H0LF+0A2CBRpE+pXVBlr28d4fdUVbPTQvUJ0cyk9b1vg3lkd Lx0IRVGExxHhEQDiyfMzCZ3mygNwFk0S3GHhjmS8Jom7j3renYcPWZxXABMgFEVRjwIekP+I5bu1 z8PKcAXCVYNAGEvaLWp3CBOxMJZfZ6NMivv49evXaLOw4ha3JxFDWBRFER6ng4eHrjyBvrnaYHBT f66V7NYFf9IOwLEzwDSHh6oUHnroZXUfP378kK9fv8b/c7ZPOh0IRVHUDeHRbLR0QnjU5HkoxXVY SHAaflz6qfWFVJio9LIdDo+SB/n+/ft4l79QOhCKop4zPMre5Z8+fSrAmBZg3UmwLPgHwuOFhMS5 3b4N+3tswHX04OEAUXiU0+nnX/p1Dg/V5D52PoVXw1f//PNPL3x1ErDQgVAU9Wzh8eHDh7J/uZ7/ 8eNHs4tgBg/s77Bk+YtOzweW7Q6dL+sNLOD4baC4RJDoocDwx7n7mF7rTiuxOu6DORCKoqhjw+P9 +/cFHpqP+PnzZ4WHbg4FG0GdLcFD8n6PZuKuJc9jlVUJR0F+o4GHAeO3QsQPhIw7EIXH9Ho9eS5y R8lzAoSiqGcNj0+fPpVhhD14hJDVuZ9O179YAw9pt6VFR9CEqhQUHqqanv+3QeS3uw53I7urvWzd fWjoSgFS+kCm/0MGjZMlzwkQiqIID4OHVkZpzgPhAc7jDOAR8xxr4DHb68MgUIBh7uJ3dhhcfmu6 Qw9zIO4+RnUfmjxfyH2cVMyBUBT1rOBhYatabeXw8J0ELfHdDEZ0eCRNghk8tkvgMNfhbqPAYzqv e9BeODj0NgVHdCIADw1dae5jZ7mPCI+Tuw8RbihFUdTTAsdeeCgwzHmUBDk6j2yq7i3hEQHS5DoM GhcOC3cd4EKavIcCQ0/VeWg17+fPn919SPh5dyKGsCiKeoquoznevXs3/PHHH8Vt/Pr1a+N9HluN AyVhKwfFgfDY9OARXISD4gJA4Q7kAvMget5DVxby2p2fn5djRejq5CBhCIuiqKcGj8aNODy02srh EXMe0XnsmW11UMIcE+Eyz3PU0NX0GhwYF54b0cPgU8JfXnWl3ec/fvzYyT2FrlwMYVEU9VThMbx9 +3bz559/qtPA7nJr9dj64q9X4ITc8xPC4yKCA3IdmDT3PEgByO/fv6v70F6Q//3vf9F93Bk06EAo inoO8Chd5kqLCR6lmW9agL03oyTLzzQTvdu546j9HhbOWtzXQx+f9HjURX3BeXio6sLCWBcBKDXc FeGh+vvvv/fBg1VYFEVRN4GHJstfvXo1TAtugYeGrbzHI3SXV/ehEBFoEkz272h2FfTdAuHAhbxW WwV4XCzAo8l7WJVWTZorPF6+fLmDpHkPGHfqQggQiqIeOzgaeGillY4imcBRy3Q1XDVBYuPwkOs8 xxkkzyssYB/zc8iNIDyww1z2wONij/Oo9/Hch0qdhz7XBI/xxYsXnve416Q5AUJR1FNzHSKhTFfn Wk0LcOM8FADoPARCVngq+UTdZi/zAA9c0H2KLpbproUHJs2biivNe/z3v/8dv3z5cq9JcwKEoqin BI+a79CR7CqstLIy3Q2MJtkmYIh7mdfb0H0EeMTFO5tptS/n0fR6YNLc4TE5jxLC2gOPexMBQlHU o4eHJsutx2PYU6a7hRLds+g8LHGOSfVtgMeQhI3q/h0+AFGgz0PBsS/nIZA8n15/gdEB8Bgfwh+G oijqoYJjER4aqvKQlVhZreU9CjCyDnNwGThlt/aBeKVWgEcNW9mmUL6xU52gC1CojYFPER50IBRF PTbXUU690sp6Ogbcx8Nchpfpbr1MVw/bm7ypuEKgYKhrCR7ReRgMatIcAWJQiTmPyx48LOcxaq/H Q4YHHQhFUY8tZFU6y705UPMd7jymhXfj+Q7bx6PmOxwg0jYLIkDiFrSbBB6+YHsHOM6pSrvLYVxJ PG1yHgk8dl+/fn3Q8KADoSjqMcGjm+/wMl13DgCCWIo7cx2SDET0Po8Aj9R5yHXSHKFRgQEOxMNW TwIedCAURT1kcKTw8HzHtNh6sryGrTSK5X0eYTAiJsYxaY5VWZsePCzfobvIxi1os2qrxnHoywV4 /MZS3ccMDzoQiqIesusop718h4NDgaHwCO4jA0bmOmYzrQAcS/DIhiJ6xVVxIQ4S6Cx/UvAgQCiK evAhK+3v8HwHjiXBmVZ6lZXsxmT5Ur4DobM1cGzgNTSVVnK9EVQDEN8Mykp4ZyErbSp3aGTVVo8V HgQIRVEP0nXIynwHdpaHEtwzafMfWLbro0wWp+lmZboSNnyKjiPs8VH388DhiAajWqqr1VaPER4E CEVRD811SAxZqevAfAc2B0roLM96PcB5NPmOpExXwqLdK9NtQlbBccyS5dPrLM8xAfAmHebjY/lD UhRF3TU4ZiErG4bYlOj6Qo87CMbmwCxsBRDByiwPXQ0yL9Od7V8u8zLdWHEVwdE4DxvJXkax6/T4 pwIPOhCKoh5FyEquK6Rq0hzzHdKpsgquA59nTaVVLNPNNoKaAcSAcxk3g1Jw2FTdJwEPOhCKou49 ZKWNga9evdJGwOI89pXoQg6j2QgqCVtV1+GJcmnzHfV1rSnTzRLkkowmAefRhK10Pw9NmP/nP/95 EvAgQCiKunfXYVVWGq4aVoastgshq+g8YnNgTJZLrLQC5zEbye6ludDbgaPY07DVU4UHAUJR1L24 DkyUR9ehI0k81OSOw0NWMk+UN0e4rYxyN/eRwsNCV7HS6lJg0CGGrbzSyvcuB+dx2ct5qCYnUjaD ekrwEGEOhKKo04MD4dH0dmieQ/crN+extcqrWmkF7uGsF7aCMt04wsQrrTBZjot1dB6eu4g9HjVZ 7iGsiQn6gpsGQa228rCVXJXplnxHsof5k4AHHQhFUXcestJEuYICQ1buOAwg0XVkIauzsK9Hmu8I yXIMWXm+I6u0ijsJprkOnGelwh6PpLtcnho86EAoiroz1/H69etBE+Wxt0PzH+Y2asJc2oa/WGU1 2y0QTn2UeyzRRXio62im6UoyFFGSaiuHjOc8DDw7r7TyHo+ku1yeGjwIEIqi7tx14DgSDzMBOGpz oIMkwiP0flR4GDjqhlJJhKW6DgtVNWW6vVEkkoxhF+sq93yHu4493eVPCh4ECEVRJwXHkuuQvLej ug4HRdLnMXMd9jxpyErmzYE7A0E6FDFWWoUmQhzFjmW6owLkgP3Lx6fwJiBAKIq6KTyycJWscR0L ifJt0tuxGLICx9ELWc3yHRi28kQ5ug6YbeXOJC3ThbDVk2oQvMm3CIqiqKO5jj3luRi6miXKOyEr 7ANx+Gx6/R3gOjzfsYthKOkkyd2JQKVVKdNVWfjqWZTp0oFQFHUKcMxcx5s3b4YPHz6UjnJ3HQoP dx4d14GJ8m0v1xHDVTJvDEzhAWPYd5Lv49Eky+PMKxzFbgAp+RN3HepCnnKZLgFCUdSduI4JEmW3 QJ1jhaNIPDfRyXWsSpSHBHtMlHfzHdYkiPmOS0lGkXjvh596b0ev0srLdJ8zPAgQiqJuDA5wHYO7 Dm0MdNehiXIfvy5X+Qksz91mZblwXdMUqAAy8GwgbLUmZNWU6Ibu8sZtYAOh3b9baeVlugYPeY7w EGEOhKKoG4Sr1HVMC6keCgl1HNV1+KFzrEKuo+Yw9FRTCFhtJfPJuWcQqtouuI7FkFVSbTVrCnSA eGd5NhBx+n/2Kq3kOcKDAKEoag04ZuGqkCQvwxA9JxE3fbJxIrWzHDvH40h2h0vYLXALjmMxZGUQ yZoDY5VVk++IFVaeLNfn84GI6jrUiXSS5c8OHgxhURR143AVJMkHmKBbFn3fLRBzHb0y3TiKxICB gxAHWV9llZboYngK8x2hs7zOw7Jk+U53z1V4qD5//vys8x0ECEVRh4BjFq6yhsA0Se5uQdoKq22S 1ziLTiRLlN+iyuoywiJWVwFQmmGIErae1bDVUx+ISIBQFHWscFUDjhiuUnhMX8bTJHlvJImEaiuB ESQGjjN0HeY8lno79lVZzUp1Q3WVX4cTeLvJ8gkezz5ZvuaNRFHU8wXHLFylneQervKGQAxXdZLk mOtoILHkOsKeHYuuQ646y6vrgKbAS4DDRRjL3lRiJfkOB9FSvkMIDzoQiiI4FsDx8uXLErJS/fz5 szgODFfhHKskXNXkOiAhfgYVWOg6ankuuI74OmvYCHcNhL07Zq7DQQI7BzbhqlvkOwgPOhCKIjgk dJFP4NgoOEJZbnUcvXCVV1mh05C2DBchgq4Dy3PXJMrdceAU3V53OZbmNolydR8OoZjveO6d5XQg FEUNnctpgty7yNVZKDgwz+HDD/3A6qpYnovQiOGq4FbQdQx7JuiOMVHus6lk3sMxC1ll+Q5Ilmf5 DsKDDoSi+HleAw7NcSg8NM+hjiPJczSluQEa1V1gzkPmXeTb4FxqnsM2fsrgkbmOGrLCnIZc71X+ O4xgv+zlO8T6O3QYIvMdBAhF8XO8AhzST5DXZkAHh+ckOuGqBhydxHnMj9QxJBk4YPT6mJTnXkZw ODSSkNXlkUJWhAdDWBT1LMCxtxlwKUGuMIl5DgtXbRwccl2Oi7DAhHjck7wZfoiluT1wuOvw/cW9 xFZgJEl0H1noCkNWBpAd7lfOYYh0IBTFz+2B4NB+DnUbCg49VUr4Ph3gPKrjwOm5kCRv9uWQeQf5 bGruCtdR9yk317Hznf8iOGJzYHQdMWTlGz9plZWHrGz/Dt+zXAgPOhCKIjg64PDKKpuWW8JVGLKS Nj9RXcS0GBdYABiq8/AwVuwi9yS5PedwC9dxiaNGMGwVO8nRdbjziCPYPWSVlOgK4UGAUBTB0QFH qKwarJO89l+EfTpmo0hinwdAJA1XyZ4kuYFj5jrMUcw6yzthqnq7h6l846cYslpRZUV4MIRFUU/2 s3kjcHi4Kqms8q1lY54jjl3fwhiSuCNgN1wlyeTcJEmOx2UER+I2mk2eYPx6ra7Sy1qeG0NWocqK ISsChKKepdtowOHluAqKkOPYB46NdPIc0XV0IFJDXjFcdXVy7ToAHCLt2PWdhIS3JPOscJ8OCdVV MMNqVp67UGXFkBVDWBT1LN1GAw6tnvJy3JDjGHD0SCzJ9fMOB6yygvuc4e1xj44Dw1XVdcTSXISH jyeJrkOumwF/wxiS2iOiDgTGkYwrqqwIDzoQinpeYaoJHBIbAN1teFWVuw4Ex0Koqtm3Q5Iu8+BC cA7WsC9cNb2ucgqVVTXUlDiOyyXX4W7DQ1Y+w8oT7+A6GLKiA6GoZwuNGTggvyEKD4XFz58/CzT0 G7+PHdEVHcaPeKhq46GqDBAxbBWgsgnnNweGq3Czp+g8mlyHQMI8cx2YKDfXUcJVPgTRXQerrOhA KIphqpDfCInxwaep++ZO3s9hjqMZQZLkOLbJJk7ZgY5jBg6IUw2wYHt1VS9JnsID51Y5RKLr8OfL EuXs7SBAKOrZuw0MU2F+AxPjmuOAvEY99VCVJCNI9oED+jeyPMeQNQOq4zC30fR0oOtYSJJjpVUd tS7tzKvqOjBkxUQ5AUJRzw0aXbfRC1NhfkOh4RVVMMV2a+DAUNVmJTg2IaS16eQ5BnAfAknyphkQ 8hwIkDg997KT36gluVhhpY8PuY6Z6/j+/TsT5QQIRT2pz9FBbmMhTFXoAM6jAEQvCyTHIVTVdJIv gSNxGlmeo1ZXhf+f2gARmJoLOwTOch0ADHcdl5jrCN3nBRp2uYSrPNdB10GAUNRzgEbXbYTcRnQb aZjKHYYe3s+h94uOI7qPleBoHIfDowcOT5AneY5dludAiEgoy3WIYJKcroMAoajnDo2u2/DchjsN h4eGhjphqpLPQIioFA76xVzm+Y5mu9kV4GjyHGJnwv8lgmNWXRX3KI/hquA66nUCvRwCSXK6DgKE op4zNOQQt5GFqTy/ASPWsSJqaxBpwlZJWGovODxU5XkO+D9gIyAmydM8B+QxfsN1FSK6G6BDRB2H QsJDVd4MqL0jdB0ECEU9N2g0ISrNEWhSPKmkGmygYd2Pw/cez8JUknSQy7wpEC9HWOwFx7XpqHbD F+IMHA08JO/tuAy9HU0Zrw89VFo4OLy3Q2c80nUQIBT12D8HB0HjzZs3pULJQ1QKkKySCsJUnm9o 3EYMU2Vw8DAVXu8uBRsAoVN8Bg4/rn5kCw6Axj5w7ARyHZ1kOQ5A3GFDoAJCDw9Xmeso3eR0HQQI RT0baGiICnMafkAlVQXHkttIwlQbaASsYSk4vwld49lk3Bk42miVVHLIfE/yXQKNS3Aa1XngeQxl 6eXdVdmWh6tmSXJ1Hnq9wiMBB10HAUJRjwoYt4KGgsGgMWBSvOc2DCK9MFV1I51cB54fem4jCVXh orzb5zqwVwPLbrGPI+vpUEio+4A8R8l1YJJcHcfff/+9+/btW4QGXQcBQlEPEhiLLkP/WQsNzGs4 NK5yxEPNc+xxG+U8JMUxTIXuIl7edEJUfn5uN24ADrFhiCFBHst0I1wqNPTxHq5SQ+a5joUkOV0H AUJR9/4+PshlvHv3TrQr3MAg3h2+DxrWt1FmUwFAMEw1gPPYhgR5c96cSC9MNZtNBSDBxPjs/3pT cMj1WJFYflvnVWH3uI8gkU51lcJDQ1W/fv3aTQeCg66DAKGoRwOMWWhKYaHQMFjIGmi463B30XMb cf/x6DYQDhkwBJr9wLWUHhLo3aj8cF7cFhwBDClE5Gozp5onwTxHrK6ycNUI4Sq6DgKEou4dFquA 4S5D19UsNKXX6W1ZTqMDDd+Lw2dSDZLkNnBmVQxDYZWV71W+JkzltMia/2w/jqOAA0tx/RAoycU8 R7Ub66urhK6DAKGoU78fbwSM9+/fe1iqAOPVq1eis6e0+TkLTel91GlYg19NhNveGxk0Bl/oARLo EryaaoODC92ReG5D+r0bTWI8cRtZ1/gI40Zw1HozJRfO7wUHXm8J8rpJlOY3/LndceyprmK4igC5 19fLN9jTft/duHJqCRgGiDQ05cCA/cQbgBwCDciBICiahLk/Jt4unWoqD1kl0MjAkZXjXsJe5LME +RpwIGg8TCU2fkTTHRqm8iS5XtYcx8+fP7PqKoarCJAH/dr4Rnw8f7+bVk0dDAwMT3VCU4Mt6kV+ 3hPhK6Gx6YWoICSV7SuOzxnDVIeCYyfzXQGzRsAuOKQdx17u6/0c+qty16FGBPMcAI59eQ7CgwB5 lK+Fb9T7+ZsNxwhPxRzGEjD0MbrmRZfh4agQmhpsym253ifiemJ8HzSSfo7MWfRyGlhVtS9MtRSq 2iVH3It8FThgVpWDozzOwDFighzzHEmCnOEqLgB3+hqO9drGe378c3xPDEf6m5fL0V3oqQJDK6Uc DPuAYY/zrvAatkpCU/WyQyI6jxVOY4OhKWj+Q2dR99wIbmNpIm4Gjl5iPCbH6+WlUFUCjjp6xGER K6v2JMgZruJicWc/ezjy6xtveTt1fEgs/u0RFrZC1rLaCAsPRWFIag0wvATXLyMgzGTU3oroLDJI LEBjE0JWGKIaOiW4smcfjnTA4Xj1JDurhGrCVHZ9yX3oNNzbgAM7yHVUl57qZYKDi8B9/cy1s4fu CyB0IEd2GQoJPQAEM2dh12HeQpbchT/HAjAwl9G4jCQ01Vy+BTQGaXs14p7iG6jAzT4HY7Ab6DbS UJWBoes29Dobqd4kx9eCw5PjKxoBheEqLhan/Hmrz2cLjks/5/pmjj/o69ev8vnz531v1rsCyPiI /p7HAMjw4cOHkqdQeUOeOwqFxOvXr8VBgM7CT9FVWEmtACxm7sIfkwHDcxue68BFPV6XhKYiNIaV 0BgypyFhi9gEHI3dcLehkS6Z7wI429RJ2lLcrCy3XDf97mYd4weCgwly6s4Asm+rz8X5Q3HBQYDo 58+OEcdS//jxQ48xA82XL1/KcUcAGR/Z33TV4ydADA6ICAnV9Dcrfzf8m0VAeE7D/p71ssJC3YXD w2AhGJqCBDhWVtXrfPaUXV8WcAxVJU5jiKGqnvOQvFrq6NDAhdlgEAGS9XDgpNxdr1tczysUBJLj twCHCBPkBMg9wqOeV2joZjxaUfPy5cvu4tM84bROOEjiZTyvMVtdH75//14AY9/qUiez0sE8SYCg e9gHCLlakZq/E4SUZo4iAwXcvgQL/RvF6zYOEHcZmJAOwHBA1KoqX+iT0NQQnUcMRR0LGiFENRoQ MM+BbmMHrgKbATFUteuEplK3YRDBctybgGNN2IoiQI4WtorwUHAoMAo0rByzhjayRScCZHqTy8XF RQaUMYJkH2AyB7MvZBaczYMBiIf/MkUoZHDYB4jsvC2i9boVoKjXL8AilrVu4DE1VIXXIzDAiTS5 Cb+f9MtqG4cC7mM4BjRCiGo014Ad42MITzUNgZ4IzyAiyQZO1jleH2/HSHBQDxEge+GhoSrf9nNa ZDYQFx9CotSTpGXRSRZDPcbEldRTh8whgMHn8pAZggaVOZv7FIb/omI4EJ0dLv5+X7wtAmL62ykg JFRFzf5mS6DA+yMsIOnsi3h1Fxii8tu8Q3xh0d9AMjvr+I4bMM1OQyL8xtCIIaroOAAGu5gYTyCy yxr+IGxVH0dwUI8NILPT6VuxLm4FGr5n9HRs8BunJ0mx8SssSg1A7Nv02AHDiJA5ADD4nBUoGUCS x81uOxEoZmG9DAQRIHi9gyE+LsLBwYTPa93cKUDs79eAIwOFl7ICFOriDFu/4m0bvA1zHZ7/QPBA QrxxJB2QxB38ehsz7YXGPEKVhqh6zX/YwxGT5DOgeHUVNPztfMghOJqmc9xKcQkO6kY6uy94/PXX X+Xb4vSGHaZjY+GU2vnri4vV4tfKGskT71nIKE3wwUI+A4hCQRuiEteBzqa5TYHTCZ3NXtcpAZL9 PiJAFAZ6eCgOoeBgiEC63rr7ap3En2V/nzQkiZfh+Qb4uzagQHfh4SgMd8GOfmn4ysNVwanURDne N44pWQsMCftsrDMb12Ep+/1FYKSTcSFpjv0bFRbe24GhKYWFOgmbiFuf0/Mb3rPhDYDTe6GCQ4FB cFAPCSA9mBTnoSGI6Q1bXYd+yPU6GAURa+jrwuMzi2I5r7mCCgSbKI37PB8MmMw9IHTs2/Wi0/Dn O/XvGF9H5kz0tTo44iIYIRThsAAL6UDCr29AAVBpQIH3TSCyyUDiC32cG4WP8/cMVmVBeAtDXLPX iP/HMItqDTRqXiOAonaPY0LcmwCz0JRPvTU4NAl0dxue6zA41Im4+hnYXasA48WLF3VDJ23+07Ar wUE9JID0ynNLzkNDVtO39rJzm8Njuq7MC8IafKzLh0UjLkJlUbSQzBg+0E33rn6gNRxztVaMda+E BcDMPjgIA39uzI9kTuOU4at9LiSCFoGSQCF1jJj3MECkuYuwAEvmJiIo8Jt9dCa48GNeA5PXASQN EDrAmLkMmDOVvf6u2/A3l72fJECj6dsI0Kh5CGnLcDEsVcNXDg2DiCfGERyY12gqqjRka26jhKt8 5IgWiEDnuBAc1EN1IM0HUxPmmvcwgDTwsG+Pcd/nugsbdAzjIoShmuYrYMhzVEcC8ecuYBwE4GKa D5Ve7gBj7ITU7iuv1Sx+IWzVAATAEMExAHwGeJ56W+ImBPMa8faY6wj5jgiLJnktMGwQYRK/XISw U5r4jr+PDoRnFkPmiXBJoDHLbQA0mhCVgaJ2kmPFFELD8hazMBXkN5rEuIepfBdAhUYycoTgoI6y 2Bz7OZsPtZbqfvz4sYSppjez5j0KPLZX2XCHh7qQcup7R0vbFdzEwXs5EM9b4IfcHYkDJYStGsA4 fPC6kA8ZewCJ4S6reDrpH9JDeL3EOF4OCfPm23YECOQsUpggQJLKqSVAdPMfMaSEI0Di8wtURoXn EUnmTCEEl6ARc17hSwSW3Y7uaJOcxtjJa8QejtlldB0C/RoAldr457Bwx5ElxvX8wqwqgoN6cACZ JVY/ffq0efv2rSbON5r7UAhM34wUEAqLrQPED78c9ouO+yNk3xhrSCF+SwR34dCQCJgAhx4wRgRE gEzz4Yu3n+J37qG8Tk6k3o7AWAJKAgYJYaEZRNaCAhVvwwU/ew78GXHk+XVEaS8wlt77mYMc4xcS g8E+cDTlt3hYN3jjRCJkcHe/BCJjDFPp7Q4PdRvT50xWJsYJDupBAmTA3MeHDx+q+1CATO5ja+5D IeHQODNY6HVnFtqqeykYUGJIoxeenkEjhKF6gGngEUET7if2SY7VWuOKxelkf8fgREreAmEbFn2B 8NLsNlj4IyQkA0DmJsJtEiAgGUw6j43uonERC8DIfmfdBTQBRgMLn34bmv5qniNMxZ2BwkEAYGgS 4nK1n3mT27DHFFAoNPy8Q8PDVDAZVwgO6jHlQLpA0mY27TKfvhGVb+M4CM+7hR0SGsJSeMjVHgsO krqXtIRtPpOfG0tw03BWBzAS3UhWyeWhMAghzcCyoqFwPPbv2RdRiNvjgpvCQ6zTX+ZVR/VsdBvJ hkdYrdW4icQZdB1MyFHELyISm/YWigD2/d7HJOTZHZket4j1xj/MX2A+Aq/DHfyw2qqX17AQ1QhO pHEbVnLelOEqMDphKoKDejQAWVzUcDieVmL5t14fre1wwOS5g8Q25Ml2dYuLzdh+0R7TsREhRJUt Hs0HD+ESnUoCDM+fLIaublqZFct1s1AWLNqxkTBeN/Sggu4kLNoNBMJCnsIkQidARZLnl8StyC2A IdnfstcdjqPTIVwVw1NjBo1QJXXp+Qq8j7sLa3D1CquaCA+5jdr0p9DAMNW3b9/2hakIDurRAaT5 UOtgPnUgvgAoPHxYHkxUxZLdZoy2OY9tDGcJlG+G8MwsluUfLncKGTT8/giYDBbxsrsVzJ9ADqYL i3GBBDcIWQnkXJqxI/7zE1chC9/ma4gIZ1xZNVUT1oqhqSy0lMGidxod04q8hSwtkImz9L9RDxgN LHQBB/fQVFZFiLiz0MqpBBoj9HPUXEZ0Gm43ICG+e/HihUOjzGgDt3FomIrgoB6FA2nyHwoQbVhS +RgS/TBkiVV0IQiTngvBhG/2LT9xIJLBIwIG7xeeQ0I/yNjjAjzfscJYw5Kbid3l8O1/9s09Asac Rr0tuoXEqTTOI4a+guuZQaL3Wm/pLmZfCMKXhZ0ks6gEkt8AjBHmUI0ACFz0G+exBA13F9qn4ZcB atV5ODhiCa66jD1NfwQH9TRDWBEs0FEuloAWWLSa+8ZmMW8wxPHbIaE+xEUlOJEm5IT5jQQw6WPx fr2ZWdkHFpzKrXMg2dgU+OYvPXAk13e/7UeXssc5dPd36TQ6ro3hdRfCLG8VZk319tbAIgp0EiPk LsZQKTWGcNWIZbUYnvLwkz9uAoBDY7RmPwfLiCEqPcBtqMuQkNuQPW6DYSrqSQPk0G/aTUgkdCzX /avj/dcuQEuAkaQsNzYrhvDUvqjULaJW6ZOtXYiH3v0TYK893ziJI0BC1vz+Y+iwE4psoBFLbg0M Y3ATdb+NzHlYWKqpjkKIKADsPqM7D4SGHpjXUJeB5bcODQ0PKjigU1zoNqjnCJCxs4jUOLN+C4vf osM3Somlt/sWyiQBO1vEklV8bfnt7HH7HMee+x8btnsdy5IryZ5rX2jshpDo/m4DLLrvhZ67kDaP MQOGQJmtn8fb7P47q3Sqk2vBZYwxCW7VU36fMYMGgGZWRYUhKtvwbG0lFcFBPUmAjLio6IdBE+e+ GOlYdV8sPHwVx6dLKJ+0b4Mbme8RvYVF/6b7ee+zEGNYVMeVoZaH5uYkOKYh+e8ON4TUrUNQCIYE JLHrWxJ30STEwUmMe4CBoaomke2uwnITFRhePeX9IAJ5FAtPdaGBVVQrQ1R0G9TzDWHp9rDaA/L2 7duyeOkHR9/0+sGBBqzmCB/KnYWxfMSDhHlOnnjfQeJ3lMOqd5YWyn0OZvGDfOpBiklI66aL/7DC Qa79f/dcXQwFjgvXxVBUdBdjDEdhsx8mw9cAw58jqZhClzE6VPwLDgznrD/X3HUKDU2EL1RR0W1Q BEiUflj0g+QfKv9WFuLNs810JFTw4A56ENJwZ5KNuJDOzKzhgMU0u21c+5hj5j3uSAclZRNH1oSe sOAggiJzFZ1QFMKiNvKFkttmT3EASYXAPmCgw3DYoMvAnzmCLBHuYSxBaOihY0UW8hp0GxQBEkNX KG14Uhfy5s2b8o3cRzHoh8s/eAEiER4NOOwD7n0iTU+IXE9rtfVtaBrr1jiTG0LnMUOiXreng36M RgwAkX17noWh8HLiKqTnLBJYYLntrPnvah+p64V+BTBGG1A4ei4D+kYaWHiDnzoNrJ6yoZblskND H6vv/4W8xl5IExzUc3QgzZteP0z2IfPJt/qBxzHfDg3cj7wpe7UP+taAs41TegX2fug1tCVASMte Y0nsIQCB3pS7pcJ14+JN+k/G4JgyMOyDhCSQkMRRSOIqMNexCwnyHTjWJlSFEIiJc8hhLALDnTGE uuIU51loCktuFRw69VYdhs0dOxQadBsUAQIuZOZG9MP16tWrcXIh1fLrNzntB9G9Qez+l0n39mxf BQPHpcwbCgdJRpzAKIy4s9zeXogOPHrd4PfpXMYkbNar/OqGnZYWu6TcOQJC0GnAgi8dUDT9Gri4 d5xFBQOGkPxx6DowB4Lluh1gSOgE9yqq6DJ8J8oamkqqp24TkiI0KDqQfS5ExzPouqF5RwWIbw0L Y0CwpLN8sr2s0sDh+4T4lqazUe/RicTpr8EtxKGDQ7bNawaFI3RTnzI01RunMutnkYWu7l4Ow3to HBAIDoQAjg7BnftCCAqB0DgLCzk11xssortoIIQ5DL9/5i5s75OmE9wnLKPL0FOdPaWJ8OAybgMN goMiQA5wIbt3795tbKxD+cKnOwFqeS9svIQjHrzDd2uLw8acinejN7vSeZOhwPjv2K2O850kbGGa TXnFbTGWQl29TZzuCx69EFRszosQWQJDMicsbebz500cxay6KjzPzD2ga+ncVkEUHEbcn7xxPBCW EsttVGDYeJfGZehlPa+VhXJYsQGhQREgx1jY9AOpH1p3IXpMl2sviC4AcjWB1yuscFBdcRm+d/rG pjEaTPbtgJeOEA9t7lkIq5z6kEK8zsevQM5m33ynO/tdx/3bMdkdXUQ2PDKMdYlAQFgI5ifg+WcV VdFVoquQ+XRk7ANqbvMQFsKiV80VK6U8JIUOw2FhoSnPZxziMggN6tlpuKPnj0ns4d///vegLmT6 oGr+Y+P7o/ucK+kPVKyuw+/vjgP34JZ2MyKRdq8JkXxjJJGkmz0bh95xJ/fpPjLXMQNIEtpaNXE4 QkSSUfcIAd+AC0NS8b5Z2AphAfttzGCjbgDDWg4QGxEieBlyGOU1OSgcGnq9hqX0i41D7ogug9Cg 6ECOHNbyybwautKdCYuz0A++OZMm1u3g8D1D7PC9RTYwYDHOyoqJ8xjOqvuU9OARgYGwiLv+IWTu yYWM4Ip6YSt0GLMpw0noCV1Ktg2weMIZ9g/vVl/ZfaXjKqpjSJxF5ipq2Ak6v0cLhVZgxJBUdBgH AIMug6LueGFbmuBaRr1//PhxUJCoC/Hjqgl44y6jnNruhRvbP6TuJWK9IA04JGznDe5kBopYnRWn yvqY82TL1+g4FhPoMXl/FGKMY9YYvzR6ZdYh7qe4uMddGGP4KRl1jwn1WWgruAhJQlgIqBpeAich ntz2+2nYM3MXDooIDE98630VGF++fDkWMAgNig7kDh1IdSLWlasbTu10Xtb0bXGYFoXBKmsGWyCG q/WtOIUN7JBXy3N9t0OHSgSIXCfXG1g4HPx57PENLGC71xQivslSsvtfA5Js/PopHEgGD9sdsYEH JMgXQ1cZLBIAxb04amLa3IRkISz4WU3iXV8vOgt3pwgLfc7oLjwcpXkL78e4JTAIDYq6RwcSf053 61R1I69evSoQUZgER1IAMDmVso+IXrZ91QXCVYNVyjQhLHcZ5mhwdz3By1n5rgPBwZLcD2/rOZEs rHW8X+48XDVzHhBqkrCPyRhum4Ej3g+v9zwEuhRwHT5xoIEM3ob5Cr9eQWFFFQ0svP8CYaGnEzCk 4y4IDIp6Ag4Ey3kbB4JSN6LVLraD4eCORBcgh4g+VhcXPw872w2WI1kMm4XchzuXCBlJHiewlavA z25GnfcS5x2oHBMi6UIYR+XHza88pxFh4a4lAmNfSAsXWncsDpDobrJ8hb8mHXvjPyPCAnMXChTN Xax0FwQGRT3yEBZ+MFeBRBegaUFRd1IXfAWKLsoKE30eC9E0riKErJbAgmEmdzXN/QximUMpP0/j 7Cuc3akg0u02xxH6AIOZw4iQgBEyS+WrzZ7wyV4uFRLgTlaDIoahFBYKig4s1gJkHxgIDYp6gACJ 4Fh0IwYSHQ1Rw1s6iNGdg8JEw13oIvw2zaGgq/Db0EUgWAJkZuGrXigOOrxjbvzBAQTDUL0d/vx3 EUEQrmsAYr/vFBDuVBASDo4eKBJXcVsncew96SmKOvGCdpOfv2qHPL/87t07nexbQaBAmdyKh12q I0GAxPPoIvz68/NzHcU9C00hUCJwtItej2TXvvsOYdUF2yqW0nAWPhZzFBcXF+UIcGgcBEIhO++u QsNOnqfwn3MLUNBdUBQBsh4Ye17z8P79e9EDwlvlBnUpChdVcCsRCN3Lfl0GHL3s0IH7pcA4cRI9 BYrf5jBAeCThrPT2pctQFVUAobPO8HV50htCT8cCBd0FRREgh8PigP/H8OHDh+JWXJaMb+6EkImg wcV/CTAodz/3+ou8rmBKb8uAgAs/giGDg8rzEn5Z3cTnz59vuujf1jkQFhT1zAGyFwg3+H/s3Xkw QqYHmh5wegAJW+/eFTiaPENPGRB6YDgADre9fe0vi7CgKALkKK/x1LevAk6mJQidStnin+kAIBwT EDcBAGFBUQTIvbzm4QS/g+GJvQfGE9x/vIPXQVHUPWtLED57jSe+P0FBUXQg/D8+4d/X+ECfi6Io AoS/A8KGoigunvx9EQoURVEEyKP+3XPRpyiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiK oiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoqgnov8LMAAI0hD/7FMy 6AAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 2237.5872 1692.7593)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M1591.97,1486.33v-20.39c0,0,295.74,37.16,442.84,198.97l-3.1,13.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st216",
    x1: 1813.39,
    y1: 1524.2,
    x2: 1806.42,
    y2: 1544.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M1526.83,1678.85l8.62-22.45c0,0,328.18,62.34,402.93,182.91l-6.93,21.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st216",
    x1: 1747.03,
    y1: 1716.18,
    x2: 1739.06,
    y2: 1736.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M2479.83,507.83v-11.42c0,0-80.38-52.4-161.32-72.86c-80.95-20.45-205.71,6.52-205.71,6.52l2.14,12.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st216",
    x1: 2315.15,
    y1: 422.74,
    x2: 2315.15,
    y2: 434.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M2095.19,244.19v-13.2c0,0,137.81-20.03,229.94-3.76c92.13,16.27,255.48,95.9,255.48,95.9l-3.1,8.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st216",
    x1: 2321.11,
    y1: 226.54,
    x2: 2321.11,
    y2: 238.65
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_54"
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "st217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3248.74,965.67c-2.15,1-214.45,98.78-214.45,98.78l-25.55-28.18l-15.68-48.77c0,0,11.81,55.74,11.81,59.62 c0,3.88,25.55,30.22,25.55,30.22l-10.06,11.8L2908.87,1231l151.74,98.69c0,0,55.74,131.61,55.74,136.26s113.61-55.74,113.61-55.74 l6.26-39.47l67.48-306.29l-29.42-111.02C3274.29,953.43,3250.89,964.66,3248.74,965.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4295.04,754.83c-2.9,1.36-289.96,133.55-289.96,133.55l-34.54-38.11l-21.2-65.94c0,0,15.97,75.37,15.97,80.62 c0,5.25,34.54,40.85,34.54,40.85l-13.61,15.95l-150.74,191.81l205.17,133.44c0,0,75.37,177.95,75.37,184.23 s153.61-75.37,153.61-75.37l8.47-53.37l91.24-414.13l-39.78-150.1C4329.58,738.28,4297.94,753.47,4295.04,754.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3206.89,1623.48l-128.4-89.11l-76.72,102.82l71.23,14.18l20.6,60.73l75.8,34.09l79.33,89.16c0,0-5.42-67.49-5.42-72.13 s5.42-96,5.42-96L3206.89,1623.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2958.42,1970.35c0,0,218.32,76.25,227.23,69.28c8.9-6.97,63.1-204.25,63.1-204.25l-178.84-14.22L2958.42,1970.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2824,2013.54l-38.23-11.95l22.74-4.05l-39.77-15.98l19.77,0.41c0,0-39.12-18.22-41.44-19.77 c-2.32-1.55-33.93,23.91-33.93,23.91h14.57l-34.99,20.57l21.96,5.28l-43.91,16.88l45.33,23.3l-28.26,10.7l32.91,19.35 l-15.48,17.03l72,35.61l53.42-52.65l-30.97-13.16L2824,2013.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154.51,532.53c0,0-5.91-16.53-5.33-17.12c0,0,5.18-7.17,6.25-9.52c1.06-2.35-15.33-23.95-15.33-23.95l4.17-3.94 c0,0-10.75-27.41-14.23-28.96s-19.71,15.05-24.39,20.25c-4.67,5.2,1.71,9.06,1.71,9.06s-12.94,1.66-22.61,9.93 c-9.68,8.27-10.99,24.07-10.99,24.07s-0.85-1.22-17.93,15.22c-3.4-8.18-9.31-21.71-11.73-22.78 c-3.48-1.55-19.71,15.05-24.39,20.25c-4.67,5.2,1.71,9.06,1.71,9.06s-12.94,1.66-22.61,9.93c-9.68,8.27-10.99,24.07-10.99,24.07 s-0.9-1.3-19.59,16.82c-17.42,16.89,18.48,41.97,23.44,45.3c-1.19-0.52-4.64-1.01-13.76,2.7c-9.87,4.01,0.89,23.76,5.68,31.64 c-1.71-1.02-4.79-0.96-10.32,3.26c-11.23,8.58,18.58,67.68,18.58,67.68s57.68-38.71,61.57-46.84 c3.89-8.13-18.99-10.84-18.99-10.84s29.42-17.42,30.19-26.71c0.03-0.36,0.03-0.7,0.02-1.03c5.98,15.49,13.14,29.68,13.14,29.68 s57.68-38.71,61.57-46.84c3.89-8.13-18.99-10.84-18.99-10.84s29.42-17.42,30.19-26.71c0.77-9.29-12-10.45-12-10.45l15.96-26.32 C2163.12,538.46,2154.51,532.53,2154.51,532.53z M2052.61,640.65l5.8-9.56c1.11,4.47,2.68,9.33,4.44,14.2 C2059.5,641.29,2052.61,640.65,2052.61,640.65z M2064.68,576.84c-0.96-3-1.65-5.46-1.43-5.68c0,0,1.8-2.49,3.5-5.02 c4.91,4.25,9.34,7.32,10.86,8.34C2076.45,573.97,2073.17,573.5,2064.68,576.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.16,1769.36l-50.63-22.48c0,0-31.03,1-49.72,19.12c-17.42,16.89,18.48,41.97,23.44,45.3 c-1.19-0.52-4.64-1.01-13.76,2.7c-12.39,5.03,7.74,34.9,7.74,34.9s-21.17-14.1-32.4-5.52c-11.23,8.58-11.87,58.7-11.87,58.7 s108.14-24.21,112.03-32.34c3.89-8.13-18.99-10.84-18.99-10.84s29.42-17.42,30.19-26.71s-12-10.45-12-10.45l15.96-26.32 C1239.77,1775.29,1231.16,1769.36,1231.16,1769.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2671.43,381.96c3.12-4.71-15.22-6.28-15.22-6.28s23.59-10.09,24.21-15.47c0.62-5.38-9.62-6.05-9.62-6.05l12.8-15.24 c6.9-11.66,0-15.09,0-15.09s-4.74-9.57-4.27-9.91c0,0,4.16-4.15,5.01-5.51s-12.29-13.87-12.29-13.87l3.34-2.28 c0,0-8.62-15.87-11.41-16.77c-2.79-0.9-15.8,8.71-19.55,11.73c-3.75,3.01,1.37,5.25,1.37,5.25s-10.37,0.96-18.13,5.75 c-7.76,4.79-8.81,13.94-8.81,13.94s-0.72-0.75-15.71,9.74c-13.97,9.79,14.85,24.32,18.8,26.24c-0.94-0.3-3.7-0.59-11.04,1.56 c-7.91,2.32,0.71,13.76,4.55,18.32c-1.37-0.59-3.84-0.56-8.28,1.89c-9,4.97,14.9,39.19,14.9,39.19S2668.31,386.66,2671.43,381.96z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2758.53,410.97c0,0-0.72-0.87-15.71,11.32c-13.97,11.37,14.85,28.27,18.8,30.49c-0.94-0.35-3.7-0.69-11.04,1.81 c-7.91,2.7,0.71,15.99,4.55,21.3c-1.37-0.69-3.84-0.65-8.28,2.2c-9,5.77,14.9,45.55,14.9,45.55s46.24-26.05,49.36-31.52 c3.12-5.47-15.22-7.29-15.22-7.29s23.59-11.72,24.21-17.98c0.62-6.25-9.62-7.03-9.62-7.03l12.8-17.72c6.9-13.55,0-17.54,0-17.54 s-4.74-11.13-4.27-11.52c0,0,4.16-4.83,5.01-6.41c0.85-1.58-12.29-16.12-12.29-16.12l3.34-2.65c0,0-8.62-18.45-11.41-19.49 c-2.79-1.04-15.8,10.13-19.55,13.63s1.37,6.1,1.37,6.1s-10.37,1.12-18.13,6.68S2758.53,410.97,2758.53,410.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.78,245.47c-0.94-0.35-3.7-0.69-11.04,1.81c-7.91,2.7,0.71,15.99,4.55,21.3c-1.37-0.69-3.84-0.65-8.28,2.2 c-9,5.77,14.9,45.55,14.9,45.55s46.24-26.05,49.36-31.52c3.12-5.47-15.22-7.29-15.22-7.29s23.59-11.72,24.21-17.98 c0.62-6.25-9.62-7.03-9.62-7.03l12.8-17.72c6.9-13.55,0-17.54,0-17.54s-4.74-11.13-4.27-11.52c0,0,4.16-4.83,5.01-6.41 s-12.29-16.12-12.29-16.12l3.34-2.65c0,0-8.62-18.45-11.41-19.49s-15.8,10.13-19.55,13.63s1.37,6.1,1.37,6.1 s-10.37,1.12-18.13,6.68s-8.81,16.2-8.81,16.2s-0.72-0.87-15.71,11.32C2053.01,226.35,2081.83,243.24,2085.78,245.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.43,1683.75c-8.1-4.28,0.31,2.06-11.04-4.65s-18.06-10.84-21.68-12.9c-3.61-2.06-12.05-7.23-12.05-7.23 c-3.95,0-17.87,2.41-17.87,2.41s-7.75,8.09-10.33,11.87c-2.58,3.78-8.41,5.44-12.39,9.46s-1.25,1.85-3.98,4.02 c-2.73,2.17-29.6,25.68-33.24,35.09c-3.64,9.41,3.67,25.05,3.67,25.05s-28.39,2.19-19.61,20.63c8.77,18.44,9.29,21.54,9.29,21.54 s-21.68,7.48-20.13,21.81c1.55,14.32,19.61,41.68,27.35,36.52c7.74-5.16,46.45-21.68,40.26-33.55 c-6.19-11.87-12.9-17.55-12.9-17.55s39.74-10.84,35.1-23.74c-4.65-12.9-12.39-15.48-12.39-15.48s31.46,7.92,40.25,1.12 c8.78-6.8,16.53-22.47,24.78-31.92S1088.53,1688.03,1080.43,1683.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.35,1505.57c-4.09-4.09-5.57-0.53-5.11-3.63c0.46-3.1-2.64-13.94-9.6-17.81c-6.97-3.87-13.55-4.25-13.55-6.77 c0-2.52-6.58-11.81-10.45-12.97c-3.87-1.16-9.68-2.26-15.1,4.19c-5.42,6.44,0,11.3,0,11.3s-9.62,0.39-12.74,4.65 c-3.13,4.26-1.84,5.41,0,8.9c1.84,3.49,14.29,12.45,10.03,12.15c-4.25-0.31-3.24,1.91-0.44,4.63 c2.81,2.72-36.72,21.55-31.69,38.58c5.03,17.03,11.57,25.16,11.57,25.16s-37.51,0.39-29.38,15.48 c8.13,15.1,13.16,26.21,13.16,26.21s-23.61,4.76-24,18.69s11.61,30.58,11.61,30.58s48.57-25.03,48.39-27.48 c-0.18-2.45-6.09-12-6.09-12s53.05-15.48,45.63-28.26c-7.41-12.77-14.56-16.65-14.56-16.65s29.98-3.21,40.05-16.31 s22.06-39.43,16.26-48.72C823.53,1514.18,804.44,1509.67,800.35,1505.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,1700.55c-4.09-4.09-5.57-0.53-5.11-3.63c0.46-3.1-2.64-13.94-9.6-17.81c-6.97-3.87-13.55-4.25-13.55-6.77 c0-2.52-6.58-11.81-10.45-12.97c-3.87-1.16-9.68-2.26-15.1,4.19c-5.42,6.44,0,11.3,0,11.3s-9.62,0.39-12.74,4.65 c-3.13,4.26-1.84,5.41,0,8.9c1.84,3.49,14.29,12.45,10.03,12.15c-4.25-0.31-3.24,1.91-0.44,4.63 c2.81,2.72-36.72,21.55-31.69,38.58c5.03,17.03,11.57,25.16,11.57,25.16s-37.51,0.39-29.38,15.48 c8.13,15.1,13.16,26.21,13.16,26.21s-23.61,4.76-24,18.69s11.61,30.58,11.61,30.58s48.57-25.03,48.39-27.48 c-0.18-2.45-6.09-12-6.09-12s53.05-15.48,45.63-28.26c-7.41-12.77-14.56-16.65-14.56-16.65s29.98-3.21,40.05-16.31 s22.06-39.43,16.26-48.72C230.55,1709.16,211.46,1704.64,207.37,1700.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,1917.86c-4.09-4.09-5.57-0.53-5.11-3.63c0.46-3.1-2.64-13.94-9.6-17.81c-6.97-3.87-13.55-4.25-13.55-6.77 c0-2.52-6.58-11.81-10.45-12.97c-3.87-1.16-9.68-2.26-15.1,4.19c-5.42,6.44,0,11.3,0,11.3s-9.62,0.39-12.74,4.65 c-3.13,4.26-1.84,5.41,0,8.9c1.84,3.49,14.29,12.45,10.03,12.15c-4.25-0.31-3.24,1.91-0.44,4.63 c2.81,2.72-36.72,21.55-31.69,38.58c5.03,17.03,11.57,25.16,11.57,25.16s-37.51,0.39-29.38,15.48 c8.13,15.1,13.16,26.21,13.16,26.21s-23.61,4.76-24,18.69s11.61,30.58,11.61,30.58s48.57-25.03,48.39-27.48 c-0.18-2.45-6.09-12-6.09-12s53.05-15.48,45.63-28.26c-7.41-12.77-14.56-16.65-14.56-16.65s29.98-3.21,40.05-16.31 s22.06-39.43,16.26-48.72C126.78,1926.47,107.69,1921.95,103.6,1917.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.58,1957.33l8.46-6.35c0,0-17.49-12.18-19.64-11.36c-2.15,0.82,8.48-5.6,8.48-5.6s-29.1-11.69-31.81-14.16 c-2.71-2.47-29.48,6.98-29.48,6.98l6.34,5.14l-22.67,6.87l4.4,3.57l-16.82,6.16l28.8,69.36l-19.35,2.32l20.9,34.06h-13.94 l29.42,51.1l43.35-32.52l-17.81-10.06l29.42-33.29c0,0-17.03-3.1-19.35-3.87c-2.32-0.77,32.09-59.05,32.09-59.05L1917.58,1957.33z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.45,1861.09c0,0-114.04-89.68-254.64-136.45c-143.2-47.64-149.99-35.02-149.99-35.02s72.18,70.45,82.95,77.88 s8.07,16.51,8.07,16.51l87.07,18l-2.23-7.17c0,0,22.05,4.38,48.76,15.99S1931.45,1861.09,1931.45,1861.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.14,1163.36l5.21-2.44l-12.39-14.97c0,0,3.88-0.85,4.56-1.11c0.68-0.26-15.14-15.67-15.14-15.67l-19.8,9.39l8.02,6.5 l-19.42,7.73c0,0,7.43,6.03,7.9,6.41c0.47,0.38-12.53,6.43-13.63,5.54l14.48,37.99l-14.48-1.03l12.41,28.39l-12.41-2.06 l14.48,29.94l33.55-19.1l-14.21-3.61l27.12-24.77h-14.97l21.66-34.98L2007.14,1163.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455.26,561.25v-14.8l27.81-26.84c0,0-70.84-70.62-195.1-77.18s-149.91,3.35-149.91,3.35s84.88,24.55,84.88,25.58 c0,1.03,7.68,14.46,7.68,14.46s68.97,46.95,127.03,60.63C2415.71,560.14,2455.26,561.25,2455.26,561.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2156.61,98.2c0.77,0.52,18.84-20.87,18.84-20.87s-14.71-3.65-15.94-5.19s-16.06,5.19-16.06,5.19s0.52,10.55,1.29,12.87 S2155.84,97.69,2156.61,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3318.18,232.84l-21.34,37.57l-38.03,9.31l-24,41.97l13.94,56.13c0,0,53.03,32.52,55.55,31.27s40.45-46.48,40.45-46.48 l29.03-39.69L3318.18,232.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.95,1356.71l-21.34,37.57l-38.03,9.31l-24,41.97l13.94,56.13c0,0,53.03,32.52,55.55,31.27s40.45-46.48,40.45-46.48 l29.03-39.69L264.95,1356.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290.16,514.85c0,0-8.65,29.81-9.29,31.35c-0.65,1.55,9.29,7.23,9.29,7.23l22.65-23.48 C3312.81,529.95,3290.16,517.3,3290.16,514.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3466.7,919.59c0,0-8.65,29.81-9.29,31.35c-0.65,1.55,9.29,7.23,9.29,7.23l22.65-23.48 C3489.34,934.69,3466.7,922.04,3466.7,919.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3706.89,954.66c0,0-8.65,29.81-9.29,31.35c-0.65,1.55,9.29,7.23,9.29,7.23l22.65-23.48 C3729.53,969.75,3706.89,957.11,3706.89,954.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2897.26,0c0,0-77.74,145.41-80.49,149.44c-2.75,4.03-14.51,38.31-14.51,38.31l-30.11,59.26l-30.33,41.72l-13.59,27.39 l-46.2,69.82l11.61,8.13c0,0,86.71-79.36,91.81-83.15c5.1-3.79,26.89-40.52,26.89-40.52l35.52-46.7c0,0,26.94-6.53,29.26-8.95 c2.32-2.41,17.81-81.97,17.81-81.97L2977.77,0H2897.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970.55,948.78l-115.45,106.11l-135.39,58.02l-63.48,103.74l12.3-6.31c0,0,67.83-75.36,71.31-79.36 c3.48-4,133.55-41.91,133.55-41.91l116-116.67l128.26-20.27l10.82-11.65l-10.82-8.73L1970.55,948.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2102.16,911.62l-14.9-20.13l-12.19,3.48c0,0-10.32,31.1-10.58,32.13c-0.26,1.03,36.13-9.55,36.13-9.55L2102.16,911.62z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2305,1059.23 2318.94,1039.36 2304.23,1045.17 2292.23,1052.91 2271.77,1063.82 2274.42,1069.56 2303.06,1069.56  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2319.32,1207.36l-18.97-2.32l8.52,31.74l26.06,1.03c0,0,14.19-11.35,14.71-12.13c0.52-0.77,8.73-22.65,9.55-23.59 c0.82-0.94-2.32-21.14-2.32-21.14L2319.32,1207.36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1492.36,1822.48 1501.39,1856.14 1535.45,1837.56 1513.76,1827.11  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.13,784.65l-12,25.16c0,0,22.45,15.48,23.61,15.87c1.16,0.39,20.98-21.85,20.98-21.85l-11.3-19.18 c0,0-15.53-5.29-17.03-5.81C1127.88,778.34,1125.13,784.65,1125.13,784.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,975.35l-12,25.16c0,0,22.45,15.48,23.61,15.87c1.16,0.39,20.98-21.85,20.98-21.85l-11.3-19.18 c0,0-15.53-5.29-17.03-5.81C102.94,969.03,100.19,975.35,100.19,975.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.37,730.59l-1.48,30.64l2.84,11.8l40.56-50.32c0,0-18.88-4.69-21.59-8.13l-15.87,10.45L1183.37,730.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.1,831.11c1.55,0,20.65,0,20.65,0l-13.1-8.71l15.16,3.29l-27.87-20.15l-4.54-9.37l-2.57-12.38 c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35l-18.35,11.1l-22.35,9.38l20.81,2.23l-14.57,17.6 l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19c-6.19,5.14-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29 l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71l18.06,4.13l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65 l-17.9-25.81l39-10.32l-5.65-25.29l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77 C878.42,850.23,882.55,831.11,884.1,831.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.59,714.76l39-10.32l-5.65-25.29l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77 c0,0,4.13-19.12,5.68-19.12c1.55,0,20.65,0,20.65,0l-13.1-8.71l15.16,3.29l-27.87-20.15l-4.54-9.37l-2.57-12.38 c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35l-18.35,11.1l-22.35,9.38l20.81,2.23l-14.57,17.6 l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19c-6.19,5.14-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29 l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71l18.06,4.13l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65 L1103.59,714.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.37,462.69l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65l-17.9-25.81l39-10.32l-5.65-25.29 l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77c0,0,4.13-19.12,5.68-19.12s20.65,0,20.65,0l-13.1-8.71l15.16,3.29 l-27.87-20.15l-4.54-9.37l-2.57-12.38c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35l-18.35,11.1 l-22.35,9.38l20.81,2.23l-14.57,17.6l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19 c-6.19,5.14-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71L1231.37,462.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.16,1064.06l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65l-17.9-25.81l39-10.32l-5.65-25.29 l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77c0,0,4.13-19.12,5.68-19.12s20.65,0,20.65,0l-13.1-8.71l15.16,3.29 l-27.87-20.15l-4.54-9.37l-2.57-12.38c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35l-18.35,11.1 l-22.35,9.38l20.81,2.23l-14.57,17.6l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19 c-6.19,5.14-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71L278.16,1064.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.59,351.47l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65l-17.9-25.81l39-10.32l-5.65-25.29 l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77c0,0,4.13-19.12,5.68-19.12c1.55,0,20.65,0,20.65,0l-13.1-8.71 l15.16,3.29l-27.87-20.15l-4.54-9.37l-2.57-12.38c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35 l-18.35,11.1l-22.35,9.38l20.81,2.23l-14.57,17.6l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19 s-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71L1582.59,351.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.37,197.4l-7.23,22.19l13.68,13.42l-2.84,11.87l39.74-17.55l35.61-4.65l-17.9-25.81l39-10.32l-5.65-25.29l22.75-8.77 l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77c0,0,4.13-19.12,5.68-19.12s20.65,0,20.65,0l-13.1-8.71l15.16,3.29l-27.87-20.15 l-4.54-9.37l-2.57-12.38c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35l-18.35,11.1l-22.35,9.38 l20.81,2.23l-14.57,17.6l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19c-6.19,5.14-16.73,12.89-16.73,12.89 l19.83-4.11l-39.75,26.29l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71L1231.37,197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.37,230.96l-7.23,22.19l13.68,13.42l-2.84,11.87l29.53-13.04c4.42,3.34,8.61,5.78,9.95,6.53 c-0.94-0.35-3.7-0.69-11.04,1.81c-7.91,2.7,0.71,15.99,4.55,21.3c-1.37-0.69-3.84-0.65-8.28,2.2c-9,5.77,14.9,45.55,14.9,45.55 s46.24-26.05,49.36-31.52c3.12-5.47-15.22-7.29-15.22-7.29s23.59-11.72,24.21-17.98c0.62-6.25-9.62-7.03-9.62-7.03l12.8-17.72 c6.9-13.55,0-17.54,0-17.54s-4.74-11.13-4.27-11.52c0,0,4.16-4.83,5.01-6.41c0.44-0.82-2.89-5.13-6.19-9.09l-4.88-21.85 l22.75-8.77l2.06-30.97l36.13-4.13l3.92-18.46l-34.37-21.77c0,0,4.13-19.12,5.68-19.12c1.55,0,20.65,0,20.65,0l-13.1-8.71 l15.16,3.29l-27.87-20.15l-4.54-9.37l-2.57-12.38c0,0,19.65,9.84,17.95,7.64c-1.7-2.2-20.75-15.14-20.75-15.14l-10.45-14.35 l-18.35,11.1l-22.35,9.38l20.81,2.23l-14.57,17.6l-33.89,18.23l30.9-2.8l-19.21,14.35c0,0-14.34,13.05-20.53,18.19 c-6.19,5.14-16.73,12.89-16.73,12.89l19.83-4.11l-39.75,26.29l25.81,7.23l-35.1,29.94l24.52,5.16l-24.52,38.71L1778.37,230.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.39,716.53c0,0,33.8,4.65,36.39,5.08c2.59,0.43-41.42-24.43-41.42-24.43l17.54-3.88l-34.08-13.94 c0,0-40.18,16.48-41.9,18.98s14.09,10.06,14.09,10.06l-34.39,24.53c0,0,12.95-0.91,14.5-0.53c1.55,0.39-30.19,31.46-30.19,31.46 l16.26,9.19l-26.71,15.83l32.9,21.33l-26.71,13.94l29.81,11.07h-23.23l20.13,62.87l65.42-39.48l-18.58-13.94l41.42-14.71 l-15.1-31.74l40.26-15.87l-14.32-18.48l27.22-13.59L1369.39,716.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,648.81c0,0,33.8,4.65,36.39,5.08c2.59,0.43-41.42-24.43-41.42-24.43l17.54-3.88l-34.08-13.94 c0,0-40.18,16.48-41.9,18.98c-1.72,2.5,14.09,10.06,14.09,10.06l-34.39,24.53c0,0,12.95-0.91,14.5-0.53 c1.55,0.39-30.19,31.46-30.19,31.46l16.26,9.19l-26.71,15.83l32.9,21.33l-26.71,13.94l29.81,11.07h-23.23l20.13,62.87l65.42-39.48 l-18.58-13.94l41.42-14.71l-15.1-31.74l40.26-15.87l-14.32-18.48l27.22-13.59L299.48,648.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,516.74c0,0,33.8,4.65,36.39,5.08c2.59,0.43-41.42-24.43-41.42-24.43l17.54-3.88l-34.08-13.94 c0,0-40.18,16.48-41.9,18.98c-1.72,2.5,14.09,10.06,14.09,10.06l-34.39,24.53c0,0,12.95-0.91,14.5-0.53 c1.55,0.39-30.19,31.46-30.19,31.46l16.26,9.19l-26.71,15.83l32.9,21.33l-26.71,13.94l29.81,11.07H94.64l20.13,62.87l65.42-39.48 l-18.58-13.94l41.42-14.71l-15.1-31.74l40.26-15.87l-14.32-18.48l27.22-13.59L191.8,516.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.14,658.76l-26.71,13.94l29.81,11.07h-23.23l20.13,62.87l65.42-39.48l-18.58-13.94l41.42-14.71l-15.1-31.74 l40.26-15.87l-14.32-18.48l27.22-13.59l-49.29-33.74c0,0,33.8,4.65,36.39,5.08s-41.42-24.43-41.42-24.43l17.54-3.88l-34.08-13.94 c0,0-40.18,16.48-41.9,18.98c-1.72,2.5,14.09,10.06,14.09,10.06l-34.39,24.53c0,0,12.95-0.91,14.5-0.53 c1.55,0.39-30.19,31.46-30.19,31.46l16.26,9.19l-26.71,15.83L1778.14,658.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.95,459.49l45.02-28.04c0,0-5.4-7.57-4.06-8.54c1.33-0.97-20.71,8.19-20.71,8.19s-0.52-18.58-0.52-21.68 c0-3.1-25.29-0.52-32.45-4.13S756.1,390.33,737,391.36c-19.1,1.03-22.71,32.19-22.71,32.19l81.03,26.65L802.95,459.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2518.16,1077.33l7.74-7.77l-11.82-6.27l9.01-8.13l-16.29-0.69c0,0-19.33,6.08-19.61,4.77 c-0.28-1.31-18.87-1.04-18.87-1.04l3.42,16.01c0,0-17.41-19.84-18.11-23.09l13.94,60.25l-21.68-2.58l10.84,37.16l-7.23-5.16 l13.94,44.39l32.24-18.58h-14.17l42.42-39.87l-11.96-2.45l14.83-46.94H2518.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3676.02,724.93l7.74-7.77l-11.82-6.27l9.01-8.13l-16.29-0.69c0,0-19.33,6.08-19.61,4.77 c-0.28-1.31-18.87-1.04-18.87-1.04l3.42,16.01c0,0-17.41-19.84-18.11-23.09l13.94,60.25l-21.68-2.58l10.84,37.16l-7.23-5.16 l13.94,44.39l32.24-18.58h-14.17l42.42-39.87l-11.96-2.45l14.83-46.94H3676.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3425.87,1206.2l7.74-7.77l-11.82-6.27l9.01-8.13l-16.29-0.69c0,0-19.33,6.08-19.61,4.77s-18.87-1.04-18.87-1.04 l3.42,16.01c0,0-17.41-19.84-18.11-23.09l13.94,60.25l-21.68-2.58l10.84,37.16l-7.23-5.16l13.94,44.39l32.24-18.58h-14.17 l42.42-39.87l-11.96-2.45l14.83-46.94H3425.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3745.36,1059.6l7.74-7.77l-11.82-6.27l9.01-8.13l-16.29-0.69c0,0-19.33,6.08-19.61,4.77s-18.87-1.04-18.87-1.04 l3.42,16.01c0,0-17.41-19.84-18.11-23.09l13.94,60.25l-21.68-2.58l10.84,37.16l-7.23-5.16l13.94,44.39l32.24-18.58h-14.17 l42.42-39.87l-11.96-2.45l14.83-46.94H3745.36z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 3877.9631,
    y1: 587.2181,
    x2: 4106.2466,
    y2: 587.2181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "3892.89,666.6 4106.25,605.68 4010.72,527.55 3983.36,507.83 3877.96,599.15  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 3833.7402,
    y1: 824.1025,
    x2: 4038.0322,
    y2: 824.1025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "3864.93,752.82 4038.03,730.64 3945.13,765.74 3833.74,917.56  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 3878.5183,
    y1: 1339.3013,
    x2: 4040.6724,
    y2: 1339.3013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "4040.67,1247.01 3907.97,1277.82 3878.52,1313.14 3904.77,1431.59 3990.06,1414.23  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 4057.6602,
    y1: 1684.6283,
    x2: 4057.6602,
    y2: 1684.6283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M4057.66,1684.63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_70"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 3909.1292,
    y1: 1638.2487,
    x2: 4065.1575,
    y2: 1638.2487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "3932.52,1751.5 4065.16,1525 3909.13,1694.72  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 3901.3389,
    y1: 1872.1819,
    x2: 4085.7917,
    y2: 1872.1819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st223",
    points: "4085.79,1767.87 4079.4,1772.04 3901.34,1888.2 3909.13,1976.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 3878.5183,
    y1: 1316.995,
    x2: 4040.6724,
    y2: 1316.995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st224",
    points: "4040.67,1247.01 3923.43,1339.3 3894.88,1386.98 3878.52,1313.14 3907.97,1277.82  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 604.0968,
    y1: 35.9579,
    x2: 604.0968,
    y2: 35.9579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M604.1,35.96"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_71"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st226"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_191_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.6702,
    y1: 2178.4089,
    x2: 1180.215,
    y2: 2178.4089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M1180.21,2167.03H837.67C974.25,2193.25,1106.85,2201.22,1180.21,2167.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 1081.2804,
    x2: 4096,
    y2: 1081.2804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M4096-4.47H0v2171.51h837.67c-265.46-50.96-545.89-170.81-435.25-183.8 c179.25-21.05,421.96,104.04,635.31,66.55c213.36-37.5,91.99-168.44-55.66-366.74c-147.65-198.3-192.6-10.51-192.6-10.51 c116.55-43.61,137.23,121.35,48.56,210.04c-88.67,88.69-262.01-40.1-393.72-160.83s39.42-255.02,95.3-316.53 c55.87-61.51-82.55-199.89-82.55-199.89s-111.74,203.09-204.4,199.85S128.45,1282.08,140.88,1100 c12.43-182.08,342.87-180.72,580.61-201.83s412.86-176.48,428.95-279.82c16.09-103.34-271.54,16.09-394.95-10.94 s34-273.74,34-273.74c-100.32-2.55-208.83,174.23-249.86,260.95s-328.11,101.16-411.04,76.86 c-82.93-24.29-92.4-140.91-69.33-191.25c23.07-50.35,150.97-53.8,150.97-53.8c81.76,41.62,262.7-125.68,262.7-125.68 s-201.42,54.9-210.56-8.38c-9.14-63.28,212.96-87.6,210.56-99.33C452.85,95.22,156.14,103,234.86,52.26 c78.72-50.73,456.52-17.29,613.57-0.49c157.04,16.8,327.45,145.16,320.52,132.54c-6.92-12.62,117.66-94.27,276.43-154.85 C1604.15-31.13,1935,37.25,1879.53,103c-55.46,65.75,27.91,93.79,27.91,93.79c-2.08-22.83,283.55-132.66,428.55-158.59 s261.05,12.98,288.73,123.87s275.79,171.62,275.79,171.62s-94.6-51.83-40.4-189.98c54.21-138.14,484.42-131.4,567.48-108.42 c83.06,22.98,9.23,119.55-96.9,156.79s-96.9,134.44-107.19,213.63c-10.29,79.19,107.19,155.13,107.19,155.13 c-69.21-131.72,87.67-269.95,125.45-279.83c37.78-9.89,206.78-9.55,352.99,52.69c146.21,62.24,6.06,115.92,66.04,182.14 s163.8,73.07,198.41,114.08c34.61,41.01-41.53,120.95-50.76,184.38c-9.23,63.42,18.46,101.78,4.61,137.41 c-13.84,35.63-55.37,80.98-70.88,8.27c-15.51-72.72,38.58-196.14-0.64-273.21s-117.66-36.3-200.72-56.84 c-83.06-20.54-62.29-104.17-62.29-104.17c-34.65-2.02-126.24,76.41-76.13,125.11c50.1,48.71,112.36,67.27,138.43,142.12 c26.06,74.85-80.88,118.61-145.35,145.77c-64.46,27.15-237.63,87.46-272.2,129.08c-34.56,41.62,40.68,137.52,40.68,137.52 c47.64-44.37,164.61-17.18,249.98,0c85.36,17.18,215.83,147.81,223.79,182.86c7.96,35.05-28.77,154.09-23.07,214.34 c5.7,60.25,115.35,162.2,126.89,217.8c11.54,55.59-136.12,180.87-253.78,162.92c-117.66-17.96-151.11-104.89-126.89-193.56 c24.22-88.67,106.13-144.8,107.25-307.06c1.13-162.26-325.99-120.78-325.99-120.78c99.64,5.25,57.25,143.25,78.01,203.9 c20.77,60.65-125.94,106.06-211.01,106.81c-85.08,0.74-234.26,69.52-295.73,130.67s116.85,97.57,141.97,133.2 c25.13,35.63-80.5,174.92-161.34,190.88c-80.84,15.96-306.75-28.92-318.42-63.42c-11.67-34.5,64.83-31.99,64.83-31.99 s29.9,89.17,124.88,31.99c94.98-57.18-154.96-127.46-298-70.77c-143.04,56.69,69.21,157.1-100.36,134.19 c-169.57-22.91-213.41-90.46-337.84-95.41s-272.39,76.21-430.06,43.26c-157.68-32.95-176.85-188.66-219.02-245.62 c-42.16-56.97-144.71-21.05-144.71-21.05s114.86,166.74-32.3,332.02c-9.58,10.76-22.14,19.54-37.18,26.55H4096V-4.47z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_38"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_193_",
    gradientUnits: "userSpaceOnUse",
    x1: 2929.5051,
    y1: 1953.4532,
    x2: 4096,
    y2: 1953.4532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M3153.46,2104.85c44.39,0,56.23-97.18,56.75-191.12c0.52-93.94,166.63-192.6,194.31-170.8 c0,0-147.65,43.88-73.83,158.16c73.83,114.28,55.37,96.07,244.55,114.28c189.18,18.21,267.62,115.38,380.67,76.51 c113.05-38.87,140.08-169.53,140.08-169.53v244.67H2929.51C2929.51,2167.03,3054.66,2104.85,3153.46,2104.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 3588.4236,
    y1: 1139.7118,
    x2: 4096,
    y2: 1139.7118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M3875.17,1285.32c-85.58-4.62-244.55-90.7-272.24-168.44s-13.84-177.51,25.38-185.93 c0,0,38.56,93.6,103.49,107.37c64.93,13.77,127.56,26.09,158.54-46.47c30.98-72.56,151.6-122.87,178.63-117.15 c27.04,5.72,27.04,16.44,27.04,16.44v514.03C4096,1405.17,3935.15,1288.56,3875.17,1285.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 850.2538,
    x2: 722.0589,
    y2: 850.2538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M0,1049.67c0,0,37.95-115.42,140.88-158.54c102.93-43.12,370.55-31.81,532.05-94.15 s-129.42-84.21-99.31-146.16c0,0-73.8,12.8-67.99,59.64s-209.04,111.48-295.41,77.54S0,681.13,0,681.13V1049.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_196_",
    gradientUnits: "userSpaceOnUse",
    x1: 1519.8333,
    y1: 102.6694,
    x2: 3575.2463,
    y2: 102.6694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M1519.83,97.57c0,0,445.06-101.47,717.3-62.6s441.26,87.38,603.4,52.07s344.44-49.97,438.06-91.51h296.65 c0,0-139.71,29.99-170.72,103.75c-31.01,73.76-173.43,119.29-334.78,109.13c-161.34-10.16-395.16-83.57-408.51-24.09 c0,0-63.42-26.48-31.89-38.51s28.45-27.69,17.69-30.93s-292.23-31.83-276.85,12.97c15.38,44.8,99.2,1.62,70.75-6.75 c0,0,23.07-12.15,33.84,2.42c10.77,14.58-21.04,58.96-107.66,43.19s-76.13-71.26-145.35-94.48 C2152.54,49.01,1546.95,120.76,1519.83,97.57z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_63",
    className: "st233"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st234",
    width: 4096,
    height: 2160
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    className: "st233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M1573.95,2369.16c-3.73,0-7.41-0.04-11.07-0.1c-93.23-1.77-168.24-26.09-222.95-72.29 c-48.03-40.56-78.47-95.65-90.46-163.73c-11.27-63.97-6.11-137.52,15.76-224.85l0.29-1.13l288.73-1095.92l0.89-2.71 c4.07-12.41,28.04-77.55,100.07-141.14c41.61-36.73,91.3-65.79,147.69-86.35c66.92-24.4,143.45-36.78,227.45-36.78 c163.76,0,335.28,3.14,480.21,25.94c82.85,13.03,149.5,31.25,203.75,55.7c71.4,32.17,122.08,76.27,150.61,131.05 c76.6,147.08,217.46,469.05,228.43,494.18c4.86,10.51,26.19,58.66,39.7,121.44c9.02,41.91,12.7,81.95,10.94,119.02 c-2.44,51.55-15.35,97.73-38.38,137.23c-24.23,41.58-58.94,74.79-103.15,98.73c-44.11,23.88-97.94,38.27-159.99,42.79 c-24.82,1.8-48.74,3.46-71.88,5.05c-111.44,7.69-207.69,14.32-273.78,30.17c-71.24,17.08-81.54,38.25-85.94,47.29 c-9.16,18.84-18.02,39.14-27.39,60.63c-22.66,51.96-48.34,110.85-86.27,164.83c-47,66.88-104.29,114.51-175.14,145.61 c-117.56,51.6-227.98,90.28-328.21,114.95C1711.83,2358.94,1637.91,2369.16,1573.95,2369.16z M1451.34,1955.37 c-14.24,57.07-31.37,157.68,12.46,194.7c19.87,16.78,55.38,26.12,102.71,27.02c49.8,0.94,110.84-7.39,181.45-24.78 c89.54-22.04,189.45-57.14,296.93-104.32c87.08-38.22,122.07-118.46,162.58-211.37c9.75-22.35,19.82-45.45,30.73-67.88 c20.13-41.39,50.96-75.47,91.61-101.3c33.02-20.97,73-36.91,122.22-48.71c81.67-19.58,180.37-26.38,305.33-35 c22.96-1.58,46.71-3.22,71.17-5c58.05-4.22,95.41-19.87,111.06-46.5c14.44-24.58,16.75-65.7,6.49-115.76 c-9.4-45.89-25.91-82.43-27.08-84.98l-0.72-1.5l-0.45-1.08c-1.47-3.38-148.22-339.37-223.22-483.37 c-7.91-15.18-28.93-31.05-59.2-44.69c-37.88-17.07-89.93-30.89-154.71-41.08c-131.9-20.75-294.41-23.61-450.37-23.61 c-101.46,0-184.48,23.63-240.08,68.33c-34.78,27.96-48.96,55.79-52.5,63.7L1451.34,1955.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_62",
    className: "st233"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      opacity: 0.43
    },
    width: 769,
    height: 451,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAEAAQAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAABpwAAA1LgAAWpL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAc0DEQMBIgACEQEDEQH/ xADDAAEAAwEBAQAAAAAAAAAAAAAAAQIDBAUGAQEBAQEBAQAAAAAAAAAAAAAAAQIDBAUQAAEDAgQE BwEBAAMBAQAAAAEAAgMRBBAgEgUwITETMjMUFSU1BiJBQCMkFlARAAECAwIJCgUDAwUAAwEAAAEA AhEhAzESECAwQVFhcSIEgZGx0TJyohMzQ0ChQpKyUtIjwYIUUOFiUwXw8SQVEgABAwMFAAIDAQEB AAAAAAABADAxEZECECBAITJRcVBBYRIiQv/aAAwDAQACEQMRAAAA+Soz1NGatGY0ZjRmPtfS5fV+ Z7eSOxz3xusckdg43YON1jkdY5HWrkjsRxuyK5HWOR1K5HWOR1l5HWTkdcVy8/pcW7ivju3ii2+b Nd3P0kNLS4Nsysc1LeyONb2OOp69tNuXHldURzR1c1Z14+jfS8a2XB0SzlbXWZ5XSzOaOqK5nSOZ 0jmdI8n5P7H4r0+XRm78NGY0ZjRmNGaNGY0z0zAAAAPvPW8n1flfQDnsJBFswkiYAUQBWq15XXp6 EUcsXZwmkUVeuee7tnx83S+lGN6vg4z0OG2OsyqtmIg2247ptz2zaa5XWKbzMc7rHJtttHojjQI5 unCvFmXo6O7htHqsdudm1TO8UvnCAAEEoHn/ABX2vxXq8Yd/OAAAABpnpmAAAAfeer5Xq/K94jn0 mAAIzq9aqtECYKc9sOvRnfyd9Popz048Akjn6eaS3ler873z2c2OXflvfmXnvGVrmyhNJzG04yu9 uaTqvxzL224ZO+/nJfWz87TO+vTLpzvrnycM691876Mvo46556eMl23EzJl6HlmvccvViTekzOsR MzABBKIOH4r7X4r1eMO3nAAAAA0z0zAAAAPu/V8r1fl+8OXQhQoRZr0zfz8NemdpRy6Tgy6dGVfN 3v1XlevcOjLHE74c/PPPO/B347eX3R18/madqzFtBjOsLxOuhzzuTFvJi3GLUZzpK0ukXpJtfnsm +/Ja30ceXfO49LitjfNXszdeado1rktrNV6674uExPPpN6GbprMoKIHF8V9p8X6fIHbzAAAAAaZ6 ZgAAAH3fq+T63y/eg59BUdHJ29cR4PG9PH1ejl6vN3Y6YXrGenkdN0q26Ka3pJ6Onielmbzly3zI R086EExEEokiOnrPL09OObyY9ht471615T06nnO7M5Z1yorJZWSZrJeaK1nIdHZ5mudehz9nncfR plHJve88Wmt+hXm5833GWvPUzBmb0lmFqoBw/F/ZfG+nyB28wAAAAGmemYAAAB916vler8v6Ajn0 Zoq0PD9PGOvn9jWZI8/oyojp0YbtTxevr8zdqot6aW6XPmvjrrwoQkxAdPdrjrz9ec8u0WqzrTn1 4k9BW0SqW1s4s2jCtdduNZ1cdosw5/QnU8bP3uDeOG003ytNZssjM9XPz/e5dvLx0tnp5/Vlvrvz ULer0vL9LFvMMyZiUlBkE4fi/s/jPT5A7eYAAAADTPTMAAAA+69XyvU+Z9BnNefQNKc/WspaYJyt jrSJb6Qz1uYpcz5TsyuLZd/JeOEq9eMwgexwenz6zBw9IADPSSwgCvPtnpj00vaRWLxE1ETF0DUc nXGufkzbPt4V4my3ueF0R2cvrcvD1cHP08ut49Fe69W+GuF5rMtkSzM1lBCcHxv2Px3p8YdvMAAA ABpnpmAAAAfc+r5XqfM+hmRnpKBMIJqy3UG9RW9WvK9HDn3PVjm2zjnhecvT8L3fB6edCOmURB36 9ePD03uc+pGRtHge9U6VtAiJzV2RMXcRJYLNSHOImFBqImFjn6Is8uUej5tprunsZzpy7efz9/Hj ta2md3MxMuk0tOtkSzM1lmYmE4PjfsvjfT4g7eYAAAADTPTMAAAA+59PzPT+Z9DMZ6ImKROdRB01 WLGqzJeLz/S87aO3ianf18vr8vPzeR08vfyqlRpl6seryXp5vZKE0IJmLkoIrattFY1bwhoStkwx AWImFBYiYaghri024+/zvS5uC2uWnt+N1xR1Rw9kZZ53p0STK3n9Lt0WrMszBiyDPn/HfZfG+nxB 28wAAAAGmemYAAAB9x6vler836GS9MdBFMtctVExuwmGkTVbZ8Xo3Hn8vuY2Y+v5vXOHhVmO/npM 5F/oPmvrM3CJjze0mKmAm5GGXXxc+fbE8fXeHn6Y9t6bc21vZpzRl7OfRzZwE1ETCgsRMNxEwvJx +p53bwW7fP36ef6Dxeq2uHbxxr5/f5bq5526Sc3y84jp09Xbyss69ufH1k9R5+smXx32Px3o8Adv MAAAABpnpmAAAAfcep5fp/N+hMGN0i9LYztXdil8Najmlq8+W/Pqr0V6+3hehjHbTv8ABvk563r1 5Via10fSeT3cusQcfSAmLFoB5HpePrHu8umk18tHoc/bjzR0xZO3PDf1ng77Y6eZfFevT2+T2noO aMOmMqzW3nX49t9/A6uvg7FfavmZcnR1509n5z2OPprwejxcPZe/Pe3y5jffTq871vJkDWlq9Ma/ HfY/HdPnh28wAAAAGmemYAAAB9v6nl+p876AjnsDGtq9dImLpEwsef6GVnkPT87pa+h5/tZnf817 /ga8EVmN5iJg+jr08vD0yMdRAvS5IObLtzudA0pcmNd1eVj7OGs+TreNZxp0mubaYTs4dcnWu+G7 VMduazk1tGvLT6z5vHp4fWy4O+6vbC+O/wBD53Xhx9PBXSjfF302uujxfd8OWBvbv4PWzOf477L4 3r4Q7eUAAAADTPTMAAAA+39Ty/T+d9AOewrGtq9NImLpEwsZa1SM9KWef73P6DHleXpn28UVmKjb H1Ty/b+Z+o4+ywxoBeBNKTSYodEZahCJiFK2HJHRTWcq9Fk5I75POj0r2eZr6EanBX0YZ8rL2ot8 zh+mrvhyeZvleNZrM7dPoeP7GO3Lz93Lz7Zi56/K68m+ZvbW+b3PO9LM4fjfsvje3iDt5gAAAANM 9MwAAAD7b1PL9T530BGNyi1c8dNel5Z1rdZzay5tanPWOu5z7aYuHhxnbt50IqPo/nvqca5Rw9iF yLAzlUQikIWJiDaaXQIWqNq5X1NJzk0YQm1UlVlkLCb50Ohy2OOeXHv5e/DGo7uHqmttonz+yvJ2 5HILglUd3D1TXP8AG/ZfG9/IHbzAAAAAaZ6ZgAAAH23p+Z6fz/oC+N20q1mKxHRKs22mlSeCkbt+ rm0T1uL0PDeXHk746Y8unr1Of2pty68jeOXppLFdYpYRNSExURMLBoWCBKrapETFTFakVmLd9aTJ dRF4pICoScnnep5ffyWmJ3i187Ho3R5/XMwz0lEgESHD8b9j8d6fEHbygAAAAaZ6ZgAAAH2vqeX6 fz/oTplOd6KRYUbt1C3ytz1TO/Fu9HV4XbZ9F4vX5F8XXGE7zswk+iz15OPo2vy1z038rtjOq2mF QEQi1EwTpAlKITArapETBWtptz2mYAECc9AiQiq5+V6Hn9/JaYnfO01uduh5/WtVnpdEgKIOD4/7 D4/0+EO3lAAAAA0z0zAAAAPtfT8z0/n/AECGOil89DLi3fSefrb08lsS8TFcnsc3qMeRw3p28UVt Wo7uH3Y2xT5/bM54r1POwt9jHxq2+vbxpr2reGPc5PNldcYVea1t0tns5aXvrneF+plTXK8l1epO eOrNnJalzWM41LRHIvTHDnrOtIdON5iSdse+XSc9PP7CE1NqWWxABwfH/Y/Henwh28oAAAAGmemY AAAFfaen5fpeD6FlWOivHvppneV8jm97h668/uptZffl7OWqddKa8vj1tXt54raCv03zv0md8nj+ jyc/ZxvYtb4j3bHgR7PkWVvjtqhN1tnoznbLe519imvKwiMy2UWuVvK5t8vU5+KN40ziLmCNSZiR MSTMWJmJJtWxMxJb06V59rWTy9MCVMC8wlA4fjvsfjvV4Q7eQAAAADTPTMAAAA+z9LzvS8P0Ii0Y 6Z5bxpndCpQvPj082rPFtza17PL0efvwxFq75Vi0R6PWz5d8+itsegIcufnbs1lrXPtjprlozznT S/JOuUe35n0WAjl0pnFdc3lw68EQuUCRExQUkJJJmJJmLC1Opce/avPqmLcvQDYQJLAERxfHfY/H erwh28gAAAAGmemYAAAC/ael5npeH3zSWekC2AsRJeXC+epyt+zU6PL9Py+nhiJrYrbQ93k7eTh6 ptHjunoeXwR15dk46Tvat9k8qPouly+e7PXjOuTToZ15/oE1GWuCb+B3ef180wawhFkw0XKPU2l8 WfpdE+Xt9HrNfNbfRZy+Ft1RymOunDvr22w2nSmkM7lCWUFlAma2JQJRC8nx313yPp8AdvIAAAAB pnpmAAAAv2fo+b6Pi94Y6BUBpW2C8iG0+z5HtOXjc8u3jrF6rX1PM9uIopw9nL509O+nL1ekc+be WdWtnaLKonC9LNiJqawEW4dZ4KxHfySgk3y9ma6Naxx9MxEZ2IWYKJlcMtMHPtx3xb1SWElhIiJR C0kLCAoLxfH/AGHx/p+eHbyAAAAAaZ6ZgAAAL9l6Pneh4vfIz0iYkgTTxfX8Pd6p5t9Or0OTNw5B 18qJVX6HxfY59OXyuu/P15dtUs1lEJEJCayWx0xs2glElvn/AFfF7eaSOnIdcvP9Ly9HL0QRz7wQ 2gZBAWsXWKXShRCAVMiSAFlAA4PkfrvkfT88O3kAAAAA0z0zAAAAPsvQ870fF9EM7lErAly8f3OH d8+27V9bzvU8e+WB084Hdpnpy9NbGO4QABAAABnV7V8XfLKJdfNCVer6PF28PTETGOsRMNxlrRqt /M9O4CUABAAoC0WIlCyiRAAAvB8j9d8j6fnh28YAAAAGmemYAAAC/Y+j53o+P6AY3KJWAvJwTjvX oZcvZZ6vjex498ojpxlA9G2OvH1yMdCAAAMq1YdSUprz75dPn8NN8prLWYFhMHt9WO3m9cRMTcRM N1Kt56rXnVZLVYVi5aLwVWFZkoEwKAIAAOL5D675H0/PDt4wAAAANM9MwAAAD7H0fO9Hx/RDHRMA JfL5u/k6axaU09bitpfNhExvzhXXTHq599457c++8c9zVatzg2jWE+fhrn7HmYxedVmlYsKpEJLH ovR59U48nL0ehFLxETDcYsLrtEyACoAFJgAAAQKAgUDh+S+t+S9Pzg7eMAAAADTPTMAAACvsfR83 0fF9EMdExIBz+b6vlb0Grt28/ZOPlr07eQAFtrgjW2BbZ2hIiVVi0FUiqRWLCrfsl8/0ulz72rDl 6OLk9GupOduVWPVeuLo1unSRjcoKmJIBMASISKrCqYUgswAkgHF8j9d8j6fnB28YAAAAGmemYAAA FfYej53peH6SDPSZrIEU8f2ufd86NMtXq7fO9TMy8/0J35fOTHXkCAoACAiLCsW6Y5J9rpzrxOjo 4fNv2eSGvQE6AZ03tc88brnndUnLfeJrNpDVF4WrSUzm5IkQEELMArYuUbUboGhCzEji+R+u+R9P zg7eIAAAADTPTMAAACvsPS830fD9KUM9BBJBKJWeXotZ5Hq2qM9BXk6q75ee9TLfHgehnZxu4cMe zdPDv7szXnddc8dO3PnnPSqJz0jxfa8m59djvNwuK2mGZiYQAFCAoAgAoglAkhZQEwCSxW8FI0Lk 1hrzvkfr/kPT88O3jAAAAA0z3oZtBm0GbQZtB9T6fyX0vl9/RPMx06XMXpjnHQ5pOhzjoc5Ohzl6 HON6Zi+vMTpcxelzDoc5ehzjpvyyllSXrEHTPKOlzDpcyOlzDpcw6XMrpc0HS5i9Lmk6HMOlzDpj nheqOcdDmR0uYvS5h0uaDqc0HS5S9TlVh8j6XD6PBm0dfPm0GbQZtBm0GbQf/9oACAECAAEFAMs0 rxJ3ZF3ZF3ZF3ZF3ZF3ZF3ZF3XruPXceu69d167j13HruPTHvWpy1PWp61OWty1uVXqr1V6Mjq9x 6D3lVetblrci9y7jl3HLuPWty1uUDiRw5vMzgEks5UVFRNYCAwLSg1AHGiphVakXcsG9URiRlt/D w5vMyUwATQAgKo9UQVG1BqDQqZKBUCoFpCLAjGV2kYyEBzwIqiMKZIOnDm8zFjKohoCa2iDaoiiL aoDm1gQ5KqrxKJwQKoFRPGaDpw5vMwiaCdIo882hNFV0XUEJrMtQnvoA4KoVQqjO4VHQgqqIqiMs HThzeYqKFoUj6IcyAgaKtVTK6QBF7iqlUrhUqpVStRWsoSFB4QNcXjmFXB2WDpw5vMGAcQq1LRk1 FM5nB7qDLRAIhUVMWuoga4EVR6hVRywdOHN5mLRj/lCio+mEnM4EUxA4AJBHRPHMFVzQdOHN5mAG RvQ9CmigRTuZyDhM8KIqOhpgRkg6cOXzMG5OYQchzdg/kMjgagFAcqIhHMzoFyTxQjoh0LVpKoVB 04cvjwb0C5IURCcKKMc8JTlAC/0FVRX+0CICoqFNagETQmgUnNBf7/jTgekHThy+PAdMAUDVPPJg 5YPPPJXGpQcVXEBFBVVA9h5hOFCETybg7pB04cvjwGIQRNUOmD6Y0VOCMjHUIFCpAhgFVOKg6cOX x4AKioVQrSU0Vdg/pxqqqqg7mDUJw5FDEqDpw5fGhyQxARNQwYyKnFJysPLB3XJB04cvjGNUCuqL aNZ0wcedUc1OGwUGDssHThy+NBAErSUAcC4lDoieRVCtJWlaVpWlUw5IkKowoVpK0FaCu2gxDAnk csHThyD+1RDkmyJzkTzbzODzyC1Bawgao4/452ACDEGhUHAe7NB4eHJ48g5poFQ0VwkPOuAGB6UK pyeaBAIDhOeic0HThyePIFWib0wceYbVBgRFDyXcARkK1lEkoJoyagtYXcC7iM7g7WSi48CDpw5P HkC/0dE48upHIayi4nGmLRzpg40BcTloOFB4eHJ4sWqib4sJDyHJE8BjcCQE91f+BB04cnixaqpn XB55k8BrVTB554BEcWDpw5PFi0cqKPF/XLQoMQYFTF3XE8WDpw5PFi3om9cHtWlaVoQYgxBoyvfR UrjRHiwdOHJ4sW4A0ONAqBUGYkBOkRNUDyXJE8aDpw5PFi04FMdwXPAD5H11E41VVVV40HThyeLI DRE1VUHlCQLUFqC1hGQIyLUTgAP+LB04cjRq0rStK0rStK0rStK0laVpWlaVpWlaVpWlaVpWlaVp WlaVpWlaVpWlaVpWlaVpWlQgAZv/2gAIAQMAAQUAyxsaW9tq7bV22rttXbau21dtq7bF22LtsXbY u2xdti7bF22rtsXbYu0xdpi7bEImLtMXbjXbjXbjRjZXtsQjYhDGuzGu0xGNi7bF22LtsXbYu2xX DQDw4vBwAz+cgC1AIyBCRq7rV3GruNQe1F4XdXdK7mIwrgRmufFw4vBnYxO6HAp7tKM5Re4qpy1K qVqcmyIPaV3QhIEMpGW58XDi8GLnUQJODWqqdVEclJIESTjThAkIPBDHUQeVqK1FNcUURkuevDi8 GDyQC41YOTRkKlkpkojUcRjqE0KYAVpQAGBRGNz4uHF4MJSo2VwCceYOD3UBNTgyIlCNoVAiAgAq BaWrQ1dtq7TEYQUYXBFpGMbhQGiBqAgijjc9eHF4MC0FBAIJw5pzypH8sIm14FCtJVEMJY9TS0jA ck2jmsPMlNKIwOF114cXgxAQwcqI8y8/1hD4coQQRNAhgE5gcHChULkRTAHn/hCOF14uHF4MAhgM CEeWRgo3KEMK4DAIKcf9iBoRzFRRNPIo4XXi4cXgwGQ1rVSmjcGirshrX/GuFKjAZBhc+Y6tATWB 3Inmgq4FXXi4cXgwGVwopjzwhH9ZHHn1BBXNB7gmFURQKqiVMavfKGoAvUZ0o8w1f4MCrvxcOLwY BDAoFPPJ5q7CEfzkphRUCLAui1uWtya4IlFwAcKqWP8AqJwaVE6rQaEvqm4FXfi4cXgwGJHMqR3L FooOCQqKmGoqpXNTR6gyJrSoSAXDBpotQVQVdeLhxeDAOCBCqFqCc4KZ3LBgq7hUVFRaVpWlaU5l QRQppoW8wRi1Xfi4cXgqiqKioqIhSHnhD4q8WioqKmEgo7CM8lRUVFd+LhxeAqioqKiATk7mcI2/ zpQH/BlP9YR9Ml34uHF4M0ho3Foo1UKotK0oBf6aDAALkqhF4A7zF32rvhCcFOmqia4AVLBypku/ Fw4vBVA40ThymPLCNtXBVVcGmuAPMH+jg51EZEXFEngRMQHLJd+LhxeBUwGBP8zH+sIBzwARHJpo 4uARkGplSU91EXV4TIiU1tM154uHF4MuohONXYRCjSjIatcC0vRa4kRBBjVREp7ueOkrS4rtPXZe u26oiADWBAZ7zxcOLwZZTRuHUtHLoixpIAAwNa4PIAPVNFS2NoVFTE+IjkBwLzxcOLwYhFT9MIm1 eMxxlfUoAlRR0QCoEeuFOFe+LhxeDEYTnGFopwJH0ROEYFEF/gNeLe+LhxeDEBUU/XCHw5S5oTpw u44onFo5IL/OHRUV74uHF4MRhP1wieAqhEgIysCM4Rlec0cZKpyQR6cKmN74uHF4MRhK2qpjUouJ zgEpkKAAFVyVVUoZaqoVQhlvfFw4vBlcFJHzz1QBK7ZCZGGjAqpVUCFqCqFqWoqpyAkIOyX3i4cX gydFVEVTogUYnLQ5aHLSUInlC3KELGoUUg5g8qok8epWooOV6f64cT/41rWta1rWtYWtawtYWtq1 hawta1ovQei9a1rWta1rC1ha1rWta1rWta1rC1hawta1hawtYVy4udm//9oACAEBAAEFAJ55xP6i 4XqLhepuF6i4XqLheouF6i4XqLheonX5+xtbnafadvXtO3L2nbl7Tty9o25e07cvadvXtO3r2nb1 7Tt69p29e07evadvXtW3r2rb17Vt69q29e1bevatvXtW3r2rb17Vt69q29e1WC9qsF7VYL2qwXtW 3r2rb17VYL2uwXtdgn2FiH+32S9us17fZr2+0R260KfaWkaFhZke32i9BZr0FovQWi9BaL0FovQW q9Bar0NqvQ2qFlaAx2G3yN9ssV7ZYr2yxXtlivbLFOsNuCNpYo2doV6C0XoLRe32ij26ycPbbJe2 2K9tsV7bYr22xXttivbbFe22S9tsl7bYr22yW8Wltb7d6m4XqbhepuF6m4XqbhepuF6m4Xqbhepu F351351351P5+NFTL+X+k/51RhL5mohPvHNd6569c9eucpbp8gillLhcOCbNG5d2Nd2NSXLWqS4m 1epnXqJ16idGeZOmmcrWLtQZNwc5lsy8lCZeRuTXtdka7SevD376pUVFRUVFRUyz+fwfy/0v/Bmd SO3l7jcahagtYXcCMiMrQnXQCE7pBVy1PXeJmKk8xHGHxJxo0lVTeYkBrQrS5aXJzHg2cDpLjLuI /wDLTAEg2s+sYsfpNBwarfvq+JP5/B/MfS8eqc4NEsjpDEXCTWVqKqcaqRdVduIKtiBG6aJqN3bq WeTutvLgp7pnOrOv+9UnRFwmuuWETyp8wcNQVQU1zQAQ5UAWmo0rSrYaZst8K22FECWmCYStGLHa URmrjv31fEn8/g/mPpeCXBF5WsrUVVVQqVPJqcmzht03mMSSBFI5094Xi2Zu0oUt8bhz55DG6Zgm 9axqO4XBXrbtG7uihd3S9XdL1l2he3aG4XgQ3G8Q3K8Q3O6Q3SRDcoihe2DkJdpcmxbY9NstSkZL FMXFphe3UJGFFza43grbUyOkdHJa3TZhix9ERwN9Fdr4k/n8H8x9LnLqIknMBVTS4E0DpXGaF4fF kY+MXjmPnc/tRtknke8NWlaVRMj1KioqKioqKioqLSqKiAVFRRula+Ka5axroJJJLK9L59l3SWRk 2+2Stt4jmLHskZcj/owoqJ5q4FzTa3bZRixyPLLVVW9/V8Sfz+D+Y+lzE0BNTGwvd6eBrbjcLVj2 kkYSy1wmnjiFrcsmE9lDMLR0kDYZmzNRJ02txuDprhjYdxluZpmTW7+4WEKO2e9C1jp6SNelYuzo jLSDRUVFRUQaVRUVFRUQZVBjVpamBoIcEHIOUN5NFIy4hljvdsjedpunNErGvjNrGjaMXowvRigs Yl6KBQWUYlfG5mRhqiCCicm9fV8Sfz+D+Y+lzONSxrKXF5a20MjLi9dFHEyTCSWuFzciFrnOeWPd G+3uGTscaJjXW05NAZHPM8zbYGpdXAhpyVVU4Ncu0xdpi7TF2mIMaFyVAVpatLVQKgQVVVVQcg8o PQcg5Q3k0TLizivXbfdunZMND3c0Cnuo0OVVEKCdw05GnWDyy719XxJ/P4P5j6XK51FBZhzZZrC1 M8rHXjHSOcAAFJJXCaZsTJJHSPCkjLDYh7rguD5SKruVVxK61bVVVVXGqqq4c12qCqqqqqqqqqqq qqqqquNUCg4oOQeEy4dGrWO3c+aVr4+81GVoM1xGALmNC6jq+6Iba3fdygkI/wBDJvf1nEn8/g/m fpcjnUQNDc3TWWMk73P1OcrCB8MakdRqJoLmV8kitIu7PfOAmZIYomSPY63vmSJkrrYKqJxqqqqa x71a7fdXab+d3AofnLlHbLiC4/8Am7kn/wCaukfzN2j+bvkfzm5I/nt0COx7oE7adyYXWN4xOjkb hVVVVVVVVXJBKY3uMcrXNLXEVVwf7UDdUlw6jWktNvKJYkMWmhcBk336ziT+fwfzP02JdRE1LGOe 7dgIbWRgabG01GuErqlA0VzasmD43xu28sjE8ndlilMbpbcOZbMDnuewzEquJOFvt880jNvtmw9w NmjrEA96qCp5mR3SqVUrU5a3oTShequAvX3YQ3O8C9zmKdcWUivLXb5WHaIXPk2ydkcsE8Li4Boc CqquAwsbgvZcijgVcRamq2ZRsr9T1YTaJBlBIRpjvYrtnEn8/gFfmfpcHGiJrgZ/TxzXE08ltGZ5 xQBONATXJPBHM2aKSE4Wkksb5qxQsFTgSqoAk29hHbHU4syA0W4sbcOYC1mQuoia5g7k54Abcu1v tIHg20kZQVVVOkJUcZEm4WsYh6LqLiLQ557UGENq94YXaeBvZptfEn8/g/mfpUTREknCWJkzPbbW scUcTcJXcsssTJWz2r4nxwBMFBdSxyuaKBVVcLGD00ed0ba5HFXV1HbR2V76vMcSuSv7bt4VAH9P TQGrqtolF1avgZV0ZjJAcrp9Xq3t9SbyIKBzHDffrOJP5/B/M/TJ54Dn6Uak4TTthb1GF4apgVjE ZLi8LXXRRx26GSW6fI3uZ2jIelQpoYZmRxxQsq1FzQi9NJOciMxvglYtOIVncutbjcI29ySMPZ0N y2jreAyENoKJh5cDfPrOJP5/B/M/TI8zkrg51ASTga0EgBuZjM+wl7tuWnC5NZWhbcwQWxJJKqqo lWMDyz1DAo2BuYc0MSaJzq4HI0c8pxKu4g5lVVAoLa5PV2Ckt3gvYHhrQ0YNNDVDPvn1nEn8/g/m fpj0zOdQE1ySMa8XkUcdtaXQt3e6Qq3njuWzedbt1ybi/sbTXA4EqSD02y2zAyPG6mdDbwzX95MB QNGNUXE5Tg1tBlOJRAIkYY5AuajtbiSKwhbYXN9ojuY3uKoHyPjAYFRUQQz759ZxJ/P4P5r6Z3TK TRE1wOHMqi3F1I8NslYx0lTNZRFzv0Mg7yJROFvCZ7jcyx0vIDJyTRzCOD8wFSAM5xOF20unZtsy EdjYTSbk5wklkmfG925bQ90zZoGEva4EUo7DUK1yDArfPrOJP5/B/NfTHplf1wIyX0Mkoc0tOEY5 bREHTbjOZ73Aqq/ORCTcZHmR+YCgVQcH9HyRxoSxOVQUSBgzxuFHZjicJLwW7pL65liqmtLi+2lY 3abh1nf7pZGO4LQDcSuhFrcvuXYXzy2a2uBM0FDLvn1nEn8/g/mvpk4UOJR64HJpqpIWuUthVPhk jMY5Qu9Nt5NUSQu5RBwOGxs7O2ZmjCSV0cltKwFO6bo7ASPCEkjrdtxIGx3h7kzaHMcSv9vxyCZE 9y2mBk1zcS21gb24t7mQSev2yi3CobYDTGqK7dquGPdG6G4ZIwEHLvn1nEn8/g/mvpk4VyE8sznt YGbg9k0M0czXNBTgFE2rt3f2drqij0LEWyBNjNrtWYCmB6bfHpctznkt4Lq9iuHCRhVWlamC1Z5Y 8cgqzU3Mch5JsIv44DSRxfqZM+GWG1ffwXOzxstthuBFczxGGa5jDmsdpcOY/wAedT1JHptw97U2 5nam7hOE3cim7lCVvZ1bXxJ/P4P5r6fBwqv9TuiJou/DWS+gYpNyeU67nei5xwjlfEbW9ZMpRytW a5P0Uuq+JojIF3GovarKH1F3uLw66ytxPTabl5uFubO5ZFi0LQi0qO8exrbuNyDg6K8jfDMJpQhd 3AQ3C5CtrgyxBHJdXL3u2zeGbbuG62wtryRwcQ46drfMzbtuNxNfbge3uFy4XNq4amuBDoHVbKdM SA1G9jpbZIm6pd85bZxJ/P4P5v6fEiqNQnnGezhlHthXthU1lLEMakK0uJJWbVGDPeTd+6KKICMb Cvy9r8g9xe/K0csJriKIW9oyae0EjYJGiRlzZPheWIsXbK7a0LbL7RHeQ96EgjGzP/SHuajfxNc2 6gen3TGqS6lcjUm5GqZl3L6W2McwvbOE21tdS2U1xu0kshLnu2KYSNe0sdcto+J2l967TbKzZruL xtbfJYM1XG+fW8Sfz+D+b+myEAp/XK7wz2lURQ4bez/qY70u2dEVVHDZo+xs+YdMHWwfKyHROcCA UYYyjBEnQxFr9vlBkt5GLQobiaEykPkov6Vtcds1BE/mx+MlHoeSc2rrUNEls51ld7bcRvt7mNsb ow3SyYl9vM61udwa1zp2ao1eyaoVtsamFYsm2M5b2K7ZxJ/P4P5v6fLJ4sr/AAqWzZMHsfG5Wkem HfJBFtyOPMm5DbayB5ZW9MSw6spAK00V20uh7RXaK7S7YRjRiKjLo1PzkZyeUVJUksotNDfRd23n 3G9MEOz7jRtGSOaWue4OO0y+qsSFK0teQCu2xW8gjJFQ4UdjZM0W+8/WcSfz+D+b+nyv8WV/hHMv 5KWJlw020jJ7WPVJv8/c3BHG0bquNxvZpzbu1W+TqhyBNEZRUzkJkzHZKqqqqqQamaF20WLQjGtC 7a7VULN7kLFxXoGp22xlO2wJ23yK1spSy1YYnt3G2Fk5+tVJIVjdutLl0ndddNyW82oTjTNgBqLW 6W7z9ZxJ/P4P5v6fK7xZXCoayikwYQ8beNL55O7Ocmx25kRtLtzmN0R40qgKJzg0HU9UARTmApj3 NVQqquV8TgtLlocUIJCm2hRsxQW8YQYxqoFRaVpWlaKqOEh28WUOp9mE63lYuYxhfPPaO0ysdC9q pgCQZYu5ILdq7DEyONr1vX1nEn8/g/m/p8r/ABInnVF3PGQiqhbymf6faUUUcNrj7Gy5A1AYeMnA lEqqa4tQIIyMoqotFRQLUqqqIqiHBaqLUqrqgyqbQKqnle+1JogUWscp7djWhbc+EG3boKfGx6mj 7bssZ1M3r6ziT+fwfzn1GRrHORtxU27aG2K9PKuxLUW8i9O9SxtjEcbe76eMpltRv6IyxWvdIQew qoVQmtLnXTRBbYgYuOpFVxKOEYIGStF3CEJAVqWpOmaCLhqDgRVEBUauS1IvARmRleo5pWPvzJDd i4lXqJU573oLb5ZYrqRj4rzC4ZqZQqhVCqFUKtjVm9fWcSfz+D+c+oxZGFVOPMlVVUFVTTNia55e 5W79YgZrk3aTuXktrFIpNvKdbOYi2i2WDv7lfSdy6waFVVVV0RyFFNGo5SjgHhPk5ElFyt3fzqWp alqReuqpjurS5gwCCYQHzmD1IOPJclywoFyW9fWcSfz+D+c+owY1VVU4864DktSkkLGSSOe5lS6R tFY85bMhqklL36lUKqOkrZIWNToI3E2y9O8J1QXTVayQvOY4MbQZSjgUUU1heWgNHBvXMdZjAIIK 7NwWoHgb2abZxJ/P4P5z6hA86qqqiamqqqqqlcpYg4QA6p7hrXbfJE5tzJ2NrrRalVVWpWreztdU DzrRSvjoYf8A0RxtjbkOBTBU5ijgUU1hcWsDBiegc05rkP8AQjAYBXbomWqqga598+t4k/n8H859 RgCqpx5VVVVVVU9/9GVXNzMCSXHamEz7/IWNEzwvUNXfYu8xMe17757IkZmoTORe52GkA8BraNDo yg0laHLS5UOJRRBKEaHLKRUNhDH5HyMYL57G2wwGDRU7hrMOIzb59bxJ/P4P536jI53OpWpVVU99 Gkk4Oa14faP1bVZiOTd5+/uBRRRWx2/f3K7kMtwh0woSjRofeWjENytCRe2ZQntigWOTtDBLuMTV NczTFqDnISytXrLkIbleBM3O8p7rcIbpIU28memSTlDVlrg6WJp78KddxAtug90nrJmGO0s3XF1N cyDAYW7WvmvOc2NaIHlk3z63iT+fwfzv1CrgeinZK4OvrqJzd0Ym7hbOU1zCWtlY84QCr7IiNr3F 7iiiivzsXbhJqdLk6e3jT9ztWp+7PKfuF29Oe5yqh1xqSU88mdE7U5Ms7p6btVyUzbAAywt2psML E6SONeoJLWXchayVsENn3YnRbfGnXGxRp257A1He9lanb1tRd/8AQW7V/wDSTBHdbozuu7l7aoIC iCGG2sIcKPuMjTl3sV23iT+fwfzv1FVXB5AGEsLJRPaFhIIQBJhiEbI3APfbhQxuYbx3Z2cooooq JnptkHI3EzpZVUKoVQuaqQgeeJ5PUh5s8NtA6eRrGMGMk7GLs3Dmn0FnLJu7RFJvF66Z1xO5pc4j OMRgEEBUvMVraQt0x5Bl3r63iT+fwfzzSdpo5UcqFXfe7sb2PbqwexrxcW1FFC1jqo9IJNbA3U7f 5AHlFHCCIzTbm4Ca7l7cFpZGVehtAhaWwQt4AhHGFeXTLcTOc8g5JDRykP8AUTC428DYGIlF4ArJ K191Z7dJLf3UsNcpzjEYBBWFvJEyY+rlzDpjvP1vEn8/g/ngfaaOVHItNO2xSQ1dE57hQhBwRAIk t9Kqj0fK9suy3UlzebhN370ooor89B3dyuJO7PJCJXAADClTd3zYU4lxcKitEw1bhNyDT/L5BXbL R0bUej3hrWxvmF7uPbNUTwBkGQYAKzszouZhLOxoa3MMarefreJP5/B/O/UYOOJaCquC5OBBCnko xTz4bG3s2/Mooo4bGzs2CaOeABKvL8AdcZRpdE4aHXELUbtqfNLIA6ZwtGwQSg1CPQASybld9lVR OWuQZAhgEeTrayuLqSC2t4IZrh1xKyNrG5hl3n63iT+fwfzv1GBykAo6grp4JLQU9h7jY5HPuA20 2b/DgUUWen2lAUQBKnv7S3V1u084aQRg57WC4kEpZbucotqunqPZCotqs41NZxSRWm0xQS4XDnFF zrG0c8udXGueiDXFNt7hybt985N2+7dFb7NfXLbjZru2Q2y2hmbFYsimvu7J23yINDRnbl3n63iT +fwfzv1KrlOM51S0IUkRkNmHlm+yNNxRHUqqoVpCbi53Q1uAFyAvr+4mVeepW76gvFW2e4TKPYqm Pa7ONNYxgzE0UIMk27TQOkyE4MtriRsWw3bprPZbd7htf5+NNi2ONPnt2KHdpEd3uU/drtwdLLHB a3FwY3vk03TpTGyziaBG0DSqFUcv7X9KrlVyqV/Sq5Vcv7VHoreNPtvEn8/g/nvqa8BxoCamqHNb XCH3N/IJ7uhRqqo0X563D7+Vzny/2tyuiFUIWbrl8eyMCj260iTWNagVXEkBQXDp1Vy1FayjItab cNtBLM6WSqqqqqggmuJLaztbQiWQRF0jiS5f2VQrStLQv4C1AK5lcyDbppLiDTVXTGiLSK6VRyo5 f2v7VXqrlqehrK/tf2v6VHLSqBbz9bxJ/P4P576jgTStMQwhGqS3cLawwPQhFoW0xug2qrgri5Fv CX6nW1m6Yshija5oWlaSqFDUqVWkKVxDLMtZbl4CMgWpq1NQdU7xI1r6qqqqqq2ZjIoC8kgyFFsq /pf0qFaQtLVQYXbyY9vhkjKu/K4FEBTPvJ+N4k/n8H899RwO85sjXBwVo2r92d2tsxKKuG+m28AK 6ndczWtiAtDUQAqOX9r+l/S/tAuQaFyCtnUZ1yRmEC4nfcTZIYjLLIXuYA1qJJVSEXHO5oKjbpwl jEjM4GFc+9/W8Sfz+D+f+pzyHTGerXlpa4OFow9vcZ7iWXJZQ9+73OTXe3crpDBashwqctVXJByy AVO9XMkLMf8AbfbbidW9hb25rXAo4A1HHA4W9/XcSfz+D+f+pz3ALoTE4KhTCQbdoCu3ufc5Nmlh gvpi97o42xjjlwaJZ22ds5znuoqKi2iKJ0RwOJVxJ24YnsfFxgEUOBVb2fjeJP5/B/P/AFOIyOpp lgABaCooWmWLk9xBdk29rBFxzQLvsJdJHaC4ndPLk2gUtjgcSpGNezau7DLnrmA4m9fW8Sfz+DsH 1OfcJtEUNxJCQ2O5a0lskNc1q7RY8WooyR0zn7VHEH7ky2me5z3ZdsbS0wOBxtmtEXDog3i7x9bx J/P4OwfU5iruUyzJrnNLJ47hQhtMrKnbGuDm8F91Awi9hcYrHcrgPGyWhuP0Vy5skkkrqY0VMCrI FtvgcDhIdLIW0hphyyclyXJclQcaq3k/HcSfz+DsH1Oe5jaJiwjHZ3yPY8aX5LLtPbZudEcnVEhq kvYWGO8Ei9r3W6Xt+z2idv0Fu26v7y7KoqKioqYUw2yyLwXVfgcDhcmkAGltf+TvX13En8/g7B9T kGN+yj+SLAUQQtum7cl63Tc5I3ujeTa3yNldxtA3FjnSXvbisN5uANj3Qh217fEu9sUCfv1w0TXl 3OVRUwpgQqKiphYbd3VLJ3XGQCL3Vyil7jDg4gJ93AxPuWzk5a/8GuTefruJP5/B2D6nIMb1mqHA iqt4jp3L/tjzB7w0Xt0Hm5nMYvbsMfLK/LRUVFRUxphHE+V9vtkcQkkdK5XT3COOJxfUtMm5AJ9/ O5F8jyInlW0REmFR/wAWmO8fXcSfz+DsH1OQY3ArBjYH+rYAsmifDJwqY0RCpl5KC0uLl1vtQbcx lkduSScHt/vSE4O0izeU22jAETQtKhb/ANnB54UK0laXLQVoKII4W7/XcSfz+B/uwfU55BWP/cLF 1J5Q8GeGO5ipTjUVFRUTGanQ7dNMLCC0EztyeGOc5xyPYSaEHQ5aSiCqFBjimM0nLzWklBiDQFy4 BYEQRlrju/13En8/g7B9TkrklsYnqa3lhKtnUnVZreWaziuEeRwrnrlttsvros/PxRKObbrQXBE5 tonudmoSg0UMZqIkGNCoAqBaQtIWhaFoQaAuXCriQCiwIgjNu/13En8/g7B9VweThPYMeu3JDJVV RY+M6ba8UtnMxtKKnAjgmkUOx7hKmbLYwps222ym3C7lXUp/Nm2TT+txoVpQH/NIBXbC0FaSqHDd /ruJP5/B2D6rg1VQnNa8EUOD42SBxuI2G6tpZvSWr7c7WwzHbZRAdpmE1ptZnPs1ixCy2WJNm26J O3O4UlxPJiBVTO0kGoJAEdqx9xbW7oWhqp/x68Yiq3ltNu4k/n8H87K1+28SpykAg28RRikaKmlT XOBVdFOCVA1+h8OsiFjZP/wKquffZmR7fxJxB36QKkCpAqQKkCpAqQKkCpAtnFz6ge4U+QXyC+QX yC+QXyC+QXyC+QXyC+QXyC+QXyC+QXyC+QXyC+QXyC+QXyC+QX/vXyC+QXyC/wDeh7jT5FfIL5Ff Ir/31+QXyK+RXyK+RXyC+QXyC+QXyC+QXyC+QXyC+RXyK+QXyC+QXyC+QXyC+QXyC+QXyC+QXyC+ QXyC+QXyC+QXyC+QXyCPuC+QXyC+Qpu4ue/SBUgVIFSBUgVIFSBUgVIFSBUgVIF//9oACAECAgY/ ANpAJleivRXor0V6K9FeivRXor0V6K9FeivRUldkqVKlSpUqVKlSpKkqSpUqSpKlSpUo1cy++YGi 5l98qV122XMtsba6Q/0qtFzLXtUXSq31pLVGS5l961VBuptnfO+rJcy+9eiu91eYXMudVguH7Zpw w0XDwR26cflguFmrHbgrGRov6GC4eb/myrNOiwXCwBxsqf8ArSu4uH7/AAxcLFecXDup+ALh2RrT nlw7O11y6bi4d1SqhujvW8uF7t4CjRcPMq0XD+GLh/DFw7i+eCXD+GLh4fXDLh4HSAqu+IXC1Knd 3xS4exdSLqRdSLqRdSLqRdSLqRdSLqRdSLqRdSLqRdSLqRdSLqRdSLqRdTjdTjdTjdTjdTjdSLqc bqRdSLqRdSLqRdSLqRdSLqcbqcbqQd//2gAIAQMCBj8A2jpQoUKFChQoUKFChQoUKFAXkLyF5C8h eQvIXkLyFAUKFCgLyF5CgKAoCgKAhRwcD9KVKlSpU6Q8HAxUqjkqdO9Ogu2w4Ns6d7aBdvdqjQcD dBwe1UMhwa0VTuKrrU6QoUKFChQq0XS6VDr/AJMshwM0VNal3odrsaVVVTeHA0eCRREfGlFXeHAy f5sAfOoO8OBk/wB1A2jSVLBXSGR+iqbw4GQNa/G0ba7iVSSiR5yQ/iruDgZOteAVVf4rOlPjcHAw eMCeyNPvcHAxTUDlhwN14ZYDgYOteWHBvOwb6bqk6QVCii6ZDg3VVPnUbyi9XcHBuoqfGpO2ilGi Jdqd4cG41ROo/uzoKsLtRvrRQoUKi7ldBgODcdQgNKqg3GutNwaDgZH8dqeAHMWa/tmg1HBDmL/Z X/IquzsHBDgZoVKqSpXQXwu+OHA1LHSqVQcIOY76s9CqFf2uh3xA4GoVaKCoouyvnQEcUOAHHKyj KyjKyjKy85WXnKyjKy85WUZWUZWUZWXnKy85WXnKy85WUZWUZWUZWUZWUZWUZWUZWXnKy85WXnKy 85WUZWXnKy85WUZWUZWUZWUZWXnKy85WXnKyjKy85WXYOP3v/9oACAEBAQY/AKn8ju076jpXqO+4 r1HfcV6j/uK9R/3Feo/7ivUf9xXqP+4r1H/cV6r/ALiqNauzzKji6LiTGTjrXojnPWvRHOeteiOc 9a9Ec5616I5z1r0RznrXojnPWvRHOeteiOc9a9Ec5616I5z1r0RznrXojnPWvRHOeteiOc9a9Ec5 616I5z1r0RznrXojnPWvRHOeteiOc9a9Ec5616I5z1r0RznrXojnPWvRHOeteiOc9a9Ec5616I5z 1r0RznrXojnPWvRHOetEeUBDWetSp/M9a9P5nrXp/M9a9P5nrUmQ5T1oX6VueJ61EU5HWeten8z1 r0/meten8z1r0/meten8z1rsfM9a9P5nrXY+Z612Pmetdj5nrUTTltPWrzaQPKetekOc9a9Ic561 6Q5z1r0hznrXpDnPWp0xHUT1rdoDnPWvSA5T1r0xznrXp/M9a9P5nrXpCO09a9Ic5616Q5z1r0hz nrXpDnPWvSHOetekOc9a9Ic5616Q5z1r0hznrXpDnPWvSHOetVqlJlx4EnAnrXqv+4r1X/cV6r/u K9V/3Feq/wC4r1X/AHFeq/7ivVf9xXqP+4r1H/cV6j/uK9R/3FVO+7pyVDa/8j/oLtqki0NBguyF 2QuyFAgAIC9IZlMRWhdoLtDnW7MrtQXbK7ZXbK7ZUC8zkmMzwiduKXMMCCJhb28pxaVuuBxIqIsy dbkytTvu6clQ2v8AyPwTpw0KB7QtyFqtUjBRDohWlScUWnA7bjkqOAYbFYVYmAiQMTyYztowyMFc d2s2vE1ZwoizJVuTK1O+7pyVDa/8j8CToWrMEHC3PjxwAAwwHat54HKu3HYi6kwunsW9QPIUXeSR FekV6RXpFemRyKIaeZbzFCBGLHEacZ/JiAiRFhX/ACFoxIZioizI1uTK1O+7pyVDa/8AI5W3Eujs j54G0f1AxOtDEN23NtT2uBDiGxaZwknupmDgIhfyAO6VGlSMWiMCUHl4AJgWi1RBdUpZ4yX8dBrR mit260ah1r1PkF6hXquXquXquXqn5L1TzBep8gu0DtaFMMO1q3qNN39sFv8ACsK3+FI7pU21Kexb nElupwX8PEU36ihQc0OqGwNMUQWGLZO1JpMAYqTggIiJsGnEfsxQ5hg4KBk8WjTiQNhyNfYDlanf d05Khtf+R+AuskM5wR0TRq570eZNcM4xawjvhrCdiFJx8ttQG6XSBkn0yI1WugHCySvxumEJSxSc zRl+pB7HEPFjozCqsvA+dAvJETFURUZcpsEKl210FX4nheIaKZ7FJx3uQKnXqv8ALrXYgZ5ZxBNF QF7S6YO/EKp5zDRFMRDjMGMsyFRhvMdMEaE8asUlAiRFhQY+T+nEgbDkK/dytTvu6clQ2v8AyORA EZ50XVDcAzkryuHpurP/AFZkCRAnNhutsz4N4xOZotRAEH5wUSN12kLyaoi0dh4/qiW2gkOGzASJ kCSe7iAG0xEButVXVjF5otu3Du8qYx7otp9kJxAkTFWFaBpKmTFZ1aU5rZkqYgfgooVAbxAhvTkm MIhXLpuNkCntpwjTmXMsmLEeGrgU7kAwOkSYlObC0GSm2CkSF2vkjFyiSSrDzoPbEEKfPiQPIVA4 3EbMrU77unJUNr/yOQjUdAGQGcohtQCpDdaJmKbWrE06b5QabTrRZTAgxoBNpjtw3W2acEBN5sCv ExKD2mBCiJOHaGDzBOlU7Y0E51HNaoEwbGZVbhgG1r4EKgzK8TEmUThiQMaYwZ8NmCzLPY07tTta ZI1eCDvMpMDiSYTE05tUjzWEggIjMVEYDiXc5xYG0Y3Ed3K1O+7pyVDa/wDI40EHVLTmQvwviwCZ R4gNiw/SdCNNk6MnA5hqUhCOCAswFx5BpRe60qSnoiU24YATdsQptMQN5yINhtXlgwAkScydw7HM qNqtBvCcMo6NoERD4U3HFsRB0DancRwlEtLW/wApJz6lfAMsIEbVagJo3ZQFquvO/mOnFkrwtz4t fZlanfd05Khtf+WLBAnMU+sDCUBtKJjaZlTnGxG8Zvnd0YNuAm2CN6ULG4Gg2CZ5E2AgQN7YnGiO 32nZ2jQr7TvaUG1N1/yKe9zGVG8QCGgmJGR3AXETIAR8hkYWkkBbxpt2uU61IcqpUPNpvNaMDmEA o+fSnrPUvWpc56lKtS5z1KTqZ/uUgw/3Bdhp2OC9AnYQp8O/kC3qDx/aVvMI2gqeTAJIpuIvhptC LqLHNomQLs6LTmwQ0DBsV0WlBwkRYmuz2HGvCzRiVuTK1O+7pyVDa/8ALGuttKZw0Yl7rzuQKS86 qJfS059eGGjDECFTMdKuuECFUqvMGiAmnPzGzYogRaZOabCF51CbM7c7Sg5zC6mybwLYImmCKcd0 Exhjsa/+FtQEte+ySIcC7iGuk49ggHQn1aTBTvtuOa0bsERT3Y2wNqm4naTg4drpF5cGnRLEtPOu 0edSe7nK9R3OpVSu3HaAv5GU37Qv5eCpu1iAQ/xqHkvjMxMIc6pMp1iL4jUc4Ahp+SqVmlrqdJ1y NhdrAV2qxzHQvQIhJR5goZxbjHh6tcU6TBea0jtHQg8WHBeFowF2lE5s2Dyz2XWbclX1DK1O+7py VDa/8jjPqgwLRLajVqvvPOc5tQQBEWibioCwWYCVHEg8TFhFquP7NoOY4dwRae0M0E6pSqhvmm6+ kFsxYBR4hrawqMi0g9klNYXEhgg0HNiyVFoMHNdaMx0pocbxAmdOVhbqzJ1RwDnubcJOhUaVwtLX G/XBm5sJRBVR12LWugSfli3aczpTX1CSAYkalTqUPRe0FueeGIscoZ4Qw3g66bWoXu1nyNfZlanf d05Khtf+Rxix82lWGesq7TbdGfDdHLjXXiI06FC1psKiZqAHImhlO4WjeOk4skKsWVfObvNIiWqA sGOCBOOMalQ7BpKcWsIa36sxOrJTAIzg50OIbdayofTaZtwTX6W9KlgqcE877N6l1JzS2DhIqBsz FQO1BosGC+/siwIQkBkq3Jlanfd05Khtf+RwQyEplROG87OQAEHCw4WtwMaNMVVcABvECGrFZ5bQ 4s3yHWGCuwDXO3rosGUmrV5dQBzTpQp091osCtVqkFPHqNcy85wg06Cpt5VPEZWb9JnrGdN4in6d YXgdagbdKKvaVF0mhQFgwQyNbkytTvu6clQ2v/I5KJwStRD90hF30CQQaZlssIGgYK/FutYwhu0o k2mZxXcU18PLIDmC0t1Ko9pi97oA6ArwJcTa4nJR+BvNE224r+FdOpQ3maYKCJEwrrtKAFmUrcmV qd93TkqG1/5HIxOJBwiPmoNEADJOLhea7MF2HIloIu2xTtSGgTKZTEnV3fIY3DtG7WINSO1XQy4N dp24j6jGlzgJAIMbfYYxe6YgEBGMBacpO3JQOeSc05rMEBajVYwuY0hpI0p1c1G1GMaBUAMCHOzF pRAi1tSbCRAHYUWvk9pnDODYVAGRNqlaMpW5MrU77unJUNr/AMjlmt0nC9jjC9CEdSftUBaYAcqp cMLKLBHacWlRbM1HBvOV5P0U2hgCgMWIz5OGVa1oJc4AADOdCqtruFCpTgA14IvOdY0GxMvk0+Io svOjCqx7zmlYqZpMFGo119zmkwc7u2J1Sobz3mLjrRpNh5/DETOZozyQFSDGVGwNUTG7EwhpKiRA ARaM8NaIRHKMIbHeNgyFbkytTvu6clQ2v/I5ZpZO7mUHAg6MIimE2Ni48irVMxcYbBLFFV3Z4dpe dsE55znI2xwgvddBsJW68HlUlOWBu0IjKMFSi2tSjfDTI3xYYhGi55NIuv3DOfLNRz6UA0Ek5gg5 zTEyugRcmioLrKm5UB12ItBJYXtcGQiCI60TnKL2zKcXNDQ2URHC26YFojFTEHC0Y9bkytTvu6cl Q2v/ACOWlmUHtio0zDUVBzSNaC4niLCGXG7So51ZFTBCkcHE8T9VV3ls2C3IuDwbjhukCMCnTJc7 sjDTbtOCTiE4ucTAyQMYyzpoc20gfNRyjDoJwWQGYukrj3FrmTDRngnGo0NpOAN4CLgUK/Dxg7dd EQmJqlxAnWo7lRQUNKIMiTHC/m5kHNMwg6IBzgqU8WtyZWp33dOSobX/AJHKxcYATTnW0ybFeYY6 RgIcIoDlVCh9VZ192wYkRJRjFcHwx7Rb5j9rp5EqoXQMDu8uBtanMteLwOcFNeN2AgQcxVoVoRiQ C50k3Ym94dKPOrclEriG0pnh23wdJjMIDSCBqKi4kuBTa9IwcZ9afVe+8xsSQZumqVXhLIOFQE55 J/C1ZMriBBzOCfTP0n5K9CYQOFx0k4KbtMSVJxHKpPPKpwK3mcygWkKqRnAOVqd93TkqG1/5HIRK 7Y51I3jqX8bbusqb4bFMk4LzDAq67deFFNGkgIUR2aDA3lMyrFMFWq1UaIn5jwDsTmt7NODByZE7 Cq7KzhCO5GWfBUGiB5jiWoNc0OAs0qe6daDhMERRgTddMKTzzqVQrtA7Qg58jqxixsmiSayoP4qk GvO3SneUQaVT+Sk4aHTkg8fUJjWrmaMVxLuGgaw0zkqYqVC0gEvpOkIHUqj6cjeDhDMYCSo8a20i 7U2ohFpzKGcJ7tAOAAZ5c6aB9MBisbpKrDZlanfd05Khtf8AkcjZddpC7Y5l2xzK8N5ukYkRIo03 zDfqQcbGAvPIqtYzvvJGyOGxWI8Q6dOgxzuVOcbSScjvGegJwfEXolhGlNbV7bZHWnMdY4QKItab DhirMB4aqZfQ49CN2bmzCnhI0FSKLXggjOpPmt0RUAYDQtpTzycyaHEvZRlAzIB0K+DeAgYKlxHD MDQBvAaCr9KYNrTYQhUpMFJ4EC8TKLiS4kxc7WqvAVDKoL1Pai10i0wPIr2YocxTtcBgboEyn8+K D+kRVbYMrU77unJUNr/yONDGKv0rc7VAyItGEuzuK4niTIltxu0yWzFq1z2uIfdbsyRc+bSgRYDh mIjQV2RzBdhvMi26ADoCi2Dhm0rebAaVYoA3m/pKL2i7HNgsRa4bpzqImCnIYSdCJ1osd2XiBRpv EGuMP907h3xccwE5FODiIg7oBBPKnOLbxZCDdWdQdJhkQLJplUW03TTOJpzp1gHbCjpGCm3XPkwO qHYE8ajivedirahlanfd05Khtf8AkcY4xwEjdfm1oscIEYGDPCK4bhhbUN9w2YsBauF4UkC4wOdG UzNSsyURkOXHhaNCJAkUMMsERaJqnxbe02DXpjGOIa6IcWCBJ5Ezi3t8umSCC4xceQIR7LhA7Ci0 2gwQIthNVOCcd+lvU9iIOwojlCmIrshXIQaURpCI0E4jdJmVX2ZWp33dOSobX/kcY4xwCCuvk7M5 NpOFpkc0E1gsJATmA7tIBo258VkRENN9w1Nmn1XvJLzIRsBsCpO0sb0ZCQiptUAYHQcgRkIARUQ2 G1bzoKbirSu0eZbpBVTh6jd2oJbU+jUECx0ojOnUKsXPHZAQ1WKJt04G1miMJOGkI1Q24HmICDxs OJcdbmTxoOENGeSDdAgq+zK1O+7pyVDa/wDI4xxoKOfCIiJbYU6oezTaXFVKh+pxPOcXi60IinRc B3nBQNJ0HHRrTGD6WgcwxolRcYDQoDBoUHTGlRGPEBWKxdlTIVqmIqQhjWRQcZQmmcQxguVRvEfq UWGGpTERpCnLC2o8tuU90DOiGmIOfYrIjDEZkXxhFTOBphYQoqvsytTvu6clR2v/ACOMcltVepY6 puDlxnVLHcQ+3UMeKj9OYY2pRHwU8P8Ajht6JiNIUDaJHBvAFF7TDVge2o1znQ3ALIqqzQ8mGgGe CYUM2M06lX2ZWp33dOSo7X/kcWViJJVpUirFYrFMgKLnb2YBXnuJvWhSihdPOuG4Zgj9b4LeCkVa rUGi1xgOVcNwo9umCdpx4Zs6l8DC1TURZjTKlgBa+6TKJzJ7W1fMB3rw1q1WreMcDPJID3bovWTV RtQgvc0OJFkcMRaFYrFYrMBGhV9mVqd93TkqO1/5HEi7IRNpsCvOtwBucJrdKeB2WANCJhA6VFu8 FNhVkORUWQiGm87YFUcLAYDk+IgDhOjNkqVVtDy2DcNTM44rSZAERItgqTuHLjTLCIujGNufIWKS r7MrU77unJUNr/yOGJwnFLgInMrzzPoQCiLM6LtAT6rrGCKc82uJOJMKvxN0C626DtRM4mak7nUb QoLc7Zdcgcx1qABIEi+QEfhYBADNknA1zepvF2ibJ43CVK7WtEgy7ohnyVbWMrU77unJUdr/AMjk 4KLZFEmUEGxErU4tcCTmTj9VUwGM3M6sbx2YhBmgw3oNmLueP6tiutszRMchHKwHLiyxq58oFl8f yG0WWY1F9Oo6oW3S8H6ZizJVeTK1O+7pyVHa/wDI5MqSgJN0qJtKLhmEOdcPwzTAsbecNZU5qYgr V2k1gMS4gDlVKgJeWwAjBJTOAnObcjEyGkyClUaeVSIPKFYrCrMWSiVLGvxzWYsXGGgZ0xl54rPd eqMNkM2KAJkmQ1qnTq0hTgGiAzzE1DRkavJlanfd05Khtf8AkckThg4RChTmD8kxlriYu5FVcLGm 6OTFog9lhvu5FUfpMsaLnBo1lTqXjoaF9Q5F6hG0KVZvKt2o08qvPe1rRnjFQoMvn9TrFGo8nVmw SJ5123DlUqrhyqVU8qm4HaAptaeRTpNOyKlw8dhU6N3aVMQ2Y8HPAOiK7YUBF2wEq62m8u0QRdTZ 5dIG655tinjiHmtVug0ywxAK8yuYvhCOoYrGudcaTN2hMpioaoDhBx0NnkqvJlanfd05Khtf+Rxr 1J91wzGwq7UYD8lvsI2Kbi3agGvBUGmJw7FW4g2U2GG0pzza4knlxeJ405gWNUVEyGkyW/VbEZhN QaHP+QX8dNrdZmVDzCBoElFziTrMcaBJOLBoJ2BbtMw1yW8Q1bz47ApguOtbrAFMgakAym50c8ID 5ohrWiEza4gLzqpBYXQDghVNVjGumLxgv5eNpjYQVvcXe7oUnVKmwFbvD1H7ZIub/wCfedpcV/H/ AOfSbt/+lucLRb/ajXZdpvOZokIpzHVDccYubmJUTgliOruo+bSaLpjYCU9wEGsF0DWZnFhi1tQy tTvu6clR2v8AyOJEywzE1IQPSoGSgLV/yNqEZgyKiySN5QsdXdDkxqFKx9Y33cqibBM8ie4kkRMB mhhtVqlNTx4IINHZHaKg0AAYl0Re/wDS2fOg+sfLY4wF2yelyqUq7wHBsWOZvRJ1pjaVP+VjomoZ RCdWa4U3PEDdGZXHVHFsY3YmEVAkkbTl4ZzYgaNYuD2xqMzXkAe0ZnaclX2ZWp33dOSo7xtf+S7R XbPyU3FBgjUY6bm/UGjQVepGyRabRtCg6RwQcIreEW5io26MI/UJEZ0G5yYKjwzTKk2Y1nFZSEy9 wbzlNot7NJoaBsTznO6OVX6kmZhpXpj5qVMKVNvMpMbzBXGAGr+KvOMSbSo4gOAprWzc6QQYJn6j rwkukBMlFzQWURa4Wu6k0MDeIa5kS0SIcdJXkF5FEEuFMZorX8GOODmRYYCm63mTi702mJhIF3+2 Tr7MrU77unJUTE2v/JdortKbirJ6c6vtN2oLHt/qi2o0RFhFhUuZQMiiDYr7TLOMJex0CLCmUqgi BvF2oKtUzFxA2CWKxx7NIF5/on1P1OJTb02NnDWoCzRhgEadE3qthd+lEmZNpRwA4QoqUzGwLz63 qvEm/pGEucYAWo1aoIoNIN0dLlUocFULqNQAOJGfQFH4GGCC/wAtzmny3D+I2lOFFoYXdqFjQg0W DJ19mVqd93TkqO1/5HG0HSFOY0qC3eZQMicF1nKVNcZxh+llxu0qJz4vFcUZF38bTi7EaPDmR7Tx /TE2qZAgpvHItxpcoQDUGAyFsAmvrC9+hgzlA2RFmGJ9Jh5zpTuH4WqXU6gHmQ6Pg2615dJs4Xpy kqVdrieJa+L2mYgE40wN47zwJDYoDlOk68pX2ZWp33dOSo7X/kchoWkIN0WxUBYhTb2nGQOcaUGX TE51SoNO9WdedyY3DULHVN9424ZTRD3X3j6WzVxkKdKMwLTtKiMMXGCFyIhnUg55OhSp3Rpcv5ag 2NUS0vP/ACRpN/jBztE15j3GoR2Ac2EUmHedn0AL/Ia1rmTZdNs86LjaZnKSaTsBW7SedjSpUH8y 87yz5QkX5gr9BgeyML0YTTBVLd/QYw2preIr/wAZaCXN/UcyewNDqrXxbUJsATXMEajW3R5cpayv 5TBv6B/UqAEAM2Vr7MrU77unJUdr/wAjkjzKSaSYXYw2lNa9sHl0LwsKp0WzFFgHKVLBPBSoid97 R80KbezTaGjkU0S6TWzJTm0jdoiwC0hf/I4LpUGguOhoiVu0/Kbpfar1arE54TXZLzpcVBjQNgyD 6oifoAGhqbToFwaBF4d+rHvspksJhehKO1CjVc2kS28CTGXIn/5dc02tsui1bxq1TtgoM4Qv7xPW mmjwzGlhlniNBRAoU2Q1LduN2BEGoIGRAGZVKdN58p29cIiIoQJDLQLJoucYwBOlBt4RdAwE4ayt 6LzbEnPyKAENklaVarVmVgVisVisVisWZWqbiq8NGVqd93TkqO1/5HIk6ETpwQ0pgNjBePIFVqaX GENAUipjCaxk2gwv5U596MSbVZHYhw7ZZ6nUtCu0xPOcyjUqE6miCiGROtbrQ3YIYxLWQYJR1rsr slTaV2SuyU6qw+W8TEpGKdUfNzzE4vl0WF7rSGzkLSqdVrRWcWnzGVMxRotAbSJvXM0VFxidZWZW q1WkqazKXQqj2tm0Z0XuAZBxC3iSESAIxE1nUiV2larQsysCsVisVgVgwdpTJVirbMrU77unJUdr /wAjkXXTGBunbhaFxPEmRhcby43EcSDB1Z3ltjoCnAovI3zJg16UXOMzMlBzt2np0q61oA+al0rt FWlW/JdpWladqIpiLzIQza01k90kWaDg/wBiv9iv9ioCJJsE02hccyo31ATI6MZ3ENe5nEEwa0CR YokEkqTYDarAdhWYK35KbipxViswOpNES4bx0BEh25nbrwHaPga2zK1O+7pyVHa/8jkIp5+lziSF EYC7QFw1Cw1XF7hqGKVwnC57t9w1maJcYNbNx1KLRu2MbqQfWmczetSENikSu0rVmWZWjmUzzKZj twOGh7unFc+rUNIARa4aQnVXuL3OPaOgYrKQhF5gCbFTpljWeU27FthhnWk6VPIki02ogjBdMpg8 3wNXkytTvu6clR2v/I5Bx0AnBJRCEBEuNiayvJ1EXQ2FgOLRo2h7wDsTwLGQYBqCHC0Z56jv6KNr 9OUqA/rMMQCyK/8A58WObEOLm27MUOI8tmlyvNF54+p2NH4qryZWp33dOSo7X/kcg8C0haRgEExp f5f/AD0Ko5z/ADDehf0gSBxW1qtjQbu1Oc07zySXbVBvKc/wEXGAQr1qYe2u0imIzBRc4xJtxH1H NBeHQBM8dztATHMMWkSPxVXkytTvu6clQ2u/LIG9Zn2LzKRv09WbA3REKPlecADFgRIEASSBi1nv pF8gG1MzT8BOSu041H/pbNUuK4gNq3owogzG1OeYhpJLWZgDiuOl2OWO7LrVX4Q71Kk6DXaNXxVX K1O+7pyVH+7pyFwGb+hRaZZ2mxX6Mn/UzqQjIgzTi2r5BDY3jn1Yz3edC+4NNGU9eWiZDSZBXOGY 6s7/AIjd5153/rcQKTbRRaZ7E4/+aLlOwFwRc8xcTEnbjDXE/PIXgIGoS9x1n4qvsytTvu6clQ/u 6cg4mwSaMF5pgRnCDa27VFj8x2og0TxEpNbmlbjVHCgD5bmudXzgRsgg5piHTByUL0TqmoMDnu/S 0RKvim3hqX/ZWzDYo8VXdx1UfQyTI8kl5XBsbwlISAaIugi+o4vcc7jE5BjSIbuO5xzAn5Jg0NHR 8VWytTvu6clR2u6cg4Q1jlxHMbV8p0SPMOYQTmxvQJEdMMWrRqveA9v8bW/U5P4etEOYbHSxokwG tQjHYoU6b3k2ABReBw9LS8wUeL4jz3f9dOxXP/P4VtIWB7puRPEVXPB+mMBzLVoyLuKLmg0SHMpu HaV455nRPHfCURDnkgNAh8VV5MrU77unJUdrunINfplhmg0s8xj3NDm2SMU4imaTXbzWHMDitqMM HNMQdCpiqS3inuPmVjZBVX0KofSpm6XRtQpOo33kXhAixeYKN1sYXjC1B7BuusMQAv5q7Kbc8XKP F8deha1gX8XDvruFheYBXeGpU+HbmuiajWqudyyyj6lV3lmnBzWOHaV8tDTACDZCSLz9MY8i9Mc6 BIuuNowxJgpuidSFNjYAkRJ2j4urlanfd05Kjtd05CP6THEfUZayDoawQf6KlxTqwqOeIXP0tzY9 0E3TaIoVBUN4C6DqXlF5LI3rutBgquDRIAGC33udtJywpsbFzjADWqn+SS3iWEXGibVedCIAEhCQ wOptiYu+SaCDCKBFgUGtiRaVI3RqW84uVibHTH4utsytTvu6clQ/u6cg8asR40hVeD8oVKhlTJ/S Zp1KoIOaYEfDXaNMvOoSRpcaTTDQb0JzzIUGsAuuiKgtUSYk58JwGFuZRc6CmIlSEMA+Bnkq2zK1 O+7pyVD+7pyDhqOIBpBTatKVWnZDOM4THcKxzqxBdUJnGHwYbpT3sgWUxFxjPmV7iKZewCN2OdBn DMFCnmuiavOJJNpOKSMeOQnkpZGtsytTvu6clQ/u6chpUWbjtK3xL9QswM2wwOrUXuax4hWY3X9Q TDwDXOddvVCTI/7qBkRmy/8ADRcW/qO61XuO4lrBnZTtUOD4YOd/2VJlOe9jQSD2WhvQi2od1sxA 9OPJTUrFM4LBgsw2/ATUlPGrbMrU77unJUP7uk5KBEQr1LddozJt8QIIOrCX0DdLu2yMA4KlRut4 dzAb7j2j1p9Vov0WOLb4ULMjCnTc7YCouYKTdLzBR4viLx/Sxf8A5OGBcPreIlQL7rf0tkFEzJ04 HAaCrtWoS2DhAmX+k1tmVqd93TkqH93ScpBwBGJBw5c6LWu82kDHy3SMl5vF0oC7dDCIAHaEwsf/ ADF29AxAan02Vhcay8HuFp0Jta+3eN27nGtOpX2RDb17NsTg+s2kGaV/JxkdTQouNSseYL+DhGxz F01CmG0xoaFvvcdpxG6lFGNiuuscTMIsvl4jKOb/AEivsytTvu6ckxgO9TLg4aIn4KYiNaiBdOkG CiyoYiwGYQBUYzyUgoOEIWIRMs4QgLP9Je1xgakmjK1N93ad9I099dt/2D967b/sH7123/YP3rtv +wfvXbf9g/eu2/7B+9dt/wBg/eu2/wCwfvXbf9g/ej/gvfGG/eaLsNe8p+VH+5e14l7PiXs+Jez4 l7PiXs+Jez4l7PiXs+Jez4l7PiXs+Jez4l7PiXs+Jez4l7PiXteJez4l7PiXteJe14l7PiXs+Jez 4l7PiXteJe14lLyfEvZ8S9nxL2fEvZ8S9mP9y9nxL2fEvZ8S9nxL2fEvZ8S9nxL2fEvZ8S9nxL2f EvZ8S9nxL2fEvZ8S9nxL2fEvZ8S9nxL2fEvZ8S9nxL2fEvZ8S9nxL2fEvZ8S9nxL2vEva8S9rxL2 vEva8S9rxL2vEva8S9rxL2vEva8SMPKjyof5r3R+iDRd5N5dt/2D967b/sH7123/AGD967b/ALB+ 9dt/2D967b/sH7123/YP3rtv+wfvXbf9g/eu2/7B+9dt/wBg/eu2/wCwfvX/2Q==",
    transform: "matrix(4.5936 0 0 4.5936 311.3624 42.3075)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "pathCars",
    d: "M 2288.11 1901.09 c -122.85 -0.37 -228.06 -37.45 -232.47 -39 h 0 c -1.43 -0.51 -2.84 -1 -4.23 -1.64 l -98.26 -41.16 a 86.08 86.08 0 0 1 -20.37 -12.09 h 0 c -90.85 -72.61 -181.13 -111.76 -240.85 -131.83 c -63.35 -21.28 -107 -26.29 -110.3 -26.65 a 78.31 78.31 0 0 1 -33.6 -10.69 h 0 l -129.11 -73.47 c -68.14 -38.1 -121.42 -82.32 -158.36 -131.41 c -36 -47.82 -57.08 -100.55 -62.72 -156.74 c -4.92 -48.88 2 -99.59 20.68 -150.72 c 13.83 -37.93 34.14 -76.18 60.37 -113.68 c 42.51 -60.79 86.44 -99.73 91.32 -104 l 1.44 -1.26 l 1 -0.82 l 1 -0.78 c 2 -1.61 42.24 -34 88 -88.8 C 1501 766.58 1556 687.24 1582.48 591.69 c 19.12 -69 60.72 -127.94 123.64 -175.19 c 45.51 -34.17 102.29 -62.07 168.76 -82.89 c 81 -25.39 157.15 -34.16 191.85 -37 c 8.73 -0.73 17.42 -1.9 26.06 -3.37 a 659.3 659.3 0 0 1 174.4 -6.85 a 609 609 0 0 1 148.5 33.26 c 47.3 17.09 83.1 36.91 105.81 51.35 q 18.2 11.58 37.07 22 a 453.21 453.21 0 0 1 55.31 36 c 60.29 45.91 104.67 104.12 128.35 168.35 c 17.09 46.34 23.73 95.91 19.73 147.31 c -4.31 55.54 -21.21 113.64 -50.21 172.7 c -60.81 123.82 -43.78 229.71 -24.05 352.32 c 9.89 61.53 20.13 125.16 19.87 192.36 c -0.31 80 -15.78 152.45 -47.31 221.64 c -19 41.63 -44 78.1 -74.49 108.43 a 348.56 348.56 0 0 1 -96.88 67.82 C 2431.33 1887.24 2363.79 1901.09 2288.11 1901.09 Z Z",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "pathCars2",
    d: "M2250.24,1809.26h-1.64c-107.33-.33-199.25-33.55-203.1-35h0c-1.24-.46-2.48-1-3.69-1.47L1956,1736a74.36,74.36,0,0,1-17.79-10.82h0c-79.38-65.05-158.25-100.12-210.43-118.09-55.35-19.07-93.47-23.56-96.37-23.88l-.36,0a67.21,67.21,0,0,1-29.36-9.58h0l-112.8-65.81c-59.53-34.13-106.08-73.75-138.35-117.72-31.43-42.83-49.87-90.07-54.81-140.4-4.29-43.79,1.8-89.21,18.08-135,12.08-34,29.82-68.23,52.74-101.83,37.14-54.46,75.52-89.33,79.78-93.13l1.26-1.13c.29-.25.58-.5.88-.73l.89-.71c1.76-1.44,36.9-30.42,76.91-79.54,36.28-44.55,84.38-115.62,107.51-201.21,16.7-61.81,53-114.61,108-156.94,39.76-30.61,89.37-55.59,147.45-74.25,70.82-22.75,137.33-30.6,167.63-33.17,7.63-.64,15.21-1.69,22.75-3A562,562,0,0,1,2232,362.82a521.06,521.06,0,0,1,129.74,29.79,468,468,0,0,1,92.45,46Q2470,449,2486.52,458.29a394.14,394.14,0,0,1,48.33,32.29c52.67,41.12,91.45,93.26,112.14,150.8,14.92,41.51,20.72,85.91,17.24,132-3.78,49.75-18.53,101.8-43.88,154.7-53.12,110.91-38.24,205.77-21,315.61,8.65,55.11,17.59,112.11,17.36,172.31-.27,71.62-13.78,136.56-41.33,198.54-16.57,37.29-38.47,70-65.08,97.12a304.32,304.32,0,0,1-84.64,60.76C2375.36,1796.86,2316.35,1809.26,2250.24,1809.26Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "green-car"
  }, /*#__PURE__*/React.createElement("image", {
    width: 180,
    height: 210,
    href: "http://185.119.57.142:4500/csgorace/svg/3car.svg",
    style: {
      transform: "rotate(-90deg) translateX(-180px)  translateY(-60px)"
    }
  }), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "red-frame"
  }, /*#__PURE__*/React.createElement("image", {
    width: 110,
    height: 130,
    href: "http://185.119.57.142:4500/csgorace/svg/3frame.svg"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "blue-car"
  }, /*#__PURE__*/React.createElement("image", {
    width: 130,
    height: 170,
    href: "http://185.119.57.142:4500/csgorace/svg/4car.svg",
    style: {
      transform: "rotate(-90deg) translateX(-150px)  translateY(-10px)"
    }
  }), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "blue-frame"
  }, /*#__PURE__*/React.createElement("image", {
    width: 110,
    height: 130,
    href: "http://185.119.57.142:4500/csgorace/svg/4frame.svg"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaceTrack2);
export default __webpack_public_path__ + "static/media/race-track2.3198a7ae.svg";
export { ForwardRef as ReactComponent };